//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { generateAcceptLanguage } from './utils/localeUtils';
export class PosClientBase {
  private configuration: PosClientConfig;

  constructor(configuration: PosClientConfig) {
    this.configuration = configuration;
  }

  transformOptions = (options: RequestInit): Promise<RequestInit> => {
    options.headers = {
      ...(options.headers || {}),
      'Accept-Language': generateAcceptLanguage(),
      'ActiveAccountId': this.configuration.activeAccountId ?? '',
    };

    return Promise.resolve(options);
  };
}

export interface IActivityLogClient {

    getActivityLog(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined): Promise<ActivityLog[]>;

    getActivityLogByFilter(query: ActivityLogQuery): Promise<ActivityLog[]>;

    getActivityLogWithAuditByFilter(query: ActivityLogQuery): Promise<ActivityLog[]>;

    getActivityLogTagNamesByEntityId(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined): Promise<string[]>;

    getRecentActivityLog(count: number | undefined, includeEventInfo: boolean | undefined): Promise<ActivityLog[]>;

    trackEntityView(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined): Promise<boolean>;

    trackListingCompsView(listingId: number | undefined): Promise<boolean>;

    trackListingDocumentView(listingId: number | undefined, documentId: string | undefined, documentType: DocumentType | undefined): Promise<boolean>;

    trackListingDocumentDownload(listingId: number | undefined, documentId: string | undefined, documentType: DocumentType | undefined): Promise<boolean>;
}

export class ActivityLogClient extends PosClientBase implements IActivityLogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getActivityLog(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined, signal?: AbortSignal | undefined): Promise<ActivityLog[]> {
        let url_ = this.baseUrl + "/api/ActivityLog/GetActivityLog?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActivityLog(_response);
        });
    }

    protected processGetActivityLog(response: Response): Promise<ActivityLog[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ActivityLog[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityLog[]>(null as any);
    }

    getActivityLogByFilter(query: ActivityLogQuery, signal?: AbortSignal | undefined): Promise<ActivityLog[]> {
        let url_ = this.baseUrl + "/api/ActivityLog/GetActivityLogByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActivityLogByFilter(_response);
        });
    }

    protected processGetActivityLogByFilter(response: Response): Promise<ActivityLog[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ActivityLog[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityLog[]>(null as any);
    }

    getActivityLogWithAuditByFilter(query: ActivityLogQuery, signal?: AbortSignal | undefined): Promise<ActivityLog[]> {
        let url_ = this.baseUrl + "/api/ActivityLog/GetActivityLogWithAuditByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActivityLogWithAuditByFilter(_response);
        });
    }

    protected processGetActivityLogWithAuditByFilter(response: Response): Promise<ActivityLog[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ActivityLog[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityLog[]>(null as any);
    }

    getActivityLogTagNamesByEntityId(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined, signal?: AbortSignal | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/ActivityLog/GetActivityLogTagNamesByEntityId?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActivityLogTagNamesByEntityId(_response);
        });
    }

    protected processGetActivityLogTagNamesByEntityId(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getRecentActivityLog(count: number | undefined, includeEventInfo: boolean | undefined, signal?: AbortSignal | undefined): Promise<ActivityLog[]> {
        let url_ = this.baseUrl + "/api/ActivityLog/GetRecentActivityLog?";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (includeEventInfo === null)
            throw new Error("The parameter 'includeEventInfo' cannot be null.");
        else if (includeEventInfo !== undefined)
            url_ += "includeEventInfo=" + encodeURIComponent("" + includeEventInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRecentActivityLog(_response);
        });
    }

    protected processGetRecentActivityLog(response: Response): Promise<ActivityLog[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ActivityLog[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityLog[]>(null as any);
    }

    trackEntityView(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ActivityLog/TrackEntityView?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTrackEntityView(_response);
        });
    }

    protected processTrackEntityView(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    trackListingCompsView(listingId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ActivityLog/TrackListingCompsView?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTrackListingCompsView(_response);
        });
    }

    protected processTrackListingCompsView(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    trackListingDocumentView(listingId: number | undefined, documentId: string | undefined, documentType: DocumentType | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ActivityLog/TrackListingDocumentView?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (documentType === null)
            throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTrackListingDocumentView(_response);
        });
    }

    protected processTrackListingDocumentView(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    trackListingDocumentDownload(listingId: number | undefined, documentId: string | undefined, documentType: DocumentType | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ActivityLog/TrackListingDocumentDownload?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (documentType === null)
            throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTrackListingDocumentDownload(_response);
        });
    }

    protected processTrackListingDocumentDownload(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IAddressClient {

    getKnownCountries(): Promise<{ [key: string]: string; }>;

    getStateProvinces(): Promise<{ [key: string]: StateProvince[]; }>;

    getMaineStateProvinceNames(): Promise<string[]>;

    getCitiesWithStateProvince(): Promise<{ [key: string]: City[]; }>;

    getCitiesWithoutStateProvince(): Promise<{ [key: string]: City[]; }>;
}

export class AddressClient extends PosClientBase implements IAddressClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getKnownCountries(signal?: AbortSignal | undefined): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/Address/GetKnownCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetKnownCountries(_response);
        });
    }

    protected processGetKnownCountries(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    getStateProvinces(signal?: AbortSignal | undefined): Promise<{ [key: string]: StateProvince[]; }> {
        let url_ = this.baseUrl + "/api/Address/GetStateProvinces";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStateProvinces(_response);
        });
    }

    protected processGetStateProvinces(response: Response): Promise<{ [key: string]: StateProvince[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: StateProvince[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: StateProvince[]; }>(null as any);
    }

    getMaineStateProvinceNames(signal?: AbortSignal | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Address/GetMaineStateProvinceNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMaineStateProvinceNames(_response);
        });
    }

    protected processGetMaineStateProvinceNames(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getCitiesWithStateProvince(signal?: AbortSignal | undefined): Promise<{ [key: string]: City[]; }> {
        let url_ = this.baseUrl + "/api/Address/GetCitiesWithStateProvince";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCitiesWithStateProvince(_response);
        });
    }

    protected processGetCitiesWithStateProvince(response: Response): Promise<{ [key: string]: City[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: City[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: City[]; }>(null as any);
    }

    getCitiesWithoutStateProvince(signal?: AbortSignal | undefined): Promise<{ [key: string]: City[]; }> {
        let url_ = this.baseUrl + "/api/Address/GetCitiesWithoutStateProvince";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCitiesWithoutStateProvince(_response);
        });
    }

    protected processGetCitiesWithoutStateProvince(response: Response): Promise<{ [key: string]: City[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: City[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: City[]; }>(null as any);
    }
}

export interface IAdminClient {

    /**
     * Health check endpoint for deployment pipelines.
    Returns 200 OK if the application is healthy and ready to serve requests.
     */
    healthCheck(): Promise<FileResponse>;

    getAppContext(): Promise<ReactAppContext>;
}

export class AdminClient extends PosClientBase implements IAdminClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Health check endpoint for deployment pipelines.
    Returns 200 OK if the application is healthy and ready to serve requests.
     */
    healthCheck(signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/HealthCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHealthCheck(_response);
        });
    }

    protected processHealthCheck(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAppContext(signal?: AbortSignal | undefined): Promise<ReactAppContext> {
        let url_ = this.baseUrl + "/api/Admin/GetAppContext";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppContext(_response);
        });
    }

    protected processGetAppContext(response: Response): Promise<ReactAppContext> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReactAppContext;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReactAppContext>(null as any);
    }
}

export interface IAdPlatformCatalogClient {

    getCatalogForSeller(): Promise<AdPlatformCatalogResults>;
}

export class AdPlatformCatalogClient extends PosClientBase implements IAdPlatformCatalogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCatalogForSeller(signal?: AbortSignal | undefined): Promise<AdPlatformCatalogResults> {
        let url_ = this.baseUrl + "/api/AdPlatformCatalog/GetCatalogForSeller";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogForSeller(_response);
        });
    }

    protected processGetCatalogForSeller(response: Response): Promise<AdPlatformCatalogResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdPlatformCatalogResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdPlatformCatalogResults>(null as any);
    }
}

export interface IAdPlatformReportingClient {

    getTransactionReport(currentyCode: string | undefined, aggType: TransactionAggType | undefined, adCampaignId: string | null | undefined, adGroupId: string | null | undefined): Promise<AdPlatformTransactionAgg[]>;
}

export class AdPlatformReportingClient extends PosClientBase implements IAdPlatformReportingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTransactionReport(currentyCode: string | undefined, aggType: TransactionAggType | undefined, adCampaignId: string | null | undefined, adGroupId: string | null | undefined, signal?: AbortSignal | undefined): Promise<AdPlatformTransactionAgg[]> {
        let url_ = this.baseUrl + "/api/AdPlatformReporting/GetTransactionReport?";
        if (currentyCode === null)
            throw new Error("The parameter 'currentyCode' cannot be null.");
        else if (currentyCode !== undefined)
            url_ += "currentyCode=" + encodeURIComponent("" + currentyCode) + "&";
        if (aggType === null)
            throw new Error("The parameter 'aggType' cannot be null.");
        else if (aggType !== undefined)
            url_ += "aggType=" + encodeURIComponent("" + aggType) + "&";
        if (adCampaignId !== undefined && adCampaignId !== null)
            url_ += "adCampaignId=" + encodeURIComponent("" + adCampaignId) + "&";
        if (adGroupId !== undefined && adGroupId !== null)
            url_ += "adGroupId=" + encodeURIComponent("" + adGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTransactionReport(_response);
        });
    }

    protected processGetTransactionReport(response: Response): Promise<AdPlatformTransactionAgg[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdPlatformTransactionAgg[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdPlatformTransactionAgg[]>(null as any);
    }
}

export interface IAutoPoClient {

    getInboundEmails(query: AutoPoInboundEmailQuery, take: number | null | undefined, skip: number | null | undefined): Promise<AutoPoInboundEmail[]>;

    getClassifiedInboundEmails(classificationTypes: AutoPoInboundEmailClassificationType[], take: number | null | undefined, skip: number | null | undefined, isSortDescending: boolean | null | undefined): Promise<AutoPoInboundEmail[]>;

    getClassifiedInboundEmailsCount(classificationTypes: AutoPoInboundEmailClassificationType[]): Promise<number>;

    getPartialPurchaseOrderInboundEmails(query: AutoPoInboundEmailPartialPurchaseOrderQuery, take: number | null | undefined, skip: number | null | undefined): Promise<AutoPoPartialPurchaseOrderInboundEmail[]>;

    getPartialPurchaseOrderInboundEmailsCount(query: AutoPoInboundEmailPartialPurchaseOrderQuery): Promise<number>;

    getPartialPurchaseOrder(partialPurchaseOrderId: number | undefined): Promise<AutoPoPartialPurchaseOrder>;

    getSingleInboundEmailThread(inboundEmailId: number | undefined): Promise<AutoPoInboundEmailThreadEmail[]>;

    getPurchaseInboundEmailThread(purchaseOrderId: number | undefined, isClassified: boolean | null | undefined): Promise<AutoPoInboundEmailThreadEmail[]>;

    getSaleInboundEmailThread(saleId: number | undefined, isClassified: boolean | null | undefined): Promise<AutoPoInboundEmailThreadEmail[]>;

    getPrivateInboundEmailThread(toEmailAddress: string | undefined, classificationType: AutoPoInboundEmailClassificationType | undefined, isClassified: boolean | null | undefined): Promise<AutoPoInboundEmailThreadEmail[]>;

    getInboundEmailBody(inboundEmailId: number | undefined): Promise<ValueTupleOfStringAndString>;

    getAutoPoClassifiedInboundEmailIdForEntity(purchaseOrderId: number | null | undefined, saleId: number | null | undefined): Promise<number | null>;

    classifyInboundEmail(inboundEmailId: number | undefined, classificationType: AutoPoInboundEmailClassificationType | undefined, purchaseOrderId: number | null | undefined, saleId: number | null | undefined): Promise<void>;

    unclassifyInboundEmail(inboundEmailId: number | undefined, purchaseOrderId: number | null | undefined): Promise<void>;

    canReprocessEmail(inboundEmailId: number | undefined, purchaseOrderId: number | null | undefined): Promise<boolean>;

    getInboundEmailSellerGuidIds(): Promise<string[]>;

    getSellerAccountCountryRestrictions(): Promise<AutoPoSellerAccountCountryRestriction[]>;

    getSellerAccountVendorRestrictions(): Promise<AutoPoSellerAccountVendorRestriction[]>;

    upsertSellerAccountCountryRestrictions(countryRestrictions: AutoPoSellerAccountCountryRestriction[]): Promise<boolean>;

    upsertSellerAccountVendorRestrictions(vendorRestrictions: AutoPoSellerAccountVendorRestriction[]): Promise<boolean>;
}

export class AutoPoClient extends PosClientBase implements IAutoPoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getInboundEmails(query: AutoPoInboundEmailQuery, take: number | null | undefined, skip: number | null | undefined, signal?: AbortSignal | undefined): Promise<AutoPoInboundEmail[]> {
        let url_ = this.baseUrl + "/api/AutoPo/GetInboundEmails?";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInboundEmails(_response);
        });
    }

    protected processGetInboundEmails(response: Response): Promise<AutoPoInboundEmail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoPoInboundEmail[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoPoInboundEmail[]>(null as any);
    }

    getClassifiedInboundEmails(classificationTypes: AutoPoInboundEmailClassificationType[], take: number | null | undefined, skip: number | null | undefined, isSortDescending: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<AutoPoInboundEmail[]> {
        let url_ = this.baseUrl + "/api/AutoPo/GetClassifiedInboundEmails?";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (isSortDescending !== undefined && isSortDescending !== null)
            url_ += "isSortDescending=" + encodeURIComponent("" + isSortDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(classificationTypes);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClassifiedInboundEmails(_response);
        });
    }

    protected processGetClassifiedInboundEmails(response: Response): Promise<AutoPoInboundEmail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoPoInboundEmail[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoPoInboundEmail[]>(null as any);
    }

    getClassifiedInboundEmailsCount(classificationTypes: AutoPoInboundEmailClassificationType[], signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AutoPo/GetClassifiedInboundEmailsCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(classificationTypes);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClassifiedInboundEmailsCount(_response);
        });
    }

    protected processGetClassifiedInboundEmailsCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getPartialPurchaseOrderInboundEmails(query: AutoPoInboundEmailPartialPurchaseOrderQuery, take: number | null | undefined, skip: number | null | undefined, signal?: AbortSignal | undefined): Promise<AutoPoPartialPurchaseOrderInboundEmail[]> {
        let url_ = this.baseUrl + "/api/AutoPo/GetPartialPurchaseOrderInboundEmails?";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPartialPurchaseOrderInboundEmails(_response);
        });
    }

    protected processGetPartialPurchaseOrderInboundEmails(response: Response): Promise<AutoPoPartialPurchaseOrderInboundEmail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoPoPartialPurchaseOrderInboundEmail[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoPoPartialPurchaseOrderInboundEmail[]>(null as any);
    }

    getPartialPurchaseOrderInboundEmailsCount(query: AutoPoInboundEmailPartialPurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AutoPo/GetPartialPurchaseOrderInboundEmailsCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPartialPurchaseOrderInboundEmailsCount(_response);
        });
    }

    protected processGetPartialPurchaseOrderInboundEmailsCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getPartialPurchaseOrder(partialPurchaseOrderId: number | undefined, signal?: AbortSignal | undefined): Promise<AutoPoPartialPurchaseOrder> {
        let url_ = this.baseUrl + "/api/AutoPo/GetPartialPurchaseOrder?";
        if (partialPurchaseOrderId === null)
            throw new Error("The parameter 'partialPurchaseOrderId' cannot be null.");
        else if (partialPurchaseOrderId !== undefined)
            url_ += "partialPurchaseOrderId=" + encodeURIComponent("" + partialPurchaseOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPartialPurchaseOrder(_response);
        });
    }

    protected processGetPartialPurchaseOrder(response: Response): Promise<AutoPoPartialPurchaseOrder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoPoPartialPurchaseOrder;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoPoPartialPurchaseOrder>(null as any);
    }

    getSingleInboundEmailThread(inboundEmailId: number | undefined, signal?: AbortSignal | undefined): Promise<AutoPoInboundEmailThreadEmail[]> {
        let url_ = this.baseUrl + "/api/AutoPo/GetSingleInboundEmailThread?";
        if (inboundEmailId === null)
            throw new Error("The parameter 'inboundEmailId' cannot be null.");
        else if (inboundEmailId !== undefined)
            url_ += "inboundEmailId=" + encodeURIComponent("" + inboundEmailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSingleInboundEmailThread(_response);
        });
    }

    protected processGetSingleInboundEmailThread(response: Response): Promise<AutoPoInboundEmailThreadEmail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoPoInboundEmailThreadEmail[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoPoInboundEmailThreadEmail[]>(null as any);
    }

    getPurchaseInboundEmailThread(purchaseOrderId: number | undefined, isClassified: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<AutoPoInboundEmailThreadEmail[]> {
        let url_ = this.baseUrl + "/api/AutoPo/GetPurchaseInboundEmailThread?";
        if (purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' cannot be null.");
        else if (purchaseOrderId !== undefined)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        if (isClassified !== undefined && isClassified !== null)
            url_ += "isClassified=" + encodeURIComponent("" + isClassified) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseInboundEmailThread(_response);
        });
    }

    protected processGetPurchaseInboundEmailThread(response: Response): Promise<AutoPoInboundEmailThreadEmail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoPoInboundEmailThreadEmail[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoPoInboundEmailThreadEmail[]>(null as any);
    }

    getSaleInboundEmailThread(saleId: number | undefined, isClassified: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<AutoPoInboundEmailThreadEmail[]> {
        let url_ = this.baseUrl + "/api/AutoPo/GetSaleInboundEmailThread?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        if (isClassified !== undefined && isClassified !== null)
            url_ += "isClassified=" + encodeURIComponent("" + isClassified) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleInboundEmailThread(_response);
        });
    }

    protected processGetSaleInboundEmailThread(response: Response): Promise<AutoPoInboundEmailThreadEmail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoPoInboundEmailThreadEmail[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoPoInboundEmailThreadEmail[]>(null as any);
    }

    getPrivateInboundEmailThread(toEmailAddress: string | undefined, classificationType: AutoPoInboundEmailClassificationType | undefined, isClassified: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<AutoPoInboundEmailThreadEmail[]> {
        let url_ = this.baseUrl + "/api/AutoPo/GetPrivateInboundEmailThread?";
        if (toEmailAddress === null)
            throw new Error("The parameter 'toEmailAddress' cannot be null.");
        else if (toEmailAddress !== undefined)
            url_ += "toEmailAddress=" + encodeURIComponent("" + toEmailAddress) + "&";
        if (classificationType === null)
            throw new Error("The parameter 'classificationType' cannot be null.");
        else if (classificationType !== undefined)
            url_ += "classificationType=" + encodeURIComponent("" + classificationType) + "&";
        if (isClassified !== undefined && isClassified !== null)
            url_ += "isClassified=" + encodeURIComponent("" + isClassified) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrivateInboundEmailThread(_response);
        });
    }

    protected processGetPrivateInboundEmailThread(response: Response): Promise<AutoPoInboundEmailThreadEmail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoPoInboundEmailThreadEmail[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoPoInboundEmailThreadEmail[]>(null as any);
    }

    getInboundEmailBody(inboundEmailId: number | undefined, signal?: AbortSignal | undefined): Promise<ValueTupleOfStringAndString> {
        let url_ = this.baseUrl + "/api/AutoPo/GetInboundEmailBody?";
        if (inboundEmailId === null)
            throw new Error("The parameter 'inboundEmailId' cannot be null.");
        else if (inboundEmailId !== undefined)
            url_ += "inboundEmailId=" + encodeURIComponent("" + inboundEmailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInboundEmailBody(_response);
        });
    }

    protected processGetInboundEmailBody(response: Response): Promise<ValueTupleOfStringAndString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValueTupleOfStringAndString;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValueTupleOfStringAndString>(null as any);
    }

    getAutoPoClassifiedInboundEmailIdForEntity(purchaseOrderId: number | null | undefined, saleId: number | null | undefined, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/AutoPo/GetAutoPoClassifiedInboundEmailIdForEntity?";
        if (purchaseOrderId !== undefined && purchaseOrderId !== null)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        if (saleId !== undefined && saleId !== null)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAutoPoClassifiedInboundEmailIdForEntity(_response);
        });
    }

    protected processGetAutoPoClassifiedInboundEmailIdForEntity(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    classifyInboundEmail(inboundEmailId: number | undefined, classificationType: AutoPoInboundEmailClassificationType | undefined, purchaseOrderId: number | null | undefined, saleId: number | null | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AutoPo/ClassifyInboundEmail?";
        if (inboundEmailId === null)
            throw new Error("The parameter 'inboundEmailId' cannot be null.");
        else if (inboundEmailId !== undefined)
            url_ += "inboundEmailId=" + encodeURIComponent("" + inboundEmailId) + "&";
        if (classificationType === null)
            throw new Error("The parameter 'classificationType' cannot be null.");
        else if (classificationType !== undefined)
            url_ += "classificationType=" + encodeURIComponent("" + classificationType) + "&";
        if (purchaseOrderId !== undefined && purchaseOrderId !== null)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        if (saleId !== undefined && saleId !== null)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClassifyInboundEmail(_response);
        });
    }

    protected processClassifyInboundEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    unclassifyInboundEmail(inboundEmailId: number | undefined, purchaseOrderId: number | null | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AutoPo/UnclassifyInboundEmail?";
        if (inboundEmailId === null)
            throw new Error("The parameter 'inboundEmailId' cannot be null.");
        else if (inboundEmailId !== undefined)
            url_ += "inboundEmailId=" + encodeURIComponent("" + inboundEmailId) + "&";
        if (purchaseOrderId !== undefined && purchaseOrderId !== null)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnclassifyInboundEmail(_response);
        });
    }

    protected processUnclassifyInboundEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    canReprocessEmail(inboundEmailId: number | undefined, purchaseOrderId: number | null | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/AutoPo/CanReprocessEmail?";
        if (inboundEmailId === null)
            throw new Error("The parameter 'inboundEmailId' cannot be null.");
        else if (inboundEmailId !== undefined)
            url_ += "inboundEmailId=" + encodeURIComponent("" + inboundEmailId) + "&";
        if (purchaseOrderId !== undefined && purchaseOrderId !== null)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCanReprocessEmail(_response);
        });
    }

    protected processCanReprocessEmail(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getInboundEmailSellerGuidIds(signal?: AbortSignal | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/AutoPo/GetInboundEmailSellerGuidIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInboundEmailSellerGuidIds(_response);
        });
    }

    protected processGetInboundEmailSellerGuidIds(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getSellerAccountCountryRestrictions(signal?: AbortSignal | undefined): Promise<AutoPoSellerAccountCountryRestriction[]> {
        let url_ = this.baseUrl + "/api/AutoPo/GetSellerAccountCountryRestrictions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerAccountCountryRestrictions(_response);
        });
    }

    protected processGetSellerAccountCountryRestrictions(response: Response): Promise<AutoPoSellerAccountCountryRestriction[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoPoSellerAccountCountryRestriction[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoPoSellerAccountCountryRestriction[]>(null as any);
    }

    getSellerAccountVendorRestrictions(signal?: AbortSignal | undefined): Promise<AutoPoSellerAccountVendorRestriction[]> {
        let url_ = this.baseUrl + "/api/AutoPo/GetSellerAccountVendorRestrictions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerAccountVendorRestrictions(_response);
        });
    }

    protected processGetSellerAccountVendorRestrictions(response: Response): Promise<AutoPoSellerAccountVendorRestriction[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoPoSellerAccountVendorRestriction[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoPoSellerAccountVendorRestriction[]>(null as any);
    }

    upsertSellerAccountCountryRestrictions(countryRestrictions: AutoPoSellerAccountCountryRestriction[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/AutoPo/UpsertSellerAccountCountryRestrictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(countryRestrictions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertSellerAccountCountryRestrictions(_response);
        });
    }

    protected processUpsertSellerAccountCountryRestrictions(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    upsertSellerAccountVendorRestrictions(vendorRestrictions: AutoPoSellerAccountVendorRestriction[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/AutoPo/UpsertSellerAccountVendorRestrictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vendorRestrictions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertSellerAccountVendorRestrictions(_response);
        });
    }

    protected processUpsertSellerAccountVendorRestrictions(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IBulkEditListingClient {

    cancelBackgroundTask(updateKey: string | undefined): Promise<boolean>;

    bulkUpdateListingsPricesPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateListingsPricesByPercent(preview: BulkEditPreview, percent: number | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, adjustmentType: ListingPriceAdjustmentType | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateListingsPrices(preview: BulkEditPreview, priceChange: number | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, adjustmentType: ListingPriceAdjustmentType | null | undefined): Promise<BulkEditProgress>;

    bulkUpdatePriceFloorCeilingPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdatePriceFloor(preview: BulkEditPreview, amount: number | undefined, updateKey: string | undefined, isRelative: boolean | undefined, adjustmentType: PricingFloorCeilingAdjustmentType | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdatePriceCeiling(preview: BulkEditPreview, percentMarketPrice: number | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUngroupListingsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUngroupListings(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkRemovePredeliveryPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkRemovePredelivery(preview: BulkEditPreview, removeBarcodes: boolean | undefined, removePdfs: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateMarketplaceSeatingOverridesPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateMarketplaceSeatingOverrides(input: ValueTupleOfBulkEditPreviewAndListingDetailsUpdateInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<boolean>;

    bulkChangeEventPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkChangeEvent(preview: BulkEditPreview, posEventId: string | undefined, viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined, deallocateSales: boolean | null | undefined, reason: string | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateAutoPricingSettingsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateAutoPricingSettings(input: ValueTupleOfBulkEditPreviewAndListingDetailsUpdateInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateAutoPricingSettingsV2(input: ValueTupleOfBulkEditPreviewAndListingDetailsAutoPricingSectionUpdatesV2, viagogoEventId: number | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkGetListingPriceCalculationsInEvent(viagogoEventId: number | undefined, body: ValueTupleOfInt64OfAndListingPriceCalculationsInEventInput): Promise<BulkListingPriceCalculationResult>;

    bulkUpdateGeneralSettingsPreview(query: ListingQuery, hasPurchaseUpdates: boolean | undefined): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateGeneralSettings(input: ValueTupleOfBulkEditPreviewAndListingDetailsUpdateInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateMarketplacePrices(input: ValueTupleOfBulkEditPreviewAndListingPricesUpdateInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateMarketplacePricesPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkBroadcastListingsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkBroadcastListings(input: ValueTupleOfBulkEditPreviewAndISetOfMarketplaceAndISetOfMarketplace, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateAdminHoldPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateAdminHold(preview: BulkEditPreview, adminHoldExpirationDate: string | null | undefined, adminHoldNotes: string | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateTicketTypeRulesPreview(query: ListingQuery, updateSalesOfListings: boolean | undefined): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateTicketTypeRules(input: ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, updateSalesOfListings: boolean | undefined): Promise<BulkEditProgress>;

    bulkUpdateTagsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateTags(preview: BulkEditPreview, tagName: string | undefined, tagValue: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkRemoveTags(preview: BulkEditPreview, tagName: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkCreateListingGroups(input: MergeListingGroupInputList, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    /**
     * Group events by  event id
     * @param updateKey (optional) 
     * @param supportBackgroundProgress (optional) 
     */
    bulkAutoCompAndGroupListingsV2(input: AutoGroupListingV2Input, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdatePurchaseCommissionsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdatePurchaseCommissions(input: ValueTupleOfBulkEditPreviewAndIListOfCommission, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkDeleteSeatSaversPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkDeleteSeatSavers(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateInternalNotesPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateInternalNotes(preview: BulkEditPreview, updateKey: string | undefined, isUpdate: boolean | undefined, searchString: string | null | undefined, replaceString: string | null | undefined, appendString: string | null | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateIsNoFulfillPreview(query: ListingQuery, updateSalesOfListings: boolean | undefined): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateIsNoFulfill(preview: BulkEditPreview, updateKey: string | undefined, isNoFulfill: boolean | undefined, updateSalesOfListings: boolean | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateDeliveryTypePreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateDeliveryType(input: ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateSeatTraitsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateSeatTraits(input: ValueTupleOfBulkEditPreviewAndIListOfListingNote, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, appendSeatTraits: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkWasteTicketsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkWasteTickets(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkResetMergedListingsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkResetMergedListings(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateBarcodesPreview(query: ListingQuery): Promise<{ [key: string]: TicketBarcodeResponse[]; }>;

    bulkUpdateBarcodes(allBarcodes: { [key: string]: TicketBarcode[]; }, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkMergeSelectedListingsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkMergeSelectedListings(preview: BulkEditPreview, excludeHeldListings: boolean | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkReturnTicketPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkReturnTicket(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    importSeatSaversFromFile(updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, file: FileParameter | null | undefined): Promise<ImportFileResult>;

    bulkSplitSelectedListingsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkSplitSelectedListings(input: ValueTupleOfBulkEditPreviewAndIDictionaryOfLongAndListOfInteger, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;
}

export class BulkEditListingClient extends PosClientBase implements IBulkEditListingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    cancelBackgroundTask(updateKey: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/BulkEditListing/CancelBackgroundTask?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelBackgroundTask(_response);
        });
    }

    protected processCancelBackgroundTask(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    bulkUpdateListingsPricesPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateListingsPricesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateListingsPricesPreview(_response);
        });
    }

    protected processBulkUpdateListingsPricesPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateListingsPricesByPercent(preview: BulkEditPreview, percent: number | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, adjustmentType: ListingPriceAdjustmentType | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateListingsPricesByPercent?";
        if (percent === null)
            throw new Error("The parameter 'percent' cannot be null.");
        else if (percent !== undefined)
            url_ += "percent=" + encodeURIComponent("" + percent) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        if (adjustmentType !== undefined && adjustmentType !== null)
            url_ += "adjustmentType=" + encodeURIComponent("" + adjustmentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateListingsPricesByPercent(_response);
        });
    }

    protected processBulkUpdateListingsPricesByPercent(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateListingsPrices(preview: BulkEditPreview, priceChange: number | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, adjustmentType: ListingPriceAdjustmentType | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateListingsPrices?";
        if (priceChange === null)
            throw new Error("The parameter 'priceChange' cannot be null.");
        else if (priceChange !== undefined)
            url_ += "priceChange=" + encodeURIComponent("" + priceChange) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        if (adjustmentType !== undefined && adjustmentType !== null)
            url_ += "adjustmentType=" + encodeURIComponent("" + adjustmentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateListingsPrices(_response);
        });
    }

    protected processBulkUpdateListingsPrices(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdatePriceFloorCeilingPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdatePriceFloorCeilingPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePriceFloorCeilingPreview(_response);
        });
    }

    protected processBulkUpdatePriceFloorCeilingPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdatePriceFloor(preview: BulkEditPreview, amount: number | undefined, updateKey: string | undefined, isRelative: boolean | undefined, adjustmentType: PricingFloorCeilingAdjustmentType | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdatePriceFloor?";
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (isRelative === null)
            throw new Error("The parameter 'isRelative' cannot be null.");
        else if (isRelative !== undefined)
            url_ += "isRelative=" + encodeURIComponent("" + isRelative) + "&";
        if (adjustmentType === null)
            throw new Error("The parameter 'adjustmentType' cannot be null.");
        else if (adjustmentType !== undefined)
            url_ += "adjustmentType=" + encodeURIComponent("" + adjustmentType) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePriceFloor(_response);
        });
    }

    protected processBulkUpdatePriceFloor(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdatePriceCeiling(preview: BulkEditPreview, percentMarketPrice: number | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdatePriceCeiling?";
        if (percentMarketPrice === null)
            throw new Error("The parameter 'percentMarketPrice' cannot be null.");
        else if (percentMarketPrice !== undefined)
            url_ += "percentMarketPrice=" + encodeURIComponent("" + percentMarketPrice) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePriceCeiling(_response);
        });
    }

    protected processBulkUpdatePriceCeiling(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUngroupListingsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUngroupListingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUngroupListingsPreview(_response);
        });
    }

    protected processBulkUngroupListingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUngroupListings(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUngroupListings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUngroupListings(_response);
        });
    }

    protected processBulkUngroupListings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkRemovePredeliveryPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkRemovePredeliveryPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkRemovePredeliveryPreview(_response);
        });
    }

    protected processBulkRemovePredeliveryPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkRemovePredelivery(preview: BulkEditPreview, removeBarcodes: boolean | undefined, removePdfs: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkRemovePredelivery?";
        if (removeBarcodes === null)
            throw new Error("The parameter 'removeBarcodes' cannot be null.");
        else if (removeBarcodes !== undefined)
            url_ += "removeBarcodes=" + encodeURIComponent("" + removeBarcodes) + "&";
        if (removePdfs === null)
            throw new Error("The parameter 'removePdfs' cannot be null.");
        else if (removePdfs !== undefined)
            url_ += "removePdfs=" + encodeURIComponent("" + removePdfs) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkRemovePredelivery(_response);
        });
    }

    protected processBulkRemovePredelivery(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateMarketplaceSeatingOverridesPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateMarketplaceSeatingOverridesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateMarketplaceSeatingOverridesPreview(_response);
        });
    }

    protected processBulkUpdateMarketplaceSeatingOverridesPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateMarketplaceSeatingOverrides(input: ValueTupleOfBulkEditPreviewAndListingDetailsUpdateInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateMarketplaceSeatingOverrides?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateMarketplaceSeatingOverrides(_response);
        });
    }

    protected processBulkUpdateMarketplaceSeatingOverrides(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    bulkChangeEventPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkChangeEventPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkChangeEventPreview(_response);
        });
    }

    protected processBulkChangeEventPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkChangeEvent(preview: BulkEditPreview, posEventId: string | undefined, viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined, deallocateSales: boolean | null | undefined, reason: string | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkChangeEvent?";
        if (posEventId === null)
            throw new Error("The parameter 'posEventId' cannot be null.");
        else if (posEventId !== undefined)
            url_ += "posEventId=" + encodeURIComponent("" + posEventId) + "&";
        if (viagogoEventId !== undefined && viagogoEventId !== null)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (eventMappingId !== undefined && eventMappingId !== null)
            url_ += "eventMappingId=" + encodeURIComponent("" + eventMappingId) + "&";
        if (deallocateSales !== undefined && deallocateSales !== null)
            url_ += "deallocateSales=" + encodeURIComponent("" + deallocateSales) + "&";
        if (reason !== undefined && reason !== null)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkChangeEvent(_response);
        });
    }

    protected processBulkChangeEvent(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateAutoPricingSettingsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateAutoPricingSettingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateAutoPricingSettingsPreview(_response);
        });
    }

    protected processBulkUpdateAutoPricingSettingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateAutoPricingSettings(input: ValueTupleOfBulkEditPreviewAndListingDetailsUpdateInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateAutoPricingSettings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateAutoPricingSettings(_response);
        });
    }

    protected processBulkUpdateAutoPricingSettings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateAutoPricingSettingsV2(input: ValueTupleOfBulkEditPreviewAndListingDetailsAutoPricingSectionUpdatesV2, viagogoEventId: number | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateAutoPricingSettingsV2?";
        if (viagogoEventId !== undefined && viagogoEventId !== null)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateAutoPricingSettingsV2(_response);
        });
    }

    protected processBulkUpdateAutoPricingSettingsV2(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkGetListingPriceCalculationsInEvent(viagogoEventId: number | undefined, body: ValueTupleOfInt64OfAndListingPriceCalculationsInEventInput, signal?: AbortSignal | undefined): Promise<BulkListingPriceCalculationResult> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkGetListingPriceCalculationsInEvent?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkGetListingPriceCalculationsInEvent(_response);
        });
    }

    protected processBulkGetListingPriceCalculationsInEvent(response: Response): Promise<BulkListingPriceCalculationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkListingPriceCalculationResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkListingPriceCalculationResult>(null as any);
    }

    bulkUpdateGeneralSettingsPreview(query: ListingQuery, hasPurchaseUpdates: boolean | undefined, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateGeneralSettingsPreview?";
        if (hasPurchaseUpdates === null)
            throw new Error("The parameter 'hasPurchaseUpdates' cannot be null.");
        else if (hasPurchaseUpdates !== undefined)
            url_ += "hasPurchaseUpdates=" + encodeURIComponent("" + hasPurchaseUpdates) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateGeneralSettingsPreview(_response);
        });
    }

    protected processBulkUpdateGeneralSettingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateGeneralSettings(input: ValueTupleOfBulkEditPreviewAndListingDetailsUpdateInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateGeneralSettings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateGeneralSettings(_response);
        });
    }

    protected processBulkUpdateGeneralSettings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateMarketplacePrices(input: ValueTupleOfBulkEditPreviewAndListingPricesUpdateInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateMarketplacePrices?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateMarketplacePrices(_response);
        });
    }

    protected processBulkUpdateMarketplacePrices(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateMarketplacePricesPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateMarketplacePricesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateMarketplacePricesPreview(_response);
        });
    }

    protected processBulkUpdateMarketplacePricesPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkBroadcastListingsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkBroadcastListingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkBroadcastListingsPreview(_response);
        });
    }

    protected processBulkBroadcastListingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkBroadcastListings(input: ValueTupleOfBulkEditPreviewAndISetOfMarketplaceAndISetOfMarketplace, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkBroadcastListings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkBroadcastListings(_response);
        });
    }

    protected processBulkBroadcastListings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateAdminHoldPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateAdminHoldPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateAdminHoldPreview(_response);
        });
    }

    protected processBulkUpdateAdminHoldPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateAdminHold(preview: BulkEditPreview, adminHoldExpirationDate: string | null | undefined, adminHoldNotes: string | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateAdminHold?";
        if (adminHoldExpirationDate !== undefined && adminHoldExpirationDate !== null)
            url_ += "adminHoldExpirationDate=" + encodeURIComponent("" + adminHoldExpirationDate) + "&";
        if (adminHoldNotes !== undefined && adminHoldNotes !== null)
            url_ += "adminHoldNotes=" + encodeURIComponent("" + adminHoldNotes) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateAdminHold(_response);
        });
    }

    protected processBulkUpdateAdminHold(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateTicketTypeRulesPreview(query: ListingQuery, updateSalesOfListings: boolean | undefined, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateTicketTypeRulesPreview?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateTicketTypeRulesPreview(_response);
        });
    }

    protected processBulkUpdateTicketTypeRulesPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateTicketTypeRules(input: ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, updateSalesOfListings: boolean | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateTicketTypeRules?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateTicketTypeRules(_response);
        });
    }

    protected processBulkUpdateTicketTypeRules(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateTagsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateTagsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateTagsPreview(_response);
        });
    }

    protected processBulkUpdateTagsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateTags(preview: BulkEditPreview, tagName: string | undefined, tagValue: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateTags?";
        if (tagName === null)
            throw new Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        if (tagValue === null)
            throw new Error("The parameter 'tagValue' cannot be null.");
        else if (tagValue !== undefined)
            url_ += "tagValue=" + encodeURIComponent("" + tagValue) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateTags(_response);
        });
    }

    protected processBulkUpdateTags(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkRemoveTags(preview: BulkEditPreview, tagName: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkRemoveTags?";
        if (tagName === null)
            throw new Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkRemoveTags(_response);
        });
    }

    protected processBulkRemoveTags(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkCreateListingGroups(input: MergeListingGroupInputList, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkCreateListingGroups?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkCreateListingGroups(_response);
        });
    }

    protected processBulkCreateListingGroups(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    /**
     * Group events by  event id
     * @param updateKey (optional) 
     * @param supportBackgroundProgress (optional) 
     */
    bulkAutoCompAndGroupListingsV2(input: AutoGroupListingV2Input, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkAutoCompAndGroupListingsV2?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAutoCompAndGroupListingsV2(_response);
        });
    }

    protected processBulkAutoCompAndGroupListingsV2(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdatePurchaseCommissionsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdatePurchaseCommissionsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePurchaseCommissionsPreview(_response);
        });
    }

    protected processBulkUpdatePurchaseCommissionsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdatePurchaseCommissions(input: ValueTupleOfBulkEditPreviewAndIListOfCommission, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdatePurchaseCommissions?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePurchaseCommissions(_response);
        });
    }

    protected processBulkUpdatePurchaseCommissions(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkDeleteSeatSaversPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkDeleteSeatSaversPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeleteSeatSaversPreview(_response);
        });
    }

    protected processBulkDeleteSeatSaversPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkDeleteSeatSavers(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkDeleteSeatSavers?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeleteSeatSavers(_response);
        });
    }

    protected processBulkDeleteSeatSavers(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateInternalNotesPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateInternalNotesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateInternalNotesPreview(_response);
        });
    }

    protected processBulkUpdateInternalNotesPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateInternalNotes(preview: BulkEditPreview, updateKey: string | undefined, isUpdate: boolean | undefined, searchString: string | null | undefined, replaceString: string | null | undefined, appendString: string | null | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateInternalNotes?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (isUpdate === null)
            throw new Error("The parameter 'isUpdate' cannot be null.");
        else if (isUpdate !== undefined)
            url_ += "isUpdate=" + encodeURIComponent("" + isUpdate) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        if (replaceString !== undefined && replaceString !== null)
            url_ += "replaceString=" + encodeURIComponent("" + replaceString) + "&";
        if (appendString !== undefined && appendString !== null)
            url_ += "appendString=" + encodeURIComponent("" + appendString) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateInternalNotes(_response);
        });
    }

    protected processBulkUpdateInternalNotes(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateIsNoFulfillPreview(query: ListingQuery, updateSalesOfListings: boolean | undefined, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateIsNoFulfillPreview?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateIsNoFulfillPreview(_response);
        });
    }

    protected processBulkUpdateIsNoFulfillPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateIsNoFulfill(preview: BulkEditPreview, updateKey: string | undefined, isNoFulfill: boolean | undefined, updateSalesOfListings: boolean | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateIsNoFulfill?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (isNoFulfill === null)
            throw new Error("The parameter 'isNoFulfill' cannot be null.");
        else if (isNoFulfill !== undefined)
            url_ += "isNoFulfill=" + encodeURIComponent("" + isNoFulfill) + "&";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateIsNoFulfill(_response);
        });
    }

    protected processBulkUpdateIsNoFulfill(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateDeliveryTypePreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateDeliveryTypePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateDeliveryTypePreview(_response);
        });
    }

    protected processBulkUpdateDeliveryTypePreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateDeliveryType(input: ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateDeliveryType?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateDeliveryType(_response);
        });
    }

    protected processBulkUpdateDeliveryType(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateSeatTraitsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateSeatTraitsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateSeatTraitsPreview(_response);
        });
    }

    protected processBulkUpdateSeatTraitsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateSeatTraits(input: ValueTupleOfBulkEditPreviewAndIListOfListingNote, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, appendSeatTraits: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateSeatTraits?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        if (appendSeatTraits !== undefined && appendSeatTraits !== null)
            url_ += "appendSeatTraits=" + encodeURIComponent("" + appendSeatTraits) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateSeatTraits(_response);
        });
    }

    protected processBulkUpdateSeatTraits(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkWasteTicketsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkWasteTicketsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkWasteTicketsPreview(_response);
        });
    }

    protected processBulkWasteTicketsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkWasteTickets(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkWasteTickets?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkWasteTickets(_response);
        });
    }

    protected processBulkWasteTickets(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkResetMergedListingsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkResetMergedListingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkResetMergedListingsPreview(_response);
        });
    }

    protected processBulkResetMergedListingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkResetMergedListings(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkResetMergedListings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkResetMergedListings(_response);
        });
    }

    protected processBulkResetMergedListings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateBarcodesPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<{ [key: string]: TicketBarcodeResponse[]; }> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateBarcodesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateBarcodesPreview(_response);
        });
    }

    protected processBulkUpdateBarcodesPreview(response: Response): Promise<{ [key: string]: TicketBarcodeResponse[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: TicketBarcodeResponse[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: TicketBarcodeResponse[]; }>(null as any);
    }

    bulkUpdateBarcodes(allBarcodes: { [key: string]: TicketBarcode[]; }, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkUpdateBarcodes?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(allBarcodes);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateBarcodes(_response);
        });
    }

    protected processBulkUpdateBarcodes(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkMergeSelectedListingsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkMergeSelectedListingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkMergeSelectedListingsPreview(_response);
        });
    }

    protected processBulkMergeSelectedListingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkMergeSelectedListings(preview: BulkEditPreview, excludeHeldListings: boolean | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkMergeSelectedListings?";
        if (excludeHeldListings !== undefined && excludeHeldListings !== null)
            url_ += "excludeHeldListings=" + encodeURIComponent("" + excludeHeldListings) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkMergeSelectedListings(_response);
        });
    }

    protected processBulkMergeSelectedListings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkReturnTicketPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkReturnTicketPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkReturnTicketPreview(_response);
        });
    }

    protected processBulkReturnTicketPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkReturnTicket(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkReturnTicket?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkReturnTicket(_response);
        });
    }

    protected processBulkReturnTicket(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    importSeatSaversFromFile(updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, file: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<ImportFileResult> {
        let url_ = this.baseUrl + "/api/BulkEditListing/ImportSeatSaversFromFile?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportSeatSaversFromFile(_response);
        });
    }

    protected processImportSeatSaversFromFile(response: Response): Promise<ImportFileResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportFileResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportFileResult>(null as any);
    }

    bulkSplitSelectedListingsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkSplitSelectedListingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkSplitSelectedListingsPreview(_response);
        });
    }

    protected processBulkSplitSelectedListingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkSplitSelectedListings(input: ValueTupleOfBulkEditPreviewAndIDictionaryOfLongAndListOfInteger, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListing/BulkSplitSelectedListings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkSplitSelectedListings(_response);
        });
    }

    protected processBulkSplitSelectedListings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }
}

export interface IBulkEditListingGroupClient {

    cancelBackgroundTask(updateKey: string | undefined): Promise<boolean>;

    bulkEditListingsGroupSettingsPreview(query: ListingQuery): Promise<BulkEditPreviewWithDetails>;

    bulkEditListingGroupSettings(input: BulkEditListingGroupSettingsInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;
}

export class BulkEditListingGroupClient extends PosClientBase implements IBulkEditListingGroupClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    cancelBackgroundTask(updateKey: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/BulkEditListingGroup/CancelBackgroundTask?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelBackgroundTask(_response);
        });
    }

    protected processCancelBackgroundTask(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    bulkEditListingsGroupSettingsPreview(query: ListingQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditListingGroup/BulkEditListingsGroupSettingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkEditListingsGroupSettingsPreview(_response);
        });
    }

    protected processBulkEditListingsGroupSettingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkEditListingGroupSettings(input: BulkEditListingGroupSettingsInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditListingGroup/BulkEditListingGroupSettings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkEditListingGroupSettings(_response);
        });
    }

    protected processBulkEditListingGroupSettings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }
}

export interface IBulkEditLogClient {

    getBulkEditLogByFilter(query: BulkEditLogQuery): Promise<BulkEditLog[]>;

    getBulkEditLogPayload(entityType: ActionOutboxEntityType | undefined, bulkActionType: BulkActionType | undefined, bulkProcessingId: string | undefined): Promise<BulkEditLogPayload>;
}

export class BulkEditLogClient extends PosClientBase implements IBulkEditLogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getBulkEditLogByFilter(query: BulkEditLogQuery, signal?: AbortSignal | undefined): Promise<BulkEditLog[]> {
        let url_ = this.baseUrl + "/api/BulkEditLog/GetBulkEditLogByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBulkEditLogByFilter(_response);
        });
    }

    protected processGetBulkEditLogByFilter(response: Response): Promise<BulkEditLog[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditLog[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditLog[]>(null as any);
    }

    getBulkEditLogPayload(entityType: ActionOutboxEntityType | undefined, bulkActionType: BulkActionType | undefined, bulkProcessingId: string | undefined, signal?: AbortSignal | undefined): Promise<BulkEditLogPayload> {
        let url_ = this.baseUrl + "/api/BulkEditLog/GetBulkEditLogPayload?";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        if (bulkActionType === null)
            throw new Error("The parameter 'bulkActionType' cannot be null.");
        else if (bulkActionType !== undefined)
            url_ += "bulkActionType=" + encodeURIComponent("" + bulkActionType) + "&";
        if (bulkProcessingId === null)
            throw new Error("The parameter 'bulkProcessingId' cannot be null.");
        else if (bulkProcessingId !== undefined)
            url_ += "bulkProcessingId=" + encodeURIComponent("" + bulkProcessingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBulkEditLogPayload(_response);
        });
    }

    protected processGetBulkEditLogPayload(response: Response): Promise<BulkEditLogPayload> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditLogPayload;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditLogPayload>(null as any);
    }
}

export interface IBulkEditPurchaseClient {

    cancelBackgroundTask(updateKey: string | undefined): Promise<boolean>;

    bulkUpdateGeneralSettingsPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateGeneralSettings(input: ValueTupleOfBulkEditPreviewAndPosFieldOfNullableGuid, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateCurrencyCodePreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateCurrencyCode(input: ValueTupleOfBulkEditPreviewAndString, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkDeletePurchaseOrderPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkVoidPurchaseOrder(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkCancelPurchaseOrder(input: ValueTupleOfBulkEditPreviewAndNullableSaleCancellationReason, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, rejectSale: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdatePurchaseCommissionsPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdatePurchaseCommissions(input: ValueTupleOfBulkEditPreviewAndIListOfCommission, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateTagsPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateTags(preview: BulkEditPreview, tagName: string | undefined, tagValue: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkRemoveTags(preview: BulkEditPreview, tagName: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateInternalNotesPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateInternalNotes(preview: BulkEditPreview, updateKey: string | undefined, isUpdate: boolean | undefined, searchString: string | null | undefined, replaceString: string | null | undefined, appendString: string | null | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkConvertPurchasePaymentPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkConvertPurchasePayment(preview: BulkEditPreview, updateKey: string | undefined, fromCurrencyCode: string | undefined, toCurrencyCode: string | undefined, conversionRate: number | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateDeliveryTypePreview(query: PurchaseOrderQuery, updateSalesOfListings: boolean | undefined): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateDeliveryType(input: ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority, updateSalesOfListings: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkBackfillDeliverySettingsPreview(query: PurchaseOrderQuery, updateSalesOfListings: boolean | undefined, applyToAllEvents: boolean | undefined): Promise<BulkEditPreviewWithDetails>;

    bulkBackfillDeliverySettings(preview: BulkEditPreview, updateSalesOfListings: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkBackfillDeliverySettingsListingOnly(preview: BulkEditPreview, updateSalesOfListings: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateSeatTraitsPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateSeatTraits(input: ValueTupleOfBulkEditPreviewAndIListOfListingNote, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, appendSeatTraits: boolean | null | undefined): Promise<BulkEditProgress>;

    importPurchaseFromFile(updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, file: FileParameter | null | undefined): Promise<ImportFileResult>;

    bulkMarkPurchaseAsPaidPreview(input: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkMarkPurchaseAsPaid(input: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkAdjustCostPreview(input: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkAdjustCost(input: BulkEditPreview, changeMode: BulkChangePriceMode | undefined, targetField: BulkAdjustCostField | undefined, percent: number | null | undefined, absoluteAmount: number | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;
}

export class BulkEditPurchaseClient extends PosClientBase implements IBulkEditPurchaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    cancelBackgroundTask(updateKey: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/CancelBackgroundTask?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelBackgroundTask(_response);
        });
    }

    protected processCancelBackgroundTask(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    bulkUpdateGeneralSettingsPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateGeneralSettingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateGeneralSettingsPreview(_response);
        });
    }

    protected processBulkUpdateGeneralSettingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateGeneralSettings(input: ValueTupleOfBulkEditPreviewAndPosFieldOfNullableGuid, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateGeneralSettings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateGeneralSettings(_response);
        });
    }

    protected processBulkUpdateGeneralSettings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateCurrencyCodePreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateCurrencyCodePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateCurrencyCodePreview(_response);
        });
    }

    protected processBulkUpdateCurrencyCodePreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateCurrencyCode(input: ValueTupleOfBulkEditPreviewAndString, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateCurrencyCode?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateCurrencyCode(_response);
        });
    }

    protected processBulkUpdateCurrencyCode(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkDeletePurchaseOrderPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkDeletePurchaseOrderPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeletePurchaseOrderPreview(_response);
        });
    }

    protected processBulkDeletePurchaseOrderPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkVoidPurchaseOrder(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkVoidPurchaseOrder?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkVoidPurchaseOrder(_response);
        });
    }

    protected processBulkVoidPurchaseOrder(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkCancelPurchaseOrder(input: ValueTupleOfBulkEditPreviewAndNullableSaleCancellationReason, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, rejectSale: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkCancelPurchaseOrder?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        if (rejectSale !== undefined && rejectSale !== null)
            url_ += "rejectSale=" + encodeURIComponent("" + rejectSale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkCancelPurchaseOrder(_response);
        });
    }

    protected processBulkCancelPurchaseOrder(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdatePurchaseCommissionsPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdatePurchaseCommissionsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePurchaseCommissionsPreview(_response);
        });
    }

    protected processBulkUpdatePurchaseCommissionsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdatePurchaseCommissions(input: ValueTupleOfBulkEditPreviewAndIListOfCommission, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdatePurchaseCommissions?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePurchaseCommissions(_response);
        });
    }

    protected processBulkUpdatePurchaseCommissions(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateTagsPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateTagsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateTagsPreview(_response);
        });
    }

    protected processBulkUpdateTagsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateTags(preview: BulkEditPreview, tagName: string | undefined, tagValue: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateTags?";
        if (tagName === null)
            throw new Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        if (tagValue === null)
            throw new Error("The parameter 'tagValue' cannot be null.");
        else if (tagValue !== undefined)
            url_ += "tagValue=" + encodeURIComponent("" + tagValue) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateTags(_response);
        });
    }

    protected processBulkUpdateTags(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkRemoveTags(preview: BulkEditPreview, tagName: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkRemoveTags?";
        if (tagName === null)
            throw new Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkRemoveTags(_response);
        });
    }

    protected processBulkRemoveTags(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateInternalNotesPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateInternalNotesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateInternalNotesPreview(_response);
        });
    }

    protected processBulkUpdateInternalNotesPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateInternalNotes(preview: BulkEditPreview, updateKey: string | undefined, isUpdate: boolean | undefined, searchString: string | null | undefined, replaceString: string | null | undefined, appendString: string | null | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateInternalNotes?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (isUpdate === null)
            throw new Error("The parameter 'isUpdate' cannot be null.");
        else if (isUpdate !== undefined)
            url_ += "isUpdate=" + encodeURIComponent("" + isUpdate) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        if (replaceString !== undefined && replaceString !== null)
            url_ += "replaceString=" + encodeURIComponent("" + replaceString) + "&";
        if (appendString !== undefined && appendString !== null)
            url_ += "appendString=" + encodeURIComponent("" + appendString) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateInternalNotes(_response);
        });
    }

    protected processBulkUpdateInternalNotes(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkConvertPurchasePaymentPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkConvertPurchasePaymentPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkConvertPurchasePaymentPreview(_response);
        });
    }

    protected processBulkConvertPurchasePaymentPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkConvertPurchasePayment(preview: BulkEditPreview, updateKey: string | undefined, fromCurrencyCode: string | undefined, toCurrencyCode: string | undefined, conversionRate: number | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkConvertPurchasePayment?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (fromCurrencyCode === null)
            throw new Error("The parameter 'fromCurrencyCode' cannot be null.");
        else if (fromCurrencyCode !== undefined)
            url_ += "fromCurrencyCode=" + encodeURIComponent("" + fromCurrencyCode) + "&";
        if (toCurrencyCode === null)
            throw new Error("The parameter 'toCurrencyCode' cannot be null.");
        else if (toCurrencyCode !== undefined)
            url_ += "toCurrencyCode=" + encodeURIComponent("" + toCurrencyCode) + "&";
        if (conversionRate === null)
            throw new Error("The parameter 'conversionRate' cannot be null.");
        else if (conversionRate !== undefined)
            url_ += "conversionRate=" + encodeURIComponent("" + conversionRate) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkConvertPurchasePayment(_response);
        });
    }

    protected processBulkConvertPurchasePayment(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateDeliveryTypePreview(query: PurchaseOrderQuery, updateSalesOfListings: boolean | undefined, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateDeliveryTypePreview?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateDeliveryTypePreview(_response);
        });
    }

    protected processBulkUpdateDeliveryTypePreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateDeliveryType(input: ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority, updateSalesOfListings: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateDeliveryType?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateDeliveryType(_response);
        });
    }

    protected processBulkUpdateDeliveryType(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkBackfillDeliverySettingsPreview(query: PurchaseOrderQuery, updateSalesOfListings: boolean | undefined, applyToAllEvents: boolean | undefined, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkBackfillDeliverySettingsPreview?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        if (applyToAllEvents === null)
            throw new Error("The parameter 'applyToAllEvents' cannot be null.");
        else if (applyToAllEvents !== undefined)
            url_ += "applyToAllEvents=" + encodeURIComponent("" + applyToAllEvents) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkBackfillDeliverySettingsPreview(_response);
        });
    }

    protected processBulkBackfillDeliverySettingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkBackfillDeliverySettings(preview: BulkEditPreview, updateSalesOfListings: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkBackfillDeliverySettings?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkBackfillDeliverySettings(_response);
        });
    }

    protected processBulkBackfillDeliverySettings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkBackfillDeliverySettingsListingOnly(preview: BulkEditPreview, updateSalesOfListings: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkBackfillDeliverySettingsListingOnly?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkBackfillDeliverySettingsListingOnly(_response);
        });
    }

    protected processBulkBackfillDeliverySettingsListingOnly(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateSeatTraitsPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateSeatTraitsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateSeatTraitsPreview(_response);
        });
    }

    protected processBulkUpdateSeatTraitsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateSeatTraits(input: ValueTupleOfBulkEditPreviewAndIListOfListingNote, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, appendSeatTraits: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkUpdateSeatTraits?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        if (appendSeatTraits !== undefined && appendSeatTraits !== null)
            url_ += "appendSeatTraits=" + encodeURIComponent("" + appendSeatTraits) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateSeatTraits(_response);
        });
    }

    protected processBulkUpdateSeatTraits(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    importPurchaseFromFile(updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, file: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<ImportFileResult> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/ImportPurchaseFromFile?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportPurchaseFromFile(_response);
        });
    }

    protected processImportPurchaseFromFile(response: Response): Promise<ImportFileResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportFileResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportFileResult>(null as any);
    }

    bulkMarkPurchaseAsPaidPreview(input: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkMarkPurchaseAsPaidPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkMarkPurchaseAsPaidPreview(_response);
        });
    }

    protected processBulkMarkPurchaseAsPaidPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkMarkPurchaseAsPaid(input: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkMarkPurchaseAsPaid?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkMarkPurchaseAsPaid(_response);
        });
    }

    protected processBulkMarkPurchaseAsPaid(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkAdjustCostPreview(input: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkAdjustCostPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAdjustCostPreview(_response);
        });
    }

    protected processBulkAdjustCostPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkAdjustCost(input: BulkEditPreview, changeMode: BulkChangePriceMode | undefined, targetField: BulkAdjustCostField | undefined, percent: number | null | undefined, absoluteAmount: number | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditPurchase/BulkAdjustCost?";
        if (changeMode === null)
            throw new Error("The parameter 'changeMode' cannot be null.");
        else if (changeMode !== undefined)
            url_ += "changeMode=" + encodeURIComponent("" + changeMode) + "&";
        if (targetField === null)
            throw new Error("The parameter 'targetField' cannot be null.");
        else if (targetField !== undefined)
            url_ += "targetField=" + encodeURIComponent("" + targetField) + "&";
        if (percent !== undefined && percent !== null)
            url_ += "percent=" + encodeURIComponent("" + percent) + "&";
        if (absoluteAmount !== undefined && absoluteAmount !== null)
            url_ += "absoluteAmount=" + encodeURIComponent("" + absoluteAmount) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAdjustCost(_response);
        });
    }

    protected processBulkAdjustCost(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }
}

export interface IBulkEditSaleClient {

    cancelBackgroundTask(updateKey: string | undefined): Promise<boolean>;

    bulkUpdateGeneralSettingsPreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateGeneralSettings(input: ValueTupleOfBulkEditPreviewAndSaleInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdatePurchaseCommissionsPreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdatePurchaseCommissions(input: ValueTupleOfBulkEditPreviewAndIListOfCommission, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdatePaymentFieldsPreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdatePaymentFields(preview: BulkEditPreview, paymentReceived: boolean | null | undefined, paymentReferenceId: string | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateTagsPreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateTags(preview: BulkEditPreview, tagName: string | undefined, tagValue: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkRemoveTags(preview: BulkEditPreview, tagName: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateInternalNotesPreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateInternalNotes(preview: BulkEditPreview, updateKey: string | undefined, isUpdate: boolean | undefined, searchString: string | null | undefined, replaceString: string | null | undefined, appendString: string | null | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateIsNoFulfillPreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateIsNoFulfill(preview: BulkEditPreview, updateKey: string | undefined, isNoFulfill: boolean | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateMarkAsFulfilledPreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateMarkAsFulfilled(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkMarkSaleAsPaidPreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkMarkSaleAsPaid(preview: BulkEditPreview, paymentRefId: string | undefined, paymentDate: string | undefined, marketplace: Marketplace | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkDeallocateCancelSalePreview(query: SaleQuery): Promise<BulkEditPreviewWithDetails>;

    bulkDeallocateCancelSale(input: ValueTupleOfBulkEditPreviewAndNullableSaleCancellationReason, deallocateOnly: boolean | undefined, removeArtifacts: boolean | null | undefined, adminHold: boolean | null | undefined, keepAllocatedTickets: boolean | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateBarcodesPreview(query: SaleQuery): Promise<{ [key: string]: TicketBarcodeResponse[]; }>;

    bulkUpdateBarcodes(allBarcodes: { [key: string]: TicketBarcode[]; }, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkBackfillSalesFulfillerPreview(query: SalesFulfillerBackfillQuery): Promise<BulkEditPreviewWithDetails>;

    bulkBackfillSalesFulfiller(input: ValueTupleOfBulkEditPreviewAndGuid, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;
}

export class BulkEditSaleClient extends PosClientBase implements IBulkEditSaleClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    cancelBackgroundTask(updateKey: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/BulkEditSale/CancelBackgroundTask?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelBackgroundTask(_response);
        });
    }

    protected processCancelBackgroundTask(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    bulkUpdateGeneralSettingsPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateGeneralSettingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateGeneralSettingsPreview(_response);
        });
    }

    protected processBulkUpdateGeneralSettingsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateGeneralSettings(input: ValueTupleOfBulkEditPreviewAndSaleInput, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateGeneralSettings?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateGeneralSettings(_response);
        });
    }

    protected processBulkUpdateGeneralSettings(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdatePurchaseCommissionsPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdatePurchaseCommissionsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePurchaseCommissionsPreview(_response);
        });
    }

    protected processBulkUpdatePurchaseCommissionsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdatePurchaseCommissions(input: ValueTupleOfBulkEditPreviewAndIListOfCommission, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdatePurchaseCommissions?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePurchaseCommissions(_response);
        });
    }

    protected processBulkUpdatePurchaseCommissions(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdatePaymentFieldsPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdatePaymentFieldsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePaymentFieldsPreview(_response);
        });
    }

    protected processBulkUpdatePaymentFieldsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdatePaymentFields(preview: BulkEditPreview, paymentReceived: boolean | null | undefined, paymentReferenceId: string | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdatePaymentFields?";
        if (paymentReceived !== undefined && paymentReceived !== null)
            url_ += "paymentReceived=" + encodeURIComponent("" + paymentReceived) + "&";
        if (paymentReferenceId !== undefined && paymentReferenceId !== null)
            url_ += "paymentReferenceId=" + encodeURIComponent("" + paymentReferenceId) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdatePaymentFields(_response);
        });
    }

    protected processBulkUpdatePaymentFields(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateTagsPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateTagsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateTagsPreview(_response);
        });
    }

    protected processBulkUpdateTagsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateTags(preview: BulkEditPreview, tagName: string | undefined, tagValue: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateTags?";
        if (tagName === null)
            throw new Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        if (tagValue === null)
            throw new Error("The parameter 'tagValue' cannot be null.");
        else if (tagValue !== undefined)
            url_ += "tagValue=" + encodeURIComponent("" + tagValue) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateTags(_response);
        });
    }

    protected processBulkUpdateTags(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkRemoveTags(preview: BulkEditPreview, tagName: string | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkRemoveTags?";
        if (tagName === null)
            throw new Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkRemoveTags(_response);
        });
    }

    protected processBulkRemoveTags(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateInternalNotesPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateInternalNotesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateInternalNotesPreview(_response);
        });
    }

    protected processBulkUpdateInternalNotesPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateInternalNotes(preview: BulkEditPreview, updateKey: string | undefined, isUpdate: boolean | undefined, searchString: string | null | undefined, replaceString: string | null | undefined, appendString: string | null | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateInternalNotes?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (isUpdate === null)
            throw new Error("The parameter 'isUpdate' cannot be null.");
        else if (isUpdate !== undefined)
            url_ += "isUpdate=" + encodeURIComponent("" + isUpdate) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        if (replaceString !== undefined && replaceString !== null)
            url_ += "replaceString=" + encodeURIComponent("" + replaceString) + "&";
        if (appendString !== undefined && appendString !== null)
            url_ += "appendString=" + encodeURIComponent("" + appendString) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateInternalNotes(_response);
        });
    }

    protected processBulkUpdateInternalNotes(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateIsNoFulfillPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateIsNoFulfillPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateIsNoFulfillPreview(_response);
        });
    }

    protected processBulkUpdateIsNoFulfillPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateIsNoFulfill(preview: BulkEditPreview, updateKey: string | undefined, isNoFulfill: boolean | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateIsNoFulfill?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (isNoFulfill === null)
            throw new Error("The parameter 'isNoFulfill' cannot be null.");
        else if (isNoFulfill !== undefined)
            url_ += "isNoFulfill=" + encodeURIComponent("" + isNoFulfill) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateIsNoFulfill(_response);
        });
    }

    protected processBulkUpdateIsNoFulfill(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateMarkAsFulfilledPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateMarkAsFulfilledPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateMarkAsFulfilledPreview(_response);
        });
    }

    protected processBulkUpdateMarkAsFulfilledPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateMarkAsFulfilled(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateMarkAsFulfilled?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateMarkAsFulfilled(_response);
        });
    }

    protected processBulkUpdateMarkAsFulfilled(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkMarkSaleAsPaidPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkMarkSaleAsPaidPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkMarkSaleAsPaidPreview(_response);
        });
    }

    protected processBulkMarkSaleAsPaidPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkMarkSaleAsPaid(preview: BulkEditPreview, paymentRefId: string | undefined, paymentDate: string | undefined, marketplace: Marketplace | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkMarkSaleAsPaid?";
        if (paymentRefId === null)
            throw new Error("The parameter 'paymentRefId' cannot be null.");
        else if (paymentRefId !== undefined)
            url_ += "paymentRefId=" + encodeURIComponent("" + paymentRefId) + "&";
        if (paymentDate === null)
            throw new Error("The parameter 'paymentDate' cannot be null.");
        else if (paymentDate !== undefined)
            url_ += "paymentDate=" + encodeURIComponent("" + paymentDate) + "&";
        if (marketplace === null)
            throw new Error("The parameter 'marketplace' cannot be null.");
        else if (marketplace !== undefined)
            url_ += "marketplace=" + encodeURIComponent("" + marketplace) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkMarkSaleAsPaid(_response);
        });
    }

    protected processBulkMarkSaleAsPaid(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkDeallocateCancelSalePreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkDeallocateCancelSalePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeallocateCancelSalePreview(_response);
        });
    }

    protected processBulkDeallocateCancelSalePreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkDeallocateCancelSale(input: ValueTupleOfBulkEditPreviewAndNullableSaleCancellationReason, deallocateOnly: boolean | undefined, removeArtifacts: boolean | null | undefined, adminHold: boolean | null | undefined, keepAllocatedTickets: boolean | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkDeallocateCancelSale?";
        if (deallocateOnly === null)
            throw new Error("The parameter 'deallocateOnly' cannot be null.");
        else if (deallocateOnly !== undefined)
            url_ += "deallocateOnly=" + encodeURIComponent("" + deallocateOnly) + "&";
        if (removeArtifacts !== undefined && removeArtifacts !== null)
            url_ += "removeArtifacts=" + encodeURIComponent("" + removeArtifacts) + "&";
        if (adminHold !== undefined && adminHold !== null)
            url_ += "adminHold=" + encodeURIComponent("" + adminHold) + "&";
        if (keepAllocatedTickets !== undefined && keepAllocatedTickets !== null)
            url_ += "keepAllocatedTickets=" + encodeURIComponent("" + keepAllocatedTickets) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeallocateCancelSale(_response);
        });
    }

    protected processBulkDeallocateCancelSale(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateBarcodesPreview(query: SaleQuery, signal?: AbortSignal | undefined): Promise<{ [key: string]: TicketBarcodeResponse[]; }> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateBarcodesPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateBarcodesPreview(_response);
        });
    }

    protected processBulkUpdateBarcodesPreview(response: Response): Promise<{ [key: string]: TicketBarcodeResponse[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: TicketBarcodeResponse[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: TicketBarcodeResponse[]; }>(null as any);
    }

    bulkUpdateBarcodes(allBarcodes: { [key: string]: TicketBarcode[]; }, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkUpdateBarcodes?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(allBarcodes);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateBarcodes(_response);
        });
    }

    protected processBulkUpdateBarcodes(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkBackfillSalesFulfillerPreview(query: SalesFulfillerBackfillQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkBackfillSalesFulfillerPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkBackfillSalesFulfillerPreview(_response);
        });
    }

    protected processBulkBackfillSalesFulfillerPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkBackfillSalesFulfiller(input: ValueTupleOfBulkEditPreviewAndGuid, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditSale/BulkBackfillSalesFulfiller?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkBackfillSalesFulfiller(_response);
        });
    }

    protected processBulkBackfillSalesFulfiller(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }
}

export interface IBulkEditTicketGroupClient {

    cancelBackgroundTask(updateKey: string | undefined): Promise<boolean>;

    bulkDeleteTicketGroupPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkDeleteTicketGroup(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateDeliveryTypePreview(query: PurchaseOrderQuery, updateSalesOfListings: boolean | undefined): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateDeliveryType(input: ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority, updateSalesOfListings: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkUpdateSeatTraitsPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkUpdateSeatTraits(input: ValueTupleOfBulkEditPreviewAndIListOfListingNote, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, appendSeatTraits: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkChangeEventPreview(query: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;

    bulkChangeEvent(preview: BulkEditPreview, posEventId: string | undefined, viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined, deallocateSales: boolean | null | undefined, reason: string | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined): Promise<BulkEditProgress>;

    bulkAdjustCostPreview(input: PurchaseOrderQuery): Promise<BulkEditPreviewWithDetails>;
}

export class BulkEditTicketGroupClient extends PosClientBase implements IBulkEditTicketGroupClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    cancelBackgroundTask(updateKey: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/CancelBackgroundTask?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelBackgroundTask(_response);
        });
    }

    protected processCancelBackgroundTask(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    bulkDeleteTicketGroupPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkDeleteTicketGroupPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeleteTicketGroupPreview(_response);
        });
    }

    protected processBulkDeleteTicketGroupPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkDeleteTicketGroup(preview: BulkEditPreview, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkDeleteTicketGroup?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkDeleteTicketGroup(_response);
        });
    }

    protected processBulkDeleteTicketGroup(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateDeliveryTypePreview(query: PurchaseOrderQuery, updateSalesOfListings: boolean | undefined, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkUpdateDeliveryTypePreview?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateDeliveryTypePreview(_response);
        });
    }

    protected processBulkUpdateDeliveryTypePreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateDeliveryType(input: ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority, updateSalesOfListings: boolean | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkUpdateDeliveryType?";
        if (updateSalesOfListings === null)
            throw new Error("The parameter 'updateSalesOfListings' cannot be null.");
        else if (updateSalesOfListings !== undefined)
            url_ += "updateSalesOfListings=" + encodeURIComponent("" + updateSalesOfListings) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateDeliveryType(_response);
        });
    }

    protected processBulkUpdateDeliveryType(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkUpdateSeatTraitsPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkUpdateSeatTraitsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateSeatTraitsPreview(_response);
        });
    }

    protected processBulkUpdateSeatTraitsPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkUpdateSeatTraits(input: ValueTupleOfBulkEditPreviewAndIListOfListingNote, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, appendSeatTraits: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkUpdateSeatTraits?";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        if (appendSeatTraits !== undefined && appendSeatTraits !== null)
            url_ += "appendSeatTraits=" + encodeURIComponent("" + appendSeatTraits) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkUpdateSeatTraits(_response);
        });
    }

    protected processBulkUpdateSeatTraits(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkChangeEventPreview(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkChangeEventPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkChangeEventPreview(_response);
        });
    }

    protected processBulkChangeEventPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }

    bulkChangeEvent(preview: BulkEditPreview, posEventId: string | undefined, viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined, deallocateSales: boolean | null | undefined, reason: string | null | undefined, updateKey: string | undefined, supportBackgroundProgress: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<BulkEditProgress> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkChangeEvent?";
        if (posEventId === null)
            throw new Error("The parameter 'posEventId' cannot be null.");
        else if (posEventId !== undefined)
            url_ += "posEventId=" + encodeURIComponent("" + posEventId) + "&";
        if (viagogoEventId !== undefined && viagogoEventId !== null)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (eventMappingId !== undefined && eventMappingId !== null)
            url_ += "eventMappingId=" + encodeURIComponent("" + eventMappingId) + "&";
        if (deallocateSales !== undefined && deallocateSales !== null)
            url_ += "deallocateSales=" + encodeURIComponent("" + deallocateSales) + "&";
        if (reason !== undefined && reason !== null)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        if (updateKey === null)
            throw new Error("The parameter 'updateKey' cannot be null.");
        else if (updateKey !== undefined)
            url_ += "updateKey=" + encodeURIComponent("" + updateKey) + "&";
        if (supportBackgroundProgress !== undefined && supportBackgroundProgress !== null)
            url_ += "supportBackgroundProgress=" + encodeURIComponent("" + supportBackgroundProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preview);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkChangeEvent(_response);
        });
    }

    protected processBulkChangeEvent(response: Response): Promise<BulkEditProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditProgress>(null as any);
    }

    bulkAdjustCostPreview(input: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<BulkEditPreviewWithDetails> {
        let url_ = this.baseUrl + "/api/BulkEditTicketGroup/BulkAdjustCostPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAdjustCostPreview(_response);
        });
    }

    protected processBulkAdjustCostPreview(response: Response): Promise<BulkEditPreviewWithDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkEditPreviewWithDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkEditPreviewWithDetails>(null as any);
    }
}

export interface ICampaignManagerClient {

    hasAnyCampaign(): Promise<boolean>;

    getEventsEnabledForSponsoredListings(): Promise<ValueTupleOfIListOfIntegerAndIListOfInteger>;

    mergeCampaign(campaignInput: SponsoredListingsCampaignInput): Promise<BaseClientResponse>;

    updateCampaignState(campaignId: number | undefined, state: AdCampaignState | undefined): Promise<UpdateCampaignStateClientResponse>;

    getCampaign(campaignId: number | undefined): Promise<SponsoredListingsCampaign>;

    getCampaigns(eventIds: number[], loadDetails: boolean | undefined): Promise<SponsoredListingsCampaign[]>;

    getBoostedSalesByEventIds(posEventIds: string[]): Promise<BoostedSale[]>;
}

export class CampaignManagerClient extends PosClientBase implements ICampaignManagerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    hasAnyCampaign(signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/CampaignManager/HasAnyCampaign";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasAnyCampaign(_response);
        });
    }

    protected processHasAnyCampaign(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getEventsEnabledForSponsoredListings(signal?: AbortSignal | undefined): Promise<ValueTupleOfIListOfIntegerAndIListOfInteger> {
        let url_ = this.baseUrl + "/api/CampaignManager/GetEventsEnabledForSponsoredListings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventsEnabledForSponsoredListings(_response);
        });
    }

    protected processGetEventsEnabledForSponsoredListings(response: Response): Promise<ValueTupleOfIListOfIntegerAndIListOfInteger> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValueTupleOfIListOfIntegerAndIListOfInteger;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValueTupleOfIListOfIntegerAndIListOfInteger>(null as any);
    }

    mergeCampaign(campaignInput: SponsoredListingsCampaignInput, signal?: AbortSignal | undefined): Promise<BaseClientResponse> {
        let url_ = this.baseUrl + "/api/CampaignManager/MergeCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(campaignInput);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeCampaign(_response);
        });
    }

    protected processMergeCampaign(response: Response): Promise<BaseClientResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseClientResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseClientResponse>(null as any);
    }

    updateCampaignState(campaignId: number | undefined, state: AdCampaignState | undefined, signal?: AbortSignal | undefined): Promise<UpdateCampaignStateClientResponse> {
        let url_ = this.baseUrl + "/api/CampaignManager/UpdateCampaignState?";
        if (campaignId === null)
            throw new Error("The parameter 'campaignId' cannot be null.");
        else if (campaignId !== undefined)
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCampaignState(_response);
        });
    }

    protected processUpdateCampaignState(response: Response): Promise<UpdateCampaignStateClientResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateCampaignStateClientResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateCampaignStateClientResponse>(null as any);
    }

    getCampaign(campaignId: number | undefined, signal?: AbortSignal | undefined): Promise<SponsoredListingsCampaign> {
        let url_ = this.baseUrl + "/api/CampaignManager/GetCampaign?";
        if (campaignId === null)
            throw new Error("The parameter 'campaignId' cannot be null.");
        else if (campaignId !== undefined)
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCampaign(_response);
        });
    }

    protected processGetCampaign(response: Response): Promise<SponsoredListingsCampaign> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SponsoredListingsCampaign;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SponsoredListingsCampaign>(null as any);
    }

    getCampaigns(eventIds: number[], loadDetails: boolean | undefined, signal?: AbortSignal | undefined): Promise<SponsoredListingsCampaign[]> {
        let url_ = this.baseUrl + "/api/CampaignManager/GetCampaigns?";
        if (loadDetails === null)
            throw new Error("The parameter 'loadDetails' cannot be null.");
        else if (loadDetails !== undefined)
            url_ += "loadDetails=" + encodeURIComponent("" + loadDetails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCampaigns(_response);
        });
    }

    protected processGetCampaigns(response: Response): Promise<SponsoredListingsCampaign[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SponsoredListingsCampaign[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SponsoredListingsCampaign[]>(null as any);
    }

    getBoostedSalesByEventIds(posEventIds: string[], signal?: AbortSignal | undefined): Promise<BoostedSale[]> {
        let url_ = this.baseUrl + "/api/CampaignManager/GetBoostedSalesByEventIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(posEventIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBoostedSalesByEventIds(_response);
        });
    }

    protected processGetBoostedSalesByEventIds(response: Response): Promise<BoostedSale[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BoostedSale[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoostedSale[]>(null as any);
    }
}

export interface ICatalogClient {

    getCatalogForSaleBySaleId(saleId: number): Promise<CatalogResults>;

    getCatalogBySaleIds(saleIds: number[]): Promise<CatalogResults>;

    /**
     * @param includeEventTags (optional) 
     * @deprecated
     */
    getCatalogSaleMetrics(query: SaleQuery, includeEventTags: boolean | null | undefined): Promise<CatalogSaleMetricsResults>;

    /**
     * @param includeEventTags (optional) 
     * @deprecated
     */
    getCatalogTicketGroupMetrics(query: PurchaseOrderQuery, includeEventTags: boolean | null | undefined): Promise<CatalogTicketGroupMetricsResults>;

    /**
     * Not currently used, but exist to create the types in React
     */
    getDefaultEventGroupingQuery(): Promise<EventGroupingQuery>;

    searchEvents(query: EventSearchQuery): Promise<CatalogResults>;

    searchVenues(query: string | undefined): Promise<Venue[]>;

    getSearchEventsAutoCompleteResult(searchText: string | undefined, maxCount: number | null | undefined, timeFrame: string | undefined): Promise<CatalogResults>;

    getCatalogForListingByListingId(listingId: number): Promise<CatalogResults>;

    /**
     * @param includeEventTags (optional) 
     * @deprecated
     */
    getCatalogListingMetrics(query: ListingQuery, includeEventTags: boolean | null | undefined): Promise<CatalogListingMetricsResults>;

    /**
     * @deprecated
     */
    getEventDetailedListingMetrics(query: ListingQuery): Promise<CatalogListingMetricsResults>;

    getSummaryMetricsForListings(allMetrics: ListingMetricsInput[]): Promise<ListingMetrics>;

    getCatalogHomeMetrics(): Promise<ListingMetrics>;

    requestEventMapping(request: EventMappingRequest): Promise<ValueTupleOfEventAndVenueAndPerformer>;

    getCatalogForUpcomingOnSales(): Promise<UpcomingOnSalesResult>;

    getCatalogForOnSaleEvents(query: OnSaleEventQuery): Promise<CatalogResults>;

    getCatalogOnSaleEventMetrics(query: OnSaleEventQuery): Promise<OnSaleEventMetrics[]>;

    searchOnSaleEvents(query: OnSaleEventQuery): Promise<CatalogResults>;

    getEventAttributes(eventIds: number[]): Promise<EventAttributes[]>;

    getCategoryUrlsByIds(categoryIds: number[]): Promise<CategoryResult[]>;

    getCategoryDescriptionById(topLevelCategory: TopLevelCategory | undefined, categoryId: number | undefined): Promise<CategoryResult>;

    getCatalogSlim(viagogoVirtualIds: string[]): Promise<CatalogResultsSlim>;

    getCatalogFull(viagogoVirtualIds: string[]): Promise<CatalogResults>;

    getCatalogCountForSales(query: SaleQuery): Promise<CatalogCounts>;

    getCatalogCountForPurchaseOrders(query: PurchaseOrderQuery): Promise<CatalogCounts>;

    getCatalogCountForListings(query: ListingQuery): Promise<CatalogCounts>;

    getCatalogMetricsForTicketGroups(query: PurchaseOrderQuery, rowVersion: number | null | undefined, includeEventTags: boolean | null | undefined): Promise<CatalogTicketGroupMetricsResults>;

    getCatalogMetricsForSales(query: SaleQuery, rowVersion: number | null | undefined, includeEventTags: boolean | null | undefined): Promise<CatalogSaleMetricsResults>;

    getCatalogMetricsForListings(query: ListingQuery, rowVersion: number | null | undefined, includeEventTags: boolean | null | undefined): Promise<CatalogListingMetricsResults>;

    getCatalogDetailedMetricsForListings(query: ListingQuery, rowVersion: number | null | undefined): Promise<CatalogListingMetricsResults>;
}

export class CatalogClient extends PosClientBase implements ICatalogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCatalogForSaleBySaleId(saleId: number, signal?: AbortSignal | undefined): Promise<CatalogResults> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogForSaleBySaleId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saleId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogForSaleBySaleId(_response);
        });
    }

    protected processGetCatalogForSaleBySaleId(response: Response): Promise<CatalogResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogResults>(null as any);
    }

    getCatalogBySaleIds(saleIds: number[], signal?: AbortSignal | undefined): Promise<CatalogResults> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogBySaleIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saleIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogBySaleIds(_response);
        });
    }

    protected processGetCatalogBySaleIds(response: Response): Promise<CatalogResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogResults>(null as any);
    }

    /**
     * @param includeEventTags (optional) 
     * @deprecated
     */
    getCatalogSaleMetrics(query: SaleQuery, includeEventTags: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<CatalogSaleMetricsResults> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogSaleMetrics?";
        if (includeEventTags !== undefined && includeEventTags !== null)
            url_ += "includeEventTags=" + encodeURIComponent("" + includeEventTags) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogSaleMetrics(_response);
        });
    }

    protected processGetCatalogSaleMetrics(response: Response): Promise<CatalogSaleMetricsResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogSaleMetricsResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogSaleMetricsResults>(null as any);
    }

    /**
     * @param includeEventTags (optional) 
     * @deprecated
     */
    getCatalogTicketGroupMetrics(query: PurchaseOrderQuery, includeEventTags: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<CatalogTicketGroupMetricsResults> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogTicketGroupMetrics?";
        if (includeEventTags !== undefined && includeEventTags !== null)
            url_ += "includeEventTags=" + encodeURIComponent("" + includeEventTags) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogTicketGroupMetrics(_response);
        });
    }

    protected processGetCatalogTicketGroupMetrics(response: Response): Promise<CatalogTicketGroupMetricsResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogTicketGroupMetricsResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogTicketGroupMetricsResults>(null as any);
    }

    /**
     * Not currently used, but exist to create the types in React
     */
    getDefaultEventGroupingQuery(signal?: AbortSignal | undefined): Promise<EventGroupingQuery> {
        let url_ = this.baseUrl + "/api/Catalog/GetDefaultEventGroupingQuery";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDefaultEventGroupingQuery(_response);
        });
    }

    protected processGetDefaultEventGroupingQuery(response: Response): Promise<EventGroupingQuery> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventGroupingQuery;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventGroupingQuery>(null as any);
    }

    searchEvents(query: EventSearchQuery, signal?: AbortSignal | undefined): Promise<CatalogResults> {
        let url_ = this.baseUrl + "/api/Catalog/SearchEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchEvents(_response);
        });
    }

    protected processSearchEvents(response: Response): Promise<CatalogResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogResults>(null as any);
    }

    searchVenues(query: string | undefined, signal?: AbortSignal | undefined): Promise<Venue[]> {
        let url_ = this.baseUrl + "/api/Catalog?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchVenues(_response);
        });
    }

    protected processSearchVenues(response: Response): Promise<Venue[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Venue[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Venue[]>(null as any);
    }

    getSearchEventsAutoCompleteResult(searchText: string | undefined, maxCount: number | null | undefined, timeFrame: string | undefined, signal?: AbortSignal | undefined): Promise<CatalogResults> {
        let url_ = this.baseUrl + "/api/Catalog/GetSearchEventsAutoCompleteResult?";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (maxCount !== undefined && maxCount !== null)
            url_ += "maxCount=" + encodeURIComponent("" + maxCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(timeFrame);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSearchEventsAutoCompleteResult(_response);
        });
    }

    protected processGetSearchEventsAutoCompleteResult(response: Response): Promise<CatalogResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogResults>(null as any);
    }

    getCatalogForListingByListingId(listingId: number, signal?: AbortSignal | undefined): Promise<CatalogResults> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogForListingByListingId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listingId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogForListingByListingId(_response);
        });
    }

    protected processGetCatalogForListingByListingId(response: Response): Promise<CatalogResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogResults>(null as any);
    }

    /**
     * @param includeEventTags (optional) 
     * @deprecated
     */
    getCatalogListingMetrics(query: ListingQuery, includeEventTags: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<CatalogListingMetricsResults> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogListingMetrics?";
        if (includeEventTags !== undefined && includeEventTags !== null)
            url_ += "includeEventTags=" + encodeURIComponent("" + includeEventTags) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogListingMetrics(_response);
        });
    }

    protected processGetCatalogListingMetrics(response: Response): Promise<CatalogListingMetricsResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogListingMetricsResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogListingMetricsResults>(null as any);
    }

    /**
     * @deprecated
     */
    getEventDetailedListingMetrics(query: ListingQuery, signal?: AbortSignal | undefined): Promise<CatalogListingMetricsResults> {
        let url_ = this.baseUrl + "/api/Catalog/GetEventDetailedListingMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventDetailedListingMetrics(_response);
        });
    }

    protected processGetEventDetailedListingMetrics(response: Response): Promise<CatalogListingMetricsResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogListingMetricsResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogListingMetricsResults>(null as any);
    }

    getSummaryMetricsForListings(allMetrics: ListingMetricsInput[], signal?: AbortSignal | undefined): Promise<ListingMetrics> {
        let url_ = this.baseUrl + "/api/Catalog/GetSummaryMetricsForListings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(allMetrics);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSummaryMetricsForListings(_response);
        });
    }

    protected processGetSummaryMetricsForListings(response: Response): Promise<ListingMetrics> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingMetrics;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingMetrics>(null as any);
    }

    getCatalogHomeMetrics(signal?: AbortSignal | undefined): Promise<ListingMetrics> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogHomeMetrics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogHomeMetrics(_response);
        });
    }

    protected processGetCatalogHomeMetrics(response: Response): Promise<ListingMetrics> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingMetrics;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingMetrics>(null as any);
    }

    requestEventMapping(request: EventMappingRequest, signal?: AbortSignal | undefined): Promise<ValueTupleOfEventAndVenueAndPerformer> {
        let url_ = this.baseUrl + "/api/Catalog/RequestEventMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestEventMapping(_response);
        });
    }

    protected processRequestEventMapping(response: Response): Promise<ValueTupleOfEventAndVenueAndPerformer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValueTupleOfEventAndVenueAndPerformer;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValueTupleOfEventAndVenueAndPerformer>(null as any);
    }

    getCatalogForUpcomingOnSales(signal?: AbortSignal | undefined): Promise<UpcomingOnSalesResult> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogForUpcomingOnSales";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogForUpcomingOnSales(_response);
        });
    }

    protected processGetCatalogForUpcomingOnSales(response: Response): Promise<UpcomingOnSalesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpcomingOnSalesResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpcomingOnSalesResult>(null as any);
    }

    getCatalogForOnSaleEvents(query: OnSaleEventQuery, signal?: AbortSignal | undefined): Promise<CatalogResults> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogForOnSaleEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogForOnSaleEvents(_response);
        });
    }

    protected processGetCatalogForOnSaleEvents(response: Response): Promise<CatalogResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogResults>(null as any);
    }

    getCatalogOnSaleEventMetrics(query: OnSaleEventQuery, signal?: AbortSignal | undefined): Promise<OnSaleEventMetrics[]> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogOnSaleEventMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogOnSaleEventMetrics(_response);
        });
    }

    protected processGetCatalogOnSaleEventMetrics(response: Response): Promise<OnSaleEventMetrics[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnSaleEventMetrics[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OnSaleEventMetrics[]>(null as any);
    }

    searchOnSaleEvents(query: OnSaleEventQuery, signal?: AbortSignal | undefined): Promise<CatalogResults> {
        let url_ = this.baseUrl + "/api/Catalog/SearchOnSaleEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchOnSaleEvents(_response);
        });
    }

    protected processSearchOnSaleEvents(response: Response): Promise<CatalogResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogResults>(null as any);
    }

    getEventAttributes(eventIds: number[], signal?: AbortSignal | undefined): Promise<EventAttributes[]> {
        let url_ = this.baseUrl + "/api/Catalog/GetEventAttributes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventAttributes(_response);
        });
    }

    protected processGetEventAttributes(response: Response): Promise<EventAttributes[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventAttributes[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventAttributes[]>(null as any);
    }

    getCategoryUrlsByIds(categoryIds: number[], signal?: AbortSignal | undefined): Promise<CategoryResult[]> {
        let url_ = this.baseUrl + "/api/Catalog/GetCategoryUrlsByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(categoryIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCategoryUrlsByIds(_response);
        });
    }

    protected processGetCategoryUrlsByIds(response: Response): Promise<CategoryResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoryResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryResult[]>(null as any);
    }

    getCategoryDescriptionById(topLevelCategory: TopLevelCategory | undefined, categoryId: number | undefined, signal?: AbortSignal | undefined): Promise<CategoryResult> {
        let url_ = this.baseUrl + "/api/Catalog/GetCategoryDescriptionById?";
        if (topLevelCategory === null)
            throw new Error("The parameter 'topLevelCategory' cannot be null.");
        else if (topLevelCategory !== undefined)
            url_ += "topLevelCategory=" + encodeURIComponent("" + topLevelCategory) + "&";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCategoryDescriptionById(_response);
        });
    }

    protected processGetCategoryDescriptionById(response: Response): Promise<CategoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoryResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryResult>(null as any);
    }

    getCatalogSlim(viagogoVirtualIds: string[], signal?: AbortSignal | undefined): Promise<CatalogResultsSlim> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogSlim";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viagogoVirtualIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogSlim(_response);
        });
    }

    protected processGetCatalogSlim(response: Response): Promise<CatalogResultsSlim> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogResultsSlim;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogResultsSlim>(null as any);
    }

    getCatalogFull(viagogoVirtualIds: string[], signal?: AbortSignal | undefined): Promise<CatalogResults> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogFull";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viagogoVirtualIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogFull(_response);
        });
    }

    protected processGetCatalogFull(response: Response): Promise<CatalogResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogResults>(null as any);
    }

    getCatalogCountForSales(query: SaleQuery, signal?: AbortSignal | undefined): Promise<CatalogCounts> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogCountForSales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCountForSales(_response);
        });
    }

    protected processGetCatalogCountForSales(response: Response): Promise<CatalogCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCounts>(null as any);
    }

    getCatalogCountForPurchaseOrders(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<CatalogCounts> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogCountForPurchaseOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCountForPurchaseOrders(_response);
        });
    }

    protected processGetCatalogCountForPurchaseOrders(response: Response): Promise<CatalogCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCounts>(null as any);
    }

    getCatalogCountForListings(query: ListingQuery, signal?: AbortSignal | undefined): Promise<CatalogCounts> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogCountForListings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCountForListings(_response);
        });
    }

    protected processGetCatalogCountForListings(response: Response): Promise<CatalogCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCounts>(null as any);
    }

    getCatalogMetricsForTicketGroups(query: PurchaseOrderQuery, rowVersion: number | null | undefined, includeEventTags: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<CatalogTicketGroupMetricsResults> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogMetricsForTicketGroups?";
        if (rowVersion !== undefined && rowVersion !== null)
            url_ += "rowVersion=" + encodeURIComponent("" + rowVersion) + "&";
        if (includeEventTags !== undefined && includeEventTags !== null)
            url_ += "includeEventTags=" + encodeURIComponent("" + includeEventTags) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogMetricsForTicketGroups(_response);
        });
    }

    protected processGetCatalogMetricsForTicketGroups(response: Response): Promise<CatalogTicketGroupMetricsResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogTicketGroupMetricsResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogTicketGroupMetricsResults>(null as any);
    }

    getCatalogMetricsForSales(query: SaleQuery, rowVersion: number | null | undefined, includeEventTags: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<CatalogSaleMetricsResults> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogMetricsForSales?";
        if (rowVersion !== undefined && rowVersion !== null)
            url_ += "rowVersion=" + encodeURIComponent("" + rowVersion) + "&";
        if (includeEventTags !== undefined && includeEventTags !== null)
            url_ += "includeEventTags=" + encodeURIComponent("" + includeEventTags) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogMetricsForSales(_response);
        });
    }

    protected processGetCatalogMetricsForSales(response: Response): Promise<CatalogSaleMetricsResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogSaleMetricsResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogSaleMetricsResults>(null as any);
    }

    getCatalogMetricsForListings(query: ListingQuery, rowVersion: number | null | undefined, includeEventTags: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<CatalogListingMetricsResults> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogMetricsForListings?";
        if (rowVersion !== undefined && rowVersion !== null)
            url_ += "rowVersion=" + encodeURIComponent("" + rowVersion) + "&";
        if (includeEventTags !== undefined && includeEventTags !== null)
            url_ += "includeEventTags=" + encodeURIComponent("" + includeEventTags) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogMetricsForListings(_response);
        });
    }

    protected processGetCatalogMetricsForListings(response: Response): Promise<CatalogListingMetricsResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogListingMetricsResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogListingMetricsResults>(null as any);
    }

    getCatalogDetailedMetricsForListings(query: ListingQuery, rowVersion: number | null | undefined, signal?: AbortSignal | undefined): Promise<CatalogListingMetricsResults> {
        let url_ = this.baseUrl + "/api/Catalog/GetCatalogDetailedMetricsForListings?";
        if (rowVersion !== undefined && rowVersion !== null)
            url_ += "rowVersion=" + encodeURIComponent("" + rowVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogDetailedMetricsForListings(_response);
        });
    }

    protected processGetCatalogDetailedMetricsForListings(response: Response): Promise<CatalogListingMetricsResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogListingMetricsResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogListingMetricsResults>(null as any);
    }
}

export interface ICatchUpModeClient {

    insertCatchUpModeEventIdsMap(request: InsertCatchUpModeEventIdsMapRequest): Promise<string | null>;

    getCatchUpModeEventIdsMapById(cacheId: string | undefined): Promise<CatchUpModeEventIdsMapResponse>;
}

export class CatchUpModeClient extends PosClientBase implements ICatchUpModeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    insertCatchUpModeEventIdsMap(request: InsertCatchUpModeEventIdsMapRequest, signal?: AbortSignal | undefined): Promise<string | null> {
        let url_ = this.baseUrl + "/api/CatchUpMode/InsertCatchUpModeEventIdsMap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertCatchUpModeEventIdsMap(_response);
        });
    }

    protected processInsertCatchUpModeEventIdsMap(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    getCatchUpModeEventIdsMapById(cacheId: string | undefined, signal?: AbortSignal | undefined): Promise<CatchUpModeEventIdsMapResponse> {
        let url_ = this.baseUrl + "/api/CatchUpMode/GetCatchUpModeEventIdsMapById?";
        if (cacheId === null)
            throw new Error("The parameter 'cacheId' cannot be null.");
        else if (cacheId !== undefined)
            url_ += "cacheId=" + encodeURIComponent("" + cacheId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatchUpModeEventIdsMapById(_response);
        });
    }

    protected processGetCatchUpModeEventIdsMapById(response: Response): Promise<CatchUpModeEventIdsMapResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatchUpModeEventIdsMapResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatchUpModeEventIdsMapResponse>(null as any);
    }
}

export interface IClientLogClient {

    /**
     * @deprecated
     */
    log(logRequest: ClientLogRequest): Promise<boolean>;

    logEvents(logRequests: ClientLogRequest[]): Promise<boolean>;

    logStopwatch(logEntry: StopwatchLogEntry): Promise<boolean>;
}

export class ClientLogClient extends PosClientBase implements IClientLogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @deprecated
     */
    log(logRequest: ClientLogRequest, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ClientLog/Log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(logRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLog(_response);
        });
    }

    protected processLog(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    logEvents(logRequests: ClientLogRequest[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ClientLog/LogEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(logRequests);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogEvents(_response);
        });
    }

    protected processLogEvents(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    logStopwatch(logEntry: StopwatchLogEntry, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ClientLog/LogStopwatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(logEntry);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogStopwatch(_response);
        });
    }

    protected processLogStopwatch(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface ICommandMenuClient {

    getCommandMenuOptions(): Promise<{ [key in keyof typeof CommandOptionType]?: string; }>;
}

export class CommandMenuClient extends PosClientBase implements ICommandMenuClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCommandMenuOptions(signal?: AbortSignal | undefined): Promise<{ [key in keyof typeof CommandOptionType]?: string; }> {
        let url_ = this.baseUrl + "/api/CommandMenu/GetCommandMenuOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCommandMenuOptions(_response);
        });
    }

    protected processGetCommandMenuOptions(response: Response): Promise<{ [key in keyof typeof CommandOptionType]?: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key in keyof typeof CommandOptionType]?: string; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key in keyof typeof CommandOptionType]?: string; }>(null as any);
    }
}

export interface IContentClient {

    getContentDataMap(): Promise<{ [key: string]: ContentData; }>;
}

export class ContentClient extends PosClientBase implements IContentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getContentDataMap(signal?: AbortSignal | undefined): Promise<{ [key: string]: ContentData; }> {
        let url_ = this.baseUrl + "/api/Content/GetContentDataMap";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContentDataMap(_response);
        });
    }

    protected processGetContentDataMap(response: Response): Promise<{ [key: string]: ContentData; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: ContentData; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: ContentData; }>(null as any);
    }
}

export interface IDocumentProcessorClient {

    /**
     * @param entityId (optional) 
     * @param documentType (optional) 
     * @param contentType (optional) 
     * @deprecated
     */
    getDocumentUploadInfo(entityId: number | undefined, documentType: DocumentType | undefined, contentType: string | undefined): Promise<DocumentUploadInfo>;

    getDocumentUploadInfoForEntity(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined, documentType: DocumentType | undefined, contentType: string | undefined): Promise<DocumentUploadInfo>;

    uploadDocumentForSale(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined, documentType: DocumentType | undefined, blobName: string | undefined, documentId: string | undefined, contentType: string | undefined, file: FileParameter | null | undefined): Promise<void>;

    uploadDocumentForListing(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined, documentType: DocumentType | undefined, blobName: string | undefined, documentId: string | undefined, contentType: string | undefined, file: FileParameter | null | undefined): Promise<void>;

    uploadDocumentForTicketGroup(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined, documentType: DocumentType | undefined, blobName: string | undefined, documentId: string | undefined, contentType: string | undefined, file: FileParameter | null | undefined): Promise<void>;

    uploadDocumentWithoutProcessing(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined, documentType: DocumentType | undefined, blobName: string | undefined, documentId: string | undefined, contentType: string | undefined, file: FileParameter | null | undefined): Promise<PosUiActionResultWithDataOfUserDocumentLinks>;

    /**
     * Status polling endpoint
     * @param entityId (optional) 
     * @param entityType (optional) 
     * @param documentType (optional) 
     * @param blobName (optional) 
     * @param documentId (optional) 
     * @param contentType (optional) 
     * @return 204 = not started (mapped from 404 on the function for ts client semantics/lack of NSwag extensibility)
    202 = processing
    200 = completed, list of eTicketPages
    All other response codes are a failure and should throw an exception
    Note: https://github.com/RicoSuter/NSwag/issues/622
     */
    getDocumentPages(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined, documentType: DocumentType | undefined, blobName: string | undefined, documentId: string | undefined, contentType: string | undefined): Promise<DocumentPage[]>;
}

export class DocumentProcessorClient extends PosClientBase implements IDocumentProcessorClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param entityId (optional) 
     * @param documentType (optional) 
     * @param contentType (optional) 
     * @deprecated
     */
    getDocumentUploadInfo(entityId: number | undefined, documentType: DocumentType | undefined, contentType: string | undefined, signal?: AbortSignal | undefined): Promise<DocumentUploadInfo> {
        let url_ = this.baseUrl + "/api/DocumentProcessor/GetDocumentUploadInfo?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (documentType === null)
            throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        if (contentType === null)
            throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined)
            url_ += "contentType=" + encodeURIComponent("" + contentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentUploadInfo(_response);
        });
    }

    protected processGetDocumentUploadInfo(response: Response): Promise<DocumentUploadInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentUploadInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentUploadInfo>(null as any);
    }

    getDocumentUploadInfoForEntity(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined, documentType: DocumentType | undefined, contentType: string | undefined, signal?: AbortSignal | undefined): Promise<DocumentUploadInfo> {
        let url_ = this.baseUrl + "/api/DocumentProcessor/GetDocumentUploadInfoForEntity?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        if (documentType === null)
            throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        if (contentType === null)
            throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined)
            url_ += "contentType=" + encodeURIComponent("" + contentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentUploadInfoForEntity(_response);
        });
    }

    protected processGetDocumentUploadInfoForEntity(response: Response): Promise<DocumentUploadInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentUploadInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentUploadInfo>(null as any);
    }

    uploadDocumentForSale(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined, documentType: DocumentType | undefined, blobName: string | undefined, documentId: string | undefined, contentType: string | undefined, file: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DocumentProcessor/UploadDocumentForSale?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "EntityType=" + encodeURIComponent("" + entityType) + "&";
        if (documentType === null)
            throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&";
        if (blobName === null)
            throw new Error("The parameter 'blobName' cannot be null.");
        else if (blobName !== undefined)
            url_ += "BlobName=" + encodeURIComponent("" + blobName) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (contentType === null)
            throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined)
            url_ += "ContentType=" + encodeURIComponent("" + contentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadDocumentForSale(_response);
        });
    }

    protected processUploadDocumentForSale(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    uploadDocumentForListing(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined, documentType: DocumentType | undefined, blobName: string | undefined, documentId: string | undefined, contentType: string | undefined, file: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DocumentProcessor/UploadDocumentForListing?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "EntityType=" + encodeURIComponent("" + entityType) + "&";
        if (documentType === null)
            throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&";
        if (blobName === null)
            throw new Error("The parameter 'blobName' cannot be null.");
        else if (blobName !== undefined)
            url_ += "BlobName=" + encodeURIComponent("" + blobName) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (contentType === null)
            throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined)
            url_ += "ContentType=" + encodeURIComponent("" + contentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadDocumentForListing(_response);
        });
    }

    protected processUploadDocumentForListing(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    uploadDocumentForTicketGroup(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined, documentType: DocumentType | undefined, blobName: string | undefined, documentId: string | undefined, contentType: string | undefined, file: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DocumentProcessor/UploadDocumentForTicketGroup?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "EntityType=" + encodeURIComponent("" + entityType) + "&";
        if (documentType === null)
            throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&";
        if (blobName === null)
            throw new Error("The parameter 'blobName' cannot be null.");
        else if (blobName !== undefined)
            url_ += "BlobName=" + encodeURIComponent("" + blobName) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (contentType === null)
            throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined)
            url_ += "ContentType=" + encodeURIComponent("" + contentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadDocumentForTicketGroup(_response);
        });
    }

    protected processUploadDocumentForTicketGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    uploadDocumentWithoutProcessing(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined, documentType: DocumentType | undefined, blobName: string | undefined, documentId: string | undefined, contentType: string | undefined, file: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResultWithDataOfUserDocumentLinks> {
        let url_ = this.baseUrl + "/api/DocumentProcessor/UploadDocumentWithoutProcessing?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "EntityType=" + encodeURIComponent("" + entityType) + "&";
        if (documentType === null)
            throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&";
        if (blobName === null)
            throw new Error("The parameter 'blobName' cannot be null.");
        else if (blobName !== undefined)
            url_ += "BlobName=" + encodeURIComponent("" + blobName) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (contentType === null)
            throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined)
            url_ += "ContentType=" + encodeURIComponent("" + contentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadDocumentWithoutProcessing(_response);
        });
    }

    protected processUploadDocumentWithoutProcessing(response: Response): Promise<PosUiActionResultWithDataOfUserDocumentLinks> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResultWithDataOfUserDocumentLinks;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResultWithDataOfUserDocumentLinks>(null as any);
    }

    /**
     * Status polling endpoint
     * @param entityId (optional) 
     * @param entityType (optional) 
     * @param documentType (optional) 
     * @param blobName (optional) 
     * @param documentId (optional) 
     * @param contentType (optional) 
     * @return 204 = not started (mapped from 404 on the function for ts client semantics/lack of NSwag extensibility)
    202 = processing
    200 = completed, list of eTicketPages
    All other response codes are a failure and should throw an exception
    Note: https://github.com/RicoSuter/NSwag/issues/622
     */
    getDocumentPages(entityId: number | undefined, entityType: ActionOutboxEntityType | undefined, documentType: DocumentType | undefined, blobName: string | undefined, documentId: string | undefined, contentType: string | undefined, signal?: AbortSignal | undefined): Promise<DocumentPage[]> {
        let url_ = this.baseUrl + "/api/DocumentProcessor/GetDocumentPages?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "EntityType=" + encodeURIComponent("" + entityType) + "&";
        if (documentType === null)
            throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&";
        if (blobName === null)
            throw new Error("The parameter 'blobName' cannot be null.");
        else if (blobName !== undefined)
            url_ += "BlobName=" + encodeURIComponent("" + blobName) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (contentType === null)
            throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined)
            url_ += "ContentType=" + encodeURIComponent("" + contentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentPages(_response);
        });
    }

    protected processGetDocumentPages(response: Response): Promise<DocumentPage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentPage[];
            return result204;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentPage[];
            return result202;
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentPage[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentPage[]>(null as any);
    }
}

export interface IEventConfigClient {

    getVenueMapForEvent(eventId: number | undefined): Promise<VenueMapInfo>;

    getVenueMapsByScoreModelForEvent(eventId: number | undefined): Promise<{ [key in keyof typeof ScoreModel]?: VenueMapInfo; }>;

    getListingConstraintsForEvents(eventIds: number[]): Promise<EventListingConstraints[]>;

    getSellerEventMarketplaceEventInfo(viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined): Promise<SellerEventMarketplaceEventInfo[]>;

    updateSellerEventMarketplaceEventInfos(marketplaceEventInfos: SellerEventMarketplaceEventInfo[]): Promise<boolean>;

    getTagsForEvent(viagogoVirtualId: string | undefined): Promise<Tag[]>;

    getMarketTransactionsForEvent(viagogoEventId: number | undefined, topN: number | undefined): Promise<MarketTransaction[]>;

    updateTagsForEvent(viagogoVirtualId: string | undefined, tags: Tag[]): Promise<boolean>;

    getInternalNotesForEvent(viagogoVirtualId: string | undefined): Promise<string>;

    updateInternalNotesForEvent(viagogoVirtualId: string | undefined, internalNote: string): Promise<boolean>;

    getLastReviewedDateTimeForEvents(viagogoVirtualIds: string[]): Promise<{ [key: string]: string; }>;

    updateLastReviewedDateTimeForEvent(viagogoVirtualId: string | undefined, lastReviewedDateTime: string | undefined): Promise<boolean>;

    getSellerEventNotesByViagogoEventId(viagogoEventId: number | undefined): Promise<SellerEventNoteResult[]>;

    insertSellerEventNotes(viagogoEventId: number | undefined, content: string | undefined): Promise<SellerEventNoteResult>;

    updateSellerEventGroupingMethods(viagogoVirtualId: string | undefined, groupingMethods: ListingGroupingMethods): Promise<boolean>;

    mergeSellerAccountEventSettingsForDelivery(sellerAccountEventSettings: SellerAccountEventSetting[], viagogoEventId: number | undefined): Promise<boolean>;

    getSellerAccountEventSettings(viagogoEventId: number | undefined): Promise<SellerAccountEventSetting[]>;
}

export class EventConfigClient extends PosClientBase implements IEventConfigClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getVenueMapForEvent(eventId: number | undefined, signal?: AbortSignal | undefined): Promise<VenueMapInfo> {
        let url_ = this.baseUrl + "/api/EventConfig/GetVenueMapForEvent?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVenueMapForEvent(_response);
        });
    }

    protected processGetVenueMapForEvent(response: Response): Promise<VenueMapInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VenueMapInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueMapInfo>(null as any);
    }

    getVenueMapsByScoreModelForEvent(eventId: number | undefined, signal?: AbortSignal | undefined): Promise<{ [key in keyof typeof ScoreModel]?: VenueMapInfo; }> {
        let url_ = this.baseUrl + "/api/EventConfig/GetVenueMapsByScoreModelForEvent?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVenueMapsByScoreModelForEvent(_response);
        });
    }

    protected processGetVenueMapsByScoreModelForEvent(response: Response): Promise<{ [key in keyof typeof ScoreModel]?: VenueMapInfo; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key in keyof typeof ScoreModel]?: VenueMapInfo; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key in keyof typeof ScoreModel]?: VenueMapInfo; }>(null as any);
    }

    getListingConstraintsForEvents(eventIds: number[], signal?: AbortSignal | undefined): Promise<EventListingConstraints[]> {
        let url_ = this.baseUrl + "/api/EventConfig/GetListingConstraintsForEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingConstraintsForEvents(_response);
        });
    }

    protected processGetListingConstraintsForEvents(response: Response): Promise<EventListingConstraints[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventListingConstraints[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventListingConstraints[]>(null as any);
    }

    getSellerEventMarketplaceEventInfo(viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined, signal?: AbortSignal | undefined): Promise<SellerEventMarketplaceEventInfo[]> {
        let url_ = this.baseUrl + "/api/EventConfig/GetSellerEventMarketplaceEventInfo?";
        if (viagogoEventId !== undefined && viagogoEventId !== null)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (eventMappingId !== undefined && eventMappingId !== null)
            url_ += "eventMappingId=" + encodeURIComponent("" + eventMappingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerEventMarketplaceEventInfo(_response);
        });
    }

    protected processGetSellerEventMarketplaceEventInfo(response: Response): Promise<SellerEventMarketplaceEventInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerEventMarketplaceEventInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerEventMarketplaceEventInfo[]>(null as any);
    }

    updateSellerEventMarketplaceEventInfos(marketplaceEventInfos: SellerEventMarketplaceEventInfo[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EventConfig/UpdateSellerEventMarketplaceEventInfos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketplaceEventInfos);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSellerEventMarketplaceEventInfos(_response);
        });
    }

    protected processUpdateSellerEventMarketplaceEventInfos(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getTagsForEvent(viagogoVirtualId: string | undefined, signal?: AbortSignal | undefined): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/EventConfig/GetTagsForEvent?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTagsForEvent(_response);
        });
    }

    protected processGetTagsForEvent(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Tag[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    getMarketTransactionsForEvent(viagogoEventId: number | undefined, topN: number | undefined, signal?: AbortSignal | undefined): Promise<MarketTransaction[]> {
        let url_ = this.baseUrl + "/api/EventConfig/GetMarketTransactionsForEvent?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (topN === null)
            throw new Error("The parameter 'topN' cannot be null.");
        else if (topN !== undefined)
            url_ += "topN=" + encodeURIComponent("" + topN) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMarketTransactionsForEvent(_response);
        });
    }

    protected processGetMarketTransactionsForEvent(response: Response): Promise<MarketTransaction[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketTransaction[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketTransaction[]>(null as any);
    }

    updateTagsForEvent(viagogoVirtualId: string | undefined, tags: Tag[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EventConfig/UpdateTagsForEvent?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tags);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTagsForEvent(_response);
        });
    }

    protected processUpdateTagsForEvent(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getInternalNotesForEvent(viagogoVirtualId: string | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/EventConfig/GetInternalNotesForEvent?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInternalNotesForEvent(_response);
        });
    }

    protected processGetInternalNotesForEvent(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    updateInternalNotesForEvent(viagogoVirtualId: string | undefined, internalNote: string, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EventConfig/UpdateInternalNotesForEvent?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(internalNote);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateInternalNotesForEvent(_response);
        });
    }

    protected processUpdateInternalNotesForEvent(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getLastReviewedDateTimeForEvents(viagogoVirtualIds: string[], signal?: AbortSignal | undefined): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/EventConfig/GetLastReviewedDateTimeForEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viagogoVirtualIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLastReviewedDateTimeForEvents(_response);
        });
    }

    protected processGetLastReviewedDateTimeForEvents(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    updateLastReviewedDateTimeForEvent(viagogoVirtualId: string | undefined, lastReviewedDateTime: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EventConfig/UpdateLastReviewedDateTimeForEvent?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        if (lastReviewedDateTime === null)
            throw new Error("The parameter 'lastReviewedDateTime' cannot be null.");
        else if (lastReviewedDateTime !== undefined)
            url_ += "lastReviewedDateTime=" + encodeURIComponent("" + lastReviewedDateTime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLastReviewedDateTimeForEvent(_response);
        });
    }

    protected processUpdateLastReviewedDateTimeForEvent(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getSellerEventNotesByViagogoEventId(viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<SellerEventNoteResult[]> {
        let url_ = this.baseUrl + "/api/EventConfig/GetSellerEventNotesByViagogoEventId?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerEventNotesByViagogoEventId(_response);
        });
    }

    protected processGetSellerEventNotesByViagogoEventId(response: Response): Promise<SellerEventNoteResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerEventNoteResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerEventNoteResult[]>(null as any);
    }

    insertSellerEventNotes(viagogoEventId: number | undefined, content: string | undefined, signal?: AbortSignal | undefined): Promise<SellerEventNoteResult> {
        let url_ = this.baseUrl + "/api/EventConfig/InsertSellerEventNotes?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (content === null)
            throw new Error("The parameter 'content' cannot be null.");
        else if (content !== undefined)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertSellerEventNotes(_response);
        });
    }

    protected processInsertSellerEventNotes(response: Response): Promise<SellerEventNoteResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerEventNoteResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerEventNoteResult>(null as any);
    }

    updateSellerEventGroupingMethods(viagogoVirtualId: string | undefined, groupingMethods: ListingGroupingMethods, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EventConfig/UpdateSellerEventGroupingMethods?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupingMethods);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSellerEventGroupingMethods(_response);
        });
    }

    protected processUpdateSellerEventGroupingMethods(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    mergeSellerAccountEventSettingsForDelivery(sellerAccountEventSettings: SellerAccountEventSetting[], viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EventConfig?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sellerAccountEventSettings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeSellerAccountEventSettingsForDelivery(_response);
        });
    }

    protected processMergeSellerAccountEventSettingsForDelivery(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getSellerAccountEventSettings(viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<SellerAccountEventSetting[]> {
        let url_ = this.baseUrl + "/api/EventConfig/GetSellerAccountEventSettings?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerAccountEventSettings(_response);
        });
    }

    protected processGetSellerAccountEventSettings(response: Response): Promise<SellerAccountEventSetting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerAccountEventSetting[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerAccountEventSetting[]>(null as any);
    }
}

export interface IEventDiscoveryClient {

    unlockEventDemandData(quotaConfig: EventDiscoveryQuotaConfig): Promise<boolean>;

    tryAccessOnSaleEvent(viagogoEventId: number | undefined): Promise<OnSaleEventAccess>;

    getEventDiscoveryConfigSettings(): Promise<EventDiscoveryConfigSettings>;

    getEventSectionMetrics(eventId: number | undefined, timestamp: EventMetricsTimestamp | undefined): Promise<EventSectionMetrics[]>;

    getEventNotifications(): Promise<EventNotification[]>;

    createEventNotification(input: EventNotification): Promise<EventNotification | null>;

    deleteEventNotification(eventNotifId: string): Promise<PosUiActionResult>;

    updateEventNotification(input: EventNotification): Promise<PosUiActionResult>;
}

export class EventDiscoveryClient extends PosClientBase implements IEventDiscoveryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    unlockEventDemandData(quotaConfig: EventDiscoveryQuotaConfig, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EventDiscovery/UnlockEventDemandData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quotaConfig);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnlockEventDemandData(_response);
        });
    }

    protected processUnlockEventDemandData(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    tryAccessOnSaleEvent(viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<OnSaleEventAccess> {
        let url_ = this.baseUrl + "/api/EventDiscovery/TryAccessOnSaleEvent?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTryAccessOnSaleEvent(_response);
        });
    }

    protected processTryAccessOnSaleEvent(response: Response): Promise<OnSaleEventAccess> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnSaleEventAccess;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OnSaleEventAccess>(null as any);
    }

    getEventDiscoveryConfigSettings(signal?: AbortSignal | undefined): Promise<EventDiscoveryConfigSettings> {
        let url_ = this.baseUrl + "/api/EventDiscovery/GetEventDiscoveryConfigSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventDiscoveryConfigSettings(_response);
        });
    }

    protected processGetEventDiscoveryConfigSettings(response: Response): Promise<EventDiscoveryConfigSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventDiscoveryConfigSettings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventDiscoveryConfigSettings>(null as any);
    }

    getEventSectionMetrics(eventId: number | undefined, timestamp: EventMetricsTimestamp | undefined, signal?: AbortSignal | undefined): Promise<EventSectionMetrics[]> {
        let url_ = this.baseUrl + "/api/EventDiscovery/GetEventSectionMetrics?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        if (timestamp === null)
            throw new Error("The parameter 'timestamp' cannot be null.");
        else if (timestamp !== undefined)
            url_ += "timestamp=" + encodeURIComponent("" + timestamp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventSectionMetrics(_response);
        });
    }

    protected processGetEventSectionMetrics(response: Response): Promise<EventSectionMetrics[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventSectionMetrics[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventSectionMetrics[]>(null as any);
    }

    getEventNotifications(signal?: AbortSignal | undefined): Promise<EventNotification[]> {
        let url_ = this.baseUrl + "/api/EventDiscovery/GetEventNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventNotifications(_response);
        });
    }

    protected processGetEventNotifications(response: Response): Promise<EventNotification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventNotification[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventNotification[]>(null as any);
    }

    createEventNotification(input: EventNotification, signal?: AbortSignal | undefined): Promise<EventNotification | null> {
        let url_ = this.baseUrl + "/api/EventDiscovery/CreateEventNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateEventNotification(_response);
        });
    }

    protected processCreateEventNotification(response: Response): Promise<EventNotification | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventNotification;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventNotification | null>(null as any);
    }

    deleteEventNotification(eventNotifId: string, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/EventDiscovery/DeleteEventNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventNotifId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteEventNotification(_response);
        });
    }

    protected processDeleteEventNotification(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateEventNotification(input: EventNotification, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/EventDiscovery/UpdateEventNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateEventNotification(_response);
        });
    }

    protected processUpdateEventNotification(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }
}

export interface IFulfillmentProviderClient {

    getFulfillmentProviderSettings(): Promise<FulfillmentProvider[]>;

    toggleFulfillmentProviderSetting(fulfillmentProviderSellerUserId: string | undefined, newState: boolean | undefined): Promise<boolean>;
}

export class FulfillmentProviderClient extends PosClientBase implements IFulfillmentProviderClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getFulfillmentProviderSettings(signal?: AbortSignal | undefined): Promise<FulfillmentProvider[]> {
        let url_ = this.baseUrl + "/api/FulfillmentProvider/GetFulfillmentProviderSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFulfillmentProviderSettings(_response);
        });
    }

    protected processGetFulfillmentProviderSettings(response: Response): Promise<FulfillmentProvider[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FulfillmentProvider[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FulfillmentProvider[]>(null as any);
    }

    toggleFulfillmentProviderSetting(fulfillmentProviderSellerUserId: string | undefined, newState: boolean | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/FulfillmentProvider/ToggleFulfillmentProviderSetting?";
        if (fulfillmentProviderSellerUserId === null)
            throw new Error("The parameter 'fulfillmentProviderSellerUserId' cannot be null.");
        else if (fulfillmentProviderSellerUserId !== undefined)
            url_ += "fulfillmentProviderSellerUserId=" + encodeURIComponent("" + fulfillmentProviderSellerUserId) + "&";
        if (newState === null)
            throw new Error("The parameter 'newState' cannot be null.");
        else if (newState !== undefined)
            url_ += "newState=" + encodeURIComponent("" + newState) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processToggleFulfillmentProviderSetting(_response);
        });
    }

    protected processToggleFulfillmentProviderSetting(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IInventoryEventDashboardClient {

    getEventWebsiteMetrics(queryId: InventoryMetricsQueryId, timePeriod: EventWebsiteMetricsTimePeriod | null | undefined): Promise<EventMarketplaceWebsiteMetrics>;

    getEventDemandFactors(queryId: InventoryMetricsQueryId): Promise<EventDemandFactor[]>;

    getSellerEventDashboardMetrics(queryId: InventoryMetricsQueryId, timePeriod: SellerEventDashboardMetricsTimePeriod | null | undefined): Promise<InventoryEventDashboardResults>;

    getBuyerEventDashboardMetrics(queryId: InventoryMetricsQueryId): Promise<InventoryEventDashboardResults>;

    getEventSectionClearingPrices(queryId: InventoryMetricsQueryId, timePeriod: EventSectionMetricsTimePeriod | null | undefined): Promise<EventSectionClearingPrices[]>;

    getEventSupplyMetrics(queryId: InventoryMetricsQueryId, timePeriod: EventSupplyMetricsTimePeriod | null | undefined): Promise<EventSupplyMetrics[]>;
}

export class InventoryEventDashboardClient extends PosClientBase implements IInventoryEventDashboardClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getEventWebsiteMetrics(queryId: InventoryMetricsQueryId, timePeriod: EventWebsiteMetricsTimePeriod | null | undefined, signal?: AbortSignal | undefined): Promise<EventMarketplaceWebsiteMetrics> {
        let url_ = this.baseUrl + "/api/InventoryEventDashboard/GetEventWebsiteMetrics?";
        if (timePeriod !== undefined && timePeriod !== null)
            url_ += "timePeriod=" + encodeURIComponent("" + timePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventWebsiteMetrics(_response);
        });
    }

    protected processGetEventWebsiteMetrics(response: Response): Promise<EventMarketplaceWebsiteMetrics> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventMarketplaceWebsiteMetrics;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventMarketplaceWebsiteMetrics>(null as any);
    }

    getEventDemandFactors(queryId: InventoryMetricsQueryId, signal?: AbortSignal | undefined): Promise<EventDemandFactor[]> {
        let url_ = this.baseUrl + "/api/InventoryEventDashboard/GetEventDemandFactors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventDemandFactors(_response);
        });
    }

    protected processGetEventDemandFactors(response: Response): Promise<EventDemandFactor[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventDemandFactor[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventDemandFactor[]>(null as any);
    }

    getSellerEventDashboardMetrics(queryId: InventoryMetricsQueryId, timePeriod: SellerEventDashboardMetricsTimePeriod | null | undefined, signal?: AbortSignal | undefined): Promise<InventoryEventDashboardResults> {
        let url_ = this.baseUrl + "/api/InventoryEventDashboard/GetSellerEventDashboardMetrics?";
        if (timePeriod !== undefined && timePeriod !== null)
            url_ += "timePeriod=" + encodeURIComponent("" + timePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerEventDashboardMetrics(_response);
        });
    }

    protected processGetSellerEventDashboardMetrics(response: Response): Promise<InventoryEventDashboardResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InventoryEventDashboardResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryEventDashboardResults>(null as any);
    }

    getBuyerEventDashboardMetrics(queryId: InventoryMetricsQueryId, signal?: AbortSignal | undefined): Promise<InventoryEventDashboardResults> {
        let url_ = this.baseUrl + "/api/InventoryEventDashboard/GetBuyerEventDashboardMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBuyerEventDashboardMetrics(_response);
        });
    }

    protected processGetBuyerEventDashboardMetrics(response: Response): Promise<InventoryEventDashboardResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InventoryEventDashboardResults;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryEventDashboardResults>(null as any);
    }

    getEventSectionClearingPrices(queryId: InventoryMetricsQueryId, timePeriod: EventSectionMetricsTimePeriod | null | undefined, signal?: AbortSignal | undefined): Promise<EventSectionClearingPrices[]> {
        let url_ = this.baseUrl + "/api/InventoryEventDashboard/GetEventSectionClearingPrices?";
        if (timePeriod !== undefined && timePeriod !== null)
            url_ += "timePeriod=" + encodeURIComponent("" + timePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventSectionClearingPrices(_response);
        });
    }

    protected processGetEventSectionClearingPrices(response: Response): Promise<EventSectionClearingPrices[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventSectionClearingPrices[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventSectionClearingPrices[]>(null as any);
    }

    getEventSupplyMetrics(queryId: InventoryMetricsQueryId, timePeriod: EventSupplyMetricsTimePeriod | null | undefined, signal?: AbortSignal | undefined): Promise<EventSupplyMetrics[]> {
        let url_ = this.baseUrl + "/api/InventoryEventDashboard/GetEventSupplyMetrics?";
        if (timePeriod !== undefined && timePeriod !== null)
            url_ += "timePeriod=" + encodeURIComponent("" + timePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventSupplyMetrics(_response);
        });
    }

    protected processGetEventSupplyMetrics(response: Response): Promise<EventSupplyMetrics[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventSupplyMetrics[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventSupplyMetrics[]>(null as any);
    }
}

export interface IListingClient {

    getListingByListingId(inventoryId: number | undefined, current: ListingDetails | undefined, dataToInclude: ListingDetailDataField[] | null | undefined): Promise<ListingDetails>;

    getListingAvailableQuantitiesByListingIds(inventoryIds: number[]): Promise<number>;

    getListingByMarketplaceListingId(marketplaceListingId: string | undefined): Promise<Listing[]>;

    getListingsForEvents(query: ListingQuery, useReadonlyDB: boolean | undefined, doNotProcessListingGroups: boolean | undefined, includeInternalNotes: boolean | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }>;

    /**
     * This use the exact same backend as GetListingsForEvents, but it is used by Advance Search
    The split up allows proper instrumentation and monitoring of the two different use cases
    This endpoint can later be replaced with a different backend
     * @param useReadonlyDB (optional) 
     * @param doNotProcessListingGroups (optional) 
     * @param includeInternalNotes (optional) 
     */
    searchListingsForEvents(query: ListingQuery, useReadonlyDB: boolean | undefined, doNotProcessListingGroups: boolean | undefined, includeInternalNotes: boolean | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }>;

    /**
     * This will be used by Advance Search V2 which uses OpenSearch implementation
     */
    searchListingsForEventsV2(query: ListingQueryV2): Promise<{ [key: string]: EntitiesWithSummaryOfListingWithCatalogData; }>;

    getListingsSectionalDataForEvents(input: SectionalListingsForEventsInput, dataToInclude: ListingDetailDataField[] | undefined, processListingGroup: boolean | null | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }>;

    getListingsCanBeWasted(inventoryId: number | undefined): Promise<ValueTupleOfBooleanAndIListOfTicket>;

    getDuplicateListingsForListingId(inventoryId: number | undefined): Promise<DuplicateListingDetails[]>;

    getListingEnabledForAutoPricing(posEventIds: string[]): Promise<boolean>;

    updateAutoPricingEnabledForEvent(posEventIds: string[], autoPricingState: boolean | undefined): Promise<boolean>;

    createMarketplaceListings(listingId: number | undefined, marketplaces: Marketplace[] | undefined): Promise<boolean>;

    deleteMarketplaceListings(listingId: number | undefined, marketplaces: Marketplace[] | undefined): Promise<boolean>;

    updateListingAdminHold(listingId: number | undefined, adminHoldExpirationDate: string | null | undefined, adminHoldNotes: string | null | undefined): Promise<PosUiActionResult>;

    updateListingIgnoreDuplicate(listingId: number | undefined, ignoreDuplicate: boolean | undefined): Promise<boolean>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingByListingId(listingId: number, input: ListingDetailsUpdateInput): Promise<PosUiActionResult>;

    /**
     * @deprecated
     */
    updateListing(input: ListingDetailsUpdateInput): Promise<PosUiActionResult>;

    updateListingPrices(listingId: number | undefined, listPrice: number | undefined, netProceedsFloor: number | undefined): Promise<Listing>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingsPricingSettingsByListingId(listingId: number, input: ValueTupleOfLongAndListingDetailsUpdateInput): Promise<Listing>;

    /**
     * @deprecated
     */
    updateListingsPricingSettings(input: ValueTupleOfLongAndListingDetailsUpdateInput): Promise<Listing>;

    /**
     * @param listingId One of the listing ids
    Used for route parsing so that action argument is parsed for consignee impersonation
     */
    mergeListingsWithListingId(listingId: number, input: MergeListingsInput): Promise<PosUiActionResult>;

    /**
     * @deprecated
     */
    mergeListings(input: MergeListingsInput): Promise<PosUiActionResult>;

    bulkMergeListings(input: BulkMergeListingsInput): Promise<boolean>;

    getListingMergeSuggestionsByEvent(viagogoEventId: number | undefined, excludeHeldListings: boolean | null | undefined): Promise<ListingMergeSuggestion[]>;

    getListingMergeSuggestions(excludeHeldListings: boolean | null | undefined): Promise<ListingMergeSuggestion[]>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    splitListingsByListingId(listingId: number, input: SplitListingInput): Promise<PosUiActionResult>;

    /**
     * @deprecated
     */
    splitListings(input: SplitListingInput): Promise<PosUiActionResult>;

    updateBarcodesForListing(listingId: number | undefined, barcodes: TicketBarcode[]): Promise<PosUiActionResult>;

    updateETicketsForListing(listingId: number | undefined, etickets: UserDocument[]): Promise<PosUiActionResult>;

    updateMobileQRCodesForListing(listingId: number | undefined, mobileQRCodes: UserDocument[]): Promise<PosUiActionResult>;

    updateExternalIdsForListing(listingId: number | undefined, externalIds: TicketExternalId[]): Promise<PosUiActionResult>;

    updateTicketUrlsForListing(listingId: number | undefined, ticketUrls: TicketUrl[]): Promise<PosUiActionResult>;

    updateProofOfPurchaseForListing(listingId: number | undefined, proofDocs: UserDocument[]): Promise<PosUiActionResult>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    getPriceHistoryByListingIdWithListingId(listingId: number, input: ValueTupleOfLongAndNullableInteger): Promise<ListingPriceHistory[]>;

    /**
     * @deprecated
     */
    getPriceHistoryByListingId(input: ValueTupleOfLongAndNullableInteger): Promise<ListingPriceHistory[]>;

    getCompListingsByEventId(viagogoEventId: number | undefined, listingId: number | null | undefined, currency: string | null | undefined): Promise<CompListing[]>;

    getListingPriceCalculation(viagogoEventId: number | undefined, listingId: number | undefined, input: ListingDetailsPricingUpdates): Promise<ListingPriceCalculation>;

    exportListings(input: ValueTupleOfListingQueryAndListingCsvColumnSelectionConfig): Promise<FileResponse>;

    createSeatSaver(inputs: SeatSaverListingDetailsInput[]): Promise<PosUiActionResult>;

    deleteSeatSaver(listingId: number | undefined): Promise<PosUiActionResult>;

    /**
     * Swap listing from one group to another
     */
    batchSwapListingGroup(input: BatchSwapListingGroupInput): Promise<{ [key: string]: Listing[]; }>;

    /**
     * Swap listing from one group to another
     */
    reorderListingInGroup(input: ReorderListingInGroupInput): Promise<{ [key: string]: Listing[]; }>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingBroadcastSectionByListingId(listingId: number, input: ListingDetailsBroadcastSectionUpdates): Promise<PosUiActionResult>;

    /**
     * @deprecated
     */
    updateListingBroadcastSection(input: ListingDetailsBroadcastSectionUpdates): Promise<PosUiActionResult>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingTicketSectionByListingId(listingId: number, input: ListingDetailsTicketSectionUpdates): Promise<PosUiActionResult>;

    /**
     * @deprecated
     */
    updateListingTicketSection(input: ListingDetailsTicketSectionUpdates): Promise<PosUiActionResult>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingPricingSectionFromListingTable(listingId: number, input: ListingPricingSectionPosFieldUpdates): Promise<PosUiActionResult>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingPricingSectionByListingId(listingId: number, input: ListingDetailsPricingSectionUpdates): Promise<PosUiActionResult>;

    /**
     * @deprecated
     */
    updateListingPricingSection(input: ListingDetailsPricingSectionUpdates): Promise<PosUiActionResult>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingAutoPricingSectionByListingId(listingId: number, input: ListingDetailsAutoPricingSectionUpdates): Promise<PosUiActionResult>;

    /**
     * @deprecated
     */
    updateListingAutoPricingSection(input: ListingDetailsAutoPricingSectionUpdates): Promise<PosUiActionResult>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingAutoPricingSectionV2ByListingId(listingId: number, input: ListingDetailsAutoPricingSectionUpdatesV2): Promise<PosUiActionResult>;

    /**
     * @deprecated
     */
    updateListingAutoPricingSectionV2(input: ListingDetailsAutoPricingSectionUpdatesV2): Promise<PosUiActionResult>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingTagSectionByListingId(listingId: number, input: ListingDetailsTagsSectionUpdates): Promise<PosUiActionResult>;

    /**
     * @deprecated
     */
    updateListingTagSection(input: ListingDetailsTagsSectionUpdates): Promise<PosUiActionResult>;

    downloadMergedUserDocumentsPdf(listingId: number | undefined): Promise<FileResponse>;

    getListingStatusByListingId(inventoryId: number | undefined): Promise<ListingStatusInfo>;

    getListingStatusByListingIds(inventoryIds: number[]): Promise<ListingStatusInfo[] | null>;

    getLastBroadcastListingMarketplaceByListingId(listingId: number | undefined): Promise<Marketplace[]>;

    downloadSeatSaversFileTemplate(): Promise<FileResponse>;
}

export class ListingClient extends PosClientBase implements IListingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getListingByListingId(inventoryId: number | undefined, current: ListingDetails | undefined, dataToInclude: ListingDetailDataField[] | null | undefined, signal?: AbortSignal | undefined): Promise<ListingDetails> {
        let url_ = this.baseUrl + "/api/Listing/GetListingByListingId?";
        if (inventoryId === null)
            throw new Error("The parameter 'inventoryId' cannot be null.");
        else if (inventoryId !== undefined)
            url_ += "inventoryId=" + encodeURIComponent("" + inventoryId) + "&";
        if (dataToInclude !== undefined && dataToInclude !== null)
            dataToInclude && dataToInclude.forEach(item => { url_ += "dataToInclude=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(current);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingByListingId(_response);
        });
    }

    protected processGetListingByListingId(response: Response): Promise<ListingDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingDetails>(null as any);
    }

    getListingAvailableQuantitiesByListingIds(inventoryIds: number[], signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Listing/GetListingAvailableQuantitiesByListingIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inventoryIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingAvailableQuantitiesByListingIds(_response);
        });
    }

    protected processGetListingAvailableQuantitiesByListingIds(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getListingByMarketplaceListingId(marketplaceListingId: string | undefined, signal?: AbortSignal | undefined): Promise<Listing[]> {
        let url_ = this.baseUrl + "/api/Listing/GetListingByMarketplaceListingId?";
        if (marketplaceListingId === null)
            throw new Error("The parameter 'marketplaceListingId' cannot be null.");
        else if (marketplaceListingId !== undefined)
            url_ += "marketplaceListingId=" + encodeURIComponent("" + marketplaceListingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingByMarketplaceListingId(_response);
        });
    }

    protected processGetListingByMarketplaceListingId(response: Response): Promise<Listing[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Listing[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Listing[]>(null as any);
    }

    getListingsForEvents(query: ListingQuery, useReadonlyDB: boolean | undefined, doNotProcessListingGroups: boolean | undefined, includeInternalNotes: boolean | undefined, signal?: AbortSignal | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }> {
        let url_ = this.baseUrl + "/api/Listing/GetListingsForEvents?";
        if (useReadonlyDB === null)
            throw new Error("The parameter 'useReadonlyDB' cannot be null.");
        else if (useReadonlyDB !== undefined)
            url_ += "useReadonlyDB=" + encodeURIComponent("" + useReadonlyDB) + "&";
        if (doNotProcessListingGroups === null)
            throw new Error("The parameter 'doNotProcessListingGroups' cannot be null.");
        else if (doNotProcessListingGroups !== undefined)
            url_ += "doNotProcessListingGroups=" + encodeURIComponent("" + doNotProcessListingGroups) + "&";
        if (includeInternalNotes === null)
            throw new Error("The parameter 'includeInternalNotes' cannot be null.");
        else if (includeInternalNotes !== undefined)
            url_ += "includeInternalNotes=" + encodeURIComponent("" + includeInternalNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingsForEvents(_response);
        });
    }

    protected processGetListingsForEvents(response: Response): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: EntitiesWithSummaryOfListing; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: EntitiesWithSummaryOfListing; }>(null as any);
    }

    /**
     * This use the exact same backend as GetListingsForEvents, but it is used by Advance Search
    The split up allows proper instrumentation and monitoring of the two different use cases
    This endpoint can later be replaced with a different backend
     * @param useReadonlyDB (optional) 
     * @param doNotProcessListingGroups (optional) 
     * @param includeInternalNotes (optional) 
     */
    searchListingsForEvents(query: ListingQuery, useReadonlyDB: boolean | undefined, doNotProcessListingGroups: boolean | undefined, includeInternalNotes: boolean | undefined, signal?: AbortSignal | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }> {
        let url_ = this.baseUrl + "/api/Listing/SearchListingsForEvents?";
        if (useReadonlyDB === null)
            throw new Error("The parameter 'useReadonlyDB' cannot be null.");
        else if (useReadonlyDB !== undefined)
            url_ += "useReadonlyDB=" + encodeURIComponent("" + useReadonlyDB) + "&";
        if (doNotProcessListingGroups === null)
            throw new Error("The parameter 'doNotProcessListingGroups' cannot be null.");
        else if (doNotProcessListingGroups !== undefined)
            url_ += "doNotProcessListingGroups=" + encodeURIComponent("" + doNotProcessListingGroups) + "&";
        if (includeInternalNotes === null)
            throw new Error("The parameter 'includeInternalNotes' cannot be null.");
        else if (includeInternalNotes !== undefined)
            url_ += "includeInternalNotes=" + encodeURIComponent("" + includeInternalNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchListingsForEvents(_response);
        });
    }

    protected processSearchListingsForEvents(response: Response): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: EntitiesWithSummaryOfListing; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: EntitiesWithSummaryOfListing; }>(null as any);
    }

    /**
     * This will be used by Advance Search V2 which uses OpenSearch implementation
     */
    searchListingsForEventsV2(query: ListingQueryV2, signal?: AbortSignal | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfListingWithCatalogData; }> {
        let url_ = this.baseUrl + "/api/Listing/SearchListingsForEventsV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchListingsForEventsV2(_response);
        });
    }

    protected processSearchListingsForEventsV2(response: Response): Promise<{ [key: string]: EntitiesWithSummaryOfListingWithCatalogData; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: EntitiesWithSummaryOfListingWithCatalogData; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: EntitiesWithSummaryOfListingWithCatalogData; }>(null as any);
    }

    getListingsSectionalDataForEvents(input: SectionalListingsForEventsInput, dataToInclude: ListingDetailDataField[] | undefined, processListingGroup: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }> {
        let url_ = this.baseUrl + "/api/Listing/GetListingsSectionalDataForEvents?";
        if (dataToInclude === null)
            throw new Error("The parameter 'dataToInclude' cannot be null.");
        else if (dataToInclude !== undefined)
            dataToInclude && dataToInclude.forEach(item => { url_ += "dataToInclude=" + encodeURIComponent("" + item) + "&"; });
        if (processListingGroup !== undefined && processListingGroup !== null)
            url_ += "processListingGroup=" + encodeURIComponent("" + processListingGroup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingsSectionalDataForEvents(_response);
        });
    }

    protected processGetListingsSectionalDataForEvents(response: Response): Promise<{ [key: string]: EntitiesWithSummaryOfListing; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: EntitiesWithSummaryOfListing; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: EntitiesWithSummaryOfListing; }>(null as any);
    }

    getListingsCanBeWasted(inventoryId: number | undefined, signal?: AbortSignal | undefined): Promise<ValueTupleOfBooleanAndIListOfTicket> {
        let url_ = this.baseUrl + "/api/Listing/GetListingsCanBeWasted?";
        if (inventoryId === null)
            throw new Error("The parameter 'inventoryId' cannot be null.");
        else if (inventoryId !== undefined)
            url_ += "inventoryId=" + encodeURIComponent("" + inventoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingsCanBeWasted(_response);
        });
    }

    protected processGetListingsCanBeWasted(response: Response): Promise<ValueTupleOfBooleanAndIListOfTicket> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValueTupleOfBooleanAndIListOfTicket;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValueTupleOfBooleanAndIListOfTicket>(null as any);
    }

    getDuplicateListingsForListingId(inventoryId: number | undefined, signal?: AbortSignal | undefined): Promise<DuplicateListingDetails[]> {
        let url_ = this.baseUrl + "/api/Listing/GetDuplicateListingsForListingId?";
        if (inventoryId === null)
            throw new Error("The parameter 'inventoryId' cannot be null.");
        else if (inventoryId !== undefined)
            url_ += "inventoryId=" + encodeURIComponent("" + inventoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDuplicateListingsForListingId(_response);
        });
    }

    protected processGetDuplicateListingsForListingId(response: Response): Promise<DuplicateListingDetails[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DuplicateListingDetails[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DuplicateListingDetails[]>(null as any);
    }

    getListingEnabledForAutoPricing(posEventIds: string[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Listing/GetListingEnabledForAutoPricing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(posEventIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingEnabledForAutoPricing(_response);
        });
    }

    protected processGetListingEnabledForAutoPricing(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateAutoPricingEnabledForEvent(posEventIds: string[], autoPricingState: boolean | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Listing/UpdateAutoPricingEnabledForEvent?";
        if (autoPricingState === null)
            throw new Error("The parameter 'autoPricingState' cannot be null.");
        else if (autoPricingState !== undefined)
            url_ += "autoPricingState=" + encodeURIComponent("" + autoPricingState) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(posEventIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAutoPricingEnabledForEvent(_response);
        });
    }

    protected processUpdateAutoPricingEnabledForEvent(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    createMarketplaceListings(listingId: number | undefined, marketplaces: Marketplace[] | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Listing/CreateMarketplaceListings?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketplaces);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateMarketplaceListings(_response);
        });
    }

    protected processCreateMarketplaceListings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteMarketplaceListings(listingId: number | undefined, marketplaces: Marketplace[] | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Listing/DeleteMarketplaceListings?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketplaces);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteMarketplaceListings(_response);
        });
    }

    protected processDeleteMarketplaceListings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateListingAdminHold(listingId: number | undefined, adminHoldExpirationDate: string | null | undefined, adminHoldNotes: string | null | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingAdminHold?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        if (adminHoldExpirationDate !== undefined && adminHoldExpirationDate !== null)
            url_ += "adminHoldExpirationDate=" + encodeURIComponent("" + adminHoldExpirationDate) + "&";
        if (adminHoldNotes !== undefined && adminHoldNotes !== null)
            url_ += "adminHoldNotes=" + encodeURIComponent("" + adminHoldNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingAdminHold(_response);
        });
    }

    protected processUpdateListingAdminHold(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateListingIgnoreDuplicate(listingId: number | undefined, ignoreDuplicate: boolean | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingIgnoreDuplicate?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        if (ignoreDuplicate === null)
            throw new Error("The parameter 'ignoreDuplicate' cannot be null.");
        else if (ignoreDuplicate !== undefined)
            url_ += "ignoreDuplicate=" + encodeURIComponent("" + ignoreDuplicate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingIgnoreDuplicate(_response);
        });
    }

    protected processUpdateListingIgnoreDuplicate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingByListingId(listingId: number, input: ListingDetailsUpdateInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingByListingId(_response);
        });
    }

    protected processUpdateListingByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @deprecated
     */
    updateListing(input: ListingDetailsUpdateInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListing(_response);
        });
    }

    protected processUpdateListing(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateListingPrices(listingId: number | undefined, listPrice: number | undefined, netProceedsFloor: number | undefined, signal?: AbortSignal | undefined): Promise<Listing> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingPrices?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        if (listPrice === null)
            throw new Error("The parameter 'listPrice' cannot be null.");
        else if (listPrice !== undefined)
            url_ += "listPrice=" + encodeURIComponent("" + listPrice) + "&";
        if (netProceedsFloor === null)
            throw new Error("The parameter 'netProceedsFloor' cannot be null.");
        else if (netProceedsFloor !== undefined)
            url_ += "netProceedsFloor=" + encodeURIComponent("" + netProceedsFloor) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingPrices(_response);
        });
    }

    protected processUpdateListingPrices(response: Response): Promise<Listing> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Listing;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Listing>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingsPricingSettingsByListingId(listingId: number, input: ValueTupleOfLongAndListingDetailsUpdateInput, signal?: AbortSignal | undefined): Promise<Listing> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingsPricingSettingsByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingsPricingSettingsByListingId(_response);
        });
    }

    protected processUpdateListingsPricingSettingsByListingId(response: Response): Promise<Listing> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Listing;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Listing>(null as any);
    }

    /**
     * @deprecated
     */
    updateListingsPricingSettings(input: ValueTupleOfLongAndListingDetailsUpdateInput, signal?: AbortSignal | undefined): Promise<Listing> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingsPricingSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingsPricingSettings(_response);
        });
    }

    protected processUpdateListingsPricingSettings(response: Response): Promise<Listing> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Listing;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Listing>(null as any);
    }

    /**
     * @param listingId One of the listing ids
    Used for route parsing so that action argument is parsed for consignee impersonation
     */
    mergeListingsWithListingId(listingId: number, input: MergeListingsInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/MergeListingsWithListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeListingsWithListingId(_response);
        });
    }

    protected processMergeListingsWithListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @deprecated
     */
    mergeListings(input: MergeListingsInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/MergeListings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeListings(_response);
        });
    }

    protected processMergeListings(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    bulkMergeListings(input: BulkMergeListingsInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Listing/BulkMergeListings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkMergeListings(_response);
        });
    }

    protected processBulkMergeListings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getListingMergeSuggestionsByEvent(viagogoEventId: number | undefined, excludeHeldListings: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<ListingMergeSuggestion[]> {
        let url_ = this.baseUrl + "/api/Listing/GetListingMergeSuggestionsByEvent?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (excludeHeldListings !== undefined && excludeHeldListings !== null)
            url_ += "excludeHeldListings=" + encodeURIComponent("" + excludeHeldListings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingMergeSuggestionsByEvent(_response);
        });
    }

    protected processGetListingMergeSuggestionsByEvent(response: Response): Promise<ListingMergeSuggestion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingMergeSuggestion[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingMergeSuggestion[]>(null as any);
    }

    getListingMergeSuggestions(excludeHeldListings: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<ListingMergeSuggestion[]> {
        let url_ = this.baseUrl + "/api/Listing/GetListingMergeSuggestions?";
        if (excludeHeldListings !== undefined && excludeHeldListings !== null)
            url_ += "excludeHeldListings=" + encodeURIComponent("" + excludeHeldListings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingMergeSuggestions(_response);
        });
    }

    protected processGetListingMergeSuggestions(response: Response): Promise<ListingMergeSuggestion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingMergeSuggestion[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingMergeSuggestion[]>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    splitListingsByListingId(listingId: number, input: SplitListingInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/SplitListingsByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSplitListingsByListingId(_response);
        });
    }

    protected processSplitListingsByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @deprecated
     */
    splitListings(input: SplitListingInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/SplitListings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSplitListings(_response);
        });
    }

    protected processSplitListings(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateBarcodesForListing(listingId: number | undefined, barcodes: TicketBarcode[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateBarcodesForListing?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(barcodes);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateBarcodesForListing(_response);
        });
    }

    protected processUpdateBarcodesForListing(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateETicketsForListing(listingId: number | undefined, etickets: UserDocument[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateETicketsForListing?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(etickets);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateETicketsForListing(_response);
        });
    }

    protected processUpdateETicketsForListing(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateMobileQRCodesForListing(listingId: number | undefined, mobileQRCodes: UserDocument[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateMobileQRCodesForListing?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mobileQRCodes);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMobileQRCodesForListing(_response);
        });
    }

    protected processUpdateMobileQRCodesForListing(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateExternalIdsForListing(listingId: number | undefined, externalIds: TicketExternalId[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateExternalIdsForListing?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(externalIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateExternalIdsForListing(_response);
        });
    }

    protected processUpdateExternalIdsForListing(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateTicketUrlsForListing(listingId: number | undefined, ticketUrls: TicketUrl[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateTicketUrlsForListing?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ticketUrls);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTicketUrlsForListing(_response);
        });
    }

    protected processUpdateTicketUrlsForListing(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateProofOfPurchaseForListing(listingId: number | undefined, proofDocs: UserDocument[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateProofOfPurchaseForListing?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(proofDocs);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProofOfPurchaseForListing(_response);
        });
    }

    protected processUpdateProofOfPurchaseForListing(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    getPriceHistoryByListingIdWithListingId(listingId: number, input: ValueTupleOfLongAndNullableInteger, signal?: AbortSignal | undefined): Promise<ListingPriceHistory[]> {
        let url_ = this.baseUrl + "/api/Listing/GetPriceHistoryByListingIdWithListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPriceHistoryByListingIdWithListingId(_response);
        });
    }

    protected processGetPriceHistoryByListingIdWithListingId(response: Response): Promise<ListingPriceHistory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingPriceHistory[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingPriceHistory[]>(null as any);
    }

    /**
     * @deprecated
     */
    getPriceHistoryByListingId(input: ValueTupleOfLongAndNullableInteger, signal?: AbortSignal | undefined): Promise<ListingPriceHistory[]> {
        let url_ = this.baseUrl + "/api/Listing/GetPriceHistoryByListingId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPriceHistoryByListingId(_response);
        });
    }

    protected processGetPriceHistoryByListingId(response: Response): Promise<ListingPriceHistory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingPriceHistory[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingPriceHistory[]>(null as any);
    }

    getCompListingsByEventId(viagogoEventId: number | undefined, listingId: number | null | undefined, currency: string | null | undefined, signal?: AbortSignal | undefined): Promise<CompListing[]> {
        let url_ = this.baseUrl + "/api/Listing/GetCompListingsByEventId?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (listingId !== undefined && listingId !== null)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        if (currency !== undefined && currency !== null)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompListingsByEventId(_response);
        });
    }

    protected processGetCompListingsByEventId(response: Response): Promise<CompListing[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompListing[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompListing[]>(null as any);
    }

    getListingPriceCalculation(viagogoEventId: number | undefined, listingId: number | undefined, input: ListingDetailsPricingUpdates, signal?: AbortSignal | undefined): Promise<ListingPriceCalculation> {
        let url_ = this.baseUrl + "/api/Listing/GetListingPriceCalculation?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingPriceCalculation(_response);
        });
    }

    protected processGetListingPriceCalculation(response: Response): Promise<ListingPriceCalculation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingPriceCalculation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingPriceCalculation>(null as any);
    }

    exportListings(input: ValueTupleOfListingQueryAndListingCsvColumnSelectionConfig, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Listing/ExportListings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportListings(_response);
        });
    }

    protected processExportListings(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createSeatSaver(inputs: SeatSaverListingDetailsInput[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/CreateSeatSaver";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSeatSaver(_response);
        });
    }

    protected processCreateSeatSaver(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    deleteSeatSaver(listingId: number | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/DeleteSeatSaver?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSeatSaver(_response);
        });
    }

    protected processDeleteSeatSaver(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * Swap listing from one group to another
     */
    batchSwapListingGroup(input: BatchSwapListingGroupInput, signal?: AbortSignal | undefined): Promise<{ [key: string]: Listing[]; }> {
        let url_ = this.baseUrl + "/api/Listing/BatchSwapListingGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBatchSwapListingGroup(_response);
        });
    }

    protected processBatchSwapListingGroup(response: Response): Promise<{ [key: string]: Listing[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: Listing[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: Listing[]; }>(null as any);
    }

    /**
     * Swap listing from one group to another
     */
    reorderListingInGroup(input: ReorderListingInGroupInput, signal?: AbortSignal | undefined): Promise<{ [key: string]: Listing[]; }> {
        let url_ = this.baseUrl + "/api/Listing/ReorderListingInGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReorderListingInGroup(_response);
        });
    }

    protected processReorderListingInGroup(response: Response): Promise<{ [key: string]: Listing[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: Listing[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: Listing[]; }>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingBroadcastSectionByListingId(listingId: number, input: ListingDetailsBroadcastSectionUpdates, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingBroadcastSectionByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingBroadcastSectionByListingId(_response);
        });
    }

    protected processUpdateListingBroadcastSectionByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @deprecated
     */
    updateListingBroadcastSection(input: ListingDetailsBroadcastSectionUpdates, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingBroadcastSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingBroadcastSection(_response);
        });
    }

    protected processUpdateListingBroadcastSection(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingTicketSectionByListingId(listingId: number, input: ListingDetailsTicketSectionUpdates, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingTicketSectionByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingTicketSectionByListingId(_response);
        });
    }

    protected processUpdateListingTicketSectionByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @deprecated
     */
    updateListingTicketSection(input: ListingDetailsTicketSectionUpdates, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingTicketSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingTicketSection(_response);
        });
    }

    protected processUpdateListingTicketSection(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingPricingSectionFromListingTable(listingId: number, input: ListingPricingSectionPosFieldUpdates, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingPricingSectionFromListingTable/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingPricingSectionFromListingTable(_response);
        });
    }

    protected processUpdateListingPricingSectionFromListingTable(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingPricingSectionByListingId(listingId: number, input: ListingDetailsPricingSectionUpdates, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingPricingSectionByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingPricingSectionByListingId(_response);
        });
    }

    protected processUpdateListingPricingSectionByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @deprecated
     */
    updateListingPricingSection(input: ListingDetailsPricingSectionUpdates, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingPricingSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingPricingSection(_response);
        });
    }

    protected processUpdateListingPricingSection(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingAutoPricingSectionByListingId(listingId: number, input: ListingDetailsAutoPricingSectionUpdates, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingAutoPricingSectionByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingAutoPricingSectionByListingId(_response);
        });
    }

    protected processUpdateListingAutoPricingSectionByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @deprecated
     */
    updateListingAutoPricingSection(input: ListingDetailsAutoPricingSectionUpdates, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingAutoPricingSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingAutoPricingSection(_response);
        });
    }

    protected processUpdateListingAutoPricingSection(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingAutoPricingSectionV2ByListingId(listingId: number, input: ListingDetailsAutoPricingSectionUpdatesV2, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingAutoPricingSectionV2ByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingAutoPricingSectionV2ByListingId(_response);
        });
    }

    protected processUpdateListingAutoPricingSectionV2ByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @deprecated
     */
    updateListingAutoPricingSectionV2(input: ListingDetailsAutoPricingSectionUpdatesV2, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingAutoPricingSectionV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingAutoPricingSectionV2(_response);
        });
    }

    protected processUpdateListingAutoPricingSectionV2(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateListingTagSectionByListingId(listingId: number, input: ListingDetailsTagsSectionUpdates, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingTagSectionByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingTagSectionByListingId(_response);
        });
    }

    protected processUpdateListingTagSectionByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @deprecated
     */
    updateListingTagSection(input: ListingDetailsTagsSectionUpdates, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Listing/UpdateListingTagSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingTagSection(_response);
        });
    }

    protected processUpdateListingTagSection(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    downloadMergedUserDocumentsPdf(listingId: number | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Listing/DownloadMergedUserDocumentsPdf?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadMergedUserDocumentsPdf(_response);
        });
    }

    protected processDownloadMergedUserDocumentsPdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getListingStatusByListingId(inventoryId: number | undefined, signal?: AbortSignal | undefined): Promise<ListingStatusInfo> {
        let url_ = this.baseUrl + "/api/Listing/GetListingStatusByListingId?";
        if (inventoryId === null)
            throw new Error("The parameter 'inventoryId' cannot be null.");
        else if (inventoryId !== undefined)
            url_ += "inventoryId=" + encodeURIComponent("" + inventoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingStatusByListingId(_response);
        });
    }

    protected processGetListingStatusByListingId(response: Response): Promise<ListingStatusInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingStatusInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingStatusInfo>(null as any);
    }

    getListingStatusByListingIds(inventoryIds: number[], signal?: AbortSignal | undefined): Promise<ListingStatusInfo[] | null> {
        let url_ = this.baseUrl + "/api/Listing/GetListingStatusByListingIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inventoryIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingStatusByListingIds(_response);
        });
    }

    protected processGetListingStatusByListingIds(response: Response): Promise<ListingStatusInfo[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingStatusInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingStatusInfo[] | null>(null as any);
    }

    getLastBroadcastListingMarketplaceByListingId(listingId: number | undefined, signal?: AbortSignal | undefined): Promise<Marketplace[]> {
        let url_ = this.baseUrl + "/api/Listing/GetLastBroadcastListingMarketplaceByListingId?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLastBroadcastListingMarketplaceByListingId(_response);
        });
    }

    protected processGetLastBroadcastListingMarketplaceByListingId(response: Response): Promise<Marketplace[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Marketplace[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Marketplace[]>(null as any);
    }

    downloadSeatSaversFileTemplate(signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Listing/DownloadSeatSaversFileTemplate/DownloadSeatSaversFileTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadSeatSaversFileTemplate(_response);
        });
    }

    protected processDownloadSeatSaversFileTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IListingExperimentClient {

    getListingExperimentsByViagogoEventId(viagogoEventId: number | undefined): Promise<ListingExperiment[]>;

    createListingExperiment(listingExperiment: ListingExperiment): Promise<boolean>;

    updateListingExperiment(listingExperiment: ListingExperiment): Promise<boolean>;

    restartListingExperiment(listingExperiment: ListingExperiment): Promise<boolean>;

    stopListingExperiment(viagogoEventId: number | undefined, listingGroupId: string | null | undefined): Promise<boolean>;
}

export class ListingExperimentClient extends PosClientBase implements IListingExperimentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getListingExperimentsByViagogoEventId(viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<ListingExperiment[]> {
        let url_ = this.baseUrl + "/api/ListingExperiment/GetListingExperimentsByViagogoEventId?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingExperimentsByViagogoEventId(_response);
        });
    }

    protected processGetListingExperimentsByViagogoEventId(response: Response): Promise<ListingExperiment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingExperiment[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingExperiment[]>(null as any);
    }

    createListingExperiment(listingExperiment: ListingExperiment, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ListingExperiment/CreateListingExperiment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listingExperiment);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateListingExperiment(_response);
        });
    }

    protected processCreateListingExperiment(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateListingExperiment(listingExperiment: ListingExperiment, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ListingExperiment/UpdateListingExperiment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listingExperiment);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingExperiment(_response);
        });
    }

    protected processUpdateListingExperiment(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    restartListingExperiment(listingExperiment: ListingExperiment, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ListingExperiment/RestartListingExperiment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listingExperiment);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRestartListingExperiment(_response);
        });
    }

    protected processRestartListingExperiment(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    stopListingExperiment(viagogoEventId: number | undefined, listingGroupId: string | null | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ListingExperiment/StopListingExperiment?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (listingGroupId !== undefined && listingGroupId !== null)
            url_ += "listingGroupId=" + encodeURIComponent("" + listingGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStopListingExperiment(_response);
        });
    }

    protected processStopListingExperiment(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IListingGroupClient {

    ungroupListings(listingGroupId: string | undefined): Promise<{ [key: string]: Listing[]; }>;

    setListingActiveInGroup(listingGroupId: string | undefined, listingId: number | undefined, isActive: boolean | undefined): Promise<boolean>;

    createListingGroup(input: MergeListingGroupInput): Promise<boolean>;

    updateListingGroup(listingGroupId: string | undefined, input: MergeListingGroupInput): Promise<boolean>;

    getEmptyListingGroup(): Promise<ListingGroup>;

    /**
     * Auto comp listings preview
     */
    autoCompSettingsPreview(input: AutoCompSettingsPreviewInput): Promise<PosUiActionResultWithDataOfAutoCompListingsPreview>;

    /**
     * Auto comp listings preview
     */
    autoGroupListingsPreview(input: AutoGroupListingsPreviewInput): Promise<PosUiActionResultWithDataOfAutoGroupListingsPreview>;

    /**
     * Auto comp listings preview
     */
    autoGroupListingsPreviewV2(input: AutoGroupListingsPreviewInput): Promise<PosUiActionResultWithDataOfIEnumerableOfMergeListingGroupInput>;

    getListingGroupCompData(viagogoEventId: number | undefined, listingGroupId: string | undefined): Promise<ListingGroupCompData>;
}

export class ListingGroupClient extends PosClientBase implements IListingGroupClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    ungroupListings(listingGroupId: string | undefined, signal?: AbortSignal | undefined): Promise<{ [key: string]: Listing[]; }> {
        let url_ = this.baseUrl + "/api/ListingGroup/UngroupListings?";
        if (listingGroupId === null)
            throw new Error("The parameter 'listingGroupId' cannot be null.");
        else if (listingGroupId !== undefined)
            url_ += "listingGroupId=" + encodeURIComponent("" + listingGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUngroupListings(_response);
        });
    }

    protected processUngroupListings(response: Response): Promise<{ [key: string]: Listing[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: Listing[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: Listing[]; }>(null as any);
    }

    setListingActiveInGroup(listingGroupId: string | undefined, listingId: number | undefined, isActive: boolean | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ListingGroup/SetListingActiveInGroup?";
        if (listingGroupId === null)
            throw new Error("The parameter 'listingGroupId' cannot be null.");
        else if (listingGroupId !== undefined)
            url_ += "listingGroupId=" + encodeURIComponent("" + listingGroupId) + "&";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetListingActiveInGroup(_response);
        });
    }

    protected processSetListingActiveInGroup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    createListingGroup(input: MergeListingGroupInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ListingGroup/CreateListingGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateListingGroup(_response);
        });
    }

    protected processCreateListingGroup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateListingGroup(listingGroupId: string | undefined, input: MergeListingGroupInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ListingGroup/UpdateListingGroup?";
        if (listingGroupId === null)
            throw new Error("The parameter 'listingGroupId' cannot be null.");
        else if (listingGroupId !== undefined)
            url_ += "listingGroupId=" + encodeURIComponent("" + listingGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingGroup(_response);
        });
    }

    protected processUpdateListingGroup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getEmptyListingGroup(signal?: AbortSignal | undefined): Promise<ListingGroup> {
        let url_ = this.baseUrl + "/api/ListingGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmptyListingGroup(_response);
        });
    }

    protected processGetEmptyListingGroup(response: Response): Promise<ListingGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingGroup;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingGroup>(null as any);
    }

    /**
     * Auto comp listings preview
     */
    autoCompSettingsPreview(input: AutoCompSettingsPreviewInput, signal?: AbortSignal | undefined): Promise<PosUiActionResultWithDataOfAutoCompListingsPreview> {
        let url_ = this.baseUrl + "/api/ListingGroup/AutoCompSettingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAutoCompSettingsPreview(_response);
        });
    }

    protected processAutoCompSettingsPreview(response: Response): Promise<PosUiActionResultWithDataOfAutoCompListingsPreview> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResultWithDataOfAutoCompListingsPreview;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResultWithDataOfAutoCompListingsPreview>(null as any);
    }

    /**
     * Auto comp listings preview
     */
    autoGroupListingsPreview(input: AutoGroupListingsPreviewInput, signal?: AbortSignal | undefined): Promise<PosUiActionResultWithDataOfAutoGroupListingsPreview> {
        let url_ = this.baseUrl + "/api/ListingGroup/AutoGroupListingsPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAutoGroupListingsPreview(_response);
        });
    }

    protected processAutoGroupListingsPreview(response: Response): Promise<PosUiActionResultWithDataOfAutoGroupListingsPreview> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResultWithDataOfAutoGroupListingsPreview;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResultWithDataOfAutoGroupListingsPreview>(null as any);
    }

    /**
     * Auto comp listings preview
     */
    autoGroupListingsPreviewV2(input: AutoGroupListingsPreviewInput, signal?: AbortSignal | undefined): Promise<PosUiActionResultWithDataOfIEnumerableOfMergeListingGroupInput> {
        let url_ = this.baseUrl + "/api/ListingGroup/AutoGroupListingsPreviewV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAutoGroupListingsPreviewV2(_response);
        });
    }

    protected processAutoGroupListingsPreviewV2(response: Response): Promise<PosUiActionResultWithDataOfIEnumerableOfMergeListingGroupInput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResultWithDataOfIEnumerableOfMergeListingGroupInput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResultWithDataOfIEnumerableOfMergeListingGroupInput>(null as any);
    }

    getListingGroupCompData(viagogoEventId: number | undefined, listingGroupId: string | undefined, signal?: AbortSignal | undefined): Promise<ListingGroupCompData> {
        let url_ = this.baseUrl + "/api/ListingGroup/GetListingGroupCompData?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (listingGroupId === null)
            throw new Error("The parameter 'listingGroupId' cannot be null.");
        else if (listingGroupId !== undefined)
            url_ += "listingGroupId=" + encodeURIComponent("" + listingGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingGroupCompData(_response);
        });
    }

    protected processGetListingGroupCompData(response: Response): Promise<ListingGroupCompData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingGroupCompData;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingGroupCompData>(null as any);
    }
}

export interface IListingNoteClient {

    getAccessibleListingNotes(): Promise<ListingNote[]>;
}

export class ListingNoteClient extends PosClientBase implements IListingNoteClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAccessibleListingNotes(signal?: AbortSignal | undefined): Promise<ListingNote[]> {
        let url_ = this.baseUrl + "/api/ListingNote/GetAccessibleListingNotes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessibleListingNotes(_response);
        });
    }

    protected processGetAccessibleListingNotes(response: Response): Promise<ListingNote[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingNote[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingNote[]>(null as any);
    }
}

export interface IListingsOpenSearchClient {

    /**
     * Enhanced listing search with ComprehensiveListingDocument mapped to UI DTOs
    Uses ComprehensiveListingDocument for comprehensive filtering then maps to Listing DTOs for UI consumption
    This provides the best of both worlds: comprehensive filtering + familiar UI DTOs
     * @param request The enhanced search request with ListingFilterQueryV2 criteria and options
     * @return Search results mapped to Listing DTOs with comprehensive search capabilities
     */
    searchListingsV3(request: ListingSearchRequestV2): Promise<SecureListingSearchMappedResult>;
}

export class ListingsOpenSearchClient extends PosClientBase implements IListingsOpenSearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Enhanced listing search with ComprehensiveListingDocument mapped to UI DTOs
    Uses ComprehensiveListingDocument for comprehensive filtering then maps to Listing DTOs for UI consumption
    This provides the best of both worlds: comprehensive filtering + familiar UI DTOs
     * @param request The enhanced search request with ListingFilterQueryV2 criteria and options
     * @return Search results mapped to Listing DTOs with comprehensive search capabilities
     */
    searchListingsV3(request: ListingSearchRequestV2, signal?: AbortSignal | undefined): Promise<SecureListingSearchMappedResult> {
        let url_ = this.baseUrl + "/api/OpenSearch/SearchListingsV3";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchListingsV3(_response);
        });
    }

    protected processSearchListingsV3(response: Response): Promise<SecureListingSearchMappedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SecureListingSearchMappedResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecureListingSearchMappedResult>(null as any);
    }
}

export interface ILoginClient {

    getLoginContext(returnUrl: string | null | undefined): Promise<LoginContext>;

    getLoginContextAfterAuthorization(request: LoginRequest): Promise<LoginContext>;

    setActiveAccount(accountId: string | undefined, impersonatedUserId: string | null | undefined): Promise<LoginContext>;

    logout(): Promise<LoginContext>;
}

export class LoginClient extends PosClientBase implements ILoginClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getLoginContext(returnUrl: string | null | undefined, signal?: AbortSignal | undefined): Promise<LoginContext> {
        let url_ = this.baseUrl + "/api/Login/GetLoginContext?";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLoginContext(_response);
        });
    }

    protected processGetLoginContext(response: Response): Promise<LoginContext> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoginContext;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginContext>(null as any);
    }

    getLoginContextAfterAuthorization(request: LoginRequest, signal?: AbortSignal | undefined): Promise<LoginContext> {
        let url_ = this.baseUrl + "/api/Login/GetLoginContextAfterAuthorization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLoginContextAfterAuthorization(_response);
        });
    }

    protected processGetLoginContextAfterAuthorization(response: Response): Promise<LoginContext> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoginContext;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginContext>(null as any);
    }

    setActiveAccount(accountId: string | undefined, impersonatedUserId: string | null | undefined, signal?: AbortSignal | undefined): Promise<LoginContext> {
        let url_ = this.baseUrl + "/api/Login/SetActiveAccount?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (impersonatedUserId !== undefined && impersonatedUserId !== null)
            url_ += "impersonatedUserId=" + encodeURIComponent("" + impersonatedUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetActiveAccount(_response);
        });
    }

    protected processSetActiveAccount(response: Response): Promise<LoginContext> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoginContext;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginContext>(null as any);
    }

    logout(signal?: AbortSignal | undefined): Promise<LoginContext> {
        let url_ = this.baseUrl + "/api/Login/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<LoginContext> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoginContext;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginContext>(null as any);
    }
}

export interface IMarketplacePaymentClient {

    getMarketplacePayments(query: MarketplacePaymentQuery): Promise<EntitiesWithSummaryOfMarketplaceSalePayment>;

    getMarketplacePaymentById(marketplacePaymentId: number): Promise<MarketplaceSalePayment>;

    getMonthsContainerMarketplacePayments(query: MarketplacePaymentQuery): Promise<MonthContainingMarketplacePaymentsResult[]>;

    getPaymentLinesWithSales(marketplacePaymentId: number | undefined): Promise<MarketplacePaymentLineWithSaleInfo[]>;

    getPaymentLinesWithSalesByFilters(query: MarketplacePaymentLineQuery, marketplacePaymentId: number | undefined): Promise<MarketplacePaymentLineWithSaleInfo[]>;

    convertMarketplacePaymentAmount(marketplacePaymentId: number | undefined, convertedPaymentAmount: number | null | undefined, convertedPaymentCurrencyCode: string | null | undefined): Promise<boolean>;

    addMarketplacePaymentLineToSaleLineItems(marketplacePaymentLineId: number | undefined, saleLineItems: SaleLineItem[]): Promise<boolean>;

    removeMarketplacePaymentLineFromSaleLineItems(marketplacePaymentLineId: number | undefined): Promise<boolean>;

    linkMarketplacePaymentLine(saleId: number | undefined, marketplacePaymentLineId: number | undefined): Promise<boolean>;

    unlinkMarketplacePaymentLine(marketplacePaymentLineId: number | undefined): Promise<boolean>;

    addMarketplacePaymentLine(marketplacePaymentSaleLineInput: MarketplacePaymentSaleLineInput): Promise<boolean>;

    updateMarketplacePaymentLine(marketplacePaymentSaleLineInput: MarketplacePaymentSaleLineInput): Promise<boolean>;

    exportPayments(query: MarketplacePaymentQuery): Promise<FileResponse>;

    exportPaymentLines(marketplacePaymentId: number): Promise<FileResponse>;

    getMarketplacePaymentsByExternalPaymentId(externalPaymentId: string | undefined): Promise<MarketplaceSalePayment[]>;

    importMarketplacePaymentFromFile(file: FileParameter | null | undefined, marketplace: string | null | undefined, paymentDate: string | undefined, externalPaymentId: string | null | undefined, paymentReferenceId: string | null | undefined, paymentCurrency: string | null | undefined, paymentAmount: number | undefined): Promise<ImportFileResult>;

    downloadMarketplacePaymentTemplate(): Promise<FileResponse>;

    deleteMarketplacePayment(marketplacePaymentId: number | undefined, keepSaleLineItemLinkedWithSale: boolean): Promise<boolean>;

    getIsMarketplacePaymentLockedByExternalPaymentId(externalPaymentId: string | undefined, marketplace: Marketplace | null | undefined): Promise<boolean>;

    deleteMarketplacePaymentLine(marketplacePaymentId: number | undefined): Promise<boolean>;

    updateMarketplacePayment(marketplacePaymentInput: MarketplacePaymentInput): Promise<boolean>;

    updateMarketplacePaymentIsLocked(marketplacePaymentId: number | undefined, isLocked: boolean): Promise<boolean>;
}

export class MarketplacePaymentClient extends PosClientBase implements IMarketplacePaymentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getMarketplacePayments(query: MarketplacePaymentQuery, signal?: AbortSignal | undefined): Promise<EntitiesWithSummaryOfMarketplaceSalePayment> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/GetMarketplacePayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMarketplacePayments(_response);
        });
    }

    protected processGetMarketplacePayments(response: Response): Promise<EntitiesWithSummaryOfMarketplaceSalePayment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntitiesWithSummaryOfMarketplaceSalePayment;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntitiesWithSummaryOfMarketplaceSalePayment>(null as any);
    }

    getMarketplacePaymentById(marketplacePaymentId: number, signal?: AbortSignal | undefined): Promise<MarketplaceSalePayment> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/GetMarketplacePaymentById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketplacePaymentId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMarketplacePaymentById(_response);
        });
    }

    protected processGetMarketplacePaymentById(response: Response): Promise<MarketplaceSalePayment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketplaceSalePayment;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketplaceSalePayment>(null as any);
    }

    getMonthsContainerMarketplacePayments(query: MarketplacePaymentQuery, signal?: AbortSignal | undefined): Promise<MonthContainingMarketplacePaymentsResult[]> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/GetMonthsContainerMarketplacePayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMonthsContainerMarketplacePayments(_response);
        });
    }

    protected processGetMonthsContainerMarketplacePayments(response: Response): Promise<MonthContainingMarketplacePaymentsResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MonthContainingMarketplacePaymentsResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MonthContainingMarketplacePaymentsResult[]>(null as any);
    }

    getPaymentLinesWithSales(marketplacePaymentId: number | undefined, signal?: AbortSignal | undefined): Promise<MarketplacePaymentLineWithSaleInfo[]> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/GetPaymentLinesWithSales?";
        if (marketplacePaymentId === null)
            throw new Error("The parameter 'marketplacePaymentId' cannot be null.");
        else if (marketplacePaymentId !== undefined)
            url_ += "marketplacePaymentId=" + encodeURIComponent("" + marketplacePaymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPaymentLinesWithSales(_response);
        });
    }

    protected processGetPaymentLinesWithSales(response: Response): Promise<MarketplacePaymentLineWithSaleInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketplacePaymentLineWithSaleInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketplacePaymentLineWithSaleInfo[]>(null as any);
    }

    getPaymentLinesWithSalesByFilters(query: MarketplacePaymentLineQuery, marketplacePaymentId: number | undefined, signal?: AbortSignal | undefined): Promise<MarketplacePaymentLineWithSaleInfo[]> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/GetPaymentLinesWithSalesByFilters?";
        if (marketplacePaymentId === null)
            throw new Error("The parameter 'marketplacePaymentId' cannot be null.");
        else if (marketplacePaymentId !== undefined)
            url_ += "marketplacePaymentId=" + encodeURIComponent("" + marketplacePaymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPaymentLinesWithSalesByFilters(_response);
        });
    }

    protected processGetPaymentLinesWithSalesByFilters(response: Response): Promise<MarketplacePaymentLineWithSaleInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketplacePaymentLineWithSaleInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketplacePaymentLineWithSaleInfo[]>(null as any);
    }

    convertMarketplacePaymentAmount(marketplacePaymentId: number | undefined, convertedPaymentAmount: number | null | undefined, convertedPaymentCurrencyCode: string | null | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/ConvertMarketplacePaymentAmount?";
        if (marketplacePaymentId === null)
            throw new Error("The parameter 'marketplacePaymentId' cannot be null.");
        else if (marketplacePaymentId !== undefined)
            url_ += "marketplacePaymentId=" + encodeURIComponent("" + marketplacePaymentId) + "&";
        if (convertedPaymentAmount !== undefined && convertedPaymentAmount !== null)
            url_ += "convertedPaymentAmount=" + encodeURIComponent("" + convertedPaymentAmount) + "&";
        if (convertedPaymentCurrencyCode !== undefined && convertedPaymentCurrencyCode !== null)
            url_ += "convertedPaymentCurrencyCode=" + encodeURIComponent("" + convertedPaymentCurrencyCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConvertMarketplacePaymentAmount(_response);
        });
    }

    protected processConvertMarketplacePaymentAmount(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    addMarketplacePaymentLineToSaleLineItems(marketplacePaymentLineId: number | undefined, saleLineItems: SaleLineItem[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/AddMarketplacePaymentLineToSaleLineItems?";
        if (marketplacePaymentLineId === null)
            throw new Error("The parameter 'marketplacePaymentLineId' cannot be null.");
        else if (marketplacePaymentLineId !== undefined)
            url_ += "marketplacePaymentLineId=" + encodeURIComponent("" + marketplacePaymentLineId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saleLineItems);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddMarketplacePaymentLineToSaleLineItems(_response);
        });
    }

    protected processAddMarketplacePaymentLineToSaleLineItems(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    removeMarketplacePaymentLineFromSaleLineItems(marketplacePaymentLineId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/RemoveMarketplacePaymentLineFromSaleLineItems?";
        if (marketplacePaymentLineId === null)
            throw new Error("The parameter 'marketplacePaymentLineId' cannot be null.");
        else if (marketplacePaymentLineId !== undefined)
            url_ += "marketplacePaymentLineId=" + encodeURIComponent("" + marketplacePaymentLineId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveMarketplacePaymentLineFromSaleLineItems(_response);
        });
    }

    protected processRemoveMarketplacePaymentLineFromSaleLineItems(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    linkMarketplacePaymentLine(saleId: number | undefined, marketplacePaymentLineId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/LinkMarketplacePaymentLine?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        if (marketplacePaymentLineId === null)
            throw new Error("The parameter 'marketplacePaymentLineId' cannot be null.");
        else if (marketplacePaymentLineId !== undefined)
            url_ += "marketplacePaymentLineId=" + encodeURIComponent("" + marketplacePaymentLineId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLinkMarketplacePaymentLine(_response);
        });
    }

    protected processLinkMarketplacePaymentLine(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    unlinkMarketplacePaymentLine(marketplacePaymentLineId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/UnlinkMarketplacePaymentLine?";
        if (marketplacePaymentLineId === null)
            throw new Error("The parameter 'marketplacePaymentLineId' cannot be null.");
        else if (marketplacePaymentLineId !== undefined)
            url_ += "marketplacePaymentLineId=" + encodeURIComponent("" + marketplacePaymentLineId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnlinkMarketplacePaymentLine(_response);
        });
    }

    protected processUnlinkMarketplacePaymentLine(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    addMarketplacePaymentLine(marketplacePaymentSaleLineInput: MarketplacePaymentSaleLineInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/AddMarketplacePaymentLine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketplacePaymentSaleLineInput);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddMarketplacePaymentLine(_response);
        });
    }

    protected processAddMarketplacePaymentLine(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateMarketplacePaymentLine(marketplacePaymentSaleLineInput: MarketplacePaymentSaleLineInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/UpdateMarketplacePaymentLine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketplacePaymentSaleLineInput);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMarketplacePaymentLine(_response);
        });
    }

    protected processUpdateMarketplacePaymentLine(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    exportPayments(query: MarketplacePaymentQuery, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/ExportPayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportPayments(_response);
        });
    }

    protected processExportPayments(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportPaymentLines(marketplacePaymentId: number, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/ExportPaymentLines";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketplacePaymentId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportPaymentLines(_response);
        });
    }

    protected processExportPaymentLines(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getMarketplacePaymentsByExternalPaymentId(externalPaymentId: string | undefined, signal?: AbortSignal | undefined): Promise<MarketplaceSalePayment[]> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/GetMarketplacePaymentsByExternalPaymentId?";
        if (externalPaymentId === null)
            throw new Error("The parameter 'externalPaymentId' cannot be null.");
        else if (externalPaymentId !== undefined)
            url_ += "externalPaymentId=" + encodeURIComponent("" + externalPaymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMarketplacePaymentsByExternalPaymentId(_response);
        });
    }

    protected processGetMarketplacePaymentsByExternalPaymentId(response: Response): Promise<MarketplaceSalePayment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketplaceSalePayment[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketplaceSalePayment[]>(null as any);
    }

    importMarketplacePaymentFromFile(file: FileParameter | null | undefined, marketplace: string | null | undefined, paymentDate: string | undefined, externalPaymentId: string | null | undefined, paymentReferenceId: string | null | undefined, paymentCurrency: string | null | undefined, paymentAmount: number | undefined, signal?: AbortSignal | undefined): Promise<ImportFileResult> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/ImportMarketplacePaymentFromFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (marketplace !== null && marketplace !== undefined)
            content_.append("Marketplace", marketplace.toString());
        if (paymentDate === null || paymentDate === undefined)
            throw new Error("The parameter 'paymentDate' cannot be null.");
        else
            content_.append("PaymentDate", paymentDate.toString());
        if (externalPaymentId !== null && externalPaymentId !== undefined)
            content_.append("ExternalPaymentId", externalPaymentId.toString());
        if (paymentReferenceId !== null && paymentReferenceId !== undefined)
            content_.append("PaymentReferenceId", paymentReferenceId.toString());
        if (paymentCurrency !== null && paymentCurrency !== undefined)
            content_.append("PaymentCurrency", paymentCurrency.toString());
        if (paymentAmount === null || paymentAmount === undefined)
            throw new Error("The parameter 'paymentAmount' cannot be null.");
        else
            content_.append("PaymentAmount", paymentAmount.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportMarketplacePaymentFromFile(_response);
        });
    }

    protected processImportMarketplacePaymentFromFile(response: Response): Promise<ImportFileResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportFileResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportFileResult>(null as any);
    }

    downloadMarketplacePaymentTemplate(signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/DownloadMarketplacePaymentTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadMarketplacePaymentTemplate(_response);
        });
    }

    protected processDownloadMarketplacePaymentTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteMarketplacePayment(marketplacePaymentId: number | undefined, keepSaleLineItemLinkedWithSale: boolean, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/DeleteMarketplacePayment?";
        if (marketplacePaymentId === null)
            throw new Error("The parameter 'marketplacePaymentId' cannot be null.");
        else if (marketplacePaymentId !== undefined)
            url_ += "marketplacePaymentId=" + encodeURIComponent("" + marketplacePaymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keepSaleLineItemLinkedWithSale);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteMarketplacePayment(_response);
        });
    }

    protected processDeleteMarketplacePayment(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getIsMarketplacePaymentLockedByExternalPaymentId(externalPaymentId: string | undefined, marketplace: Marketplace | null | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/GetIsMarketplacePaymentLockedByExternalPaymentId?";
        if (externalPaymentId === null)
            throw new Error("The parameter 'externalPaymentId' cannot be null.");
        else if (externalPaymentId !== undefined)
            url_ += "externalPaymentId=" + encodeURIComponent("" + externalPaymentId) + "&";
        if (marketplace !== undefined && marketplace !== null)
            url_ += "marketplace=" + encodeURIComponent("" + marketplace) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIsMarketplacePaymentLockedByExternalPaymentId(_response);
        });
    }

    protected processGetIsMarketplacePaymentLockedByExternalPaymentId(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteMarketplacePaymentLine(marketplacePaymentId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/DeleteMarketplacePaymentLine?";
        if (marketplacePaymentId === null)
            throw new Error("The parameter 'marketplacePaymentId' cannot be null.");
        else if (marketplacePaymentId !== undefined)
            url_ += "marketplacePaymentId=" + encodeURIComponent("" + marketplacePaymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteMarketplacePaymentLine(_response);
        });
    }

    protected processDeleteMarketplacePaymentLine(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateMarketplacePayment(marketplacePaymentInput: MarketplacePaymentInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/UpdateMarketplacePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketplacePaymentInput);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMarketplacePayment(_response);
        });
    }

    protected processUpdateMarketplacePayment(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateMarketplacePaymentIsLocked(marketplacePaymentId: number | undefined, isLocked: boolean, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/MarketplacePayment/UpdateMarketplacePaymentIsLocked?";
        if (marketplacePaymentId === null)
            throw new Error("The parameter 'marketplacePaymentId' cannot be null.");
        else if (marketplacePaymentId !== undefined)
            url_ += "marketplacePaymentId=" + encodeURIComponent("" + marketplacePaymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(isLocked);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMarketplacePaymentIsLocked(_response);
        });
    }

    protected processUpdateMarketplacePaymentIsLocked(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IMoneyClient {

    getConvertedMoneyAmount(valuesToConvert: { [key: string]: number; }, toCurrencyCode: string | undefined): Promise<number>;

    getAvailableCurrencies(): Promise<UiCurrency[]>;
}

export class MoneyClient extends PosClientBase implements IMoneyClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getConvertedMoneyAmount(valuesToConvert: { [key: string]: number; }, toCurrencyCode: string | undefined, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Money/GetConvertedMoneyAmount?";
        if (toCurrencyCode === null)
            throw new Error("The parameter 'toCurrencyCode' cannot be null.");
        else if (toCurrencyCode !== undefined)
            url_ += "toCurrencyCode=" + encodeURIComponent("" + toCurrencyCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(valuesToConvert);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConvertedMoneyAmount(_response);
        });
    }

    protected processGetConvertedMoneyAmount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getAvailableCurrencies(signal?: AbortSignal | undefined): Promise<UiCurrency[]> {
        let url_ = this.baseUrl + "/api/Money/GetAvailableCurrencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableCurrencies(_response);
        });
    }

    protected processGetAvailableCurrencies(response: Response): Promise<UiCurrency[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UiCurrency[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UiCurrency[]>(null as any);
    }
}

export interface INotificationClient {

    getActiveNotifications(): Promise<Notification[]>;

    getNotification(notificationId: number | undefined): Promise<Notification>;

    dismissNotification(notificationId: number | undefined): Promise<void>;
}

export class NotificationClient extends PosClientBase implements INotificationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getActiveNotifications(signal?: AbortSignal | undefined): Promise<Notification[]> {
        let url_ = this.baseUrl + "/api/Notification/GetActiveNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActiveNotifications(_response);
        });
    }

    protected processGetActiveNotifications(response: Response): Promise<Notification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Notification[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification[]>(null as any);
    }

    getNotification(notificationId: number | undefined, signal?: AbortSignal | undefined): Promise<Notification> {
        let url_ = this.baseUrl + "/api/Notification/GetNotification?";
        if (notificationId === null)
            throw new Error("The parameter 'notificationId' cannot be null.");
        else if (notificationId !== undefined)
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNotification(_response);
        });
    }

    protected processGetNotification(response: Response): Promise<Notification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Notification;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification>(null as any);
    }

    dismissNotification(notificationId: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Notification/DismissNotification?";
        if (notificationId === null)
            throw new Error("The parameter 'notificationId' cannot be null.");
        else if (notificationId !== undefined)
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDismissNotification(_response);
        });
    }

    protected processDismissNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IPricingClient {

    mergeListingGroupPricingSettings(listingGroupId: string | undefined, viagogoEventId: number | null | undefined, input: AutoPricingInputs): Promise<boolean>;

    updateListingGroupPricingSettingsFromOnePager(listingGroupId: string | undefined, eventId: number | undefined, request: UpdateListingGroupAutoPriceSettingsFromOnePagerRequest): Promise<PosUiActionResult>;

    updateListingGroupPricingSettings(listingGroupId: string | undefined, eventId: number | undefined, input: ListingGroupAutoPriceSettings): Promise<PosUiActionResult>;

    getListingGroupAutoPricingSettings(listingGroupId: string | undefined, eventId: number | undefined): Promise<AutoPricingInputs>;

    mergeEventPricingSettings(eventId: number | undefined, input: EventAutoPricingSettingsInputs): Promise<boolean>;

    getEventAutoPricingSettings(eventId: number | undefined): Promise<EventAutoPricingSettingsInputs>;

    getAccountAutoPricingSettings(): Promise<AutoPricingInputs>;

    getEventSeatMapScoreOverrides(eventId: number | undefined, venueConfigId: number | undefined): Promise<EventConfigScoreOverride[]>;

    getEventSeatMapScoreOverridesForSellerAccount(): Promise<SellerAccountEventConfigScoreOverrides[]>;

    getEventSellThroughRates(eventId: number | undefined): Promise<SellThroughRateHistory[]>;

    getListingGroupSellThroughRates(listingGroupId: string | undefined): Promise<SellThroughRateHistory[]>;

    getEventSellThroughRateTargets(viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined): Promise<SellThroughRateHistory[]>;

    setEventSellThroughRateTargets(viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined, sellThroughRateTargets: SellThroughRateHistory[]): Promise<boolean>;

    getAutoPricingStrategies(viagogoEventId: number | null | undefined, listingId: number | null | undefined): Promise<AutoPricingSettingsCollection[]>;

    upsertAutoPricingStrategy(input: AutoPricingSettingsCollection): Promise<number | null>;

    deleteAutoPricingStrategy(autoPricingSettingsCollectionId: number | undefined): Promise<boolean>;

    setEventSeatMapScoreOverride(eventId: number | undefined, eventConfigScoreOverrideId: number | null | undefined, scoreModel: ScoreModel | null | undefined): Promise<void>;

    upsertEventSeatMapScoreOverride(input: EventConfigScoreOverride): Promise<number>;

    deleteEventSeatMapScoreOverride(eventConfigScoreOverrideId: number | undefined): Promise<void>;

    downloadSeatScoreFile(eventId: number | undefined): Promise<FileResponse>;

    uploadSeatScoreFile(eventId: number | undefined, venueConfigId: number | undefined, eventConfigScoreOverrideId: number | null | undefined, name: string | null | undefined, file: FileParameter | null | undefined): Promise<EventConfigScoreOverride>;

    resetListingAutoPricingSettingsInGroup(listingGroupId: string | undefined): Promise<boolean>;

    upsertAutoCompSettings(request: UpsertAutoCompSettingsInput): Promise<boolean>;

    getAutoCompSettings(viagogoEventId: number | undefined): Promise<AutoCompSettingsResult>;

    getListingAutoPricingSettings(listingId: number | undefined, viagogoEventId: number | undefined): Promise<ListingDetailsAutoPricingSectionUpdates>;

    getVenueMapZoneConfigInfo(viagogoEventId: number | undefined, configId: number | undefined): Promise<VenueMapZoneConfigInfo>;

    getPricingConfigFromEventIds(eventIds: number[]): Promise<EventsPricingConfig>;

    setVenueZoneSelectedConfigType(viagogoEventId: number | undefined, venueZoneOverrideId: number | null | undefined, venueZoneConfigType: VenueZoneConfigType | null | undefined, setMapAsDefault: boolean | null | undefined): Promise<void>;

    getVenueMapZoneInfoOverrides(viagogoEventId: number | undefined, configId: number | undefined): Promise<{ [key: string]: VenueZoneConfigOverride; }>;

    getActiveVenueZoneMapSectionGroups(viagogoEventId: number | undefined): Promise<{ [key: string]: SectionSectionGroup; }>;

    upsertVenueZoneSectionGroupOverrides(request: UpsertVenueZoneSectionGroupOverridesInput): Promise<number | null>;

    getEventMapConfigMetadata(viagogoEventId: number | undefined): Promise<EventMapConfigMetadata>;

    getScoreSectionRecommendationsByRow(viagogoEventId: number | undefined, venueConfigId: number | undefined, rowId: number | undefined): Promise<SqsSectionRowRecommendations>;

    getSellerEventPricingUserGroupId(viagogoEventId: number | undefined): Promise<number | null>;

    setSellerEventPricingUserGroup(viagogoEventId: number | undefined, userGroupId: number | null | undefined): Promise<boolean>;

    suppressVelocityCircuitBreaker(listingId: number | undefined, suppressionType: VelocityCircuitBreakerSuppressionType | undefined): Promise<boolean>;

    getSellerEventWithVenueByVenueConfigId(venueConfigId: number | undefined): Promise<SellerEventWithVenue[]>;
}

export class PricingClient extends PosClientBase implements IPricingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    mergeListingGroupPricingSettings(listingGroupId: string | undefined, viagogoEventId: number | null | undefined, input: AutoPricingInputs, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pricing/MergeListingGroupPricingSettings?";
        if (listingGroupId === null)
            throw new Error("The parameter 'listingGroupId' cannot be null.");
        else if (listingGroupId !== undefined)
            url_ += "listingGroupId=" + encodeURIComponent("" + listingGroupId) + "&";
        if (viagogoEventId !== undefined && viagogoEventId !== null)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeListingGroupPricingSettings(_response);
        });
    }

    protected processMergeListingGroupPricingSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateListingGroupPricingSettingsFromOnePager(listingGroupId: string | undefined, eventId: number | undefined, request: UpdateListingGroupAutoPriceSettingsFromOnePagerRequest, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Pricing/UpdateListingGroupPricingSettingsFromOnePager?";
        if (listingGroupId === null)
            throw new Error("The parameter 'listingGroupId' cannot be null.");
        else if (listingGroupId !== undefined)
            url_ += "listingGroupId=" + encodeURIComponent("" + listingGroupId) + "&";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingGroupPricingSettingsFromOnePager(_response);
        });
    }

    protected processUpdateListingGroupPricingSettingsFromOnePager(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateListingGroupPricingSettings(listingGroupId: string | undefined, eventId: number | undefined, input: ListingGroupAutoPriceSettings, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Pricing/UpdateListingGroupPricingSettings?";
        if (listingGroupId === null)
            throw new Error("The parameter 'listingGroupId' cannot be null.");
        else if (listingGroupId !== undefined)
            url_ += "listingGroupId=" + encodeURIComponent("" + listingGroupId) + "&";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateListingGroupPricingSettings(_response);
        });
    }

    protected processUpdateListingGroupPricingSettings(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    getListingGroupAutoPricingSettings(listingGroupId: string | undefined, eventId: number | undefined, signal?: AbortSignal | undefined): Promise<AutoPricingInputs> {
        let url_ = this.baseUrl + "/api/Pricing/GetListingGroupAutoPricingSettings?";
        if (listingGroupId === null)
            throw new Error("The parameter 'listingGroupId' cannot be null.");
        else if (listingGroupId !== undefined)
            url_ += "listingGroupId=" + encodeURIComponent("" + listingGroupId) + "&";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingGroupAutoPricingSettings(_response);
        });
    }

    protected processGetListingGroupAutoPricingSettings(response: Response): Promise<AutoPricingInputs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoPricingInputs;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoPricingInputs>(null as any);
    }

    mergeEventPricingSettings(eventId: number | undefined, input: EventAutoPricingSettingsInputs, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pricing/MergeEventPricingSettings?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeEventPricingSettings(_response);
        });
    }

    protected processMergeEventPricingSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getEventAutoPricingSettings(eventId: number | undefined, signal?: AbortSignal | undefined): Promise<EventAutoPricingSettingsInputs> {
        let url_ = this.baseUrl + "/api/Pricing/GetEventAutoPricingSettings?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventAutoPricingSettings(_response);
        });
    }

    protected processGetEventAutoPricingSettings(response: Response): Promise<EventAutoPricingSettingsInputs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventAutoPricingSettingsInputs;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventAutoPricingSettingsInputs>(null as any);
    }

    getAccountAutoPricingSettings(signal?: AbortSignal | undefined): Promise<AutoPricingInputs> {
        let url_ = this.baseUrl + "/api/Pricing/GetAccountAutoPricingSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccountAutoPricingSettings(_response);
        });
    }

    protected processGetAccountAutoPricingSettings(response: Response): Promise<AutoPricingInputs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoPricingInputs;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoPricingInputs>(null as any);
    }

    getEventSeatMapScoreOverrides(eventId: number | undefined, venueConfigId: number | undefined, signal?: AbortSignal | undefined): Promise<EventConfigScoreOverride[]> {
        let url_ = this.baseUrl + "/api/Pricing/GetEventSeatMapScoreOverrides?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        if (venueConfigId === null)
            throw new Error("The parameter 'venueConfigId' cannot be null.");
        else if (venueConfigId !== undefined)
            url_ += "venueConfigId=" + encodeURIComponent("" + venueConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventSeatMapScoreOverrides(_response);
        });
    }

    protected processGetEventSeatMapScoreOverrides(response: Response): Promise<EventConfigScoreOverride[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventConfigScoreOverride[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventConfigScoreOverride[]>(null as any);
    }

    getEventSeatMapScoreOverridesForSellerAccount(signal?: AbortSignal | undefined): Promise<SellerAccountEventConfigScoreOverrides[]> {
        let url_ = this.baseUrl + "/api/Pricing/GetEventSeatMapScoreOverridesForSellerAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventSeatMapScoreOverridesForSellerAccount(_response);
        });
    }

    protected processGetEventSeatMapScoreOverridesForSellerAccount(response: Response): Promise<SellerAccountEventConfigScoreOverrides[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerAccountEventConfigScoreOverrides[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerAccountEventConfigScoreOverrides[]>(null as any);
    }

    getEventSellThroughRates(eventId: number | undefined, signal?: AbortSignal | undefined): Promise<SellThroughRateHistory[]> {
        let url_ = this.baseUrl + "/api/Pricing/GetEventSellThroughRates?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventSellThroughRates(_response);
        });
    }

    protected processGetEventSellThroughRates(response: Response): Promise<SellThroughRateHistory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellThroughRateHistory[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellThroughRateHistory[]>(null as any);
    }

    getListingGroupSellThroughRates(listingGroupId: string | undefined, signal?: AbortSignal | undefined): Promise<SellThroughRateHistory[]> {
        let url_ = this.baseUrl + "/api/Pricing/GetListingGroupSellThroughRates?";
        if (listingGroupId === null)
            throw new Error("The parameter 'listingGroupId' cannot be null.");
        else if (listingGroupId !== undefined)
            url_ += "listingGroupId=" + encodeURIComponent("" + listingGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingGroupSellThroughRates(_response);
        });
    }

    protected processGetListingGroupSellThroughRates(response: Response): Promise<SellThroughRateHistory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellThroughRateHistory[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellThroughRateHistory[]>(null as any);
    }

    getEventSellThroughRateTargets(viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined, signal?: AbortSignal | undefined): Promise<SellThroughRateHistory[]> {
        let url_ = this.baseUrl + "/api/Pricing/GetEventSellThroughRateTargets?";
        if (viagogoEventId !== undefined && viagogoEventId !== null)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (eventMappingId !== undefined && eventMappingId !== null)
            url_ += "eventMappingId=" + encodeURIComponent("" + eventMappingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventSellThroughRateTargets(_response);
        });
    }

    protected processGetEventSellThroughRateTargets(response: Response): Promise<SellThroughRateHistory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellThroughRateHistory[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellThroughRateHistory[]>(null as any);
    }

    setEventSellThroughRateTargets(viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined, sellThroughRateTargets: SellThroughRateHistory[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pricing/SetEventSellThroughRateTargets?";
        if (viagogoEventId !== undefined && viagogoEventId !== null)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (eventMappingId !== undefined && eventMappingId !== null)
            url_ += "eventMappingId=" + encodeURIComponent("" + eventMappingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sellThroughRateTargets);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetEventSellThroughRateTargets(_response);
        });
    }

    protected processSetEventSellThroughRateTargets(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAutoPricingStrategies(viagogoEventId: number | null | undefined, listingId: number | null | undefined, signal?: AbortSignal | undefined): Promise<AutoPricingSettingsCollection[]> {
        let url_ = this.baseUrl + "/api/Pricing/GetAutoPricingStrategies?";
        if (viagogoEventId !== undefined && viagogoEventId !== null)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (listingId !== undefined && listingId !== null)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAutoPricingStrategies(_response);
        });
    }

    protected processGetAutoPricingStrategies(response: Response): Promise<AutoPricingSettingsCollection[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoPricingSettingsCollection[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoPricingSettingsCollection[]>(null as any);
    }

    upsertAutoPricingStrategy(input: AutoPricingSettingsCollection, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/Pricing/UpsertAutoPricingStrategy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertAutoPricingStrategy(_response);
        });
    }

    protected processUpsertAutoPricingStrategy(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    deleteAutoPricingStrategy(autoPricingSettingsCollectionId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pricing/DeleteAutoPricingStrategy?";
        if (autoPricingSettingsCollectionId === null)
            throw new Error("The parameter 'autoPricingSettingsCollectionId' cannot be null.");
        else if (autoPricingSettingsCollectionId !== undefined)
            url_ += "autoPricingSettingsCollectionId=" + encodeURIComponent("" + autoPricingSettingsCollectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAutoPricingStrategy(_response);
        });
    }

    protected processDeleteAutoPricingStrategy(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    setEventSeatMapScoreOverride(eventId: number | undefined, eventConfigScoreOverrideId: number | null | undefined, scoreModel: ScoreModel | null | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Pricing/SetEventSeatMapScoreOverride?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        if (eventConfigScoreOverrideId !== undefined && eventConfigScoreOverrideId !== null)
            url_ += "eventConfigScoreOverrideId=" + encodeURIComponent("" + eventConfigScoreOverrideId) + "&";
        if (scoreModel !== undefined && scoreModel !== null)
            url_ += "scoreModel=" + encodeURIComponent("" + scoreModel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetEventSeatMapScoreOverride(_response);
        });
    }

    protected processSetEventSeatMapScoreOverride(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    upsertEventSeatMapScoreOverride(input: EventConfigScoreOverride, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Pricing/UpsertEventSeatMapScoreOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertEventSeatMapScoreOverride(_response);
        });
    }

    protected processUpsertEventSeatMapScoreOverride(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteEventSeatMapScoreOverride(eventConfigScoreOverrideId: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Pricing/DeleteEventSeatMapScoreOverride?";
        if (eventConfigScoreOverrideId === null)
            throw new Error("The parameter 'eventConfigScoreOverrideId' cannot be null.");
        else if (eventConfigScoreOverrideId !== undefined)
            url_ += "eventConfigScoreOverrideId=" + encodeURIComponent("" + eventConfigScoreOverrideId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteEventSeatMapScoreOverride(_response);
        });
    }

    protected processDeleteEventSeatMapScoreOverride(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    downloadSeatScoreFile(eventId: number | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Pricing/DownloadSeatScoreFile?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadSeatScoreFile(_response);
        });
    }

    protected processDownloadSeatScoreFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadSeatScoreFile(eventId: number | undefined, venueConfigId: number | undefined, eventConfigScoreOverrideId: number | null | undefined, name: string | null | undefined, file: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<EventConfigScoreOverride> {
        let url_ = this.baseUrl + "/api/Pricing/UploadSeatScoreFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (eventId === null || eventId === undefined)
            throw new Error("The parameter 'eventId' cannot be null.");
        else
            content_.append("EventId", eventId.toString());
        if (venueConfigId === null || venueConfigId === undefined)
            throw new Error("The parameter 'venueConfigId' cannot be null.");
        else
            content_.append("VenueConfigId", venueConfigId.toString());
        if (eventConfigScoreOverrideId !== null && eventConfigScoreOverrideId !== undefined)
            content_.append("EventConfigScoreOverrideId", eventConfigScoreOverrideId.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadSeatScoreFile(_response);
        });
    }

    protected processUploadSeatScoreFile(response: Response): Promise<EventConfigScoreOverride> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventConfigScoreOverride;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventConfigScoreOverride>(null as any);
    }

    resetListingAutoPricingSettingsInGroup(listingGroupId: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pricing/ResetListingAutoPricingSettingsInGroup?";
        if (listingGroupId === null)
            throw new Error("The parameter 'listingGroupId' cannot be null.");
        else if (listingGroupId !== undefined)
            url_ += "listingGroupId=" + encodeURIComponent("" + listingGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetListingAutoPricingSettingsInGroup(_response);
        });
    }

    protected processResetListingAutoPricingSettingsInGroup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    upsertAutoCompSettings(request: UpsertAutoCompSettingsInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pricing/UpsertAutoCompSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertAutoCompSettings(_response);
        });
    }

    protected processUpsertAutoCompSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAutoCompSettings(viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<AutoCompSettingsResult> {
        let url_ = this.baseUrl + "/api/Pricing/GetAutoCompSettings?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAutoCompSettings(_response);
        });
    }

    protected processGetAutoCompSettings(response: Response): Promise<AutoCompSettingsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoCompSettingsResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoCompSettingsResult>(null as any);
    }

    getListingAutoPricingSettings(listingId: number | undefined, viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<ListingDetailsAutoPricingSectionUpdates> {
        let url_ = this.baseUrl + "/api/Pricing/GetListingAutoPricingSettings?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingAutoPricingSettings(_response);
        });
    }

    protected processGetListingAutoPricingSettings(response: Response): Promise<ListingDetailsAutoPricingSectionUpdates> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingDetailsAutoPricingSectionUpdates;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingDetailsAutoPricingSectionUpdates>(null as any);
    }

    getVenueMapZoneConfigInfo(viagogoEventId: number | undefined, configId: number | undefined, signal?: AbortSignal | undefined): Promise<VenueMapZoneConfigInfo> {
        let url_ = this.baseUrl + "/api/Pricing/GetVenueMapZoneConfigInfo/GetVenueMapZoneConfigInfo?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (configId === null)
            throw new Error("The parameter 'configId' cannot be null.");
        else if (configId !== undefined)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVenueMapZoneConfigInfo(_response);
        });
    }

    protected processGetVenueMapZoneConfigInfo(response: Response): Promise<VenueMapZoneConfigInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VenueMapZoneConfigInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VenueMapZoneConfigInfo>(null as any);
    }

    getPricingConfigFromEventIds(eventIds: number[], signal?: AbortSignal | undefined): Promise<EventsPricingConfig> {
        let url_ = this.baseUrl + "/api/Pricing/GetPricingConfigFromEventIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPricingConfigFromEventIds(_response);
        });
    }

    protected processGetPricingConfigFromEventIds(response: Response): Promise<EventsPricingConfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventsPricingConfig;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventsPricingConfig>(null as any);
    }

    setVenueZoneSelectedConfigType(viagogoEventId: number | undefined, venueZoneOverrideId: number | null | undefined, venueZoneConfigType: VenueZoneConfigType | null | undefined, setMapAsDefault: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Pricing/SetVenueZoneSelectedConfigType?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (venueZoneOverrideId !== undefined && venueZoneOverrideId !== null)
            url_ += "venueZoneOverrideId=" + encodeURIComponent("" + venueZoneOverrideId) + "&";
        if (venueZoneConfigType !== undefined && venueZoneConfigType !== null)
            url_ += "venueZoneConfigType=" + encodeURIComponent("" + venueZoneConfigType) + "&";
        if (setMapAsDefault !== undefined && setMapAsDefault !== null)
            url_ += "setMapAsDefault=" + encodeURIComponent("" + setMapAsDefault) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetVenueZoneSelectedConfigType(_response);
        });
    }

    protected processSetVenueZoneSelectedConfigType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getVenueMapZoneInfoOverrides(viagogoEventId: number | undefined, configId: number | undefined, signal?: AbortSignal | undefined): Promise<{ [key: string]: VenueZoneConfigOverride; }> {
        let url_ = this.baseUrl + "/api/Pricing/GetVenueMapZoneInfoOverrides?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (configId === null)
            throw new Error("The parameter 'configId' cannot be null.");
        else if (configId !== undefined)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVenueMapZoneInfoOverrides(_response);
        });
    }

    protected processGetVenueMapZoneInfoOverrides(response: Response): Promise<{ [key: string]: VenueZoneConfigOverride; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: VenueZoneConfigOverride; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: VenueZoneConfigOverride; }>(null as any);
    }

    getActiveVenueZoneMapSectionGroups(viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<{ [key: string]: SectionSectionGroup; }> {
        let url_ = this.baseUrl + "/api/Pricing/GetActiveVenueZoneMapSectionGroups?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActiveVenueZoneMapSectionGroups(_response);
        });
    }

    protected processGetActiveVenueZoneMapSectionGroups(response: Response): Promise<{ [key: string]: SectionSectionGroup; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: SectionSectionGroup; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: SectionSectionGroup; }>(null as any);
    }

    upsertVenueZoneSectionGroupOverrides(request: UpsertVenueZoneSectionGroupOverridesInput, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/Pricing/UpsertVenueZoneSectionGroupOverrides";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertVenueZoneSectionGroupOverrides(_response);
        });
    }

    protected processUpsertVenueZoneSectionGroupOverrides(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    getEventMapConfigMetadata(viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<EventMapConfigMetadata> {
        let url_ = this.baseUrl + "/api/Pricing/GetEventMapConfigMetadata?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventMapConfigMetadata(_response);
        });
    }

    protected processGetEventMapConfigMetadata(response: Response): Promise<EventMapConfigMetadata> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventMapConfigMetadata;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventMapConfigMetadata>(null as any);
    }

    getScoreSectionRecommendationsByRow(viagogoEventId: number | undefined, venueConfigId: number | undefined, rowId: number | undefined, signal?: AbortSignal | undefined): Promise<SqsSectionRowRecommendations> {
        let url_ = this.baseUrl + "/api/Pricing/GetScoreSectionRecommendationsByRow?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (venueConfigId === null)
            throw new Error("The parameter 'venueConfigId' cannot be null.");
        else if (venueConfigId !== undefined)
            url_ += "venueConfigId=" + encodeURIComponent("" + venueConfigId) + "&";
        if (rowId === null)
            throw new Error("The parameter 'rowId' cannot be null.");
        else if (rowId !== undefined)
            url_ += "rowId=" + encodeURIComponent("" + rowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetScoreSectionRecommendationsByRow(_response);
        });
    }

    protected processGetScoreSectionRecommendationsByRow(response: Response): Promise<SqsSectionRowRecommendations> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SqsSectionRowRecommendations;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SqsSectionRowRecommendations>(null as any);
    }

    getSellerEventPricingUserGroupId(viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/Pricing/GetSellerEventPricingUserGroupId?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerEventPricingUserGroupId(_response);
        });
    }

    protected processGetSellerEventPricingUserGroupId(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    setSellerEventPricingUserGroup(viagogoEventId: number | undefined, userGroupId: number | null | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pricing/SetSellerEventPricingUserGroup?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (userGroupId !== undefined && userGroupId !== null)
            url_ += "userGroupId=" + encodeURIComponent("" + userGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetSellerEventPricingUserGroup(_response);
        });
    }

    protected processSetSellerEventPricingUserGroup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    suppressVelocityCircuitBreaker(listingId: number | undefined, suppressionType: VelocityCircuitBreakerSuppressionType | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pricing/SuppressVelocityCircuitBreaker?";
        if (listingId === null)
            throw new Error("The parameter 'listingId' cannot be null.");
        else if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        if (suppressionType === null)
            throw new Error("The parameter 'suppressionType' cannot be null.");
        else if (suppressionType !== undefined)
            url_ += "suppressionType=" + encodeURIComponent("" + suppressionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSuppressVelocityCircuitBreaker(_response);
        });
    }

    protected processSuppressVelocityCircuitBreaker(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getSellerEventWithVenueByVenueConfigId(venueConfigId: number | undefined, signal?: AbortSignal | undefined): Promise<SellerEventWithVenue[]> {
        let url_ = this.baseUrl + "/api/Pricing/GetSellerEventWithVenueByVenueConfigId?";
        if (venueConfigId === null)
            throw new Error("The parameter 'venueConfigId' cannot be null.");
        else if (venueConfigId !== undefined)
            url_ += "venueConfigId=" + encodeURIComponent("" + venueConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerEventWithVenueByVenueConfigId(_response);
        });
    }

    protected processGetSellerEventWithVenueByVenueConfigId(response: Response): Promise<SellerEventWithVenue[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerEventWithVenue[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerEventWithVenue[]>(null as any);
    }
}

export interface IPurchaseClient {

    getPurchaseOrderByPurchaseOrderId(purchaseOrderId: number | undefined, getCatalog: boolean | undefined): Promise<PurchaseOrderDetails>;

    getPurchaseOrdersByVendorOrderId(orderId: string | undefined): Promise<PurchaseOrderDetails[]>;

    getPurchaseOrders(query: PurchaseOrderQuery, useReadonlyDB: boolean | undefined): Promise<EntitiesWithSummaryOfPurchaseOrder>;

    /**
     * This use the exact same backend as GetPurchaseOrders, but it is used by Advance Search
    The split up allows proper instrumentation and monitoring of the two different use cases
    This endpoint can later be replaced with a different backend
     * @param useReadonlyDB (optional) 
     */
    searchPurchaseOrders(query: PurchaseOrderQuery, useReadonlyDB: boolean | undefined): Promise<EntitiesWithSummaryOfPurchaseOrder>;

    /**
     * This will be used by Advance Search V2 which uses OpenSearch implementation
     */
    searchPurchaseOrdersV2(query: PurchaseOrderQueryV2): Promise<EntitiesWithSummaryOfPurchaseOrderTicketGroup>;

    getPurchaseOrdersWithTicketGroups(query: PurchaseOrderQuery): Promise<EntitiesWithSummaryOfPurchaseOrderTicketGroup>;

    getTicketGroupsForEvents(query: PurchaseOrderQuery): Promise<{ [key: string]: EntitiesWithSummaryOfPurchaseOrderTicketGroup; }>;

    getAccessibleVendors(getDeliveryOverride: boolean | undefined, getVendorAccountsCount: boolean | undefined): Promise<PurchaseVendor[]>;

    getAccessibleAccessControlProviders(): Promise<AccessControlProvider[]>;

    getAccessibleVendorAccounts(input: ValueTupleOfISetOfIntegerAndISetOfGuid, searchText: string | null | undefined, take: number | null | undefined, skip: number | null | undefined): Promise<PurchaseVendorAccount[]>;

    getVendorAccountDetails(purchaseOrderVendorAccountId: string | undefined): Promise<PurchaseVendorAccountDetails>;

    getPurchaseOrderIdsUsingOrderId(orderId: string | undefined): Promise<number[]>;

    getIsPurchasingIdsInUse(orderId: string | undefined, purchaseOrderVendorId: number | null | undefined): Promise<PurchasingIdInUseResultType>;

    getMonthsContainerPurchaseOrders(query: PurchaseOrderQuery): Promise<MonthContainingPurchaseOrdersResult[]>;

    getTimePeriodContainerPurchaseOrders(query: PurchaseOrderQuery, timePeriodType: TimePeriodType | undefined): Promise<TimePeriodContainingPurchaseOrderResult[]>;

    insertPurchaseOrder(input: PurchaseOrderDetailsInput, isManual: boolean | undefined): Promise<PosUiActionResult>;

    insertPurchaseOrders(input: PurchaseOrderDetailsInput[], isManual: boolean | undefined): Promise<PosUiActionResultWithDataOfIEnumerableOfNullableLong>;

    downloadPurchaseFileTemplate(includeEventIdFields: boolean | undefined): Promise<FileResponse>;

    /**
     * @param purchaseOrderId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updatePurchaseOrderByPurchaseOrderId(purchaseOrderId: number, input: PurchaseOrderDetailsInput): Promise<PosUiActionResult>;

    /**
     * @deprecated
     */
    updatePurchaseOrder(input: PurchaseOrderDetailsInput): Promise<PosUiActionResult>;

    updatePurchasesQualityControlState(inputs: ValueTupleOfISetOfLongAndPosFieldOfNullableQualityControlState): Promise<boolean>;

    getVendor(vendorId: number | undefined): Promise<PurchaseVendor>;

    mergeVendor(vendor: PurchaseVendor): Promise<number | null>;

    deleteVendor(vendorId: number | undefined): Promise<boolean>;

    mergeVendorAccount(vendorAccount: PurchaseVendorAccountDetails): Promise<string | null>;

    deleteVendorAccount(vendorAccountId: string | undefined): Promise<boolean>;

    getAllCurrencyConversionOverride(): Promise<CurrencyConversionOverride[]>;

    insertCurrencyConversionOverride(conversionOverrideRequest: CurrencyConversionOverrideRequest): Promise<number | null>;

    updateCurrencyConversionOverride(conversionOverrideRequest: CurrencyConversionOverrideRequest): Promise<boolean>;

    deleteCurrencyConversionOverride(currencyConversionOverrideId: number | undefined): Promise<boolean>;

    getAccessiblePurchasePaymentMethods(): Promise<PurchasePaymentMethod[]>;

    getPurchasePaymentMethodsByName(paymentMethodName: string | undefined): Promise<PurchasePaymentMethod[]>;

    insertPurchasePaymentMethod(input: PurchasePaymentMethod): Promise<number>;

    updatePurchasePaymentMethod(input: PurchasePaymentMethod): Promise<boolean>;

    deletePurchasePaymentMethod(purchasePaymentMethodId: number): Promise<boolean>;

    cancelPurchaseOrder(purchaseOrderId: number | undefined, rejectSale: boolean | null | undefined, saleCancellationReason: SaleCancellationReason | null | undefined): Promise<boolean>;

    voidPurchaseOrder(purchaseOrderId: number | undefined): Promise<boolean>;

    restorePurchaseOrder(purchaseOrderId: number | undefined): Promise<boolean>;

    getDeliveryOverrideForNewTicketGroup(input: ValueTupleOfNullableIntegerAndNullableIntegerAndNullableGuidAndBoolean): Promise<DeliveryOverride | null>;

    mergePurchaseEventOverrides(purchaseEventOverrides: PurchaseEventOverride[], viagogoEventId: number | undefined): Promise<boolean>;

    getPurchaseEventOverrides(viagogoEventId: number | undefined): Promise<PurchaseEventOverride[]>;

    exportPurchases(request: PurchaseOrderExportRequest, selectedTicketGroupsOnly: boolean | undefined): Promise<FileResponse>;

    downloadMergedUserDocumentsPdf(ticketGroupId: number | undefined): Promise<FileResponse>;
}

export class PurchaseClient extends PosClientBase implements IPurchaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getPurchaseOrderByPurchaseOrderId(purchaseOrderId: number | undefined, getCatalog: boolean | undefined, signal?: AbortSignal | undefined): Promise<PurchaseOrderDetails> {
        let url_ = this.baseUrl + "/api/Purchase/GetPurchaseOrderByPurchaseOrderId?";
        if (purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' cannot be null.");
        else if (purchaseOrderId !== undefined)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        if (getCatalog === null)
            throw new Error("The parameter 'getCatalog' cannot be null.");
        else if (getCatalog !== undefined)
            url_ += "getCatalog=" + encodeURIComponent("" + getCatalog) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseOrderByPurchaseOrderId(_response);
        });
    }

    protected processGetPurchaseOrderByPurchaseOrderId(response: Response): Promise<PurchaseOrderDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseOrderDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseOrderDetails>(null as any);
    }

    getPurchaseOrdersByVendorOrderId(orderId: string | undefined, signal?: AbortSignal | undefined): Promise<PurchaseOrderDetails[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetPurchaseOrdersByVendorOrderId?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseOrdersByVendorOrderId(_response);
        });
    }

    protected processGetPurchaseOrdersByVendorOrderId(response: Response): Promise<PurchaseOrderDetails[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseOrderDetails[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseOrderDetails[]>(null as any);
    }

    getPurchaseOrders(query: PurchaseOrderQuery, useReadonlyDB: boolean | undefined, signal?: AbortSignal | undefined): Promise<EntitiesWithSummaryOfPurchaseOrder> {
        let url_ = this.baseUrl + "/api/Purchase/GetPurchaseOrders?";
        if (useReadonlyDB === null)
            throw new Error("The parameter 'useReadonlyDB' cannot be null.");
        else if (useReadonlyDB !== undefined)
            url_ += "useReadonlyDB=" + encodeURIComponent("" + useReadonlyDB) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseOrders(_response);
        });
    }

    protected processGetPurchaseOrders(response: Response): Promise<EntitiesWithSummaryOfPurchaseOrder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntitiesWithSummaryOfPurchaseOrder;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntitiesWithSummaryOfPurchaseOrder>(null as any);
    }

    /**
     * This use the exact same backend as GetPurchaseOrders, but it is used by Advance Search
    The split up allows proper instrumentation and monitoring of the two different use cases
    This endpoint can later be replaced with a different backend
     * @param useReadonlyDB (optional) 
     */
    searchPurchaseOrders(query: PurchaseOrderQuery, useReadonlyDB: boolean | undefined, signal?: AbortSignal | undefined): Promise<EntitiesWithSummaryOfPurchaseOrder> {
        let url_ = this.baseUrl + "/api/Purchase/SearchPurchaseOrders?";
        if (useReadonlyDB === null)
            throw new Error("The parameter 'useReadonlyDB' cannot be null.");
        else if (useReadonlyDB !== undefined)
            url_ += "useReadonlyDB=" + encodeURIComponent("" + useReadonlyDB) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchPurchaseOrders(_response);
        });
    }

    protected processSearchPurchaseOrders(response: Response): Promise<EntitiesWithSummaryOfPurchaseOrder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntitiesWithSummaryOfPurchaseOrder;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntitiesWithSummaryOfPurchaseOrder>(null as any);
    }

    /**
     * This will be used by Advance Search V2 which uses OpenSearch implementation
     */
    searchPurchaseOrdersV2(query: PurchaseOrderQueryV2, signal?: AbortSignal | undefined): Promise<EntitiesWithSummaryOfPurchaseOrderTicketGroup> {
        let url_ = this.baseUrl + "/api/Purchase/SearchPurchaseOrdersV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchPurchaseOrdersV2(_response);
        });
    }

    protected processSearchPurchaseOrdersV2(response: Response): Promise<EntitiesWithSummaryOfPurchaseOrderTicketGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntitiesWithSummaryOfPurchaseOrderTicketGroup;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntitiesWithSummaryOfPurchaseOrderTicketGroup>(null as any);
    }

    getPurchaseOrdersWithTicketGroups(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<EntitiesWithSummaryOfPurchaseOrderTicketGroup> {
        let url_ = this.baseUrl + "/api/Purchase/GetPurchaseOrdersWithTicketGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseOrdersWithTicketGroups(_response);
        });
    }

    protected processGetPurchaseOrdersWithTicketGroups(response: Response): Promise<EntitiesWithSummaryOfPurchaseOrderTicketGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntitiesWithSummaryOfPurchaseOrderTicketGroup;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntitiesWithSummaryOfPurchaseOrderTicketGroup>(null as any);
    }

    getTicketGroupsForEvents(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfPurchaseOrderTicketGroup; }> {
        let url_ = this.baseUrl + "/api/Purchase/GetTicketGroupsForEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTicketGroupsForEvents(_response);
        });
    }

    protected processGetTicketGroupsForEvents(response: Response): Promise<{ [key: string]: EntitiesWithSummaryOfPurchaseOrderTicketGroup; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: EntitiesWithSummaryOfPurchaseOrderTicketGroup; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: EntitiesWithSummaryOfPurchaseOrderTicketGroup; }>(null as any);
    }

    getAccessibleVendors(getDeliveryOverride: boolean | undefined, getVendorAccountsCount: boolean | undefined, signal?: AbortSignal | undefined): Promise<PurchaseVendor[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetAccessibleVendors?";
        if (getDeliveryOverride === null)
            throw new Error("The parameter 'getDeliveryOverride' cannot be null.");
        else if (getDeliveryOverride !== undefined)
            url_ += "getDeliveryOverride=" + encodeURIComponent("" + getDeliveryOverride) + "&";
        if (getVendorAccountsCount === null)
            throw new Error("The parameter 'getVendorAccountsCount' cannot be null.");
        else if (getVendorAccountsCount !== undefined)
            url_ += "getVendorAccountsCount=" + encodeURIComponent("" + getVendorAccountsCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessibleVendors(_response);
        });
    }

    protected processGetAccessibleVendors(response: Response): Promise<PurchaseVendor[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseVendor[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseVendor[]>(null as any);
    }

    getAccessibleAccessControlProviders(signal?: AbortSignal | undefined): Promise<AccessControlProvider[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetAccessibleAccessControlProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessibleAccessControlProviders(_response);
        });
    }

    protected processGetAccessibleAccessControlProviders(response: Response): Promise<AccessControlProvider[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessControlProvider[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessControlProvider[]>(null as any);
    }

    getAccessibleVendorAccounts(input: ValueTupleOfISetOfIntegerAndISetOfGuid, searchText: string | null | undefined, take: number | null | undefined, skip: number | null | undefined, signal?: AbortSignal | undefined): Promise<PurchaseVendorAccount[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetAccessibleVendorAccounts?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessibleVendorAccounts(_response);
        });
    }

    protected processGetAccessibleVendorAccounts(response: Response): Promise<PurchaseVendorAccount[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseVendorAccount[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseVendorAccount[]>(null as any);
    }

    getVendorAccountDetails(purchaseOrderVendorAccountId: string | undefined, signal?: AbortSignal | undefined): Promise<PurchaseVendorAccountDetails> {
        let url_ = this.baseUrl + "/api/Purchase/GetVendorAccountDetails?";
        if (purchaseOrderVendorAccountId === null)
            throw new Error("The parameter 'purchaseOrderVendorAccountId' cannot be null.");
        else if (purchaseOrderVendorAccountId !== undefined)
            url_ += "purchaseOrderVendorAccountId=" + encodeURIComponent("" + purchaseOrderVendorAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVendorAccountDetails(_response);
        });
    }

    protected processGetVendorAccountDetails(response: Response): Promise<PurchaseVendorAccountDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseVendorAccountDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseVendorAccountDetails>(null as any);
    }

    getPurchaseOrderIdsUsingOrderId(orderId: string | undefined, signal?: AbortSignal | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetPurchaseOrderIdsUsingOrderId?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseOrderIdsUsingOrderId(_response);
        });
    }

    protected processGetPurchaseOrderIdsUsingOrderId(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    getIsPurchasingIdsInUse(orderId: string | undefined, purchaseOrderVendorId: number | null | undefined, signal?: AbortSignal | undefined): Promise<PurchasingIdInUseResultType> {
        let url_ = this.baseUrl + "/api/Purchase/GetIsPurchasingIdsInUse?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (purchaseOrderVendorId !== undefined && purchaseOrderVendorId !== null)
            url_ += "purchaseOrderVendorId=" + encodeURIComponent("" + purchaseOrderVendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIsPurchasingIdsInUse(_response);
        });
    }

    protected processGetIsPurchasingIdsInUse(response: Response): Promise<PurchasingIdInUseResultType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchasingIdInUseResultType;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchasingIdInUseResultType>(null as any);
    }

    getMonthsContainerPurchaseOrders(query: PurchaseOrderQuery, signal?: AbortSignal | undefined): Promise<MonthContainingPurchaseOrdersResult[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetMonthsContainerPurchaseOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMonthsContainerPurchaseOrders(_response);
        });
    }

    protected processGetMonthsContainerPurchaseOrders(response: Response): Promise<MonthContainingPurchaseOrdersResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MonthContainingPurchaseOrdersResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MonthContainingPurchaseOrdersResult[]>(null as any);
    }

    getTimePeriodContainerPurchaseOrders(query: PurchaseOrderQuery, timePeriodType: TimePeriodType | undefined, signal?: AbortSignal | undefined): Promise<TimePeriodContainingPurchaseOrderResult[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetTimePeriodContainerPurchaseOrders?";
        if (timePeriodType === null)
            throw new Error("The parameter 'timePeriodType' cannot be null.");
        else if (timePeriodType !== undefined)
            url_ += "timePeriodType=" + encodeURIComponent("" + timePeriodType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTimePeriodContainerPurchaseOrders(_response);
        });
    }

    protected processGetTimePeriodContainerPurchaseOrders(response: Response): Promise<TimePeriodContainingPurchaseOrderResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TimePeriodContainingPurchaseOrderResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimePeriodContainingPurchaseOrderResult[]>(null as any);
    }

    insertPurchaseOrder(input: PurchaseOrderDetailsInput, isManual: boolean | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Purchase/InsertPurchaseOrder?";
        if (isManual === null)
            throw new Error("The parameter 'isManual' cannot be null.");
        else if (isManual !== undefined)
            url_ += "isManual=" + encodeURIComponent("" + isManual) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertPurchaseOrder(_response);
        });
    }

    protected processInsertPurchaseOrder(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    insertPurchaseOrders(input: PurchaseOrderDetailsInput[], isManual: boolean | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResultWithDataOfIEnumerableOfNullableLong> {
        let url_ = this.baseUrl + "/api/Purchase/InsertPurchaseOrders?";
        if (isManual === null)
            throw new Error("The parameter 'isManual' cannot be null.");
        else if (isManual !== undefined)
            url_ += "isManual=" + encodeURIComponent("" + isManual) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertPurchaseOrders(_response);
        });
    }

    protected processInsertPurchaseOrders(response: Response): Promise<PosUiActionResultWithDataOfIEnumerableOfNullableLong> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResultWithDataOfIEnumerableOfNullableLong;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResultWithDataOfIEnumerableOfNullableLong>(null as any);
    }

    downloadPurchaseFileTemplate(includeEventIdFields: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Purchase/DownloadPurchaseFileTemplate?";
        if (includeEventIdFields === null)
            throw new Error("The parameter 'includeEventIdFields' cannot be null.");
        else if (includeEventIdFields !== undefined)
            url_ += "includeEventIdFields=" + encodeURIComponent("" + includeEventIdFields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadPurchaseFileTemplate(_response);
        });
    }

    protected processDownloadPurchaseFileTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param purchaseOrderId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updatePurchaseOrderByPurchaseOrderId(purchaseOrderId: number, input: PurchaseOrderDetailsInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Purchase/{purchaseOrderId}";
        if (purchaseOrderId === undefined || purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' must be defined.");
        url_ = url_.replace("{purchaseOrderId}", encodeURIComponent("" + purchaseOrderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePurchaseOrderByPurchaseOrderId(_response);
        });
    }

    protected processUpdatePurchaseOrderByPurchaseOrderId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @deprecated
     */
    updatePurchaseOrder(input: PurchaseOrderDetailsInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Purchase/UpdatePurchaseOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePurchaseOrder(_response);
        });
    }

    protected processUpdatePurchaseOrder(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updatePurchasesQualityControlState(inputs: ValueTupleOfISetOfLongAndPosFieldOfNullableQualityControlState, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/UpdatePurchasesQualityControlState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePurchasesQualityControlState(_response);
        });
    }

    protected processUpdatePurchasesQualityControlState(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getVendor(vendorId: number | undefined, signal?: AbortSignal | undefined): Promise<PurchaseVendor> {
        let url_ = this.baseUrl + "/api/Purchase/GetVendor?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVendor(_response);
        });
    }

    protected processGetVendor(response: Response): Promise<PurchaseVendor> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseVendor;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseVendor>(null as any);
    }

    mergeVendor(vendor: PurchaseVendor, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/Purchase/MergeVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vendor);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeVendor(_response);
        });
    }

    protected processMergeVendor(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    deleteVendor(vendorId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/DeleteVendor?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteVendor(_response);
        });
    }

    protected processDeleteVendor(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    mergeVendorAccount(vendorAccount: PurchaseVendorAccountDetails, signal?: AbortSignal | undefined): Promise<string | null> {
        let url_ = this.baseUrl + "/api/Purchase/MergeVendorAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vendorAccount);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeVendorAccount(_response);
        });
    }

    protected processMergeVendorAccount(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(null as any);
    }

    deleteVendorAccount(vendorAccountId: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/DeleteVendorAccount?";
        if (vendorAccountId === null)
            throw new Error("The parameter 'vendorAccountId' cannot be null.");
        else if (vendorAccountId !== undefined)
            url_ += "vendorAccountId=" + encodeURIComponent("" + vendorAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteVendorAccount(_response);
        });
    }

    protected processDeleteVendorAccount(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAllCurrencyConversionOverride(signal?: AbortSignal | undefined): Promise<CurrencyConversionOverride[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetAllCurrencyConversionOverride";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllCurrencyConversionOverride(_response);
        });
    }

    protected processGetAllCurrencyConversionOverride(response: Response): Promise<CurrencyConversionOverride[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CurrencyConversionOverride[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrencyConversionOverride[]>(null as any);
    }

    insertCurrencyConversionOverride(conversionOverrideRequest: CurrencyConversionOverrideRequest, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/Purchase/InsertCurrencyConversionOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(conversionOverrideRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertCurrencyConversionOverride(_response);
        });
    }

    protected processInsertCurrencyConversionOverride(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    updateCurrencyConversionOverride(conversionOverrideRequest: CurrencyConversionOverrideRequest, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/UpdateCurrencyConversionOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(conversionOverrideRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCurrencyConversionOverride(_response);
        });
    }

    protected processUpdateCurrencyConversionOverride(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteCurrencyConversionOverride(currencyConversionOverrideId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/DeleteCurrencyConversionOverride?";
        if (currencyConversionOverrideId === null)
            throw new Error("The parameter 'currencyConversionOverrideId' cannot be null.");
        else if (currencyConversionOverrideId !== undefined)
            url_ += "currencyConversionOverrideId=" + encodeURIComponent("" + currencyConversionOverrideId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCurrencyConversionOverride(_response);
        });
    }

    protected processDeleteCurrencyConversionOverride(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAccessiblePurchasePaymentMethods(signal?: AbortSignal | undefined): Promise<PurchasePaymentMethod[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetAccessiblePurchasePaymentMethods";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessiblePurchasePaymentMethods(_response);
        });
    }

    protected processGetAccessiblePurchasePaymentMethods(response: Response): Promise<PurchasePaymentMethod[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchasePaymentMethod[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchasePaymentMethod[]>(null as any);
    }

    getPurchasePaymentMethodsByName(paymentMethodName: string | undefined, signal?: AbortSignal | undefined): Promise<PurchasePaymentMethod[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetPurchasePaymentMethodsByName?";
        if (paymentMethodName === null)
            throw new Error("The parameter 'paymentMethodName' cannot be null.");
        else if (paymentMethodName !== undefined)
            url_ += "paymentMethodName=" + encodeURIComponent("" + paymentMethodName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchasePaymentMethodsByName(_response);
        });
    }

    protected processGetPurchasePaymentMethodsByName(response: Response): Promise<PurchasePaymentMethod[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchasePaymentMethod[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchasePaymentMethod[]>(null as any);
    }

    insertPurchasePaymentMethod(input: PurchasePaymentMethod, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Purchase/InsertPurchasePaymentMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertPurchasePaymentMethod(_response);
        });
    }

    protected processInsertPurchasePaymentMethod(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updatePurchasePaymentMethod(input: PurchasePaymentMethod, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/UpdatePurchasePaymentMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePurchasePaymentMethod(_response);
        });
    }

    protected processUpdatePurchasePaymentMethod(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deletePurchasePaymentMethod(purchasePaymentMethodId: number, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/DeletePurchasePaymentMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(purchasePaymentMethodId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePurchasePaymentMethod(_response);
        });
    }

    protected processDeletePurchasePaymentMethod(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    cancelPurchaseOrder(purchaseOrderId: number | undefined, rejectSale: boolean | null | undefined, saleCancellationReason: SaleCancellationReason | null | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/CancelPurchaseOrder?";
        if (purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' cannot be null.");
        else if (purchaseOrderId !== undefined)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        if (rejectSale !== undefined && rejectSale !== null)
            url_ += "rejectSale=" + encodeURIComponent("" + rejectSale) + "&";
        if (saleCancellationReason !== undefined && saleCancellationReason !== null)
            url_ += "saleCancellationReason=" + encodeURIComponent("" + saleCancellationReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelPurchaseOrder(_response);
        });
    }

    protected processCancelPurchaseOrder(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    voidPurchaseOrder(purchaseOrderId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/VoidPurchaseOrder?";
        if (purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' cannot be null.");
        else if (purchaseOrderId !== undefined)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVoidPurchaseOrder(_response);
        });
    }

    protected processVoidPurchaseOrder(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    restorePurchaseOrder(purchaseOrderId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase/RestorePurchaseOrder?";
        if (purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' cannot be null.");
        else if (purchaseOrderId !== undefined)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRestorePurchaseOrder(_response);
        });
    }

    protected processRestorePurchaseOrder(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getDeliveryOverrideForNewTicketGroup(input: ValueTupleOfNullableIntegerAndNullableIntegerAndNullableGuidAndBoolean, signal?: AbortSignal | undefined): Promise<DeliveryOverride | null> {
        let url_ = this.baseUrl + "/api/Purchase/GetDeliveryOverrideForNewTicketGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeliveryOverrideForNewTicketGroup(_response);
        });
    }

    protected processGetDeliveryOverrideForNewTicketGroup(response: Response): Promise<DeliveryOverride | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeliveryOverride;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeliveryOverride | null>(null as any);
    }

    mergePurchaseEventOverrides(purchaseEventOverrides: PurchaseEventOverride[], viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Purchase?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(purchaseEventOverrides);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergePurchaseEventOverrides(_response);
        });
    }

    protected processMergePurchaseEventOverrides(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getPurchaseEventOverrides(viagogoEventId: number | undefined, signal?: AbortSignal | undefined): Promise<PurchaseEventOverride[]> {
        let url_ = this.baseUrl + "/api/Purchase/GetPurchaseEventOverrides?";
        if (viagogoEventId === null)
            throw new Error("The parameter 'viagogoEventId' cannot be null.");
        else if (viagogoEventId !== undefined)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseEventOverrides(_response);
        });
    }

    protected processGetPurchaseEventOverrides(response: Response): Promise<PurchaseEventOverride[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseEventOverride[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseEventOverride[]>(null as any);
    }

    exportPurchases(request: PurchaseOrderExportRequest, selectedTicketGroupsOnly: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Purchase/ExportPurchases?";
        if (selectedTicketGroupsOnly === null)
            throw new Error("The parameter 'selectedTicketGroupsOnly' cannot be null.");
        else if (selectedTicketGroupsOnly !== undefined)
            url_ += "selectedTicketGroupsOnly=" + encodeURIComponent("" + selectedTicketGroupsOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportPurchases(_response);
        });
    }

    protected processExportPurchases(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadMergedUserDocumentsPdf(ticketGroupId: number | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Purchase/DownloadMergedUserDocumentsPdf?";
        if (ticketGroupId === null)
            throw new Error("The parameter 'ticketGroupId' cannot be null.");
        else if (ticketGroupId !== undefined)
            url_ += "ticketGroupId=" + encodeURIComponent("" + ticketGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadMergedUserDocumentsPdf(_response);
        });
    }

    protected processDownloadMergedUserDocumentsPdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IPurchaseOrdersOpenSearchClient {

    /**
     * Enhanced purchase order search with ComprehensivePurchaseOrderDocument mapped to UI DTOs
    Uses ComprehensivePurchaseOrderDocument for comprehensive filtering then maps to PurchaseOrder DTOs for UI consumption
    This provides the best of both worlds: comprehensive filtering + familiar UI DTOs
     * @param request The enhanced search request with PurchaseOrderFilterQueryV2 criteria and options
     * @return Search results mapped to PurchaseOrder DTOs with comprehensive search capabilities
     */
    searchPurchaseOrdersV3(request: PurchaseOrderSearchRequestV2): Promise<SecurePurchaseOrdersSearchMappedResult>;
}

export class PurchaseOrdersOpenSearchClient extends PosClientBase implements IPurchaseOrdersOpenSearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Enhanced purchase order search with ComprehensivePurchaseOrderDocument mapped to UI DTOs
    Uses ComprehensivePurchaseOrderDocument for comprehensive filtering then maps to PurchaseOrder DTOs for UI consumption
    This provides the best of both worlds: comprehensive filtering + familiar UI DTOs
     * @param request The enhanced search request with PurchaseOrderFilterQueryV2 criteria and options
     * @return Search results mapped to PurchaseOrder DTOs with comprehensive search capabilities
     */
    searchPurchaseOrdersV3(request: PurchaseOrderSearchRequestV2, signal?: AbortSignal | undefined): Promise<SecurePurchaseOrdersSearchMappedResult> {
        let url_ = this.baseUrl + "/api/OpenSearch/SearchPurchaseOrdersV3";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchPurchaseOrdersV3(_response);
        });
    }

    protected processSearchPurchaseOrdersV3(response: Response): Promise<SecurePurchaseOrdersSearchMappedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SecurePurchaseOrdersSearchMappedResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecurePurchaseOrdersSearchMappedResult>(null as any);
    }
}

export interface IReportClient {

    getAvailableInventoryReportConfig(): Promise<ReportConfigOfListingQueryAndReportWidgetTypesInventory[]>;

    upsertInventoryReportConfig(reportConfig: ReportConfigOfListingQueryAndReportWidgetTypesInventory): Promise<number | null>;

    upsertInventoryReportConfigOverride(reportConfigId: number | undefined, reportConfigOverride: ReportConfigOverrideOfListingQuery): Promise<boolean>;

    getAvailableSaleReportConfig(): Promise<ReportConfigOfSaleQueryAndReportWidgetTypesNone[]>;

    upsertSaleReportConfig(reportConfig: ReportConfigOfSaleQueryAndReportWidgetTypesNone): Promise<number | null>;

    upsertSaleReportConfigOverride(reportConfigId: number | undefined, reportConfigOverride: ReportConfigOverrideOfSaleQuery): Promise<boolean>;

    deleteReportConfig(reportConfigId: number | undefined): Promise<boolean>;

    getListingReportMetrics(input: ListingReportMetricsRequest, maxResultsize: number | null | undefined): Promise<ListingReportMetricsResponse>;

    getSaleReportMetrics(input: SaleReportMetricsRequest, maxResultsize: number | null | undefined): Promise<SaleReportMetricsResponse>;

    getReportSnapshotInfos(reportConfigId: number | undefined): Promise<ReportSnapshotInfo[]>;

    downloadSaleReportMetrics(input: SaleReportMetricsDownloadRequest): Promise<FileResponse>;

    downloadListingReportMetrics(input: ListingReportMetricsDownloadRequest): Promise<FileResponse>;
}

export class ReportClient extends PosClientBase implements IReportClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAvailableInventoryReportConfig(signal?: AbortSignal | undefined): Promise<ReportConfigOfListingQueryAndReportWidgetTypesInventory[]> {
        let url_ = this.baseUrl + "/api/Report/GetAvailableInventoryReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableInventoryReportConfig(_response);
        });
    }

    protected processGetAvailableInventoryReportConfig(response: Response): Promise<ReportConfigOfListingQueryAndReportWidgetTypesInventory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportConfigOfListingQueryAndReportWidgetTypesInventory[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportConfigOfListingQueryAndReportWidgetTypesInventory[]>(null as any);
    }

    upsertInventoryReportConfig(reportConfig: ReportConfigOfListingQueryAndReportWidgetTypesInventory, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/Report/UpsertInventoryReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertInventoryReportConfig(_response);
        });
    }

    protected processUpsertInventoryReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    upsertInventoryReportConfigOverride(reportConfigId: number | undefined, reportConfigOverride: ReportConfigOverrideOfListingQuery, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Report/UpsertInventoryReportConfigOverride?";
        if (reportConfigId === null)
            throw new Error("The parameter 'reportConfigId' cannot be null.");
        else if (reportConfigId !== undefined)
            url_ += "reportConfigId=" + encodeURIComponent("" + reportConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfigOverride);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertInventoryReportConfigOverride(_response);
        });
    }

    protected processUpsertInventoryReportConfigOverride(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAvailableSaleReportConfig(signal?: AbortSignal | undefined): Promise<ReportConfigOfSaleQueryAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/Report/GetAvailableSaleReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableSaleReportConfig(_response);
        });
    }

    protected processGetAvailableSaleReportConfig(response: Response): Promise<ReportConfigOfSaleQueryAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportConfigOfSaleQueryAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportConfigOfSaleQueryAndReportWidgetTypesNone[]>(null as any);
    }

    upsertSaleReportConfig(reportConfig: ReportConfigOfSaleQueryAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/Report/UpsertSaleReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertSaleReportConfig(_response);
        });
    }

    protected processUpsertSaleReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    upsertSaleReportConfigOverride(reportConfigId: number | undefined, reportConfigOverride: ReportConfigOverrideOfSaleQuery, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Report/UpsertSaleReportConfigOverride?";
        if (reportConfigId === null)
            throw new Error("The parameter 'reportConfigId' cannot be null.");
        else if (reportConfigId !== undefined)
            url_ += "reportConfigId=" + encodeURIComponent("" + reportConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfigOverride);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertSaleReportConfigOverride(_response);
        });
    }

    protected processUpsertSaleReportConfigOverride(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteReportConfig(reportConfigId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Report/DeleteReportConfig?";
        if (reportConfigId === null)
            throw new Error("The parameter 'reportConfigId' cannot be null.");
        else if (reportConfigId !== undefined)
            url_ += "reportConfigId=" + encodeURIComponent("" + reportConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteReportConfig(_response);
        });
    }

    protected processDeleteReportConfig(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getListingReportMetrics(input: ListingReportMetricsRequest, maxResultsize: number | null | undefined, signal?: AbortSignal | undefined): Promise<ListingReportMetricsResponse> {
        let url_ = this.baseUrl + "/api/Report/GetListingReportMetrics?";
        if (maxResultsize !== undefined && maxResultsize !== null)
            url_ += "maxResultsize=" + encodeURIComponent("" + maxResultsize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingReportMetrics(_response);
        });
    }

    protected processGetListingReportMetrics(response: Response): Promise<ListingReportMetricsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingReportMetricsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingReportMetricsResponse>(null as any);
    }

    getSaleReportMetrics(input: SaleReportMetricsRequest, maxResultsize: number | null | undefined, signal?: AbortSignal | undefined): Promise<SaleReportMetricsResponse> {
        let url_ = this.baseUrl + "/api/Report/GetSaleReportMetrics?";
        if (maxResultsize !== undefined && maxResultsize !== null)
            url_ += "maxResultsize=" + encodeURIComponent("" + maxResultsize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleReportMetrics(_response);
        });
    }

    protected processGetSaleReportMetrics(response: Response): Promise<SaleReportMetricsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaleReportMetricsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleReportMetricsResponse>(null as any);
    }

    getReportSnapshotInfos(reportConfigId: number | undefined, signal?: AbortSignal | undefined): Promise<ReportSnapshotInfo[]> {
        let url_ = this.baseUrl + "/api/Report/GetReportSnapshotInfos?";
        if (reportConfigId === null)
            throw new Error("The parameter 'reportConfigId' cannot be null.");
        else if (reportConfigId !== undefined)
            url_ += "reportConfigId=" + encodeURIComponent("" + reportConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportSnapshotInfos(_response);
        });
    }

    protected processGetReportSnapshotInfos(response: Response): Promise<ReportSnapshotInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportSnapshotInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportSnapshotInfo[]>(null as any);
    }

    downloadSaleReportMetrics(input: SaleReportMetricsDownloadRequest, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Report/DownloadSaleReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadSaleReportMetrics(_response);
        });
    }

    protected processDownloadSaleReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadListingReportMetrics(input: ListingReportMetricsDownloadRequest, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Report/DownloadListingReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadListingReportMetrics(_response);
        });
    }

    protected processDownloadListingReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IReportV2ConfigClient {

    getAvailableInventoryReportConfig(): Promise<ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory[]>;

    upsertInventoryReportConfig(reportConfig: ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory): Promise<number | null>;

    getAvailableSaleReportConfig(): Promise<ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone[]>;

    upsertSaleReportConfig(reportConfig: ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone): Promise<number | null>;

    getAvailablePurchaseReportConfig(): Promise<ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone[]>;

    upsertPurchaseReportConfig(reportConfig: ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone): Promise<number | null>;

    getAvailableSaleLineItemReportConfig(): Promise<ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone[]>;

    upsertSaleLineItemReportConfig(reportConfig: ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone): Promise<number | null>;

    getAvailablePurchaseOrderLineItemReportConfig(): Promise<ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone[]>;

    upsertPurchaseOrderLineItemReportConfig(reportConfig: ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone): Promise<number | null>;

    getAvailableSoldTicketReportConfig(): Promise<ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone[]>;

    upsertSoldTicketReportConfig(reportConfig: ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone): Promise<number | null>;

    deleteReportConfig(reportConfigId: number | undefined): Promise<boolean>;

    getAvailableCommissionReportConfig(): Promise<ReportV2ConfigOfCommissionReportV2RequestAndReportWidgetTypesNone[]>;

    getAvailableCostOfGoodsSoldReportConfig(): Promise<ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone[]>;

    upsertCostOfGoodsSoldReportConfig(reportConfig: ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone): Promise<number | null>;

    getAvailableSaleTotalCostAdjustmentReportConfig(): Promise<ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone[]>;

    upsertSaleTotalCostAdjustmentReportConfig(reportConfig: ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone): Promise<number | null>;

    getAvailableTicketGroupReportConfig(): Promise<ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone[]>;

    upsertTicketGroupReportConfig(reportConfig: ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone): Promise<number | null>;

    upsertReportConfigOverride(reportConfigId: number | undefined, reportConfigOverride: ReportV2ConfigOverride): Promise<boolean>;
}

export class ReportV2ConfigClient extends PosClientBase implements IReportV2ConfigClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAvailableInventoryReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailableInventoryReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableInventoryReportConfig(_response);
        });
    }

    protected processGetAvailableInventoryReportConfig(response: Response): Promise<ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory[]>(null as any);
    }

    upsertInventoryReportConfig(reportConfig: ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertInventoryReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertInventoryReportConfig(_response);
        });
    }

    protected processUpsertInventoryReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    getAvailableSaleReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailableSaleReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableSaleReportConfig(_response);
        });
    }

    protected processGetAvailableSaleReportConfig(response: Response): Promise<ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    upsertSaleReportConfig(reportConfig: ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertSaleReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertSaleReportConfig(_response);
        });
    }

    protected processUpsertSaleReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    getAvailablePurchaseReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailablePurchaseReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailablePurchaseReportConfig(_response);
        });
    }

    protected processGetAvailablePurchaseReportConfig(response: Response): Promise<ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    upsertPurchaseReportConfig(reportConfig: ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertPurchaseReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertPurchaseReportConfig(_response);
        });
    }

    protected processUpsertPurchaseReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    getAvailableSaleLineItemReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailableSaleLineItemReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableSaleLineItemReportConfig(_response);
        });
    }

    protected processGetAvailableSaleLineItemReportConfig(response: Response): Promise<ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    upsertSaleLineItemReportConfig(reportConfig: ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertSaleLineItemReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertSaleLineItemReportConfig(_response);
        });
    }

    protected processUpsertSaleLineItemReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    getAvailablePurchaseOrderLineItemReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailablePurchaseOrderLineItemReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailablePurchaseOrderLineItemReportConfig(_response);
        });
    }

    protected processGetAvailablePurchaseOrderLineItemReportConfig(response: Response): Promise<ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    upsertPurchaseOrderLineItemReportConfig(reportConfig: ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertPurchaseOrderLineItemReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertPurchaseOrderLineItemReportConfig(_response);
        });
    }

    protected processUpsertPurchaseOrderLineItemReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    getAvailableSoldTicketReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailableSoldTicketReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableSoldTicketReportConfig(_response);
        });
    }

    protected processGetAvailableSoldTicketReportConfig(response: Response): Promise<ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    upsertSoldTicketReportConfig(reportConfig: ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertSoldTicketReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertSoldTicketReportConfig(_response);
        });
    }

    protected processUpsertSoldTicketReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    deleteReportConfig(reportConfigId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ReportV2Config/DeleteReportConfig?";
        if (reportConfigId === null)
            throw new Error("The parameter 'reportConfigId' cannot be null.");
        else if (reportConfigId !== undefined)
            url_ += "reportConfigId=" + encodeURIComponent("" + reportConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteReportConfig(_response);
        });
    }

    protected processDeleteReportConfig(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAvailableCommissionReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfCommissionReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailableCommissionReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableCommissionReportConfig(_response);
        });
    }

    protected processGetAvailableCommissionReportConfig(response: Response): Promise<ReportV2ConfigOfCommissionReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfCommissionReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfCommissionReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    getAvailableCostOfGoodsSoldReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailableCostOfGoodsSoldReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableCostOfGoodsSoldReportConfig(_response);
        });
    }

    protected processGetAvailableCostOfGoodsSoldReportConfig(response: Response): Promise<ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    upsertCostOfGoodsSoldReportConfig(reportConfig: ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertCostOfGoodsSoldReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertCostOfGoodsSoldReportConfig(_response);
        });
    }

    protected processUpsertCostOfGoodsSoldReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    getAvailableSaleTotalCostAdjustmentReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailableSaleTotalCostAdjustmentReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableSaleTotalCostAdjustmentReportConfig(_response);
        });
    }

    protected processGetAvailableSaleTotalCostAdjustmentReportConfig(response: Response): Promise<ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    upsertSaleTotalCostAdjustmentReportConfig(reportConfig: ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertSaleTotalCostAdjustmentReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertSaleTotalCostAdjustmentReportConfig(_response);
        });
    }

    protected processUpsertSaleTotalCostAdjustmentReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    getAvailableTicketGroupReportConfig(signal?: AbortSignal | undefined): Promise<ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone[]> {
        let url_ = this.baseUrl + "/api/ReportV2Config/GetAvailableTicketGroupReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableTicketGroupReportConfig(_response);
        });
    }

    protected processGetAvailableTicketGroupReportConfig(response: Response): Promise<ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone[]>(null as any);
    }

    upsertTicketGroupReportConfig(reportConfig: ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertTicketGroupReportConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfig);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertTicketGroupReportConfig(_response);
        });
    }

    protected processUpsertTicketGroupReportConfig(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    upsertReportConfigOverride(reportConfigId: number | undefined, reportConfigOverride: ReportV2ConfigOverride, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ReportV2Config/UpsertReportConfigOverride?";
        if (reportConfigId === null)
            throw new Error("The parameter 'reportConfigId' cannot be null.");
        else if (reportConfigId !== undefined)
            url_ += "reportConfigId=" + encodeURIComponent("" + reportConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportConfigOverride);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertReportConfigOverride(_response);
        });
    }

    protected processUpsertReportConfigOverride(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IReportV2Client {

    getInventoryReportMetrics(query: InventoryReportV2Request): Promise<ReportMetricsV2>;

    getInventoryReportSummary(query: InventoryReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadListingReportMetrics(query: InventoryReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getSaleReportMetrics(query: SalesReportV2Request): Promise<ReportMetricsV2>;

    getSaleReportSummary(query: SalesReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadSaleReportMetrics(query: SalesReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getCommissionReportMetrics(query: CommissionReportV2Request): Promise<ReportMetricsV2>;

    getCommissionReportSummary(query: CommissionReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadCommissionReportMetrics(query: CommissionReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getPurchaseReportMetrics(query: PurchaseReportV2Request): Promise<ReportMetricsV2>;

    getPurchaseReportSummary(query: PurchaseReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadPurchaseReportMetrics(query: PurchaseReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getSaleLineItemReportMetrics(query: SaleLineItemReportV2Request): Promise<ReportMetricsV2>;

    getSaleLineItemReportSummary(query: SaleLineItemReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadSaleLineItemReportMetrics(query: SaleLineItemReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getPurchaseOrderLineItemReportMetrics(query: PurchaseOrderLineItemReportV2Request): Promise<ReportMetricsV2>;

    getPurchaseOrderLineItemReportSummary(query: PurchaseOrderLineItemReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadPurchaseOrderLineItemReportMetrics(query: PurchaseOrderLineItemReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getSoldTicketReportMetrics(query: SoldTicketReportV2Request): Promise<ReportMetricsV2>;

    getSoldTicketReportSummary(query: SoldTicketReportV2Request): Promise<ReportMetricsSummaryV2>;

    getCatalogCountForInventoryReport(query: UIReportV2ListingQuery): Promise<CatalogCounts>;

    getCatalogCountForSalesReport(query: UIReportV2SaleQuery): Promise<CatalogCounts>;

    getCatalogCountForSaleLineItemReport(query: UIReportV2SaleLineItemQuery): Promise<CatalogCounts>;

    getCatalogCountForSoldTicketReport(query: UIReportV2SoldTicketQuery): Promise<CatalogCounts>;

    downloadSoldTicketReportMetrics(query: SoldTicketReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getCostOfGoodsSoldReportMetrics(query: CostOfGoodsSoldReportV2Request): Promise<ReportMetricsV2>;

    getCostOfGoodsSoldReportSummary(query: CostOfGoodsSoldReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadCostOfGoodsSoldReportMetrics(query: CostOfGoodsSoldReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getCatalogCountForCostOfGoodsSoldReport(query: UIReportV2CostOfGoodsSoldQuery): Promise<CatalogCounts>;

    getSaleTotalCostAdjustmentReportMetrics(query: SaleTotalCostAdjustmentReportV2Request): Promise<ReportMetricsV2>;

    getSaleTotalCostAdjustmentReportSummary(query: SaleTotalCostAdjustmentReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadSaleTotalCostAdjustmentReportMetrics(query: SaleTotalCostAdjustmentReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getCatalogCountForSaleTotalCostAdjustmentReport(query: UIReportV2SaleTotalCostAdjustmentsQuery): Promise<CatalogCounts>;

    getTicketGroupReportMetrics(query: TicketGroupReportV2Request): Promise<ReportMetricsV2>;

    getTicketGroupReportSummary(query: TicketGroupReportV2Request): Promise<ReportMetricsSummaryV2>;

    downloadTicketGroupReportMetrics(query: TicketGroupReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined): Promise<FileResponse>;

    getCatalogCountForTicketGroupReport(query: UIReportV2TicketGroupQuery): Promise<CatalogCounts>;

    /**
     * Dummy endpoint to expose FileExportResult class to the client
     */
    getEmptyFileExportResult(): Promise<FileExportResult>;

    /**
     * Dummy endpoint to expose FileExportProgress class to the client
     */
    getEmptyFileExportProgress(): Promise<FileExportProgress>;
}

export class ReportV2Client extends PosClientBase implements IReportV2Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getInventoryReportMetrics(query: InventoryReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetInventoryReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInventoryReportMetrics(_response);
        });
    }

    protected processGetInventoryReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getInventoryReportSummary(query: InventoryReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetInventoryReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInventoryReportSummary(_response);
        });
    }

    protected processGetInventoryReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadListingReportMetrics(query: InventoryReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadListingReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadListingReportMetrics(_response);
        });
    }

    protected processDownloadListingReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSaleReportMetrics(query: SalesReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetSaleReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleReportMetrics(_response);
        });
    }

    protected processGetSaleReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getSaleReportSummary(query: SalesReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetSaleReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleReportSummary(_response);
        });
    }

    protected processGetSaleReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadSaleReportMetrics(query: SalesReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadSaleReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadSaleReportMetrics(_response);
        });
    }

    protected processDownloadSaleReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCommissionReportMetrics(query: CommissionReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCommissionReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCommissionReportMetrics(_response);
        });
    }

    protected processGetCommissionReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getCommissionReportSummary(query: CommissionReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCommissionReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCommissionReportSummary(_response);
        });
    }

    protected processGetCommissionReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadCommissionReportMetrics(query: CommissionReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadCommissionReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadCommissionReportMetrics(_response);
        });
    }

    protected processDownloadCommissionReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPurchaseReportMetrics(query: PurchaseReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetPurchaseReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseReportMetrics(_response);
        });
    }

    protected processGetPurchaseReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getPurchaseReportSummary(query: PurchaseReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetPurchaseReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseReportSummary(_response);
        });
    }

    protected processGetPurchaseReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadPurchaseReportMetrics(query: PurchaseReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadPurchaseReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadPurchaseReportMetrics(_response);
        });
    }

    protected processDownloadPurchaseReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSaleLineItemReportMetrics(query: SaleLineItemReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetSaleLineItemReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleLineItemReportMetrics(_response);
        });
    }

    protected processGetSaleLineItemReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getSaleLineItemReportSummary(query: SaleLineItemReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetSaleLineItemReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleLineItemReportSummary(_response);
        });
    }

    protected processGetSaleLineItemReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadSaleLineItemReportMetrics(query: SaleLineItemReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadSaleLineItemReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadSaleLineItemReportMetrics(_response);
        });
    }

    protected processDownloadSaleLineItemReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPurchaseOrderLineItemReportMetrics(query: PurchaseOrderLineItemReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetPurchaseOrderLineItemReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseOrderLineItemReportMetrics(_response);
        });
    }

    protected processGetPurchaseOrderLineItemReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getPurchaseOrderLineItemReportSummary(query: PurchaseOrderLineItemReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetPurchaseOrderLineItemReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseOrderLineItemReportSummary(_response);
        });
    }

    protected processGetPurchaseOrderLineItemReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadPurchaseOrderLineItemReportMetrics(query: PurchaseOrderLineItemReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadPurchaseOrderLineItemReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadPurchaseOrderLineItemReportMetrics(_response);
        });
    }

    protected processDownloadPurchaseOrderLineItemReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSoldTicketReportMetrics(query: SoldTicketReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetSoldTicketReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSoldTicketReportMetrics(_response);
        });
    }

    protected processGetSoldTicketReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getSoldTicketReportSummary(query: SoldTicketReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetSoldTicketReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSoldTicketReportSummary(_response);
        });
    }

    protected processGetSoldTicketReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    getCatalogCountForInventoryReport(query: UIReportV2ListingQuery, signal?: AbortSignal | undefined): Promise<CatalogCounts> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCatalogCountForInventoryReport/GetCatalogCountForInventoryReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCountForInventoryReport(_response);
        });
    }

    protected processGetCatalogCountForInventoryReport(response: Response): Promise<CatalogCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCounts>(null as any);
    }

    getCatalogCountForSalesReport(query: UIReportV2SaleQuery, signal?: AbortSignal | undefined): Promise<CatalogCounts> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCatalogCountForSalesReport/GetCatalogCountForSalesReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCountForSalesReport(_response);
        });
    }

    protected processGetCatalogCountForSalesReport(response: Response): Promise<CatalogCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCounts>(null as any);
    }

    getCatalogCountForSaleLineItemReport(query: UIReportV2SaleLineItemQuery, signal?: AbortSignal | undefined): Promise<CatalogCounts> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCatalogCountForSaleLineItemReport/GetCatalogCountForSaleLineItemReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCountForSaleLineItemReport(_response);
        });
    }

    protected processGetCatalogCountForSaleLineItemReport(response: Response): Promise<CatalogCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCounts>(null as any);
    }

    getCatalogCountForSoldTicketReport(query: UIReportV2SoldTicketQuery, signal?: AbortSignal | undefined): Promise<CatalogCounts> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCatalogCountForSoldTicketReport/GetCatalogCountForSoldTicketReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCountForSoldTicketReport(_response);
        });
    }

    protected processGetCatalogCountForSoldTicketReport(response: Response): Promise<CatalogCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCounts>(null as any);
    }

    downloadSoldTicketReportMetrics(query: SoldTicketReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadSoldTicketReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadSoldTicketReportMetrics(_response);
        });
    }

    protected processDownloadSoldTicketReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCostOfGoodsSoldReportMetrics(query: CostOfGoodsSoldReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCostOfGoodsSoldReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCostOfGoodsSoldReportMetrics(_response);
        });
    }

    protected processGetCostOfGoodsSoldReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getCostOfGoodsSoldReportSummary(query: CostOfGoodsSoldReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCostOfGoodsSoldReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCostOfGoodsSoldReportSummary(_response);
        });
    }

    protected processGetCostOfGoodsSoldReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadCostOfGoodsSoldReportMetrics(query: CostOfGoodsSoldReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadCostOfGoodsSoldReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadCostOfGoodsSoldReportMetrics(_response);
        });
    }

    protected processDownloadCostOfGoodsSoldReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCatalogCountForCostOfGoodsSoldReport(query: UIReportV2CostOfGoodsSoldQuery, signal?: AbortSignal | undefined): Promise<CatalogCounts> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCatalogCountForCostOfGoodsSoldReport/GetCatalogCountForCostOfGoodsSoldReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCountForCostOfGoodsSoldReport(_response);
        });
    }

    protected processGetCatalogCountForCostOfGoodsSoldReport(response: Response): Promise<CatalogCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCounts>(null as any);
    }

    getSaleTotalCostAdjustmentReportMetrics(query: SaleTotalCostAdjustmentReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetSaleTotalCostAdjustmentReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleTotalCostAdjustmentReportMetrics(_response);
        });
    }

    protected processGetSaleTotalCostAdjustmentReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getSaleTotalCostAdjustmentReportSummary(query: SaleTotalCostAdjustmentReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetSaleTotalCostAdjustmentReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleTotalCostAdjustmentReportSummary(_response);
        });
    }

    protected processGetSaleTotalCostAdjustmentReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadSaleTotalCostAdjustmentReportMetrics(query: SaleTotalCostAdjustmentReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadSaleTotalCostAdjustmentReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadSaleTotalCostAdjustmentReportMetrics(_response);
        });
    }

    protected processDownloadSaleTotalCostAdjustmentReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCatalogCountForSaleTotalCostAdjustmentReport(query: UIReportV2SaleTotalCostAdjustmentsQuery, signal?: AbortSignal | undefined): Promise<CatalogCounts> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCatalogCountForSaleTotalCostAdjustmentReport/GetCatalogCountForSaleTotalCostAdjustmentReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCountForSaleTotalCostAdjustmentReport(_response);
        });
    }

    protected processGetCatalogCountForSaleTotalCostAdjustmentReport(response: Response): Promise<CatalogCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCounts>(null as any);
    }

    getTicketGroupReportMetrics(query: TicketGroupReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetTicketGroupReportMetrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTicketGroupReportMetrics(_response);
        });
    }

    protected processGetTicketGroupReportMetrics(response: Response): Promise<ReportMetricsV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsV2>(null as any);
    }

    getTicketGroupReportSummary(query: TicketGroupReportV2Request, signal?: AbortSignal | undefined): Promise<ReportMetricsSummaryV2> {
        let url_ = this.baseUrl + "/api/ReportV2/GetTicketGroupReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTicketGroupReportSummary(_response);
        });
    }

    protected processGetTicketGroupReportSummary(response: Response): Promise<ReportMetricsSummaryV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportMetricsSummaryV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportMetricsSummaryV2>(null as any);
    }

    downloadTicketGroupReportMetrics(query: TicketGroupReportV2Request, reportName: string | undefined, fileType: ReportFileType | undefined, supportBackgroundProcess: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportV2/DownloadTicketGroupReportMetrics?";
        if (reportName === null)
            throw new Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        if (supportBackgroundProcess === null)
            throw new Error("The parameter 'supportBackgroundProcess' cannot be null.");
        else if (supportBackgroundProcess !== undefined)
            url_ += "supportBackgroundProcess=" + encodeURIComponent("" + supportBackgroundProcess) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadTicketGroupReportMetrics(_response);
        });
    }

    protected processDownloadTicketGroupReportMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCatalogCountForTicketGroupReport(query: UIReportV2TicketGroupQuery, signal?: AbortSignal | undefined): Promise<CatalogCounts> {
        let url_ = this.baseUrl + "/api/ReportV2/GetCatalogCountForTicketGroupReport/GetCatalogCountForTicketGroupReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCatalogCountForTicketGroupReport(_response);
        });
    }

    protected processGetCatalogCountForTicketGroupReport(response: Response): Promise<CatalogCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CatalogCounts>(null as any);
    }

    /**
     * Dummy endpoint to expose FileExportResult class to the client
     */
    getEmptyFileExportResult(signal?: AbortSignal | undefined): Promise<FileExportResult> {
        let url_ = this.baseUrl + "/api/ReportV2/GetEmptyFileExportResult/GetEmptyFileExportResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmptyFileExportResult(_response);
        });
    }

    protected processGetEmptyFileExportResult(response: Response): Promise<FileExportResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileExportResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileExportResult>(null as any);
    }

    /**
     * Dummy endpoint to expose FileExportProgress class to the client
     */
    getEmptyFileExportProgress(signal?: AbortSignal | undefined): Promise<FileExportProgress> {
        let url_ = this.baseUrl + "/api/ReportV2/GetEmptyFileExportProgress/GetEmptyFileExportProgress";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmptyFileExportProgress(_response);
        });
    }

    protected processGetEmptyFileExportProgress(response: Response): Promise<FileExportProgress> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileExportProgress;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileExportProgress>(null as any);
    }
}

export interface ISaleClient {

    getSalesForEvents(query: SaleQuery, requireEventIds: boolean | undefined, useReadonlyDB: boolean | undefined, includeInternalNotes: boolean | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfSale; }>;

    /**
     * This use the exact same backend as GetSalesForEvents, but it is used by Advance Search
    The split up allows proper instrumentation and monitoring of the two different use cases
    This endpoint can later be replaced with a different backend
     * @param requireEventIds (optional) 
     * @param useReadonlyDB (optional) 
     * @param includeInternalNotes (optional) 
     */
    searchSalesForEvents(query: SaleQuery, requireEventIds: boolean | undefined, useReadonlyDB: boolean | undefined, includeInternalNotes: boolean | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfSale; }>;

    /**
     * Used by Advanced Search V2 which uses OpenSearch implementation
     */
    searchSalesForEventsV2(query: SaleQueryV2): Promise<{ [key: string]: EntitiesWithSummaryOfSaleWithCatalogData; }>;

    getRecentSales(minRowVersion: number | undefined): Promise<ValueTupleOfIEnumerableOfSaleAndUInt64>;

    getUnableToProcessSales(): Promise<{ [key: string]: Sale[]; }>;

    getSalesByMarketplaceSaleId(marketplaceSaleId: string | undefined): Promise<Sale[]>;

    getSaleBySaleId(saleId: number | undefined): Promise<SaleDetails>;

    confirmAllocationSale(saleId: number | undefined, seatingToAllocate: Seating | undefined, skipAllocationValidation: boolean | null | undefined): Promise<PosUiActionResult>;

    rejectSale(saleId: number | undefined, keepAllocatedTickets: boolean | null | undefined, cancellationReason: SaleCancellationReason | null | undefined): Promise<PosUiActionResult>;

    deallocateSale(saleId: number | undefined, adminHold: boolean | undefined): Promise<PosUiActionResult>;

    saveETicketAssignments(saleId: number | undefined, eticketImages: UserDocument[]): Promise<PosUiActionResult>;

    saveQRCodeAssignments(saleId: number | undefined, qrCodes: UserDocument[]): Promise<PosUiActionResult>;

    updateBarcodesForSale(saleId: number | undefined, ticketBarcodes: TicketBarcode[]): Promise<PosUiActionResult>;

    /**
     * @param saleId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    saveTicketTransferInfoBySaleId(saleId: number, request: TicketTransferRequest): Promise<PosUiActionResult>;

    /**
     * @deprecated
     */
    saveTicketTransferInfo(request: TicketTransferRequest): Promise<PosUiActionResult>;

    resetFulfillment(saleId: number | undefined, removeArtifacts: boolean | undefined): Promise<PosUiActionResult>;

    markAsFulfilled(saleId: number | undefined): Promise<PosUiActionResult>;

    getBarcodesAlreadyInUse(viagogoVirtualId: string | undefined, ticketBarcodes: TicketBarcode[]): Promise<TicketBarcode[]>;

    getTicketExternalIdsAlreadyInUse(viagogoVirtualId: string | undefined, externalIds: TicketExternalId[]): Promise<TicketExternalId[]>;

    getTicketUrlsAlreadyInUse(viagogoVirtualId: string | undefined, urls: TicketUrl[]): Promise<TicketUrl[]>;

    expireHold(saleId: number | undefined): Promise<PosUiActionResult>;

    getSeatingsForSaleAllocation(saleId: number | undefined, allPossibleSeatings: boolean | undefined, isAllocateSingleTickets: boolean | undefined): Promise<SaleAvailableSeatings>;

    exportSales(query: SaleQuery): Promise<FileResponse>;

    /**
     * @param saleId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateSaleBySaleId(saleId: number, saleInput: SaleInput): Promise<PosUiActionResult>;

    /**
     * @deprecated
     */
    updateSale(saleInput: SaleInput): Promise<PosUiActionResult>;

    /**
     * @param saleId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateSaleIsNoFulfillBySaleId(saleId: number, input: ValueTupleOfLongAndNullableBoolean): Promise<PosUiActionResult>;

    /**
     * @deprecated
     */
    updateSaleIsNoFulfill(input: ValueTupleOfLongAndNullableBoolean): Promise<PosUiActionResult>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    mergePosManagedMarketplaceSaleForListingId(listingId: number, input: PosManagedMarketplaceSaleInput): Promise<PosUiActionResult>;

    /**
     * @deprecated
     */
    mergePosManagedMarketplaceSale(input: PosManagedMarketplaceSaleInput): Promise<PosUiActionResult>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    mergeMarketplaceSaleForListingId(listingId: number, input: MarketplaceSaleInput): Promise<PosUiActionResult>;

    /**
     * @deprecated
     */
    mergeMarketplaceSale(input: MarketplaceSaleInput): Promise<PosUiActionResult>;

    getAllAvailableBuyers(): Promise<BuyerInfo[]>;

    downloadMergedUserDocumentsPdf(saleId: number | undefined): Promise<FileResponse>;

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    wasteListingTicketsByListingId(listingId: number, input: WasteListingTicketsInput): Promise<PosUiActionResult>;

    /**
     * @deprecated
     */
    wasteListingTickets(input: WasteListingTicketsInput): Promise<PosUiActionResult>;

    /**
     * @param saleId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    unwasteSaleBySaleId(saleId: number, input: UnwasteSaleInput): Promise<PosUiActionResult>;

    /**
     * @deprecated
     */
    unwasteSale(input: UnwasteSaleInput): Promise<PosUiActionResult>;

    getSaleLineItemsBySaleId(saleId: number | undefined): Promise<SaleLineItem[]>;

    getAggregatedSaleMetrics(timePeriod: AggregateMetricsTimePeriod | undefined, timezoneOffsetMins: number | undefined): Promise<AggregatedSaleMetric[]>;

    backfillCancelledProceeds(): Promise<PosUiActionResult>;
}

export class SaleClient extends PosClientBase implements ISaleClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSalesForEvents(query: SaleQuery, requireEventIds: boolean | undefined, useReadonlyDB: boolean | undefined, includeInternalNotes: boolean | undefined, signal?: AbortSignal | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfSale; }> {
        let url_ = this.baseUrl + "/api/Sale/GetSalesForEvents?";
        if (requireEventIds === null)
            throw new Error("The parameter 'requireEventIds' cannot be null.");
        else if (requireEventIds !== undefined)
            url_ += "requireEventIds=" + encodeURIComponent("" + requireEventIds) + "&";
        if (useReadonlyDB === null)
            throw new Error("The parameter 'useReadonlyDB' cannot be null.");
        else if (useReadonlyDB !== undefined)
            url_ += "useReadonlyDB=" + encodeURIComponent("" + useReadonlyDB) + "&";
        if (includeInternalNotes === null)
            throw new Error("The parameter 'includeInternalNotes' cannot be null.");
        else if (includeInternalNotes !== undefined)
            url_ += "includeInternalNotes=" + encodeURIComponent("" + includeInternalNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSalesForEvents(_response);
        });
    }

    protected processGetSalesForEvents(response: Response): Promise<{ [key: string]: EntitiesWithSummaryOfSale; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: EntitiesWithSummaryOfSale; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: EntitiesWithSummaryOfSale; }>(null as any);
    }

    /**
     * This use the exact same backend as GetSalesForEvents, but it is used by Advance Search
    The split up allows proper instrumentation and monitoring of the two different use cases
    This endpoint can later be replaced with a different backend
     * @param requireEventIds (optional) 
     * @param useReadonlyDB (optional) 
     * @param includeInternalNotes (optional) 
     */
    searchSalesForEvents(query: SaleQuery, requireEventIds: boolean | undefined, useReadonlyDB: boolean | undefined, includeInternalNotes: boolean | undefined, signal?: AbortSignal | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfSale; }> {
        let url_ = this.baseUrl + "/api/Sale/SearchSalesForEvents?";
        if (requireEventIds === null)
            throw new Error("The parameter 'requireEventIds' cannot be null.");
        else if (requireEventIds !== undefined)
            url_ += "requireEventIds=" + encodeURIComponent("" + requireEventIds) + "&";
        if (useReadonlyDB === null)
            throw new Error("The parameter 'useReadonlyDB' cannot be null.");
        else if (useReadonlyDB !== undefined)
            url_ += "useReadonlyDB=" + encodeURIComponent("" + useReadonlyDB) + "&";
        if (includeInternalNotes === null)
            throw new Error("The parameter 'includeInternalNotes' cannot be null.");
        else if (includeInternalNotes !== undefined)
            url_ += "includeInternalNotes=" + encodeURIComponent("" + includeInternalNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchSalesForEvents(_response);
        });
    }

    protected processSearchSalesForEvents(response: Response): Promise<{ [key: string]: EntitiesWithSummaryOfSale; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: EntitiesWithSummaryOfSale; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: EntitiesWithSummaryOfSale; }>(null as any);
    }

    /**
     * Used by Advanced Search V2 which uses OpenSearch implementation
     */
    searchSalesForEventsV2(query: SaleQueryV2, signal?: AbortSignal | undefined): Promise<{ [key: string]: EntitiesWithSummaryOfSaleWithCatalogData; }> {
        let url_ = this.baseUrl + "/api/Sale/SearchSalesForEventsV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchSalesForEventsV2(_response);
        });
    }

    protected processSearchSalesForEventsV2(response: Response): Promise<{ [key: string]: EntitiesWithSummaryOfSaleWithCatalogData; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: EntitiesWithSummaryOfSaleWithCatalogData; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: EntitiesWithSummaryOfSaleWithCatalogData; }>(null as any);
    }

    getRecentSales(minRowVersion: number | undefined, signal?: AbortSignal | undefined): Promise<ValueTupleOfIEnumerableOfSaleAndUInt64> {
        let url_ = this.baseUrl + "/api/Sale/GetRecentSales?";
        if (minRowVersion === null)
            throw new Error("The parameter 'minRowVersion' cannot be null.");
        else if (minRowVersion !== undefined)
            url_ += "minRowVersion=" + encodeURIComponent("" + minRowVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRecentSales(_response);
        });
    }

    protected processGetRecentSales(response: Response): Promise<ValueTupleOfIEnumerableOfSaleAndUInt64> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValueTupleOfIEnumerableOfSaleAndUInt64;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValueTupleOfIEnumerableOfSaleAndUInt64>(null as any);
    }

    getUnableToProcessSales(signal?: AbortSignal | undefined): Promise<{ [key: string]: Sale[]; }> {
        let url_ = this.baseUrl + "/api/Sale/GetUnableToProcessSales";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnableToProcessSales(_response);
        });
    }

    protected processGetUnableToProcessSales(response: Response): Promise<{ [key: string]: Sale[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: Sale[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: Sale[]; }>(null as any);
    }

    getSalesByMarketplaceSaleId(marketplaceSaleId: string | undefined, signal?: AbortSignal | undefined): Promise<Sale[]> {
        let url_ = this.baseUrl + "/api/Sale/GetSalesByMarketplaceSaleId?";
        if (marketplaceSaleId === null)
            throw new Error("The parameter 'marketplaceSaleId' cannot be null.");
        else if (marketplaceSaleId !== undefined)
            url_ += "marketplaceSaleId=" + encodeURIComponent("" + marketplaceSaleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSalesByMarketplaceSaleId(_response);
        });
    }

    protected processGetSalesByMarketplaceSaleId(response: Response): Promise<Sale[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Sale[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sale[]>(null as any);
    }

    getSaleBySaleId(saleId: number | undefined, signal?: AbortSignal | undefined): Promise<SaleDetails> {
        let url_ = this.baseUrl + "/api/Sale/GetSaleBySaleId?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleBySaleId(_response);
        });
    }

    protected processGetSaleBySaleId(response: Response): Promise<SaleDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaleDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleDetails>(null as any);
    }

    confirmAllocationSale(saleId: number | undefined, seatingToAllocate: Seating | undefined, skipAllocationValidation: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/ConfirmAllocationSale?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        if (skipAllocationValidation !== undefined && skipAllocationValidation !== null)
            url_ += "skipAllocationValidation=" + encodeURIComponent("" + skipAllocationValidation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(seatingToAllocate);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConfirmAllocationSale(_response);
        });
    }

    protected processConfirmAllocationSale(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    rejectSale(saleId: number | undefined, keepAllocatedTickets: boolean | null | undefined, cancellationReason: SaleCancellationReason | null | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/RejectSale?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        if (keepAllocatedTickets !== undefined && keepAllocatedTickets !== null)
            url_ += "keepAllocatedTickets=" + encodeURIComponent("" + keepAllocatedTickets) + "&";
        if (cancellationReason !== undefined && cancellationReason !== null)
            url_ += "cancellationReason=" + encodeURIComponent("" + cancellationReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRejectSale(_response);
        });
    }

    protected processRejectSale(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    deallocateSale(saleId: number | undefined, adminHold: boolean | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/DeallocateSale?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        if (adminHold === null)
            throw new Error("The parameter 'adminHold' cannot be null.");
        else if (adminHold !== undefined)
            url_ += "adminHold=" + encodeURIComponent("" + adminHold) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeallocateSale(_response);
        });
    }

    protected processDeallocateSale(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    saveETicketAssignments(saleId: number | undefined, eticketImages: UserDocument[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/SaveETicketAssignments?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eticketImages);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveETicketAssignments(_response);
        });
    }

    protected processSaveETicketAssignments(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    saveQRCodeAssignments(saleId: number | undefined, qrCodes: UserDocument[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/SaveQRCodeAssignments?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(qrCodes);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveQRCodeAssignments(_response);
        });
    }

    protected processSaveQRCodeAssignments(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateBarcodesForSale(saleId: number | undefined, ticketBarcodes: TicketBarcode[], signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/UpdateBarcodesForSale?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ticketBarcodes);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateBarcodesForSale(_response);
        });
    }

    protected processUpdateBarcodesForSale(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param saleId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    saveTicketTransferInfoBySaleId(saleId: number, request: TicketTransferRequest, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/SaveTicketTransferInfoBySaleId/{saleId}";
        if (saleId === undefined || saleId === null)
            throw new Error("The parameter 'saleId' must be defined.");
        url_ = url_.replace("{saleId}", encodeURIComponent("" + saleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveTicketTransferInfoBySaleId(_response);
        });
    }

    protected processSaveTicketTransferInfoBySaleId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @deprecated
     */
    saveTicketTransferInfo(request: TicketTransferRequest, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/SaveTicketTransferInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveTicketTransferInfo(_response);
        });
    }

    protected processSaveTicketTransferInfo(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    resetFulfillment(saleId: number | undefined, removeArtifacts: boolean | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/ResetFulfillment?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        if (removeArtifacts === null)
            throw new Error("The parameter 'removeArtifacts' cannot be null.");
        else if (removeArtifacts !== undefined)
            url_ += "removeArtifacts=" + encodeURIComponent("" + removeArtifacts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetFulfillment(_response);
        });
    }

    protected processResetFulfillment(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    markAsFulfilled(saleId: number | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/MarkAsFulfilled?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkAsFulfilled(_response);
        });
    }

    protected processMarkAsFulfilled(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    getBarcodesAlreadyInUse(viagogoVirtualId: string | undefined, ticketBarcodes: TicketBarcode[], signal?: AbortSignal | undefined): Promise<TicketBarcode[]> {
        let url_ = this.baseUrl + "/api/Sale/GetBarcodesAlreadyInUse?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ticketBarcodes);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBarcodesAlreadyInUse(_response);
        });
    }

    protected processGetBarcodesAlreadyInUse(response: Response): Promise<TicketBarcode[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TicketBarcode[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketBarcode[]>(null as any);
    }

    getTicketExternalIdsAlreadyInUse(viagogoVirtualId: string | undefined, externalIds: TicketExternalId[], signal?: AbortSignal | undefined): Promise<TicketExternalId[]> {
        let url_ = this.baseUrl + "/api/Sale/GetTicketExternalIdsAlreadyInUse?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(externalIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTicketExternalIdsAlreadyInUse(_response);
        });
    }

    protected processGetTicketExternalIdsAlreadyInUse(response: Response): Promise<TicketExternalId[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TicketExternalId[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketExternalId[]>(null as any);
    }

    getTicketUrlsAlreadyInUse(viagogoVirtualId: string | undefined, urls: TicketUrl[], signal?: AbortSignal | undefined): Promise<TicketUrl[]> {
        let url_ = this.baseUrl + "/api/Sale/GetTicketUrlsAlreadyInUse?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(urls);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTicketUrlsAlreadyInUse(_response);
        });
    }

    protected processGetTicketUrlsAlreadyInUse(response: Response): Promise<TicketUrl[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TicketUrl[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketUrl[]>(null as any);
    }

    expireHold(saleId: number | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/ExpireHold?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExpireHold(_response);
        });
    }

    protected processExpireHold(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    getSeatingsForSaleAllocation(saleId: number | undefined, allPossibleSeatings: boolean | undefined, isAllocateSingleTickets: boolean | undefined, signal?: AbortSignal | undefined): Promise<SaleAvailableSeatings> {
        let url_ = this.baseUrl + "/api/Sale/GetSeatingsForSaleAllocation?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        if (allPossibleSeatings === null)
            throw new Error("The parameter 'allPossibleSeatings' cannot be null.");
        else if (allPossibleSeatings !== undefined)
            url_ += "allPossibleSeatings=" + encodeURIComponent("" + allPossibleSeatings) + "&";
        if (isAllocateSingleTickets === null)
            throw new Error("The parameter 'isAllocateSingleTickets' cannot be null.");
        else if (isAllocateSingleTickets !== undefined)
            url_ += "isAllocateSingleTickets=" + encodeURIComponent("" + isAllocateSingleTickets) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSeatingsForSaleAllocation(_response);
        });
    }

    protected processGetSeatingsForSaleAllocation(response: Response): Promise<SaleAvailableSeatings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaleAvailableSeatings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleAvailableSeatings>(null as any);
    }

    exportSales(query: SaleQuery, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Sale/ExportSales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportSales(_response);
        });
    }

    protected processExportSales(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param saleId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateSaleBySaleId(saleId: number, saleInput: SaleInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/UpdateSaleBySaleId/{saleId}";
        if (saleId === undefined || saleId === null)
            throw new Error("The parameter 'saleId' must be defined.");
        url_ = url_.replace("{saleId}", encodeURIComponent("" + saleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saleInput);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSaleBySaleId(_response);
        });
    }

    protected processUpdateSaleBySaleId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @deprecated
     */
    updateSale(saleInput: SaleInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/UpdateSale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saleInput);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSale(_response);
        });
    }

    protected processUpdateSale(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param saleId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    updateSaleIsNoFulfillBySaleId(saleId: number, input: ValueTupleOfLongAndNullableBoolean, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/UpdateSaleIsNoFulfillBySaleId/{saleId}";
        if (saleId === undefined || saleId === null)
            throw new Error("The parameter 'saleId' must be defined.");
        url_ = url_.replace("{saleId}", encodeURIComponent("" + saleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSaleIsNoFulfillBySaleId(_response);
        });
    }

    protected processUpdateSaleIsNoFulfillBySaleId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @deprecated
     */
    updateSaleIsNoFulfill(input: ValueTupleOfLongAndNullableBoolean, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/UpdateSaleIsNoFulfill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSaleIsNoFulfill(_response);
        });
    }

    protected processUpdateSaleIsNoFulfill(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    mergePosManagedMarketplaceSaleForListingId(listingId: number, input: PosManagedMarketplaceSaleInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/MergePosManagedMarketplaceSaleForListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergePosManagedMarketplaceSaleForListingId(_response);
        });
    }

    protected processMergePosManagedMarketplaceSaleForListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @deprecated
     */
    mergePosManagedMarketplaceSale(input: PosManagedMarketplaceSaleInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/MergePosManagedMarketplaceSale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergePosManagedMarketplaceSale(_response);
        });
    }

    protected processMergePosManagedMarketplaceSale(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    mergeMarketplaceSaleForListingId(listingId: number, input: MarketplaceSaleInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/MergeMarketplaceSaleForListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeMarketplaceSaleForListingId(_response);
        });
    }

    protected processMergeMarketplaceSaleForListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @deprecated
     */
    mergeMarketplaceSale(input: MarketplaceSaleInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/MergeMarketplaceSale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeMarketplaceSale(_response);
        });
    }

    protected processMergeMarketplaceSale(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    getAllAvailableBuyers(signal?: AbortSignal | undefined): Promise<BuyerInfo[]> {
        let url_ = this.baseUrl + "/api/Sale/GetAllAvailableBuyers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllAvailableBuyers(_response);
        });
    }

    protected processGetAllAvailableBuyers(response: Response): Promise<BuyerInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuyerInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BuyerInfo[]>(null as any);
    }

    downloadMergedUserDocumentsPdf(saleId: number | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Sale/DownloadMergedUserDocumentsPdf?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadMergedUserDocumentsPdf(_response);
        });
    }

    protected processDownloadMergedUserDocumentsPdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param listingId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    wasteListingTicketsByListingId(listingId: number, input: WasteListingTicketsInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/WasteListingTicketsByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWasteListingTicketsByListingId(_response);
        });
    }

    protected processWasteListingTicketsByListingId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @deprecated
     */
    wasteListingTickets(input: WasteListingTicketsInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/WasteListingTickets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWasteListingTickets(_response);
        });
    }

    protected processWasteListingTickets(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @param saleId Used for route parsing so that action argument is parsed for consignee impersonation
     */
    unwasteSaleBySaleId(saleId: number, input: UnwasteSaleInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/UnwasteSaleBySaleId/{saleId}";
        if (saleId === undefined || saleId === null)
            throw new Error("The parameter 'saleId' must be defined.");
        url_ = url_.replace("{saleId}", encodeURIComponent("" + saleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnwasteSaleBySaleId(_response);
        });
    }

    protected processUnwasteSaleBySaleId(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    /**
     * @deprecated
     */
    unwasteSale(input: UnwasteSaleInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/UnwasteSale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnwasteSale(_response);
        });
    }

    protected processUnwasteSale(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    getSaleLineItemsBySaleId(saleId: number | undefined, signal?: AbortSignal | undefined): Promise<SaleLineItem[]> {
        let url_ = this.baseUrl + "/api/Sale/GetSaleLineItemsBySaleId?";
        if (saleId === null)
            throw new Error("The parameter 'saleId' cannot be null.");
        else if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleLineItemsBySaleId(_response);
        });
    }

    protected processGetSaleLineItemsBySaleId(response: Response): Promise<SaleLineItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaleLineItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleLineItem[]>(null as any);
    }

    getAggregatedSaleMetrics(timePeriod: AggregateMetricsTimePeriod | undefined, timezoneOffsetMins: number | undefined, signal?: AbortSignal | undefined): Promise<AggregatedSaleMetric[]> {
        let url_ = this.baseUrl + "/api/Sale/GetAggregatedSaleMetrics?";
        if (timePeriod === null)
            throw new Error("The parameter 'timePeriod' cannot be null.");
        else if (timePeriod !== undefined)
            url_ += "timePeriod=" + encodeURIComponent("" + timePeriod) + "&";
        if (timezoneOffsetMins === null)
            throw new Error("The parameter 'timezoneOffsetMins' cannot be null.");
        else if (timezoneOffsetMins !== undefined)
            url_ += "timezoneOffsetMins=" + encodeURIComponent("" + timezoneOffsetMins) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAggregatedSaleMetrics(_response);
        });
    }

    protected processGetAggregatedSaleMetrics(response: Response): Promise<AggregatedSaleMetric[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AggregatedSaleMetric[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AggregatedSaleMetric[]>(null as any);
    }

    backfillCancelledProceeds(signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/Sale/BackfillCancelledProceeds";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBackfillCancelledProceeds(_response);
        });
    }

    protected processBackfillCancelledProceeds(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }
}

export interface ISalesOpenSearchClient {

    /**
     * Enhanced sales search with ComprehensiveSaleDocument mapped to UI DTOs
    Uses ComprehensiveSaleDocument for comprehensive filtering then maps to Sale DTOs for UI consumption
    This provides the best of both worlds: comprehensive filtering + familiar UI DTOs
     * @param request The enhanced search request with SaleFilterQueryV2 criteria and options
     * @return Search results mapped to Sale DTOs with comprehensive search capabilities
     */
    searchSalesV3(request: SaleSearchRequestV2): Promise<SecureSalesSearchMappedResult>;
}

export class SalesOpenSearchClient extends PosClientBase implements ISalesOpenSearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Enhanced sales search with ComprehensiveSaleDocument mapped to UI DTOs
    Uses ComprehensiveSaleDocument for comprehensive filtering then maps to Sale DTOs for UI consumption
    This provides the best of both worlds: comprehensive filtering + familiar UI DTOs
     * @param request The enhanced search request with SaleFilterQueryV2 criteria and options
     * @return Search results mapped to Sale DTOs with comprehensive search capabilities
     */
    searchSalesV3(request: SaleSearchRequestV2, signal?: AbortSignal | undefined): Promise<SecureSalesSearchMappedResult> {
        let url_ = this.baseUrl + "/api/OpenSearch/SearchSalesV3";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchSalesV3(_response);
        });
    }

    protected processSearchSalesV3(response: Response): Promise<SecureSalesSearchMappedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SecureSalesSearchMappedResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecureSalesSearchMappedResult>(null as any);
    }
}

export interface ISearchClient {

    getPurchaseSearchConfigs(includeAllUsers: boolean | undefined): Promise<PurchaseSearchResult[]>;

    getPurchaseSearchResult(searchConfigId: string | undefined): Promise<PurchaseSearchResult>;

    savePurchaseSearchResult(r: PurchaseSearchResult): Promise<PurchaseSearchResult | null>;

    getSaleSearchConfigs(includeAllUsers: boolean | undefined): Promise<SaleSearchResult[]>;

    getSaleSearchResult(searchConfigId: string | undefined): Promise<SaleSearchResult>;

    saveSaleSearchResult(r: SaleSearchResult): Promise<SaleSearchResult | null>;

    getInventorySearchConfigs(includeAllUsers: boolean | undefined): Promise<InventorySearchResult[]>;

    getInventorySearchResult(searchConfigId: string | undefined): Promise<InventorySearchResult>;

    saveInventorySearchResult(r: InventorySearchResult): Promise<InventorySearchResult | null>;

    deleteSearchConfig(searchConfigId: string | undefined): Promise<void>;
}

export class SearchClient extends PosClientBase implements ISearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getPurchaseSearchConfigs(includeAllUsers: boolean | undefined, signal?: AbortSignal | undefined): Promise<PurchaseSearchResult[]> {
        let url_ = this.baseUrl + "/api/Search/GetPurchaseSearchConfigs?";
        if (includeAllUsers === null)
            throw new Error("The parameter 'includeAllUsers' cannot be null.");
        else if (includeAllUsers !== undefined)
            url_ += "includeAllUsers=" + encodeURIComponent("" + includeAllUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseSearchConfigs(_response);
        });
    }

    protected processGetPurchaseSearchConfigs(response: Response): Promise<PurchaseSearchResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseSearchResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseSearchResult[]>(null as any);
    }

    getPurchaseSearchResult(searchConfigId: string | undefined, signal?: AbortSignal | undefined): Promise<PurchaseSearchResult> {
        let url_ = this.baseUrl + "/api/Search/GetPurchaseSearchResult?";
        if (searchConfigId === null)
            throw new Error("The parameter 'searchConfigId' cannot be null.");
        else if (searchConfigId !== undefined)
            url_ += "searchConfigId=" + encodeURIComponent("" + searchConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseSearchResult(_response);
        });
    }

    protected processGetPurchaseSearchResult(response: Response): Promise<PurchaseSearchResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseSearchResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseSearchResult>(null as any);
    }

    savePurchaseSearchResult(r: PurchaseSearchResult, signal?: AbortSignal | undefined): Promise<PurchaseSearchResult | null> {
        let url_ = this.baseUrl + "/api/Search/SavePurchaseSearchResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(r);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSavePurchaseSearchResult(_response);
        });
    }

    protected processSavePurchaseSearchResult(response: Response): Promise<PurchaseSearchResult | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseSearchResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseSearchResult | null>(null as any);
    }

    getSaleSearchConfigs(includeAllUsers: boolean | undefined, signal?: AbortSignal | undefined): Promise<SaleSearchResult[]> {
        let url_ = this.baseUrl + "/api/Search/GetSaleSearchConfigs?";
        if (includeAllUsers === null)
            throw new Error("The parameter 'includeAllUsers' cannot be null.");
        else if (includeAllUsers !== undefined)
            url_ += "includeAllUsers=" + encodeURIComponent("" + includeAllUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleSearchConfigs(_response);
        });
    }

    protected processGetSaleSearchConfigs(response: Response): Promise<SaleSearchResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaleSearchResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleSearchResult[]>(null as any);
    }

    getSaleSearchResult(searchConfigId: string | undefined, signal?: AbortSignal | undefined): Promise<SaleSearchResult> {
        let url_ = this.baseUrl + "/api/Search/GetSaleSearchResult?";
        if (searchConfigId === null)
            throw new Error("The parameter 'searchConfigId' cannot be null.");
        else if (searchConfigId !== undefined)
            url_ += "searchConfigId=" + encodeURIComponent("" + searchConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSaleSearchResult(_response);
        });
    }

    protected processGetSaleSearchResult(response: Response): Promise<SaleSearchResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaleSearchResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleSearchResult>(null as any);
    }

    saveSaleSearchResult(r: SaleSearchResult, signal?: AbortSignal | undefined): Promise<SaleSearchResult | null> {
        let url_ = this.baseUrl + "/api/Search/SaveSaleSearchResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(r);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveSaleSearchResult(_response);
        });
    }

    protected processSaveSaleSearchResult(response: Response): Promise<SaleSearchResult | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaleSearchResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleSearchResult | null>(null as any);
    }

    getInventorySearchConfigs(includeAllUsers: boolean | undefined, signal?: AbortSignal | undefined): Promise<InventorySearchResult[]> {
        let url_ = this.baseUrl + "/api/Search/GetInventorySearchConfigs?";
        if (includeAllUsers === null)
            throw new Error("The parameter 'includeAllUsers' cannot be null.");
        else if (includeAllUsers !== undefined)
            url_ += "includeAllUsers=" + encodeURIComponent("" + includeAllUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInventorySearchConfigs(_response);
        });
    }

    protected processGetInventorySearchConfigs(response: Response): Promise<InventorySearchResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InventorySearchResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventorySearchResult[]>(null as any);
    }

    getInventorySearchResult(searchConfigId: string | undefined, signal?: AbortSignal | undefined): Promise<InventorySearchResult> {
        let url_ = this.baseUrl + "/api/Search/GetInventorySearchResult?";
        if (searchConfigId === null)
            throw new Error("The parameter 'searchConfigId' cannot be null.");
        else if (searchConfigId !== undefined)
            url_ += "searchConfigId=" + encodeURIComponent("" + searchConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInventorySearchResult(_response);
        });
    }

    protected processGetInventorySearchResult(response: Response): Promise<InventorySearchResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InventorySearchResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventorySearchResult>(null as any);
    }

    saveInventorySearchResult(r: InventorySearchResult, signal?: AbortSignal | undefined): Promise<InventorySearchResult | null> {
        let url_ = this.baseUrl + "/api/Search/SaveInventorySearchResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(r);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveInventorySearchResult(_response);
        });
    }

    protected processSaveInventorySearchResult(response: Response): Promise<InventorySearchResult | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InventorySearchResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventorySearchResult | null>(null as any);
    }

    deleteSearchConfig(searchConfigId: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Search/DeleteSearchConfig?";
        if (searchConfigId === null)
            throw new Error("The parameter 'searchConfigId' cannot be null.");
        else if (searchConfigId !== undefined)
            url_ += "searchConfigId=" + encodeURIComponent("" + searchConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSearchConfig(_response);
        });
    }

    protected processDeleteSearchConfig(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISellerAccountClient {

    getCurrentUserSellerAccounts(): Promise<SellerAccount[]>;

    getConsigneeSellerAccounts(): Promise<SellerAccount[]>;

    getSellerUsersForSellerAccount(): Promise<SellerUserAccountInfo[]>;

    getSelleRolesForSellerAccount(): Promise<SellerRoleInfo[]>;

    getAllSellerPermissions(): Promise<SellerPermissionInfo[]>;

    updateSellerUser(input: SellerUserInput): Promise<boolean>;

    getSellerUser(stubHubLoginId: string | undefined): Promise<SellerUser>;

    mergeRolesToSellerUser(input: SellerUserRolesInput): Promise<boolean>;

    activateUserForSellerAccountByEmail(email: string | undefined, consigneeSellerAccountId: string | null | undefined): Promise<boolean>;

    activateUserForSellerAccount(input: SellerUserAccountInput): Promise<boolean>;

    deactivateUserForSellerAccount(input: SellerUserAccountInput): Promise<boolean>;

    getSyncCenterSettings(): Promise<SyncCenterSettings>;

    mergeSyncCenterSettings(settings: SyncCenterSettings): Promise<boolean>;

    getAccountAutoPricingSettings(): Promise<AccountAutoPricingSettingsInputs>;

    mergeAccountAutoPricingSettings(input: AccountAutoPricingSettingsInputs): Promise<boolean>;

    getAutoCurrencyConversionSettings(): Promise<AutoCurrencyConversionSettings>;

    mergeAutoCurrencyConversionSettings(settings: AutoCurrencyConversionSettings): Promise<boolean>;

    getCustomTimeZoneSettings(): Promise<TimezoneInfo>;

    mergeCustomTimeZoneSettings(settings: TimezoneInfo | undefined): Promise<boolean>;

    updateMarketplaceSellerAccountPassword(marketplace: Marketplace | undefined, password: string | undefined): Promise<boolean>;

    createSellerRole(input: SellerRoleInput): Promise<PosUiActionResult>;

    updateSellerRole(input: SellerRoleInput): Promise<PosUiActionResult>;

    deleteSellerRole(roleId: number | undefined): Promise<PosUiActionResult>;

    initiateTradeDeskReset(username: string | undefined): Promise<PosUiActionResult>;

    resetTradeDeskPassword(input: TradeDeskPasswordResetInput): Promise<PosUiActionResult>;

    getRevealSyncConfig(): Promise<RevealMarketExternalPosSyncConfig>;

    upsertRevealSyncConfig(syncConfigOverride: RevealSyncConfigOverrideInput): Promise<PosUiActionResult>;

    getConfirmationDialogSettings(): Promise<ConfirmationDialogSettingsResponse>;

    upsertConfirmationDialogSettings(request: ConfirmationDialogSettingRequest): Promise<boolean>;

    getPurchaseOrderSettings(): Promise<PurchaseOrderSettings>;

    mergePurchaseOrderSettings(settings: PurchaseOrderSettings): Promise<boolean>;

    getListingGroupSettings(): Promise<ListingGroupSettings>;

    mergeListingGroupSettings(settings: ListingGroupSettings): Promise<boolean>;
}

export class SellerAccountClient extends PosClientBase implements ISellerAccountClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCurrentUserSellerAccounts(signal?: AbortSignal | undefined): Promise<SellerAccount[]> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetCurrentUserSellerAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUserSellerAccounts(_response);
        });
    }

    protected processGetCurrentUserSellerAccounts(response: Response): Promise<SellerAccount[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerAccount[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerAccount[]>(null as any);
    }

    getConsigneeSellerAccounts(signal?: AbortSignal | undefined): Promise<SellerAccount[]> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetConsigneeSellerAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConsigneeSellerAccounts(_response);
        });
    }

    protected processGetConsigneeSellerAccounts(response: Response): Promise<SellerAccount[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerAccount[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerAccount[]>(null as any);
    }

    getSellerUsersForSellerAccount(signal?: AbortSignal | undefined): Promise<SellerUserAccountInfo[]> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetSellerUsersForSellerAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerUsersForSellerAccount(_response);
        });
    }

    protected processGetSellerUsersForSellerAccount(response: Response): Promise<SellerUserAccountInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerUserAccountInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerUserAccountInfo[]>(null as any);
    }

    getSelleRolesForSellerAccount(signal?: AbortSignal | undefined): Promise<SellerRoleInfo[]> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetSelleRolesForSellerAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSelleRolesForSellerAccount(_response);
        });
    }

    protected processGetSelleRolesForSellerAccount(response: Response): Promise<SellerRoleInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerRoleInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerRoleInfo[]>(null as any);
    }

    getAllSellerPermissions(signal?: AbortSignal | undefined): Promise<SellerPermissionInfo[]> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetAllSellerPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSellerPermissions(_response);
        });
    }

    protected processGetAllSellerPermissions(response: Response): Promise<SellerPermissionInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerPermissionInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerPermissionInfo[]>(null as any);
    }

    updateSellerUser(input: SellerUserInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/UpdateSellerUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSellerUser(_response);
        });
    }

    protected processUpdateSellerUser(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getSellerUser(stubHubLoginId: string | undefined, signal?: AbortSignal | undefined): Promise<SellerUser> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetSellerUser?";
        if (stubHubLoginId === null)
            throw new Error("The parameter 'stubHubLoginId' cannot be null.");
        else if (stubHubLoginId !== undefined)
            url_ += "stubHubLoginId=" + encodeURIComponent("" + stubHubLoginId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerUser(_response);
        });
    }

    protected processGetSellerUser(response: Response): Promise<SellerUser> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerUser;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerUser>(null as any);
    }

    mergeRolesToSellerUser(input: SellerUserRolesInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/MergeRolesToSellerUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeRolesToSellerUser(_response);
        });
    }

    protected processMergeRolesToSellerUser(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    activateUserForSellerAccountByEmail(email: string | undefined, consigneeSellerAccountId: string | null | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/ActivateUserForSellerAccountByEmail?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (consigneeSellerAccountId !== undefined && consigneeSellerAccountId !== null)
            url_ += "consigneeSellerAccountId=" + encodeURIComponent("" + consigneeSellerAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processActivateUserForSellerAccountByEmail(_response);
        });
    }

    protected processActivateUserForSellerAccountByEmail(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    activateUserForSellerAccount(input: SellerUserAccountInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/ActivateUserForSellerAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processActivateUserForSellerAccount(_response);
        });
    }

    protected processActivateUserForSellerAccount(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deactivateUserForSellerAccount(input: SellerUserAccountInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/DeactivateUserForSellerAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeactivateUserForSellerAccount(_response);
        });
    }

    protected processDeactivateUserForSellerAccount(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getSyncCenterSettings(signal?: AbortSignal | undefined): Promise<SyncCenterSettings> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetSyncCenterSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSyncCenterSettings(_response);
        });
    }

    protected processGetSyncCenterSettings(response: Response): Promise<SyncCenterSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SyncCenterSettings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncCenterSettings>(null as any);
    }

    mergeSyncCenterSettings(settings: SyncCenterSettings, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/MergeSyncCenterSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeSyncCenterSettings(_response);
        });
    }

    protected processMergeSyncCenterSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAccountAutoPricingSettings(signal?: AbortSignal | undefined): Promise<AccountAutoPricingSettingsInputs> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetAccountAutoPricingSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccountAutoPricingSettings(_response);
        });
    }

    protected processGetAccountAutoPricingSettings(response: Response): Promise<AccountAutoPricingSettingsInputs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountAutoPricingSettingsInputs;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountAutoPricingSettingsInputs>(null as any);
    }

    mergeAccountAutoPricingSettings(input: AccountAutoPricingSettingsInputs, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/MergeAccountAutoPricingSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeAccountAutoPricingSettings(_response);
        });
    }

    protected processMergeAccountAutoPricingSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAutoCurrencyConversionSettings(signal?: AbortSignal | undefined): Promise<AutoCurrencyConversionSettings> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetAutoCurrencyConversionSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAutoCurrencyConversionSettings(_response);
        });
    }

    protected processGetAutoCurrencyConversionSettings(response: Response): Promise<AutoCurrencyConversionSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoCurrencyConversionSettings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoCurrencyConversionSettings>(null as any);
    }

    mergeAutoCurrencyConversionSettings(settings: AutoCurrencyConversionSettings, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/MergeAutoCurrencyConversionSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeAutoCurrencyConversionSettings(_response);
        });
    }

    protected processMergeAutoCurrencyConversionSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCustomTimeZoneSettings(signal?: AbortSignal | undefined): Promise<TimezoneInfo> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetCustomTimeZoneSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomTimeZoneSettings(_response);
        });
    }

    protected processGetCustomTimeZoneSettings(response: Response): Promise<TimezoneInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TimezoneInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimezoneInfo>(null as any);
    }

    mergeCustomTimeZoneSettings(settings: TimezoneInfo | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/MergeCustomTimeZoneSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeCustomTimeZoneSettings(_response);
        });
    }

    protected processMergeCustomTimeZoneSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateMarketplaceSellerAccountPassword(marketplace: Marketplace | undefined, password: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/UpdateMarketplaceSellerAccountPassword?";
        if (marketplace === null)
            throw new Error("The parameter 'marketplace' cannot be null.");
        else if (marketplace !== undefined)
            url_ += "marketplace=" + encodeURIComponent("" + marketplace) + "&";
        if (password === null)
            throw new Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMarketplaceSellerAccountPassword(_response);
        });
    }

    protected processUpdateMarketplaceSellerAccountPassword(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    createSellerRole(input: SellerRoleInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/SellerAccount/CreateSellerRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSellerRole(_response);
        });
    }

    protected processCreateSellerRole(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    updateSellerRole(input: SellerRoleInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/SellerAccount/UpdateSellerRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSellerRole(_response);
        });
    }

    protected processUpdateSellerRole(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    deleteSellerRole(roleId: number | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/SellerAccount/DeleteSellerRole?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSellerRole(_response);
        });
    }

    protected processDeleteSellerRole(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    initiateTradeDeskReset(username: string | undefined, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/SellerAccount/InitiateTradeDeskReset?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInitiateTradeDeskReset(_response);
        });
    }

    protected processInitiateTradeDeskReset(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    resetTradeDeskPassword(input: TradeDeskPasswordResetInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/SellerAccount/ResetTradeDeskPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetTradeDeskPassword(_response);
        });
    }

    protected processResetTradeDeskPassword(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    getRevealSyncConfig(signal?: AbortSignal | undefined): Promise<RevealMarketExternalPosSyncConfig> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetRevealSyncConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRevealSyncConfig(_response);
        });
    }

    protected processGetRevealSyncConfig(response: Response): Promise<RevealMarketExternalPosSyncConfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RevealMarketExternalPosSyncConfig;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RevealMarketExternalPosSyncConfig>(null as any);
    }

    upsertRevealSyncConfig(syncConfigOverride: RevealSyncConfigOverrideInput, signal?: AbortSignal | undefined): Promise<PosUiActionResult> {
        let url_ = this.baseUrl + "/api/SellerAccount/UpsertRevealSyncConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(syncConfigOverride);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertRevealSyncConfig(_response);
        });
    }

    protected processUpsertRevealSyncConfig(response: Response): Promise<PosUiActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosUiActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosUiActionResult>(null as any);
    }

    getConfirmationDialogSettings(signal?: AbortSignal | undefined): Promise<ConfirmationDialogSettingsResponse> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetConfirmationDialogSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfirmationDialogSettings(_response);
        });
    }

    protected processGetConfirmationDialogSettings(response: Response): Promise<ConfirmationDialogSettingsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConfirmationDialogSettingsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmationDialogSettingsResponse>(null as any);
    }

    upsertConfirmationDialogSettings(request: ConfirmationDialogSettingRequest, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/UpsertConfirmationDialogSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertConfirmationDialogSettings(_response);
        });
    }

    protected processUpsertConfirmationDialogSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getPurchaseOrderSettings(signal?: AbortSignal | undefined): Promise<PurchaseOrderSettings> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetPurchaseOrderSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPurchaseOrderSettings(_response);
        });
    }

    protected processGetPurchaseOrderSettings(response: Response): Promise<PurchaseOrderSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PurchaseOrderSettings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseOrderSettings>(null as any);
    }

    mergePurchaseOrderSettings(settings: PurchaseOrderSettings, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/MergePurchaseOrderSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergePurchaseOrderSettings(_response);
        });
    }

    protected processMergePurchaseOrderSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getListingGroupSettings(signal?: AbortSignal | undefined): Promise<ListingGroupSettings> {
        let url_ = this.baseUrl + "/api/SellerAccount/GetListingGroupSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListingGroupSettings(_response);
        });
    }

    protected processGetListingGroupSettings(response: Response): Promise<ListingGroupSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListingGroupSettings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingGroupSettings>(null as any);
    }

    mergeListingGroupSettings(settings: ListingGroupSettings, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccount/MergeListingGroupSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeListingGroupSettings(_response);
        });
    }

    protected processMergeListingGroupSettings(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface ISellerAccountFulfillmentRulesClient {

    getFulfillmentRuleForEvent(viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined): Promise<SellerAccountFulfillmentRuleDto>;

    createFulfillmentRuleForEvent(input: SellerAccountFulfillmentRulesInput): Promise<boolean>;

    deleteFulfillmentRule(fulfillmentRuleId: number | undefined): Promise<boolean>;

    deleteFulfillmentRules(fulfillmentRuleIds: number[]): Promise<boolean>;

    updateFulfillmentRuleForEvent(input: SellerAccountFulfillmentRulesInput): Promise<boolean>;

    createFulfillmentRulesForVenues(input: SellerAccountFulfillmentRulesInput[]): Promise<FileResponse>;

    getVenueLevelFulfillmentRules(): Promise<SellerAccountFulfillmentRule[]>;
}

export class SellerAccountFulfillmentRulesClient extends PosClientBase implements ISellerAccountFulfillmentRulesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getFulfillmentRuleForEvent(viagogoEventId: number | null | undefined, eventMappingId: string | null | undefined, signal?: AbortSignal | undefined): Promise<SellerAccountFulfillmentRuleDto> {
        let url_ = this.baseUrl + "/api/SellerAccountFulfillmentRules/GetFulfillmentRuleForEvent?";
        if (viagogoEventId !== undefined && viagogoEventId !== null)
            url_ += "viagogoEventId=" + encodeURIComponent("" + viagogoEventId) + "&";
        if (eventMappingId !== undefined && eventMappingId !== null)
            url_ += "eventMappingId=" + encodeURIComponent("" + eventMappingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFulfillmentRuleForEvent(_response);
        });
    }

    protected processGetFulfillmentRuleForEvent(response: Response): Promise<SellerAccountFulfillmentRuleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerAccountFulfillmentRuleDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerAccountFulfillmentRuleDto>(null as any);
    }

    createFulfillmentRuleForEvent(input: SellerAccountFulfillmentRulesInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccountFulfillmentRules/CreateFulfillmentRuleForEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFulfillmentRuleForEvent(_response);
        });
    }

    protected processCreateFulfillmentRuleForEvent(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteFulfillmentRule(fulfillmentRuleId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccountFulfillmentRules/DeleteFulfillmentRule?";
        if (fulfillmentRuleId === null)
            throw new Error("The parameter 'fulfillmentRuleId' cannot be null.");
        else if (fulfillmentRuleId !== undefined)
            url_ += "fulfillmentRuleId=" + encodeURIComponent("" + fulfillmentRuleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFulfillmentRule(_response);
        });
    }

    protected processDeleteFulfillmentRule(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteFulfillmentRules(fulfillmentRuleIds: number[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccountFulfillmentRules/DeleteFulfillmentRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fulfillmentRuleIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFulfillmentRules(_response);
        });
    }

    protected processDeleteFulfillmentRules(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateFulfillmentRuleForEvent(input: SellerAccountFulfillmentRulesInput, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerAccountFulfillmentRules/UpdateFulfillmentRuleForEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFulfillmentRuleForEvent(_response);
        });
    }

    protected processUpdateFulfillmentRuleForEvent(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    createFulfillmentRulesForVenues(input: SellerAccountFulfillmentRulesInput[], signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/SellerAccountFulfillmentRules/CreateFulfillmentRulesForVenues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFulfillmentRulesForVenues(_response);
        });
    }

    protected processCreateFulfillmentRulesForVenues(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getVenueLevelFulfillmentRules(signal?: AbortSignal | undefined): Promise<SellerAccountFulfillmentRule[]> {
        let url_ = this.baseUrl + "/api/SellerAccountFulfillmentRules/GetVenueLevelFulfillmentRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVenueLevelFulfillmentRules(_response);
        });
    }

    protected processGetVenueLevelFulfillmentRules(response: Response): Promise<SellerAccountFulfillmentRule[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerAccountFulfillmentRule[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerAccountFulfillmentRule[]>(null as any);
    }
}

export interface ISellerSupportCaseClient {

    getSellerSupportCaseNotesByCaseId(sellerSupportCaseId: number | undefined, take: number | null | undefined, skip: number | null | undefined, markAsRead: boolean | null | undefined): Promise<SellerSupportCaseNote[]>;

    getSellerSupportCases(query: SellerSupportCaseQuery, take: number | null | undefined, skip: number | null | undefined): Promise<SellerSupportCase[]>;

    createSellerSupportCase(request: SellerSupportCaseRequest): Promise<number | null>;

    createSellerSupportCaseReply(sellerSupportCaseId: number | undefined, noteContent: string | null | undefined, marketplace: string | null | undefined, attachments: FileParameter[] | null | undefined): Promise<number | null>;

    updateSellerSupportCasesReadDate(sellerSupportCaseIds: number[], readDate: string | null | undefined): Promise<void>;

    retrieveSellerSupportCaseNoteAttachments(attachmentRequests: SellerSupportCaseAttachmentRequest[], retrieveContent: boolean | undefined): Promise<FileDownloadInfo[]>;
}

export class SellerSupportCaseClient extends PosClientBase implements ISellerSupportCaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSellerSupportCaseNotesByCaseId(sellerSupportCaseId: number | undefined, take: number | null | undefined, skip: number | null | undefined, markAsRead: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<SellerSupportCaseNote[]> {
        let url_ = this.baseUrl + "/api/SellerSupportCase/GetSellerSupportCaseNotesByCaseId?";
        if (sellerSupportCaseId === null)
            throw new Error("The parameter 'sellerSupportCaseId' cannot be null.");
        else if (sellerSupportCaseId !== undefined)
            url_ += "sellerSupportCaseId=" + encodeURIComponent("" + sellerSupportCaseId) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (markAsRead !== undefined && markAsRead !== null)
            url_ += "markAsRead=" + encodeURIComponent("" + markAsRead) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerSupportCaseNotesByCaseId(_response);
        });
    }

    protected processGetSellerSupportCaseNotesByCaseId(response: Response): Promise<SellerSupportCaseNote[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerSupportCaseNote[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerSupportCaseNote[]>(null as any);
    }

    getSellerSupportCases(query: SellerSupportCaseQuery, take: number | null | undefined, skip: number | null | undefined, signal?: AbortSignal | undefined): Promise<SellerSupportCase[]> {
        let url_ = this.baseUrl + "/api/SellerSupportCase/GetSellerSupportCases?";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerSupportCases(_response);
        });
    }

    protected processGetSellerSupportCases(response: Response): Promise<SellerSupportCase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerSupportCase[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerSupportCase[]>(null as any);
    }

    createSellerSupportCase(request: SellerSupportCaseRequest, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/SellerSupportCase/CreateSellerSupportCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSellerSupportCase(_response);
        });
    }

    protected processCreateSellerSupportCase(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    createSellerSupportCaseReply(sellerSupportCaseId: number | undefined, noteContent: string | null | undefined, marketplace: string | null | undefined, attachments: FileParameter[] | null | undefined, signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/SellerSupportCase/CreateSellerSupportCaseReply?";
        if (sellerSupportCaseId === null)
            throw new Error("The parameter 'sellerSupportCaseId' cannot be null.");
        else if (sellerSupportCaseId !== undefined)
            url_ += "sellerSupportCaseId=" + encodeURIComponent("" + sellerSupportCaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (noteContent !== null && noteContent !== undefined)
            content_.append("NoteContent", noteContent.toString());
        if (marketplace !== null && marketplace !== undefined)
            content_.append("Marketplace", marketplace.toString());
        if (attachments !== null && attachments !== undefined)
            attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSellerSupportCaseReply(_response);
        });
    }

    protected processCreateSellerSupportCaseReply(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    updateSellerSupportCasesReadDate(sellerSupportCaseIds: number[], readDate: string | null | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SellerSupportCase/UpdateSellerSupportCasesReadDate?";
        if (readDate !== undefined && readDate !== null)
            url_ += "readDate=" + encodeURIComponent("" + readDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sellerSupportCaseIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSellerSupportCasesReadDate(_response);
        });
    }

    protected processUpdateSellerSupportCasesReadDate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    retrieveSellerSupportCaseNoteAttachments(attachmentRequests: SellerSupportCaseAttachmentRequest[], retrieveContent: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileDownloadInfo[]> {
        let url_ = this.baseUrl + "/api/SellerSupportCase/RetrieveSellerSupportCaseNoteAttachments?";
        if (retrieveContent === null)
            throw new Error("The parameter 'retrieveContent' cannot be null.");
        else if (retrieveContent !== undefined)
            url_ += "retrieveContent=" + encodeURIComponent("" + retrieveContent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attachmentRequests);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRetrieveSellerSupportCaseNoteAttachments(_response);
        });
    }

    protected processRetrieveSellerSupportCaseNoteAttachments(response: Response): Promise<FileDownloadInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileDownloadInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDownloadInfo[]>(null as any);
    }
}

export interface ISellerUserClient {

    getSellerUserSetting(userSetting: UserSetting | undefined, currentLoginUserOnly: boolean | undefined): Promise<SellerUserSetting>;

    getSellerUserSettings(userSettings: UserSetting[], currentLoginUserOnly: boolean | undefined): Promise<{ [key in keyof typeof UserSetting]?: string; }>;

    getAllSellerUserSettings(exceptUserSettings: UserSetting[] | undefined, currentLoginUserOnly: boolean | undefined): Promise<{ [key in keyof typeof UserSetting]?: string; }>;

    setSellerUserSetting(userSetting: UserSetting | undefined, userSettingValue: string, currentLoginUserOnly: boolean | undefined): Promise<boolean>;

    getCustomInventoryQuickFiltersSetting(): Promise<CustomQuickFilterOfListingQuery[] | null>;

    setCustomInventoryQuickFiltersSetting(value: CustomQuickFilterOfListingQuery[]): Promise<boolean>;

    getCustomOnSaleEventQuickFiltersSetting(): Promise<CustomQuickFilterOfOnSaleEventQuery[] | null>;

    setCustomOnSaleEventQuickFiltersSetting(value: CustomQuickFilterOfOnSaleEventQuery[]): Promise<boolean>;

    getCustomSalesQuickFiltersSetting(): Promise<CustomQuickFilterOfSaleQuery[] | null>;

    setCustomSalesQuickFiltersSetting(value: CustomQuickFilterOfSaleQuery[]): Promise<boolean>;

    getCustomPurchasesQuickFiltersSetting(): Promise<CustomQuickFilterOfPurchaseOrderQuery[] | null>;

    setCustomPurchasesQuickFiltersSetting(value: CustomQuickFilterOfPurchaseOrderQuery[]): Promise<boolean>;

    getCustomMarketplacePaymentsQuickFiltersSetting(): Promise<CustomQuickFilterOfMarketplacePaymentQuery[] | null>;

    setCustomMarketplacePaymentsQuickFiltersSetting(value: CustomQuickFilterOfMarketplacePaymentQuery[]): Promise<boolean>;

    getAvailableReleaseNoteInfos(currentLoginUserOnly: boolean | undefined, getUnreadOnly: boolean | undefined): Promise<ReleaseNote[]>;

    getHasReleaseNotesUnread(currentLoginUserOnly: boolean | undefined): Promise<boolean>;

    getReleaseNoteHtmlByReleaseNoteIds(currentLoginUserOnly: boolean | undefined, releaseNoteIds: number[]): Promise<ReleaseNote[]>;

    getAllTutorialItems(currentLoginUserOnly: boolean | undefined): Promise<TutorialItem[]>;

    getTutorialItemContents(tutorialItemIds: number[]): Promise<TutorialItemContent[]>;

    getSellerEventConfirmationDialogSuppressions(viagogoVirtualId: string | undefined): Promise<SellerEventConfirmationDialogSuppression[]>;

    insertSellerEventConfirmationDialogSuppression(request: InsertSellerEventConfirmationDialogSuppressionRequest): Promise<PosActionResult>;
}

export class SellerUserClient extends PosClientBase implements ISellerUserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSellerUserSetting(userSetting: UserSetting | undefined, currentLoginUserOnly: boolean | undefined, signal?: AbortSignal | undefined): Promise<SellerUserSetting> {
        let url_ = this.baseUrl + "/api/SellerUser/GetSellerUserSetting?";
        if (userSetting === null)
            throw new Error("The parameter 'userSetting' cannot be null.");
        else if (userSetting !== undefined)
            url_ += "userSetting=" + encodeURIComponent("" + userSetting) + "&";
        if (currentLoginUserOnly === null)
            throw new Error("The parameter 'currentLoginUserOnly' cannot be null.");
        else if (currentLoginUserOnly !== undefined)
            url_ += "currentLoginUserOnly=" + encodeURIComponent("" + currentLoginUserOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerUserSetting(_response);
        });
    }

    protected processGetSellerUserSetting(response: Response): Promise<SellerUserSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerUserSetting;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerUserSetting>(null as any);
    }

    getSellerUserSettings(userSettings: UserSetting[], currentLoginUserOnly: boolean | undefined, signal?: AbortSignal | undefined): Promise<{ [key in keyof typeof UserSetting]?: string; }> {
        let url_ = this.baseUrl + "/api/SellerUser/GetSellerUserSettings?";
        if (currentLoginUserOnly === null)
            throw new Error("The parameter 'currentLoginUserOnly' cannot be null.");
        else if (currentLoginUserOnly !== undefined)
            url_ += "currentLoginUserOnly=" + encodeURIComponent("" + currentLoginUserOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userSettings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerUserSettings(_response);
        });
    }

    protected processGetSellerUserSettings(response: Response): Promise<{ [key in keyof typeof UserSetting]?: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key in keyof typeof UserSetting]?: string; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key in keyof typeof UserSetting]?: string; }>(null as any);
    }

    getAllSellerUserSettings(exceptUserSettings: UserSetting[] | undefined, currentLoginUserOnly: boolean | undefined, signal?: AbortSignal | undefined): Promise<{ [key in keyof typeof UserSetting]?: string; }> {
        let url_ = this.baseUrl + "/api/SellerUser/GetAllSellerUserSettings?";
        if (currentLoginUserOnly === null)
            throw new Error("The parameter 'currentLoginUserOnly' cannot be null.");
        else if (currentLoginUserOnly !== undefined)
            url_ += "currentLoginUserOnly=" + encodeURIComponent("" + currentLoginUserOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exceptUserSettings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSellerUserSettings(_response);
        });
    }

    protected processGetAllSellerUserSettings(response: Response): Promise<{ [key in keyof typeof UserSetting]?: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key in keyof typeof UserSetting]?: string; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key in keyof typeof UserSetting]?: string; }>(null as any);
    }

    setSellerUserSetting(userSetting: UserSetting | undefined, userSettingValue: string, currentLoginUserOnly: boolean | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerUser/SetSellerUserSetting?";
        if (userSetting === null)
            throw new Error("The parameter 'userSetting' cannot be null.");
        else if (userSetting !== undefined)
            url_ += "userSetting=" + encodeURIComponent("" + userSetting) + "&";
        if (currentLoginUserOnly === null)
            throw new Error("The parameter 'currentLoginUserOnly' cannot be null.");
        else if (currentLoginUserOnly !== undefined)
            url_ += "currentLoginUserOnly=" + encodeURIComponent("" + currentLoginUserOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userSettingValue);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetSellerUserSetting(_response);
        });
    }

    protected processSetSellerUserSetting(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCustomInventoryQuickFiltersSetting(signal?: AbortSignal | undefined): Promise<CustomQuickFilterOfListingQuery[] | null> {
        let url_ = this.baseUrl + "/api/SellerUser/GetCustomInventoryQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomInventoryQuickFiltersSetting(_response);
        });
    }

    protected processGetCustomInventoryQuickFiltersSetting(response: Response): Promise<CustomQuickFilterOfListingQuery[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomQuickFilterOfListingQuery[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomQuickFilterOfListingQuery[] | null>(null as any);
    }

    setCustomInventoryQuickFiltersSetting(value: CustomQuickFilterOfListingQuery[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerUser/SetCustomInventoryQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCustomInventoryQuickFiltersSetting(_response);
        });
    }

    protected processSetCustomInventoryQuickFiltersSetting(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCustomOnSaleEventQuickFiltersSetting(signal?: AbortSignal | undefined): Promise<CustomQuickFilterOfOnSaleEventQuery[] | null> {
        let url_ = this.baseUrl + "/api/SellerUser/GetCustomOnSaleEventQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomOnSaleEventQuickFiltersSetting(_response);
        });
    }

    protected processGetCustomOnSaleEventQuickFiltersSetting(response: Response): Promise<CustomQuickFilterOfOnSaleEventQuery[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomQuickFilterOfOnSaleEventQuery[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomQuickFilterOfOnSaleEventQuery[] | null>(null as any);
    }

    setCustomOnSaleEventQuickFiltersSetting(value: CustomQuickFilterOfOnSaleEventQuery[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerUser/SetCustomOnSaleEventQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCustomOnSaleEventQuickFiltersSetting(_response);
        });
    }

    protected processSetCustomOnSaleEventQuickFiltersSetting(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCustomSalesQuickFiltersSetting(signal?: AbortSignal | undefined): Promise<CustomQuickFilterOfSaleQuery[] | null> {
        let url_ = this.baseUrl + "/api/SellerUser/GetCustomSalesQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomSalesQuickFiltersSetting(_response);
        });
    }

    protected processGetCustomSalesQuickFiltersSetting(response: Response): Promise<CustomQuickFilterOfSaleQuery[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomQuickFilterOfSaleQuery[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomQuickFilterOfSaleQuery[] | null>(null as any);
    }

    setCustomSalesQuickFiltersSetting(value: CustomQuickFilterOfSaleQuery[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerUser/SetCustomSalesQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCustomSalesQuickFiltersSetting(_response);
        });
    }

    protected processSetCustomSalesQuickFiltersSetting(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCustomPurchasesQuickFiltersSetting(signal?: AbortSignal | undefined): Promise<CustomQuickFilterOfPurchaseOrderQuery[] | null> {
        let url_ = this.baseUrl + "/api/SellerUser/GetCustomPurchasesQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomPurchasesQuickFiltersSetting(_response);
        });
    }

    protected processGetCustomPurchasesQuickFiltersSetting(response: Response): Promise<CustomQuickFilterOfPurchaseOrderQuery[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomQuickFilterOfPurchaseOrderQuery[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomQuickFilterOfPurchaseOrderQuery[] | null>(null as any);
    }

    setCustomPurchasesQuickFiltersSetting(value: CustomQuickFilterOfPurchaseOrderQuery[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerUser/SetCustomPurchasesQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCustomPurchasesQuickFiltersSetting(_response);
        });
    }

    protected processSetCustomPurchasesQuickFiltersSetting(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getCustomMarketplacePaymentsQuickFiltersSetting(signal?: AbortSignal | undefined): Promise<CustomQuickFilterOfMarketplacePaymentQuery[] | null> {
        let url_ = this.baseUrl + "/api/SellerUser/GetCustomMarketplacePaymentsQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomMarketplacePaymentsQuickFiltersSetting(_response);
        });
    }

    protected processGetCustomMarketplacePaymentsQuickFiltersSetting(response: Response): Promise<CustomQuickFilterOfMarketplacePaymentQuery[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomQuickFilterOfMarketplacePaymentQuery[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomQuickFilterOfMarketplacePaymentQuery[] | null>(null as any);
    }

    setCustomMarketplacePaymentsQuickFiltersSetting(value: CustomQuickFilterOfMarketplacePaymentQuery[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerUser/SetCustomMarketplacePaymentsQuickFiltersSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCustomMarketplacePaymentsQuickFiltersSetting(_response);
        });
    }

    protected processSetCustomMarketplacePaymentsQuickFiltersSetting(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAvailableReleaseNoteInfos(currentLoginUserOnly: boolean | undefined, getUnreadOnly: boolean | undefined, signal?: AbortSignal | undefined): Promise<ReleaseNote[]> {
        let url_ = this.baseUrl + "/api/SellerUser/GetAvailableReleaseNoteInfos?";
        if (currentLoginUserOnly === null)
            throw new Error("The parameter 'currentLoginUserOnly' cannot be null.");
        else if (currentLoginUserOnly !== undefined)
            url_ += "currentLoginUserOnly=" + encodeURIComponent("" + currentLoginUserOnly) + "&";
        if (getUnreadOnly === null)
            throw new Error("The parameter 'getUnreadOnly' cannot be null.");
        else if (getUnreadOnly !== undefined)
            url_ += "getUnreadOnly=" + encodeURIComponent("" + getUnreadOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableReleaseNoteInfos(_response);
        });
    }

    protected processGetAvailableReleaseNoteInfos(response: Response): Promise<ReleaseNote[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleaseNote[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleaseNote[]>(null as any);
    }

    getHasReleaseNotesUnread(currentLoginUserOnly: boolean | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SellerUser/GetHasReleaseNotesUnread?";
        if (currentLoginUserOnly === null)
            throw new Error("The parameter 'currentLoginUserOnly' cannot be null.");
        else if (currentLoginUserOnly !== undefined)
            url_ += "currentLoginUserOnly=" + encodeURIComponent("" + currentLoginUserOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHasReleaseNotesUnread(_response);
        });
    }

    protected processGetHasReleaseNotesUnread(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getReleaseNoteHtmlByReleaseNoteIds(currentLoginUserOnly: boolean | undefined, releaseNoteIds: number[], signal?: AbortSignal | undefined): Promise<ReleaseNote[]> {
        let url_ = this.baseUrl + "/api/SellerUser/GetReleaseNoteHtmlByReleaseNoteIds?";
        if (currentLoginUserOnly === null)
            throw new Error("The parameter 'currentLoginUserOnly' cannot be null.");
        else if (currentLoginUserOnly !== undefined)
            url_ += "currentLoginUserOnly=" + encodeURIComponent("" + currentLoginUserOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(releaseNoteIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReleaseNoteHtmlByReleaseNoteIds(_response);
        });
    }

    protected processGetReleaseNoteHtmlByReleaseNoteIds(response: Response): Promise<ReleaseNote[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReleaseNote[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleaseNote[]>(null as any);
    }

    getAllTutorialItems(currentLoginUserOnly: boolean | undefined, signal?: AbortSignal | undefined): Promise<TutorialItem[]> {
        let url_ = this.baseUrl + "/api/SellerUser/GetAllTutorialItems?";
        if (currentLoginUserOnly === null)
            throw new Error("The parameter 'currentLoginUserOnly' cannot be null.");
        else if (currentLoginUserOnly !== undefined)
            url_ += "currentLoginUserOnly=" + encodeURIComponent("" + currentLoginUserOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllTutorialItems(_response);
        });
    }

    protected processGetAllTutorialItems(response: Response): Promise<TutorialItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TutorialItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorialItem[]>(null as any);
    }

    getTutorialItemContents(tutorialItemIds: number[], signal?: AbortSignal | undefined): Promise<TutorialItemContent[]> {
        let url_ = this.baseUrl + "/api/SellerUser/GetTutorialItemContents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tutorialItemIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTutorialItemContents(_response);
        });
    }

    protected processGetTutorialItemContents(response: Response): Promise<TutorialItemContent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TutorialItemContent[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorialItemContent[]>(null as any);
    }

    getSellerEventConfirmationDialogSuppressions(viagogoVirtualId: string | undefined, signal?: AbortSignal | undefined): Promise<SellerEventConfirmationDialogSuppression[]> {
        let url_ = this.baseUrl + "/api/SellerUser/GetSellerEventConfirmationDialogSuppressions?";
        if (viagogoVirtualId === null)
            throw new Error("The parameter 'viagogoVirtualId' cannot be null.");
        else if (viagogoVirtualId !== undefined)
            url_ += "viagogoVirtualId=" + encodeURIComponent("" + viagogoVirtualId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSellerEventConfirmationDialogSuppressions(_response);
        });
    }

    protected processGetSellerEventConfirmationDialogSuppressions(response: Response): Promise<SellerEventConfirmationDialogSuppression[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SellerEventConfirmationDialogSuppression[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerEventConfirmationDialogSuppression[]>(null as any);
    }

    insertSellerEventConfirmationDialogSuppression(request: InsertSellerEventConfirmationDialogSuppressionRequest, signal?: AbortSignal | undefined): Promise<PosActionResult> {
        let url_ = this.baseUrl + "/api/SellerUser/InsertSellerEventConfirmationDialogSuppression";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertSellerEventConfirmationDialogSuppression(_response);
        });
    }

    protected processInsertSellerEventConfirmationDialogSuppression(response: Response): Promise<PosActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosActionResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PosActionResult>(null as any);
    }
}

export interface ITagClient {

    getTagsByEntityTypeId(entityType: ActionOutboxEntityType | undefined, includeInReport: boolean | null | undefined): Promise<Tag[]>;

    getTagsWithValueByEntityTypeId(entityType: ActionOutboxEntityType | undefined): Promise<Tag[]>;

    upsertEntityTagsMetadata(entityType: ActionOutboxEntityType | undefined, tags: Tag[]): Promise<boolean>;

    deleteEntityTagsMetadata(entityType: ActionOutboxEntityType | undefined, tagNames: string[]): Promise<boolean>;
}

export class TagClient extends PosClientBase implements ITagClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTagsByEntityTypeId(entityType: ActionOutboxEntityType | undefined, includeInReport: boolean | null | undefined, signal?: AbortSignal | undefined): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/Tag/GetTagsByEntityTypeId?";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        if (includeInReport !== undefined && includeInReport !== null)
            url_ += "includeInReport=" + encodeURIComponent("" + includeInReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTagsByEntityTypeId(_response);
        });
    }

    protected processGetTagsByEntityTypeId(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Tag[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    getTagsWithValueByEntityTypeId(entityType: ActionOutboxEntityType | undefined, signal?: AbortSignal | undefined): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/Tag/GetTagsWithValueByEntityTypeId?";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTagsWithValueByEntityTypeId(_response);
        });
    }

    protected processGetTagsWithValueByEntityTypeId(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Tag[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    upsertEntityTagsMetadata(entityType: ActionOutboxEntityType | undefined, tags: Tag[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Tag/UpsertEntityTagsMetadata?";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tags);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertEntityTagsMetadata(_response);
        });
    }

    protected processUpsertEntityTagsMetadata(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteEntityTagsMetadata(entityType: ActionOutboxEntityType | undefined, tagNames: string[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Tag/DeleteEntityTagsMetadata?";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tagNames);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteEntityTagsMetadata(_response);
        });
    }

    protected processDeleteEntityTagsMetadata(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface ITicketClient {

    getAllDeliveryTypeTicketTypeMappings(): Promise<DeliveryTypeTicketTypeMapping[]>;

    /**
     * @param purchaseOrderId Used for route parsing so that action argument is parsed for consignee impersonation
     * @param isManual (optional) 
     */
    mergeTicketGroupsForPurchaseOrderId(purchaseOrderId: number, input: TicketGroupMergeInput, isManual: boolean | undefined): Promise<boolean>;

    /**
     * @param isManual (optional) 
     * @deprecated
     */
    mergeTicketGroups(input: TicketGroupMergeInput, isManual: boolean | undefined): Promise<boolean>;
}

export class TicketClient extends PosClientBase implements ITicketClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllDeliveryTypeTicketTypeMappings(signal?: AbortSignal | undefined): Promise<DeliveryTypeTicketTypeMapping[]> {
        let url_ = this.baseUrl + "/api/Ticket/GetAllDeliveryTypeTicketTypeMappings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllDeliveryTypeTicketTypeMappings(_response);
        });
    }

    protected processGetAllDeliveryTypeTicketTypeMappings(response: Response): Promise<DeliveryTypeTicketTypeMapping[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeliveryTypeTicketTypeMapping[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeliveryTypeTicketTypeMapping[]>(null as any);
    }

    /**
     * @param purchaseOrderId Used for route parsing so that action argument is parsed for consignee impersonation
     * @param isManual (optional) 
     */
    mergeTicketGroupsForPurchaseOrderId(purchaseOrderId: number, input: TicketGroupMergeInput, isManual: boolean | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Ticket/MergeTicketGroupsForPurchaseOrderId/{purchaseOrderId}?";
        if (purchaseOrderId === undefined || purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' must be defined.");
        url_ = url_.replace("{purchaseOrderId}", encodeURIComponent("" + purchaseOrderId));
        if (isManual === null)
            throw new Error("The parameter 'isManual' cannot be null.");
        else if (isManual !== undefined)
            url_ += "isManual=" + encodeURIComponent("" + isManual) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeTicketGroupsForPurchaseOrderId(_response);
        });
    }

    protected processMergeTicketGroupsForPurchaseOrderId(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param isManual (optional) 
     * @deprecated
     */
    mergeTicketGroups(input: TicketGroupMergeInput, isManual: boolean | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Ticket/MergeTicketGroups?";
        if (isManual === null)
            throw new Error("The parameter 'isManual' cannot be null.");
        else if (isManual !== undefined)
            url_ += "isManual=" + encodeURIComponent("" + isManual) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMergeTicketGroups(_response);
        });
    }

    protected processMergeTicketGroups(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IUserGroupClient {

    getUserGroups(): Promise<UserGroup[]>;

    insertUserGroup(userGroupName: string | undefined, userGroupDescription: string | null | undefined, sellerUserIds: string[]): Promise<number | null>;

    updateUserGroup(userGroupId: number | undefined, userGroupName: string | undefined, userGroupDescription: string | null | undefined, sellerUserIds: string[]): Promise<boolean>;

    deleteUserGroup(userGroupId: number | undefined): Promise<boolean>;
}

export class UserGroupClient extends PosClientBase implements IUserGroupClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUserGroups(signal?: AbortSignal | undefined): Promise<UserGroup[]> {
        let url_ = this.baseUrl + "/api/UserGroup/GetUserGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserGroups(_response);
        });
    }

    protected processGetUserGroups(response: Response): Promise<UserGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGroup[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroup[]>(null as any);
    }

    insertUserGroup(userGroupName: string | undefined, userGroupDescription: string | null | undefined, sellerUserIds: string[], signal?: AbortSignal | undefined): Promise<number | null> {
        let url_ = this.baseUrl + "/api/UserGroup/InsertUserGroup?";
        if (userGroupName === null)
            throw new Error("The parameter 'userGroupName' cannot be null.");
        else if (userGroupName !== undefined)
            url_ += "userGroupName=" + encodeURIComponent("" + userGroupName) + "&";
        if (userGroupDescription !== undefined && userGroupDescription !== null)
            url_ += "userGroupDescription=" + encodeURIComponent("" + userGroupDescription) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sellerUserIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertUserGroup(_response);
        });
    }

    protected processInsertUserGroup(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    updateUserGroup(userGroupId: number | undefined, userGroupName: string | undefined, userGroupDescription: string | null | undefined, sellerUserIds: string[], signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/UserGroup/UpdateUserGroup?";
        if (userGroupId === null)
            throw new Error("The parameter 'userGroupId' cannot be null.");
        else if (userGroupId !== undefined)
            url_ += "userGroupId=" + encodeURIComponent("" + userGroupId) + "&";
        if (userGroupName === null)
            throw new Error("The parameter 'userGroupName' cannot be null.");
        else if (userGroupName !== undefined)
            url_ += "userGroupName=" + encodeURIComponent("" + userGroupName) + "&";
        if (userGroupDescription !== undefined && userGroupDescription !== null)
            url_ += "userGroupDescription=" + encodeURIComponent("" + userGroupDescription) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sellerUserIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserGroup(_response);
        });
    }

    protected processUpdateUserGroup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteUserGroup(userGroupId: number | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/UserGroup/DeleteUserGroup?";
        if (userGroupId === null)
            throw new Error("The parameter 'userGroupId' cannot be null.");
        else if (userGroupId !== undefined)
            url_ += "userGroupId=" + encodeURIComponent("" + userGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUserGroup(_response);
        });
    }

    protected processDeleteUserGroup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface ActivityLog {
    activityLogId: number;
    entityId: number;
    entityType: ActionOutboxEntityType;
    actionDate: string;
    initiatedBy: ActivityLogInitiatedByUser;
    initiatedByImpersonated: ActivityLogInitiatedByUser | null;
    actionType: ActionType;
    auditActionType: AuditActionType | null;
    actionTypeDisplay: string;
    additionalInfo: ActivityLogAdditionalInformationDictionaryOfActivityLogValueChange;
    event: Event | null;
    performer: Performer | null;
    venue: Venue | null;
    tagName: string | null;
}

export enum ActionOutboxEntityType {
    Sale = "Sale",
    Listing = "Listing",
    Purchase = "Purchase",
    SellerSupportCase = "SellerSupportCase",
    Document = "Document",
    SellerEvent = "SellerEvent",
    InboundEmail = "InboundEmail",
    TicketGroup = "TicketGroup",
}

export interface ActivityLogInitiatedByUser {
    userId: string;
    username: string | null;
}

export enum ActionType {
    SaleConfirm = "SaleConfirm",
    SaleReject = "SaleReject",
    SaleUploadBarcodes = "SaleUploadBarcodes",
    SaleUploadTicketUrls = "SaleUploadTicketUrls",
    SaleUploadProofOfTransfer = "SaleUploadProofOfTransfer",
    SaleUploadEtickets = "SaleUploadEtickets",
    SaleMarketplaceInsert = "SaleMarketplaceInsert",
    SaleMarketplaceUpdate = "SaleMarketplaceUpdate",
    SaleBroadcastConfirmSale = "SaleBroadcastConfirmSale",
    SaleBroadcastRejectSale = "SaleBroadcastRejectSale",
    SaleBroadcastUploadBarcodes = "SaleBroadcastUploadBarcodes",
    SaleBroadcastUploadETickets = "SaleBroadcastUploadETickets",
    SaleBroadcastUploadTransferProof = "SaleBroadcastUploadTransferProof",
    SaleBroadcastUploadTransferUrls = "SaleBroadcastUploadTransferUrls",
    SaleViewed = "SaleViewed",
    SaleDeallocate = "SaleDeallocate",
    SaleMarketplaceUpdateTicketType = "SaleMarketplaceUpdateTicketType",
    SaleHoldTickets = "SaleHoldTickets",
    SaleHoldExpire = "SaleHoldExpire",
    SaleHoldCreate = "SaleHoldCreate",
    SaleUploadTransferProofId = "SaleUploadTransferProofId",
    SaleBroadcastUploadTransferProofId = "SaleBroadcastUploadTransferProofId",
    SaleUpdateTicketType = "SaleUpdateTicketType",
    SaleTicketMasterBarcodeTransfer = "SaleTicketMasterBarcodeTransfer",
    SaleCostUpdate = "SaleCostUpdate",
    SaleCostInsert = "SaleCostInsert",
    SaleCostDelete = "SaleCostDelete",
    SaleBroadcastUpdateTicketType = "SaleBroadcastUpdateTicketType",
    SaleConfirmTransferWithoutProof = "SaleConfirmTransferWithoutProof",
    SaleResetFulfillment = "SaleResetFulfillment",
    SaleTotalProceedsUpdate = "SaleTotalProceedsUpdate",
    SaleDocumentUploadActivity = "SaleDocumentUploadActivity",
    SaleFulfillWithoutArtifacts = "SaleFulfillWithoutArtifacts",
    SaleNoFulfillUpdate = "SaleNoFulfillUpdate",
    SaleTicketsAllocatedAction = "SaleTicketsAllocatedAction",
    SaleCommissionsUpdate = "SaleCommissionsUpdate",
    SaleRemoveTicketUserDocuments = "SaleRemoveTicketUserDocuments",
    SaleUpdatePaymentState = "SaleUpdatePaymentState",
    ListingInsert = "ListingInsert",
    ListingUpdateUnitNetProceeds = "ListingUpdateUnitNetProceeds",
    ListingUpdateAllInPrice = "ListingUpdateAllInPrice",
    ListingUpdateDeliveryType = "ListingUpdateDeliveryType",
    ListingUpdateSplitType = "ListingUpdateSplitType",
    ListingUpdateInHandDate = "ListingUpdateInHandDate",
    ListingUpdateHideSeats = "ListingUpdateHideSeats",
    ListingSplit = "ListingSplit",
    ListingMerge = "ListingMerge",
    ListingBroadcast = "ListingBroadcast",
    ListingUnbroadcast = "ListingUnbroadcast",
    ListingMarketplaceInsert = "ListingMarketplaceInsert",
    ListingMarketplaceUpdate = "ListingMarketplaceUpdate",
    ListingMarketplaceDelete = "ListingMarketplaceDelete",
    ListingUpdatePricerUserId = "ListingUpdatePricerUserId",
    BroadcastMarketplaceListing = "BroadcastMarketplaceListing",
    UnbroadcastMarketplaceListing = "UnbroadcastMarketplaceListing",
    ListingBroadcastMergeListing = "ListingBroadcastMergeListing",
    ListingBroadcastSplitListing = "ListingBroadcastSplitListing",
    ListingBroadcastUpdateInHandDate = "ListingBroadcastUpdateInHandDate",
    ListingBroadcastUpdateAllInPrice = "ListingBroadcastUpdateAllInPrice",
    ListingBroadcastUpdateUnitNetProceeds = "ListingBroadcastUpdateUnitNetProceeds",
    ListingBroadcastUpdateSplitType = "ListingBroadcastUpdateSplitType",
    ListingBroadcastUpdateDeliveryType = "ListingBroadcastUpdateDeliveryType",
    ListingViewed = "ListingViewed",
    ListingDelete = "ListingDelete",
    ListingUpdateQuantity = "ListingUpdateQuantity",
    ListingBroadcastUpdateQuantity = "ListingBroadcastUpdateQuantity",
    ListingUpdateListingNotes = "ListingUpdateListingNotes",
    ListingBroadcastUpdateListingNotes = "ListingBroadcastUpdateListingNotes",
    ListingUpdateSeating = "ListingUpdateSeating",
    ListingBroadcastUpdateSeating = "ListingBroadcastUpdateSeating",
    ListingPreDeliverBarcodes = "ListingPreDeliverBarcodes",
    ListingPreDeliverETickets = "ListingPreDeliverETickets",
    ListingRebroadcast = "ListingRebroadcast",
    ListingSyncUpdate = "ListingSyncUpdate",
    ListingUpdateNetProceedsFloor = "ListingUpdateNetProceedsFloor",
    ListingAutoPricingConfig = "ListingAutoPricingConfig",
    ListingAutoPricingResultUpdate = "ListingAutoPricingResultUpdate",
    ListingPreDeliverTicketExternalIds = "ListingPreDeliverTicketExternalIds",
    ListingPreDeliverTicketUrls = "ListingPreDeliverTicketUrls",
    ListingMarketplaceSeatingOverrideUpdate = "ListingMarketplaceSeatingOverrideUpdate",
    ListingRemoveTicketBarcodes = "ListingRemoveTicketBarcodes",
    ListingRemoveTicketUserDocuments = "ListingRemoveTicketUserDocuments",
    ListingUploadVerificationDocumentAction = "ListingUploadVerificationDocumentAction",
    ListingCompsViewed = "ListingCompsViewed",
    ListingOfflineSaleAdded = "ListingOfflineSaleAdded",
    ListingDocumentViewed = "ListingDocumentViewed",
    ListingDocumentDownloaded = "ListingDocumentDownloaded",
    ListingBroadcastUploadVerificationDocument = "ListingBroadcastUploadVerificationDocument",
    ListingBroadcastUpdateHideSeats = "ListingBroadcastUpdateHideSeats",
    ListingDocumentUploadActivity = "ListingDocumentUploadActivity",
    ListingUpdateUnitCost = "ListingUpdateUnitCost",
    ListingUpdateInternalNotes = "ListingUpdateInternalNotes",
    ListingNoFulfillUpdate = "ListingNoFulfillUpdate",
    ListingUpdateAdminHold = "ListingUpdateAdminHold",
    ListingListingGroupUpdate = "ListingListingGroupUpdate",
    ListingSaleConfirm = "ListingSaleConfirm",
    ListingSaleDeallocate = "ListingSaleDeallocate",
    ListingSaleMarketplaceInsert = "ListingSaleMarketplaceInsert",
    ListingUpdateTopTicketType = "ListingUpdateTopTicketType",
    ListingUpdateDuplicateAttribute = "ListingUpdateDuplicateAttribute",
    ListingUpdateEventId = "ListingUpdateEventId",
    SellerSupportCaseCreate = "SellerSupportCaseCreate",
    SellerSupportCaseReply = "SellerSupportCaseReply",
    PurchaseInsert = "PurchaseInsert",
    PurchaseTicketGroupsMerge = "PurchaseTicketGroupsMerge",
    PurchasePaymentsMerge = "PurchasePaymentsMerge",
    PurchaseCostsMerge = "PurchaseCostsMerge",
    PurchaseUpdate = "PurchaseUpdate",
    PurchaseTicketGroupUpdate = "PurchaseTicketGroupUpdate",
    PurchaseTicketGroupInsert = "PurchaseTicketGroupInsert",
    PurchaseTicketGroupDelete = "PurchaseTicketGroupDelete",
    PurchasePaymentUpdate = "PurchasePaymentUpdate",
    PurchasePaymentInsert = "PurchasePaymentInsert",
    PurchasePaymentDelete = "PurchasePaymentDelete",
    PurchaseCostUpdate = "PurchaseCostUpdate",
    PurchaseCostInsert = "PurchaseCostInsert",
    PurchaseCostDelete = "PurchaseCostDelete",
    PurchaseCancel = "PurchaseCancel",
    PurchaseVoid = "PurchaseVoid",
    PurchaseResetListings = "PurchaseResetListings",
    PurchaseOrderQualityStateUpdate = "PurchaseOrderQualityStateUpdate",
    SaleDocumentUpload = "SaleDocumentUpload",
    ListingDocumentUpload = "ListingDocumentUpload",
    InboundEmailReprocess = "InboundEmailReprocess",
}

export enum AuditActionType {
    TagCreate = "TagCreate",
    TagUpdate = "TagUpdate",
    TagDelete = "TagDelete",
    TagTypeCreate = "TagTypeCreate",
    TagTypeUpdate = "TagTypeUpdate",
    SaleInternalNotesUpdate = "SaleInternalNotesUpdate",
    SaleInternalNotesInsert = "SaleInternalNotesInsert",
    ListingSellerEventUpdate = "ListingSellerEventUpdate",
    PurchaseCommissionUpdate = "PurchaseCommissionUpdate",
    PurchaseCommissionInsert = "PurchaseCommissionInsert",
    PurchaseInternalNotesUpdate = "PurchaseInternalNotesUpdate",
    PurchaseInternalNotesInsert = "PurchaseInternalNotesInsert",
}

export interface ActivityLogAdditionalInformationDictionaryOfActivityLogValueChange {

    [key: string]: ActivityLogValueChange | any;
}

export interface ActivityLogValueChange {
    oldValue: string | null;
    newValue: string | null;
    message: ActivityLogMessage | null;
}

export interface ActivityLogMessage {
    errorCode: string | null;
    message: string | null;
    state: MarketplaceOperationResultState;
}

export enum MarketplaceOperationResultState {
    Succeeded = "Succeeded",
    FailedWithRetryableError = "FailedWithRetryableError",
    FailedWithNonRetryableError = "FailedWithNonRetryableError",
    FailedAndRequiresSellerAction = "FailedAndRequiresSellerAction",
    NotImplemented = "NotImplemented",
    Skipped = "Skipped",
}

export interface CatalogEntity {
    /** ViagogoEntityId */
    viagId: number | null;
    name: string;
    shortName: string | null;
}

export interface Event extends CatalogEntity {
    rowVer: number | null;
    /** PosEventIdS */
    posIds: string[];
    posId: string | null;
    /** ViagogoVirtualId (ViagogoEventId or ViagogoEventMappingId) */
    virtId: string;
    oldVirtIds: string[] | null;
    /** ViagogoEventMappingId */
    mpId: string | null;
    dates: DateTimeRange;
    datesUtc: DateTimeRange;
    onSaleDate: string | null;
    rawOnSaleDate: string | null;
    rawPreSaleDate: string | null;
    evType: string | null;
    evStat: ApiEventStatus | null;
    /** Performer Id */
    perfId: number | null;
    venId: number;
    venCfgId: number | null;
    genre: TopLevelCategory;
    /** Mapping Rejection Reason Id */
    mapRejRsnId: number | null;
    /** Mapping Rejection Reason Default Text */
    mapRejDftTxt: string | null;
}

export interface DateTimeRange {
    start: string | null;
    end: string | null;
}

export enum ApiEventStatus {
    Normal = "Normal",
    Postponed = "Postponed",
    Cancelled = "Cancelled",
    Rescheduled = "Rescheduled",
    Relocated = "Relocated",
    RelocatedAndRescheduled = "RelocatedAndRescheduled",
    Draft = "Draft",
    Deleted = "Deleted",
    Contingent = "Contingent",
}

export enum TopLevelCategory {
    Theatre = "Theatre",
    Sports = "Sports",
    Concert = "Concert",
    Festival = "Festival",
}

export interface Performer extends CatalogEntity {
    /** Categories */
    categ: TopLevelCategory[];
    /** Genre Id */
    genreId: number | null;
    /** Genre name */
    grName: string | null;
}

export interface Venue extends CatalogEntity {
    city: string | null;
    /** State/Province */
    state: string | null;
    ctryCode: string | null;
    cap: number | null;
    /** Do not include this object as first-class search-result items
Since this obj is embedded in another object as an info-only obj */
    excludeSearch: boolean;
}

export interface ActivityLogQuery {
    userId: string | null;
    includeUserOnly: boolean | null;
    impersonatedUserId: string | null;
    entityId: number | null;
    entityType: ActionOutboxEntityType | null;
    actionTypes: ActionType[] | null;
    auditActionTypes: AuditActionType[] | null;
    take: number | null;
    skip: number | null;
    /** Filter by tag name within audit data */
    tagName: string | null;
}

export enum DocumentType {
    ETicket = "ETicket",
    TicketTransfer = "TicketTransfer",
    AirBill = "AirBill",
    PKPass = "PKPass",
    GoogleWallet = "GoogleWallet",
    ListingVerification = "ListingVerification",
    QRCode = "QRCode",
}

export interface StateProvince {
    id: number;
    name: string;
    countryName: string;
    cId: number | null;
}

export interface City {
    id: number;
    name: string;
    stateProvinceName: string | null;
    countryName: string;
    cId: number | null;
}

export interface ReactAppContext {
    stage: string;
    appName: string;
    isNativeApp: boolean;
    cobrandId: CoBrandId;
    environment: string;
    features: FeatureDetail[];
    isDevelopment: boolean;
    version: string;
}

export enum CoBrandId {
    Viagogo = "Viagogo",
    TicketUtil = "TicketUtil",
    Starburst = "Starburst",
    ReachPro = "ReachPro",
    StubHub = "StubHub",
}

export interface FeatureDetail {
    id: Feature;
    state: FeatureState;
}

export enum Feature {
    AutoPricing = "AutoPricing",
    HomePageActivityLog = "HomePageActivityLog",
    OneTicketTransferApi = "OneTicketTransferApi",
    AdvanceAutopricingModes = "AdvanceAutopricingModes",
    CompListingMode_ParentListing = "CompListingMode_ParentListing",
    ExportInventory = "ExportInventory",
    ListingIdForCompListings = "ListingIdForCompListings",
    InventoryEventRecentTransactions = "InventoryEventRecentTransactions",
    ScaledSeatScore = "ScaledSeatScore",
    SeatSaver = "SeatSaver",
    ConfirmTransferWithoutProof = "ConfirmTransferWithoutProof",
    TeamManagement = "TeamManagement",
    BezierGraphControlPointsManager = "BezierGraphControlPointsManager",
    UndercutByRankListingGroup = "UndercutByRankListingGroup",
    UpdatedVenueMapPrompt = "UpdatedVenueMapPrompt",
    ReportSnapshot = "ReportSnapshot",
    DisplayBuildVersion = "DisplayBuildVersion",
    OverrideDailyFxRate = "OverrideDailyFxRate",
    PricedAtZeroFilter = "PricedAtZeroFilter",
    PricingCatchup = "PricingCatchup",
    PriceByWebsitePrice = "PriceByWebsitePrice",
    ExcludeFanInventory = "ExcludeFanInventory",
    CurrencyConversionSettingsTab = "CurrencyConversionSettingsTab",
    AutoPriceFrequency = "AutoPriceFrequency",
    DisableAutoSourcing = "DisableAutoSourcing",
    ArAgingReport = "ArAgingReport",
    MarketplacePaymentLinesDisplay = "MarketplacePaymentLinesDisplay",
    InventoryEventPageV2 = "InventoryEventPageV2",
    DynamicPricingBySTR = "DynamicPricingBySTR",
    GroupingDrip = "GroupingDrip",
    AutoPricingGroupSettings = "AutoPricingGroupSettings",
    SaleSkyboxNotesSection = "SaleSkyboxNotesSection",
    EnableDisableMarketplaces = "EnableDisableMarketplaces",
    AutoCompAndGroup = "AutoCompAndGroup",
    ExcludeFullySoldInGroup = "ExcludeFullySoldInGroup",
    ReportingV2 = "ReportingV2",
    AutoFulfillSetting = "AutoFulfillSetting",
    PricingSettingsInTable = "PricingSettingsInTable",
    SponsoredListings = "SponsoredListings",
    VenueMapCtrlPlusM = "VenueMapCtrlPlusM",
    ScoreSectionRowTable = "ScoreSectionRowTable",
    VenueMapRectSelect = "VenueMapRectSelect",
    ViewListingOriginalSeating = "ViewListingOriginalSeating",
    FulfillmentProviders = "FulfillmentProviders",
    EventListingTableHotkeys = "EventListingTableHotkeys",
    AutoGroupAndCompV2 = "AutoGroupAndCompV2",
    ListingGroupingMethods = "ListingGroupingMethods",
    GroupSoldListings = "GroupSoldListings",
    PricingV2DemandDashboard = "PricingV2DemandDashboard",
    CustomVenueRows = "CustomVenueRows",
    BulkActionGroupListings = "BulkActionGroupListings",
    PricingABTest = "PricingABTest",
    EnableNativeSyncToggle = "EnableNativeSyncToggle",
    BulkUpdateIndividualTicketGroup = "BulkUpdateIndividualTicketGroup",
    AutoCompRankOverrides = "AutoCompRankOverrides",
    UpgradedGroupListingView = "UpgradedGroupListingView",
    UpcomingOnSalesPage = "UpcomingOnSalesPage",
    RemoveUiGateOnUnmap = "RemoveUiGateOnUnmap",
    SortListingsInGroup = "SortListingsInGroup",
    ReorderListingInGroup = "ReorderListingInGroup",
    EditMapInListingTab = "EditMapInListingTab",
    BackfillDeliveryStrategyInventoryEventToSales = "BackfillDeliveryStrategyInventoryEventToSales",
    BackfillDeliveryStrategyPurchaseEventToSales = "BackfillDeliveryStrategyPurchaseEventToSales",
    BackfillDeliveryStrategyVendorAccountToSales = "BackfillDeliveryStrategyVendorAccountToSales",
    FullPageEventViewEntitySelection = "FullPageEventViewEntitySelection",
    CompQuantitiesFilter = "CompQuantitiesFilter",
    FullPageEventViewSideTableBulkEdit = "FullPageEventViewSideTableBulkEdit",
    DefaultNotToMergeHoldListings = "DefaultNotToMergeHoldListings",
    CustomDeliveryType = "CustomDeliveryType",
    ListingNotesAdditionalInfo = "ListingNotesAdditionalInfo",
    FullPageEventViewSideTableFilters = "FullPageEventViewSideTableFilters",
    BulkEditsToListingGroups = "BulkEditsToListingGroups",
    GroupedActivityLog = "GroupedActivityLog",
    ExcludeDefects = "ExcludeDefects",
    AllocateSingleTickets = "AllocateSingleTickets",
    PdfViewerToolbar = "PdfViewerToolbar",
    FufillmentMismatchDisplay = "FufillmentMismatchDisplay",
    DisplayTicketOrderedByPriority = "DisplayTicketOrderedByPriority",
    ShowSeatTraitOnMerge = "ShowSeatTraitOnMerge",
    EventMultiScreen = "EventMultiScreen",
    DefaultFilterRows = "DefaultFilterRows",
    RowSeatColumnSalePurchase = "RowSeatColumnSalePurchase",
    CommandMenu = "CommandMenu",
    ReconcileOrphanTickets = "ReconcileOrphanTickets",
    UseSelectedRowIdForMarketplaceSeatingOverride = "UseSelectedRowIdForMarketplaceSeatingOverride",
    SelectDeliveryStrategyInSeatSaver = "SelectDeliveryStrategyInSeatSaver",
    ListingGroupCompUi = "ListingGroupCompUi",
    YourListingsInComps = "YourListingsInComps",
    NewListingDefaultToSpeculativeRowId = "NewListingDefaultToSpeculativeRowId",
    UploadTicketFilesFlowV2 = "UploadTicketFilesFlowV2",
    RightNowStatsInMap = "RightNowStatsInMap",
    ConsignmentDeal = "ConsignmentDeal",
    FilterByCurrencyCodeMulti = "FilterByCurrencyCodeMulti",
    FilterByPaymentCurrencyCodeMulti = "FilterByPaymentCurrencyCodeMulti",
    AutoPricingTabInAccountSettings = "AutoPricingTabInAccountSettings",
    AttemptFulfillWhenToggleOnAutoFulfill = "AttemptFulfillWhenToggleOnAutoFulfill",
    SaleDetailDisplayTicketUrl = "SaleDetailDisplayTicketUrl",
    PreventInitialBroadcastForXDays = "PreventInitialBroadcastForXDays",
    AutoCompPersistAllConfigChanges = "AutoCompPersistAllConfigChanges",
    ManageMarketplacePayment = "ManageMarketplacePayment",
    HideAutoCompOnlyBulkEditOption = "HideAutoCompOnlyBulkEditOption",
    PreventDraftPOinUI = "PreventDraftPOinUI",
    MarketplacePaymentsTab = "MarketplacePaymentsTab",
    AllowSeatScoreCompListingMode = "AllowSeatScoreCompListingMode",
    DemandDashLastDaySupplyMetrics = "DemandDashLastDaySupplyMetrics",
    GroupingWizard = "GroupingWizard",
    IntelligiblePricePreviewForListingGroup = "IntelligiblePricePreviewForListingGroup",
    SimplifiedAutoPricingUiV2 = "SimplifiedAutoPricingUiV2",
    MoveToGroup = "MoveToGroup",
    IgnoreDuplicate = "IgnoreDuplicate",
    QuickFloorToolbar = "QuickFloorToolbar",
    BulkUpdatePurchaseCurrency = "BulkUpdatePurchaseCurrency",
    BulkWasteTickets = "BulkWasteTickets",
    AutoPricingBulkEditToDrawerWithPreview = "AutoPricingBulkEditToDrawerWithPreview",
    PurchasePaymentMethodEdit = "PurchasePaymentMethodEdit",
    CancelSaleKeepTickets = "CancelSaleKeepTickets",
    ConvertSaleCurrency = "ConvertSaleCurrency",
    DisplayDeactivatedUser = "DisplayDeactivatedUser",
    SVGVenueMapV3 = "SVGVenueMapV3",
    LockCommissionsOnPo = "LockCommissionsOnPo",
    CleanupWhiteSpace = "CleanupWhiteSpace",
    LinkPaymentLine = "LinkPaymentLine",
    PricingSectionSettingsAcrossEvents = "PricingSectionSettingsAcrossEvents",
    PurchaseCommissionFilterInSearchView = "PurchaseCommissionFilterInSearchView",
    MultiTicketGroupTable = "MultiTicketGroupTable",
    EventDiscoveryPage = "EventDiscoveryPage",
    SeatTraitsColumn = "SeatTraitsColumn",
    EventSelectorFilter = "EventSelectorFilter",
    BlockEventDiscoveryData = "BlockEventDiscoveryData",
    BulkUploadPurchaseV2Perf = "BulkUploadPurchaseV2Perf",
    ListingTableSplitTypeColumn = "ListingTableSplitTypeColumn",
    CompListingDisplayUpdate = "CompListingDisplayUpdate",
    CatalogMetricsV2 = "CatalogMetricsV2",
    HideSalePaymentConversionSection = "HideSalePaymentConversionSection",
    FlashSaleDiscountRestriction = "FlashSaleDiscountRestriction",
    EventMapRibbonYolo = "EventMapRibbonYolo",
    ReportV2CommissionsReport = "ReportV2CommissionsReport",
    KnowledgePortalPageTestData = "KnowledgePortalPageTestData",
    SearchView_ReadOnlyDB = "SearchView_ReadOnlyDB",
    BulkEditPricingSettingsUpdate = "BulkEditPricingSettingsUpdate",
    HomePageNotifications = "HomePageNotifications",
    EventsDetailedViewGrouping = "EventsDetailedViewGrouping",
    GlobalReportV1RedirectV2 = "GlobalReportV1RedirectV2",
    BlockInventorySummaryStats = "BlockInventorySummaryStats",
    AllocateSingleTicketListingRestrictionRemoval = "AllocateSingleTicketListingRestrictionRemoval",
    OnePagerGroupSelectionFunctionality = "OnePagerGroupSelectionFunctionality",
    ConsignmentFilterPurchaseSearchView = "ConsignmentFilterPurchaseSearchView",
    HideNavAndFilterBars = "HideNavAndFilterBars",
    ReportSinglePagedV1V2 = "ReportSinglePagedV1V2",
    EventDiscoveryCapacityAndPrimary = "EventDiscoveryCapacityAndPrimary",
    BackfillListingTicketTypeOverrideToSale = "BackfillListingTicketTypeOverrideToSale",
    ListingDetailsDeprecatedOnlySelectedSectionsFlag = "ListingDetailsDeprecatedOnlySelectedSectionsFlag",
    BulkUpdateSeatingForAllMarketplace = "BulkUpdateSeatingForAllMarketplace",
    MultiExpandGroups = "MultiExpandGroups",
    NewPurchaseDirectEmailVendorInput = "NewPurchaseDirectEmailVendorInput",
    SeatTraitsColumnSales = "SeatTraitsColumnSales",
    AccessibilityMode = "AccessibilityMode",
    DisplayMarketplaceSeatingOverride = "DisplayMarketplaceSeatingOverride",
    BulkCreatePurchase = "BulkCreatePurchase",
    SearchViewGroupRowWithEvent = "SearchViewGroupRowWithEvent",
    RemoveEventAccordian = "RemoveEventAccordian",
    UnsoldTicketsFilter = "UnsoldTicketsFilter",
    GroupPricingSettingsV2 = "GroupPricingSettingsV2",
    MarketplaceSaleAvoidIdPrefill = "MarketplaceSaleAvoidIdPrefill",
    CatalogV2_LocalStore = "CatalogV2_LocalStore",
    HomePageRecentSalesFast = "HomePageRecentSalesFast",
    PriceHistory_ShowNullMarketplaceAsAllMarketplace = "PriceHistory_ShowNullMarketplaceAsAllMarketplace",
    FallbackRowFilterWithOrdinalRank = "FallbackRowFilterWithOrdinalRank",
    TableSortInGroupingWizard = "TableSortInGroupingWizard",
    EditMarketplaceSaleId_Offline = "EditMarketplaceSaleId_Offline",
    EditMarketplaceSaleId_Marketplace = "EditMarketplaceSaleId_Marketplace",
    UseUtilitiesFeatureService = "UseUtilitiesFeatureService",
    TicketGroupV2PopulateHighSeat = "TicketGroupV2PopulateHighSeat",
    SearchViewVenueFilter = "SearchViewVenueFilter",
    OnSaleEventDetailsView = "OnSaleEventDetailsView",
    UnitCostInBulkPreview = "UnitCostInBulkPreview",
    GlobalReportV1RedirectV2_ActiveInventory = "GlobalReportV1RedirectV2_ActiveInventory",
    GlobalReportV1RedirectV2_DailySales = "GlobalReportV1RedirectV2_DailySales",
    GlobalReportV1RedirectV2_EventPandL = "GlobalReportV1RedirectV2_EventPandL",
    GlobalReportV1RedirectV2_MarketplacePerformance = "GlobalReportV1RedirectV2_MarketplacePerformance",
    GlobalReportV1RedirectV2_PerformerPandL = "GlobalReportV1RedirectV2_PerformerPandL",
    GlobalReportV1RedirectV2_SoldInventory = "GlobalReportV1RedirectV2_SoldInventory",
    GlobalReportV1RedirectV2_CommissionReport = "GlobalReportV1RedirectV2_CommissionReport",
    DisableMetricsQueryRefetch = "DisableMetricsQueryRefetch",
    ExcludeToIncludeFanInv = "ExcludeToIncludeFanInv",
    HideEventDiscoveryDemandData = "HideEventDiscoveryDemandData",
    ReportSnapshotBackgroundExport = "ReportSnapshotBackgroundExport",
    UseGrpcCache = "UseGrpcCache",
    ExportPaymentMonth = "ExportPaymentMonth",
    EventHeaderRework = "EventHeaderRework",
    ReportV2ExposeLatencyLivePage = "ReportV2ExposeLatencyLivePage",
    MarketplacePaymentSearch = "MarketplacePaymentSearch",
    FilterByEntityIdOptimization = "FilterByEntityIdOptimization",
    BulkUploadMarketplacePaymentLine = "BulkUploadMarketplacePaymentLine",
    BackfillCancelledProceeds = "BackfillCancelledProceeds",
    EditMarketplacePaymentLine = "EditMarketplacePaymentLine",
    AvoidRowVersionUpdateForSectionalUpdate = "AvoidRowVersionUpdateForSectionalUpdate",
    DeleteMarketplacePayment = "DeleteMarketplacePayment",
    DeleteMarketplacePaymentLine = "DeleteMarketplacePaymentLine",
    EditRevealSyncDate = "EditRevealSyncDate",
    ReportsSummaryFetchAll = "ReportsSummaryFetchAll",
    AddMarketplacePaymentLine = "AddMarketplacePaymentLine",
    MarketplacePaymentLineFilter = "MarketplacePaymentLineFilter",
    PurchaseLineItemReport = "PurchaseLineItemReport",
    LockMarketplacePayment = "LockMarketplacePayment",
    RemoveListView = "RemoveListView",
    EditMarketplacePayment = "EditMarketplacePayment",
    CompareGrpcCacheWithLiveCounts = "CompareGrpcCacheWithLiveCounts",
    AllowAddCostOnCancelledPO = "AllowAddCostOnCancelledPO",
    ReportV2ColumnFormat = "ReportV2ColumnFormat",
    RatioToReportCustomCol = "RatioToReportCustomCol",
    MarketplacePaymentDiscrepancy = "MarketplacePaymentDiscrepancy",
    AvgCntForReports = "AvgCntForReports",
    QuantityFiltersWithDefaults = "QuantityFiltersWithDefaults",
    UseGrpcCache_ListingCounts = "UseGrpcCache_ListingCounts",
    UseGrpcCache_SaleCounts = "UseGrpcCache_SaleCounts",
    UseGrpcCache_PurchaseCounts = "UseGrpcCache_PurchaseCounts",
    RowOffsetOnManualSections = "RowOffsetOnManualSections",
    EventDiscoveryTransactionPrice = "EventDiscoveryTransactionPrice",
    CostChangeReports = "CostChangeReports",
    AutoLinkSaleLineItemSetting = "AutoLinkSaleLineItemSetting",
    LogSectionalData = "LogSectionalData",
    SelectedSectionScoreRecommendations = "SelectedSectionScoreRecommendations",
    PersistentTagCreate = "PersistentTagCreate",
    DeletedEventStateDisplay = "DeletedEventStateDisplay",
    FavoritePaymentMethods = "FavoritePaymentMethods",
    EventPricingTeam = "EventPricingTeam",
    DateRangeSelectorV2 = "DateRangeSelectorV2",
    AutoSplitDiscontinuousListingSetting = "AutoSplitDiscontinuousListingSetting",
    EventSelectorV2 = "EventSelectorV2",
    GroupWizardInEdit = "GroupWizardInEdit",
    StandaloneEntityDetailModals = "StandaloneEntityDetailModals",
    DynamicUnderCutSettingsInOnePager = "DynamicUnderCutSettingsInOnePager",
    DefaultYesNoFilters = "DefaultYesNoFilters",
    PricingSettingStrategyWithFallback = "PricingSettingStrategyWithFallback",
    DisplayAllPaymentMethods = "DisplayAllPaymentMethods",
    AlignCurrenciesOnReports = "AlignCurrenciesOnReports",
    CompareGrpcCacheWithLiveMetrics = "CompareGrpcCacheWithLiveMetrics",
    EventDiscoveryNotifications = "EventDiscoveryNotifications",
    RowIdFilterWithRowRange = "RowIdFilterWithRowRange",
    SaleEditBarcode = "SaleEditBarcode",
    NonCumulativeMarketshareChart = "NonCumulativeMarketshareChart",
    TagsUiV3 = "TagsUiV3",
    PageLoadMonitoring = "PageLoadMonitoring",
    SellerEventAlertMutes = "SellerEventAlertMutes",
    RemovePriceIncreaseRoadbump = "RemovePriceIncreaseRoadbump",
    BroadcastByMarketplaceColumn = "BroadcastByMarketplaceColumn",
    CatchUpModeShortenUrl = "CatchUpModeShortenUrl",
    TableFooterColumnVirtualized = "TableFooterColumnVirtualized",
    TurnOffDoubleWriteToUserSetting = "TurnOffDoubleWriteToUserSetting",
    ZoneMapV2 = "ZoneMapV2",
    MobileInventoryEventPage = "MobileInventoryEventPage",
    MobileInventoryPortfolioPage = "MobileInventoryPortfolioPage",
    MobileInventoryDetailsView = "MobileInventoryDetailsView",
    SelectedSectionRecsByConfigVenueType = "SelectedSectionRecsByConfigVenueType",
    TableTotals_All = "TableTotals_All",
    TableTotals_Purchase = "TableTotals_Purchase",
    TableTotals_Sales = "TableTotals_Sales",
    TableTotals_Inventory = "TableTotals_Inventory",
    TableTotals_Payments = "TableTotals_Payments",
    TableTotals_Events = "TableTotals_Events",
    UseGrpcCache_AllowStaleData = "UseGrpcCache_AllowStaleData",
    SignalRHealthCheck = "SignalRHealthCheck",
    DefaultManualMaxDisplayQuantitySetting = "DefaultManualMaxDisplayQuantitySetting",
    ConsigneeSingleEntityUpdate = "ConsigneeSingleEntityUpdate",
    SurfacePricingStates = "SurfacePricingStates",
    NewMultiTgTableInput = "NewMultiTgTableInput",
    SearchViewPerformerFilter = "SearchViewPerformerFilter",
    AdminHoldWarningDuringAllocation = "AdminHoldWarningDuringAllocation",
    ReportBackgroundExport = "ReportBackgroundExport",
    EventHeaderRework_Purchase = "EventHeaderRework_Purchase",
    EventHeaderRework_Sales = "EventHeaderRework_Sales",
    BulkUploadSeatTraits = "BulkUploadSeatTraits",
    PurchaseOutstandingBalanceColumn = "PurchaseOutstandingBalanceColumn",
    BulkSetTotalTicketCost = "BulkSetTotalTicketCost",
    EnableSelectionByDefaultSetting = "EnableSelectionByDefaultSetting",
    BulkUploadSeatSavers = "BulkUploadSeatSavers",
    MaineEventComplianceMessage = "MaineEventComplianceMessage",
    ManualPriceStaggers = "ManualPriceStaggers",
    RecentSalesTableV3 = "RecentSalesTableV3",
    RememberScrollPositionEventList = "RememberScrollPositionEventList",
    SetCeilingOnPricingOnePager = "SetCeilingOnPricingOnePager",
    FavoriteVendors = "FavoriteVendors",
    SalesTableV2 = "SalesTableV2",
    AutoCleanupBrowserData = "AutoCleanupBrowserData",
    PurchaseInternalIdColumnDisplay = "PurchaseInternalIdColumnDisplay",
    ListingTableV2 = "ListingTableV2",
    UseGrpcCache_BatchEventIds = "UseGrpcCache_BatchEventIds",
    BulkEditAutoPricingPriceAgainstMySection = "BulkEditAutoPricingPriceAgainstMySection",
    ListingTableDeterminsticListingGroupSort = "ListingTableDeterminsticListingGroupSort",
    ReducedBroadcastStatusPullingFrequency = "ReducedBroadcastStatusPullingFrequency",
    BatchGetListingStatusCalls = "BatchGetListingStatusCalls",
    MobileSalePortfolioPage = "MobileSalePortfolioPage",
    MobilePurchasePortfolioPage = "MobilePurchasePortfolioPage",
    SurfaceFirstListingInGroup = "SurfaceFirstListingInGroup",
    StubHubListingFilterWithPurchaseQuantities = "StubHubListingFilterWithPurchaseQuantities",
    ToggleNotificationsSettings = "ToggleNotificationsSettings",
    ShowEventTagOnEventTile = "ShowEventTagOnEventTile",
    InventoryStatsInStubhubSidePanel = "InventoryStatsInStubhubSidePanel",
    BulkSplitListings = "BulkSplitListings",
    AdvancedSearchV2 = "AdvancedSearchV2",
    TicketGroupReport = "TicketGroupReport",
    BulkEditListingMaxDisplayQuantity = "BulkEditListingMaxDisplayQuantity",
    BulkEditListingPricingBasedOffUnitCost = "BulkEditListingPricingBasedOffUnitCost",
    PurchaseTableV2 = "PurchaseTableV2",
    CleanUpOutdatedPricingState = "CleanUpOutdatedPricingState",
    SponsoredListingsV2 = "SponsoredListingsV2",
    DateFiltersRelativeExactCustom = "DateFiltersRelativeExactCustom",
    RefetchCatalogAndEntityOnNavigate_All = "RefetchCatalogAndEntityOnNavigate_All",
    RefetchCatalogAndEntityOnNavigate_Purchase = "RefetchCatalogAndEntityOnNavigate_Purchase",
    RefetchCatalogAndEntityOnNavigate_Sales = "RefetchCatalogAndEntityOnNavigate_Sales",
    RefetchCatalogAndEntityOnNavigate_Inventory = "RefetchCatalogAndEntityOnNavigate_Inventory",
    MinimalFiltersForMetrics_Inventory = "MinimalFiltersForMetrics_Inventory",
    UserSettingOnTableSorting = "UserSettingOnTableSorting",
    DataExportFormatDateAsAccountTimeZone = "DataExportFormatDateAsAccountTimeZone",
    MinMaxInCustomColumn = "MinMaxInCustomColumn",
    TableRowSelectionV2 = "TableRowSelectionV2",
    ShowSponsoredSalesAsSponsored = "ShowSponsoredSalesAsSponsored",
    EventDiscoveryInInventoryView = "EventDiscoveryInInventoryView",
    ListingGroupAccountSettings = "ListingGroupAccountSettings",
    CompanionModeInInsightView = "CompanionModeInInsightView",
    SponsoredListingsV2_EventDetailBoostTab = "SponsoredListingsV2_EventDetailBoostTab",
    FrontendTelemetryContext = "FrontendTelemetryContext",
    GlobalReportV1RedirectV2_PurchasedInventory = "GlobalReportV1RedirectV2_PurchasedInventory",
    GlobalReportV1RedirectV2_CanceledInventory = "GlobalReportV1RedirectV2_CanceledInventory",
    GlobalReportV1RedirectV2_All = "GlobalReportV1RedirectV2_All",
    RejectedPendingEventsFilter = "RejectedPendingEventsFilter",
    ReplaceUnsoldWithAvailableTickets = "ReplaceUnsoldWithAvailableTickets",
    CreatePurchaseFromListing = "CreatePurchaseFromListing",
    ReEvaluatePredeliveryStateAndTopTicketType = "ReEvaluatePredeliveryStateAndTopTicketType",
    MarketplacePaymentConversion = "MarketplacePaymentConversion",
    WasteSale = "WasteSale",
    UseShLnLookup = "UseShLnLookup",
    BlockPricingCompListingEndpoint = "BlockPricingCompListingEndpoint",
    BlockPricingCalculationEndpoint = "BlockPricingCalculationEndpoint",
    BlockEventDashboardEndpoint = "BlockEventDashboardEndpoint",
    AlwaysGetEventLevelSettingsFromAutoPricer = "AlwaysGetEventLevelSettingsFromAutoPricer",
    WriteAutopriceConfigUpdateToSbt = "WriteAutopriceConfigUpdateToSbt",
    SetAsDefaultAllNewEvents = "SetAsDefaultAllNewEvents",
    AccountLevelFeatureCheck = "AccountLevelFeatureCheck",
    UpdateSaleStatusOnSiteCreation = "UpdateSaleStatusOnSiteCreation",
    BulkReturnTicket = "BulkReturnTicket",
    ExternalPosAndProcessorAuthEncryption = "ExternalPosAndProcessorAuthEncryption",
    FulfillmentRulesEventLevel = "FulfillmentRulesEventLevel",
    BackfillSalesFulfillerToEvent = "BackfillSalesFulfillerToEvent",
    RightHolderMarkAsFulfill = "RightHolderMarkAsFulfill",
    IncludeFanInventoryBroadcast = "IncludeFanInventoryBroadcast",
    GetListingAutoPricingSettingsReadListingPropsFromPricer = "GetListingAutoPricingSettingsReadListingPropsFromPricer",
    EnableMasterUiViewForConsignors = "EnableMasterUiViewForConsignors",
    FulfillmentRulesVenueLevel = "FulfillmentRulesVenueLevel",
    GetPurchasePerformanceImprovement = "GetPurchasePerformanceImprovement",
    ImprovePerfForUpdateListingSectionalApis = "ImprovePerfForUpdateListingSectionalApis",
    UserManagementMasterUiForConsignor = "UserManagementMasterUiForConsignor",
    MemorizeLastBroadcastListingMarketplace = "MemorizeLastBroadcastListingMarketplace",
    RemoveViewPricedListingsPerm = "RemoveViewPricedListingsPerm",
    GranularListingGroupSettingOverride = "GranularListingGroupSettingOverride",
    DefaultToMyRowOnSectionSelection = "DefaultToMyRowOnSectionSelection",
    DefaultGroupPricingSettings = "DefaultGroupPricingSettings",
    AutoPricingEmptySelectedSectionsNoComps = "AutoPricingEmptySelectedSectionsNoComps",
    RevealMarketUseProcessorConfig = "RevealMarketUseProcessorConfig",
    ShowAmpSectionRecs = "ShowAmpSectionRecs",
    ShowConcertsSectionBehindStageSectionRecs = "ShowConcertsSectionBehindStageSectionRecs",
    ShowSportsOrConcerts360SectionRecs = "ShowSportsOrConcerts360SectionRecs",
    FixFloorRelativeToMarket = "FixFloorRelativeToMarket",
    MultiFeatureReleaseNotes = "MultiFeatureReleaseNotes",
    ReconfirmCancelledSaleHandleByProcessor = "ReconfirmCancelledSaleHandleByProcessor",
    ApplyInHandDaysBeforeEvent = "ApplyInHandDaysBeforeEvent",
    CleanUpPricingSettingsInListingHistory = "CleanUpPricingSettingsInListingHistory",
    UseListingGroupDefaultsFromPricer = "UseListingGroupDefaultsFromPricer",
    AutoPricingIgnoreVeloCB = "AutoPricingIgnoreVeloCB",
    FixUpdateFloorAndCeilingIssues = "FixUpdateFloorAndCeilingIssues",
    EventVenueConfigIdFromEventService = "EventVenueConfigIdFromEventService",
    CalibrateTgUnitCostOnBackend = "CalibrateTgUnitCostOnBackend",
    AutoPricingCompRowOffsetMode = "AutoPricingCompRowOffsetMode",
    AutoPricingPausePriceUpdates = "AutoPricingPausePriceUpdates",
    AddCountryCodeInActionOutboxPayload = "AddCountryCodeInActionOutboxPayload",
    ExportCsvFilterColumns = "ExportCsvFilterColumns",
    AutoPricingCompFailureAction = "AutoPricingCompFailureAction",
    LinkProceedWithSaleLineItem = "LinkProceedWithSaleLineItem",
    AutoPricingWebsitePriceUndercuts = "AutoPricingWebsitePriceUndercuts",
    AutoPricingImprovedPricePreivewForVeloCB = "AutoPricingImprovedPricePreivewForVeloCB",
    AutoGeneratePONumbers = "AutoGeneratePONumbers",
    UnmappedInvToggle = "UnmappedInvToggle",
    TagMappingToDefaultBuyer = "TagMappingToDefaultBuyer",
    AdminHoldInventoryOnSaleRejection = "AdminHoldInventoryOnSaleRejection",
}

export enum FeatureState {
    Disabled = "Disabled",
    Restricted = "Restricted",
    GeneralAvailability = "GeneralAvailability",
    LimitedAvailability = "LimitedAvailability",
    InDevelopment = "InDevelopment",
}

export interface AdPlatformCatalogResults {
    events: { [key: string]: EventWithData; };
    performers: { [key: string]: Performer; };
    venues: { [key: string]: Venue; };
    listingsByExternalId: { [key: string]: Listing; };
    venueMapByEventId: { [key: string]: VenueMapInfo; };
}

export interface EventWithData {
    event: Event;
    counts: EventEntityCounts;
    entities: EventEntities;
}

export interface EventEntityCounts {
    viagVirtId: string;
    perfId: number | null;
    venId: number;
    rowVer: number | null;
    salesCnt: number | null;
    /** Listing count */
    listCnt: number | null;
    /** Priced listing count */
    pricedListCnt: number | null;
    /** Ungrouped listing count */
    ungrListCnt: number | null;
    /** Listing Group count */
    listGrpCnt: number | null;
    /** Ticket Group count */
    tktGrpsCnt: number | null;
    /** PurchaseOrderCount */
    poCnt: number | null;
}

export interface EventEntities {
    listings: Listing[] | null;
    listingsSummary: Listing | null;
    sales: Sale[] | null;
    salesSummary: Sale | null;
    ticketGroups: PurchaseOrderTicketGroup[] | null;
    ticketGroupsSummary: PurchaseOrderTicketGroup | null;
    getDataFail: boolean | null;
    /** PIT ID for next page requests, null if not using PIT (Point-In-Time) pagination */
    pitId: string | null;
    /** Total number of matching documents that may have not been returned yet due to pagination */
    totalItemsCount: number | null;
}

/** Base class to represent common info between Listing, Sale, or PurchaseOrder, which basically is an entity that contains metadata about a set of Tickets for a single Event */
export interface EntityWithTickets {
    /** The ID of this entity in the DB (ListingId, SaleId, or PurchaseOrderId) */
    id: number;
    /** The seller account id that this entity belongs to.
This field only populates in MasterView UI (not single-account UI) */
    accId: string | null;
    /** The event of which this entity is for. */
    posEvId: string;
    /** ViagogoEntityId */
    viagEvId: number | null;
    /** ViagogoEventMappingId */
    viagEvMapId: string | null;
    /** ViagogoVirtualId (ViagogoEventId or ViagogoEventMappingId) */
    viagVirtId: string;
    rowVer: number;
    insertBy: string | null;
    currency: string;
    /** Given a Sale can consist of tickets purchased at different times, this should be
the latest date that all tickets are in hand.  This is a seller-provided field
and it does not have to coincide with listings or purchase orders. */
    inHandAt: string | null;
    seating: Seating;
    /** The number of tickets in this set.
- For Sale, it would be the same as QuantitySold - but this is the physical number of allocated tickets.
- For Listing for PO, it would just mean the number of tickets listed. */
    ticketCnt: number;
    seatTraits: ListingNote[] | null;
    privNotes: string | null;
}

/** Base class to represent common info between Sale and Listing (with Marketplace related info) */
export interface MarketplaceEntityWithTickets extends EntityWithTickets {
    /** Marketplace where these tickets were listed and sold */
    mkp: Marketplace | null;
    /** Represent either the MarketplaceListingId or MarketplaceSaleId */
    idOnMkp: string | null;
}

export interface Listing extends MarketplaceEntityWithTickets {
    rowId: number | null;
    entityType: ActionOutboxEntityType;
    dataIsLoaded: { [key in keyof typeof ListingDetailDataField]?: boolean; };
    /** Cost per ticket (from purchase order) */
    unitCst: UiMoney | null;
    status: ListingStatus;
    isUSEvent: boolean | null;
    /** Marketplace listing broadcast status */
    brdcstStatus: ListingBroadcastStatus | null;
    isSeatSaver: boolean;
    isAdminHold: boolean;
    adminHoldExpiredOn: string | null;
    adminHoldNotes: string | null;
    /** ValidPurchaseQuantity - computed value based on Quantity, MaxDisplayQuantity, and SplitType.
Will be an array of values that correspond to how many tickets from the listing buyers are
able to buy in one transaction. */
    vldPurQty: number[];
    /** This the number of tickets that have not yet sold or wasted and is always less than TicketCount. */
    availQty: number;
    /** MaxDisplayQuantity */
    maxDispQty: number;
    /** ManualMaxDisplayQuantity */
    manMaxDispQty: number | null;
    /** This is the number of tickets that have been sold */
    soldQty: number | null;
    /** This is the number of tickets that have been wasted */
    wastedQty: number | null;
    /** This is the number of tickets that are not sold, which is equivalent to AvailQty + WastedQty */
    unsoldQty: number;
    /** A number from 0 to 1 that represent a %
Null represent that the marketplace doesn't provide this info */
    preDelivState: PreDeliveryState;
    /** DeliveryType */
    delivType: DeliveryType;
    /** TopPriorityTicketType */
    topPriTktType: TicketType | null;
    isUndeliv: boolean;
    isNoFulfill: boolean | null;
    enableNativeSync: boolean | null;
    actions: ListingActionType[];
    isCurUserPo: boolean;
    poBys: string[] | null;
    poId: number | null;
    poOrderId: string | null;
    poDate: string | null;
    poVendAccEmail: string | null;
    poCreatedBys: string[] | null;
    isDeleted: boolean;
    mkpListings: MarketplaceListing[] | null;
    qcState: QualityControlState | null;
    pendProofState: PendingProofState | null;
    dupListingId: number | null;
    ignoreDup: boolean | null;
    /** MarketplaceVisibility */
    mkpVis: number | null;
    sectionType: VenueMapSectionType | null;
    /** Original Seat From for the listing, different from Seating.SeatFr which is the current seatFr available */
    orgSeatFr: string | null;
    orgSeatTo: string | null;
    /** Internal notes, which are truncated to 80 characters if it's more than 80 characters. */
    internalNotesPreview: string | null;
    /** Indicates whether the InternalNotesPreview is truncated or not. */
    isInternalNotesPreviewTruncated: boolean | null;
    noteIds: string | null;
    ltGrpId: string | null;
    ltGrpParentId: number | null;
    ltGrpPrior: number | null;
    ltGrpActive: boolean | null;
    isLtGrp: boolean;
    isFull: boolean;
    ltGrpUndercut: ListingGroupUndercutSetting | null;
    tags: Tag[] | null;
    splitType: SplitType;
    hideSeats: boolean;
    pricerId: string | null;
    listPrice: number;
    allInPrice: number;
    faceValue: UiMoney | null;
    lastPrcUpdOn: string | null;
    /** Indicates whether automatic pricing is enabled for this listing.
When true, the listing price will be automatically adjusted based on configured pricing rules and market conditions. */
    isAutoPrc: boolean | null;
    procsFloor: number | null;
    procsCeil: number | null;
    /** UndercutMode */
    undMode: AutoPricingUndercutMode | null;
    /** UndercutAbsoluteAmount */
    undAbsAmt: number | null;
    /** UndercutRelativeAmount */
    undRelAmt: number | null;
    /** UndercutNewPrice */
    undNewPrice: number | null;
    /** CompListingMode */
    compMode: AutoPricingCompListingMode | null;
    /** CompListingFloor */
    compFloor: number | null;
    /** CompLIstingCeiling */
    compCeil: number | null;
    /** IsCompListingQuantityScoreAdjustmentEnabled */
    isCompQtyScrAdj: boolean | null;
    /** CompListingQuantityScoreAdjustmentJson */
    compQtyScrAdjJson: string | null;
    /** CompListingOnlyForSameZoneEnabled */
    isCompForSameZone: boolean | null;
    /** CompListingOnlyForSelectedSectionsEnabled */
    isCompSelectedSections: boolean | null;
    /** CompListingExcludeFanInventory */
    compExclFanInv: boolean | null;
    /** CompListingExcludeDefects */
    compExclDefects: boolean | null;
    /** CompListingSelectedSectionSettings */
    compSectionSettings: SelectedSectionSettings | null;
    /** CircuitBreakerRelativeCeiling */
    cirBrRelCeil: number | null;
    /** CircuitBreakerRelativeFloor */
    cirBrRelFloor: number | null;
    /** CircuitBreakerMaxDiscountVelocityPercent */
    cirBrMaxDiscVelocPercent: number | null;
    /** CircuitBreakerMaxDiscountVelocityTicksInHours */
    cirBrMaxDiscVelocTicksInHrs: number | null;
    /** CircuitBreakerMinCompListingCount */
    cirBrMinCompCount: number | null;
    /** OutlierMode */
    outMode: AutoPricingOutlierMode | null;
    /** OutlierStandardDeviations */
    outlStdDev: number | null;
    /** OutlierKthLowestLimit */
    outKthLowestLim: number | null;
    /** OutlierKthLowestLimitAbsoluteSpacing */
    outKthLowestLimRelSpc: number | null;
    /** OutlierKthLowestLimitRelativeSpacing */
    outKthLowestLimAbsSpc: number | null;
    /** AutoPricingResultState */
    autoPrcResult: AutoPricingResultType | null;
    /** Categorized constraint type for AutoPricing result
Only populated when SurfacePricingStates feature flag is enabled */
    autoPrcConstraintType: AutoPricingConstraintType | null;
    /** The rowversion of the row that indicates when the circuitbreaker was reset for a listing */
    cirBrSuppRowVer: number | null;
    tktTypeRules: TicketTypeOverride | null;
    shownQuantity: number | null;
    wastedCost: UiMoney | null;
    unsoldCost: UiMoney | null;
    soldCost: UiMoney | null;
    unsoldProceeds: number | null;
}

export enum ListingDetailDataField {
    Basic = "Basic",
    Tickets = "Tickets",
    Pricing = "Pricing",
    AutoPricing = "AutoPricing",
    Sales = "Sales",
    Purchase = "Purchase",
    Tags = "Tags",
    InternalNotes = "InternalNotes",
}

export interface UiMoney {
    amt: number;
    disp: string | null;
    currency: string | null;
    dec: number;
}

export enum ListingStatus {
    Disabled = "Disabled",
    FullySold = "Fully Sold",
    DelistingPending = "Delisting Pending",
    DelistingFailed = "Delist Failed",
    Delisted = "Delisted",
    ListingPending = "Listing Pending",
    ListingFailed = "List Failed",
    Listed = "Listed",
}

export enum ListingBroadcastStatus {
    Unknown = "Unknown",
    Broadcast = "Broadcast",
    BroadcastFailed = "BroadcastFailed",
    BroadcastWithError = "BroadcastWithError",
    Unbroadcast = "Unbroadcast",
    UnbroadcastFailed = "UnbroadcastFailed",
    UnbroadcastWithError = "UnbroadcastWithError",
}

export enum PreDeliveryState {
    NotPreDelivered = "No",
    PreDelivered = "Yes",
}

export enum DeliveryType {
    InApp = "In-app",
    PDF = "PDF",
    Paper = "Paper",
    MemberCard = "Member Card",
    Wallet = "Wallet",
    Custom = "Custom",
}

export enum TicketType {
    Custom = "Custom",
    Paper = "Paper",
    ETicket = "ETicket",
    ETicketUrl = "ETicketUrl",
    Transfer = "Transfer",
    Barcode = "Barcode",
    Season = "Season",
    QRCode = "QRCode",
    SMPWallet = "SMPWallet",
}

export enum ListingActionType {
    Broadcast = "Broadcast",
    Unbroadcast = "Unbroadcast",
    Split = "Split",
    SplitToOriginal = "SplitToOriginal",
    AddOfflineSale = "AddOfflineSale",
    AddMarketplaceSale = "AddMarketplaceSale",
    PredeliverBarcodes = "PredeliverBarcodes",
    PredeliverETickets = "PredeliverETickets",
    PredeliverQRCode = "PredeliverQRCode",
    PredeliverExternalIds = "PredeliverExternalIds",
    PredeliverTicketUrls = "PredeliverTicketUrls",
    RedeliverBarcodes = "RedeliverBarcodes",
    RedeliverETickets = "RedeliverETickets",
    RedeliverQRCode = "RedeliverQRCode",
    RedeliverExternalIds = "RedeliverExternalIds",
    RedeliverTicketUrls = "RedeliverTicketUrls",
    DownloadUserDocuments = "DownloadUserDocuments",
    FullySoldNoAction = "FullySoldNoAction",
    AddAdminHold = "AddAdminHold",
    RemoveAdminHold = "RemoveAdminHold",
    Waste = "Waste",
}

export interface MarketplaceListing {
    mkpListingId: string | null;
    mkp: Marketplace;
    status: ListingStatus;
    markup: number | null;
    sellerAccountDefaultMarkup: number | null;
    sellerFee: number | null;
    netProcs: number | null;
    webPrice: number | null;
    isPriceByMkp: boolean;
    overrideSection: string | null;
    overrideRow: string | null;
    overrideSeats: string | null;
    overrideRowId: number | null;
    overrideSectionId: number | null;
    isEnabled: boolean;
    availQty: number | null;
    currency: string;
    errMsgs: string[] | null;
    errCodes: BroadcastErrorCode[] | null;
    pendProofState: PendingProofState | null;
    brdcstStatus: ListingBroadcastStatus | null;
}

export enum Marketplace {
    StubHub = "StubHub",
    VividSeats = "VividSeats",
    SeatGeek = "SeatGeek",
    TickPick = "TickPick",
    Ticketmaster = "Ticketmaster",
    Offline = "Offline",
    AXS = "AXS",
    FanXchange = "FanXchange",
    Gametime = "Gametime",
    TicketEvolution = "TicketEvolution",
    TicketNetwork = "TicketNetwork",
    Automatiq = "Automatiq",
    Lyte = "Lyte",
    GoTickets = "GoTickets",
    B2BSales = "B2BSales",
    TicketNetworkMercury = "TicketNetworkMercury",
    Wastage = "Wastage",
    ReachPro = "ReachPro",
}

export enum BroadcastErrorCode {
    Unknown = "Unknown",
    UpdatePrice = "UpdatePrice",
    UpdateTicketType = "UpdateTicketType",
    UpdateSplitType = "UpdateSplitType",
    UpdateInHandDate = "UpdateInHandDate",
    SplitListing = "SplitListing",
    MergeListing = "MergeListing",
    BroadcastListing = "BroadcastListing",
    UnbroadcastListing = "UnbroadcastListing",
    UpdateQuantity = "UpdateQuantity",
    HideSeats = "HideSeats",
    UpdateListingNotes = "UpdateListingNotes",
    UpdateSeating = "UpdateSeating",
    MarketplaceResaleRestricted = "MarketplaceResaleRestricted",
    MarketplaceManifestMismatch = "MarketplaceManifestMismatch",
    MarketplacePriceBelowFloor = "MarketplacePriceBelowFloor",
}

export enum PendingProofState {
    PendingProof = "PendingProof",
    PendingReview = "PendingReview",
    Approved = "Approved",
}

export enum QualityControlState {
    Pending = "Pending",
    Approved = "Approved",
    Rejected = "Rejected",
}

export enum VenueMapSectionType {
    ForcedRow = "ForcedRow",
    OptionalRow = "OptionalRow",
    NoRow = "NoRow",
    GeneralAdmission = "GeneralAdmission",
    NoRowPairs = "NoRowPairs",
    OptionalRowPairs = "OptionalRowPairs",
    ForcedRowPairs = "ForcedRowPairs",
    GeneralAdmissionWithQueueNumber = "GeneralAdmissionWithQueueNumber",
    GeneralAdmissionStanding = "GeneralAdmissionStanding",
    GeneralAdmissionSeating = "GeneralAdmissionSeating",
}

export interface ListingGroupUndercutSetting {
    /** UndercutAbsoluteAmount */
    undAbsAmt: number | null;
    /** UndercutRelativeAmount */
    undRelAmt: number | null;
    /** ActiveRankUndercutAbsoluteAmount */
    actRankUndAbsAmt: number | null;
    /** ActiveRankUndercutRelativeAmount */
    actRankUndRelAmt: number | null;
}

export interface Tag {
    /** The key of of the tag associated with an entity */
    key: string;
    /** The value of of the tag associated with an entity */
    value: string;
    valueType: TagsValueType | null;
    singleValueOnly: boolean | null;
    includeInReport: boolean | null;
    ordinal: number | null;
    persistentTagId: number | null;
    saleTagValueInheritModeId: TagValueInheritMode | null;
    sourceEntityId: number | null;
}

export enum TagsValueType {
    String = "String",
    Decimal = "Decimal",
    Int = "Int",
    Boolean = "Boolean",
    Json = "Json",
    Url = "Url",
    Marketplace = "Marketplace",
    Date = "Date",
    POSUser = "POSUser",
    Vendor = "Vendor",
    UserGroup = "UserGroup",
}

export enum TagValueInheritMode {
    SyncLiveValue = "SyncLiveValue",
    CopyValueOnCreate = "CopyValueOnCreate",
    DoNotInherit = "DoNotInherit",
}

export enum SplitType {
    Any = "Any",
    None = "None",
    AvoidOne = "Avoid One",
    AvoidOneAndThree = "Avoid One and Three",
    Pairs = "Pairs",
}

export enum AutoPricingUndercutMode {
    Simple = "Simple",
    RowExtrapolation = "RowExtrapolation",
    Deal = "Deal",
    AverageOfCheapestListings = "AverageOfCheapestListings",
}

export enum AutoPricingCompListingMode {
    QualityScore = "QualityScore",
    SameSection = "SameSection",
    SameZone = "SameZone",
    SameEvent = "SameEvent",
    ParentListing = "ParentListing",
}

export interface SelectedSectionSettings {
    sectionIdFilter: number[] | null;
    rowIdFilter: number[] | null;
    sectionRowIdFilter: { [key: string]: string; } | null;
    sectionIdFilterFromZoneMap: boolean;
    includeBetterZones: boolean;
    rowOffset: number | null;
    sectionFilterMode: SectionFilterMode | null;
}

export enum SectionFilterMode {
    Custom = "Custom",
    SameSection = "SameSection",
    SameZone = "SameZone",
    AllSections = "AllSections",
}

export enum AutoPricingOutlierMode {
    StandardDeviations = "StandardDeviations",
    SkipLogic = "SkipLogic",
    KthLowest = "KthLowest",
}

export enum AutoPricingResultType {
    None = "None",
    PriceSuccess = "PriceSuccess",
    PriceBelowFloor = "PriceBelowFloor",
    InsufficientComparables = "InsufficientComparables",
    PriceBelowMaxAllowedDrop = "PriceBelowMaxAllowedDrop",
    PriceAboveCeiling = "PriceAboveCeiling",
    MissingUnitCost = "MissingUnitCost",
    MissingSeatScore = "MissingSeatScore",
    MissingZone = "MissingZone",
    CannotCalculateUndercut = "CannotCalculateUndercut",
    EffectiveCeilingBelowFloor = "EffectiveCeilingBelowFloor",
    PriceHitHardFloor = "PriceHitHardFloor",
    PriceHitRelativeFloor = "PriceHitRelativeFloor",
    PriceHitMaxAllowedDrop = "PriceHitMaxAllowedDrop",
    ConfigRowMissing = "ConfigRowMissing",
    SectionUnmapped = "SectionUnmapped",
    AllPriceUpdatesPaused = "AllPriceUpdatesPaused",
    PriceDecreasesPaused = "PriceDecreasesPaused",
}

export enum AutoPricingConstraintType {
    None = "None",
    HardConstraint = "HardConstraint",
    SoftConstraint = "SoftConstraint",
}

export interface TicketTypeOverride {
    overrides: TicketTypeOverrideForDeliveryType[];
}

export interface TicketTypeOverrideForDeliveryType {
    deliveryType: DeliveryType;
    ticketTypePriorities: TicketTypePriority[];
}

export interface TicketTypePriority {
    priority: number;
    ticketType: TicketType;
    isBlocked: boolean;
}

export interface Seating {
    section: string;
    sectionId: number | null;
    row: string | null;
    rowId: number | null;
    seatFr: string | null;
    seatTo: string | null;
    ticketIds: number[] | null;
    listingIds: number[] | null;
}

export interface ListingNote {
    listingNoteId: number;
    listingNoteText: string;
    listingNoteUntranslated: string;
    sellerAccountId: string | null;
    stubhubListingNoteId: number | null;
    type: ListingNoteType | null;
}

export enum ListingNoteType {
    Defect = "Defect",
    RestrictionOnUse = "Restriction on Use",
    Perk = "Perk",
    Information = "Information",
    ConnectedSeller = "ConnectedSeller",
    InternallyGenerated = "InternallyGenerated",
}

export interface Sale extends MarketplaceEntityWithTickets {
    entityType: ActionOutboxEntityType;
    /** The ID of the Listing in POS that this Sale comes from. */
    listingId: number | null;
    originatedFromListingId: number | null;
    saleDate: string;
    ttlNetProcs: UiMoney | null;
    soldTktCost: UiMoney | null;
    pandL: UiMoney | null;
    /** Margin (SoldProceeds - SoldCost) / SoldProceeds */
    margin: number | null;
    charges: UiMoney | null;
    credits: UiMoney | null;
    /** The total payment amount in the original currency */
    totalPmt: UiMoney | null;
    /** The total payment amount in the converted currency */
    totalConvertedPmt: UiMoney | null;
    /** PaymentState */
    pmtState: PointOfSalePaymentState | null;
    /** MarketplacePaymentState */
    mkpPmtState: MarketplacePaymentState | null;
    /** MarketplaceFulfillmentState */
    mkpFulfState: MarketplaceFulfillmentState | null;
    fulfillState: PointOfSaleFulfillmentState;
    fulfillDate: string | null;
    actions: SaleActionType[];
    status: PointOfSaleSaleStatus;
    isSeatSaver: boolean;
    adCmpFlightId: number | null;
    qtySold: number;
    ticketType: TicketType | null;
    fulfillerId: string | null;
    tags: Tag[] | null;
    holdExpiredOn: string | null;
    isNoFulfill: boolean | null;
    /** MarketplaceContractState */
    mkpContrState: MarketplaceContractState | null;
    /** IsFulfillmentVersionMismatched */
    isFulfillVerMis: boolean;
    owners: SaleOwnershipInfo | null;
    /** IsPaymentReceived */
    pmtRcv: boolean | null;
    /** PaymentReferenceId */
    pmtRefId: string | null;
    /** PaymentAmountReceived */
    pmtAmtRcv: number | null;
    /** LastPaymentDate */
    lastPmtDate: string | null;
    /** PaymentCurrencyCode */
    pmtCurcy: string | null;
    poDate: string | null;
    poId: number | null;
    poVendOrdId: string | null;
    poVendAccEmail: string | null;
    /** DisableAutoSourcing */
    disAutoSource: boolean;
    /** Originated By. The seller User ID that created the Listing that the sale originally comes from.  */
    origBy: string | null;
    /** Comment notes */
    comNotes: SaleCommentNote[] | null;
    /** Is unprocessed order from processor */
    isUnprocessedOrdFromPro: boolean | null;
    /** IsWastageSale */
    isWastageSale: boolean | null;
    /** The quantity of tickets that were wasted */
    qtyWasted: number;
    cancellationReason: SaleCancellationReason | null;
    hasMarketplaceProblem: boolean | null;
    /** Internal notes, which are truncated to 80 characters if it's more than 80 characters. */
    internalNotesPreview: string | null;
    /** Indicates whether the InternalNotesPreview is truncated or not. */
    isInternalNotesPreviewTruncated: boolean | null;
}

export enum PointOfSalePaymentState {
    Unpaid = "Unpaid",
    Queued = "Queued",
    Paid = "Paid",
    PartiallyPaid = "PartiallyPaid",
    PendingReversal = "PendingReversal",
    Reversed = "Reversed",
}

export enum MarketplacePaymentState {
    Ineligible = "Ineligible",
    Unpaid = "Unpaid",
    Queued = "Queued",
    Paid = "Paid",
    PartiallyPaid = "PartiallyPaid",
    PendingReversal = "PendingReversal",
    Reversed = "Reversed",
}

export enum MarketplaceFulfillmentState {
    Ineligible = "Ineligible",
    Pending = "Pending",
    Processing = "Processing",
    PendingPickup = "PendingPickup",
    InTransit = "InTransit",
    Fulfilled = "Fulfilled",
    Failed = "Failed",
    PendingReshipment = "PendingReshipment",
}

export enum PointOfSaleFulfillmentState {
    Ineligible = "Ineligible",
    Pending = "Pending",
    Processing = "Processing",
    PendingPickup = "PendingPickup",
    InTransit = "InTransit",
    Fulfilled = "Fulfilled",
    Failed = "Failed",
    Resetted = "Resetted",
}

export enum SaleActionType {
    Confirm = "Confirm",
    Fulfill = "Fulfill",
    Reject = "Reject",
    Deallocate = "Deallocate",
    ExpireHold = "ExpireHold",
    Refulfill = "Refulfill",
    EditOffline = "EditOffline",
    Allocate = "Allocate",
    ResetFulfillment = "ResetFulfillment",
    RejectAllocation = "RejectAllocation",
    ConfirmAllocation = "ConfirmAllocation",
    MarkAsFulfilled = "MarkAsFulfilled",
    DownloadUserDocuments = "DownloadUserDocuments",
    Unwaste = "Unwaste",
    EditMarketplaceSale = "EditMarketplaceSale",
}

export enum PointOfSaleSaleStatus {
    PendingConfirmation = "PendingConfirmation",
    PendingFulfillment = "PendingFulfillment",
    ProcessingFulfillment = "ProcessingFulfillment",
    Fulfilled = "Fulfilled",
    FulfillmentFailed = "FulfillmentFailed",
    PendingRejection = "PendingRejection",
    Rejected = "Rejected",
    Hold = "Hold",
    CancelledHold = "CancelledHold",
    PendingAllocation = "PendingAllocation",
    ProvisionalAllocation = "ProvisionalAllocation",
    PendingReshipment = "PendingReshipment",
    Wasted = "Wasted",
}

export enum MarketplaceContractState {
    Provisional = "Provisional",
    CancelledProvisional = "CancelledProvisional",
    Contracted = "Contracted",
    MarketplaceDispute = "MarketplaceDispute",
    Complete = "Complete",
    CancelledUnknownFault = "CancelledUnknownFault",
    CancelledSellerFault = "CancelledSellerFault",
    CancelledMutual = "CancelledMutual",
    CancelledMarketplaceFault = "CancelledMarketplaceFault",
}

export interface SaleOwnershipInfo {
    fulfillerId: string | null;
    buyerIds: string[];
    pricerIds: string[];
    poInsertBys: string[];
    poIds: number[];
}

export interface SaleCommentNote {
    date: string | null;
    email: string | null;
    text: string | null;
}

export enum SaleCancellationReason {
    EventCancellation = "EventCancellation",
    SellerFault = "SellerFault",
    MarketplaceFault = "MarketplaceFault",
    NoFault = "NoFault",
    Other = "Other",
}

/** Base class of purchase order that has common fields for both request and response. */
export interface PurchaseOrder {
    id: number;
    entityType: ActionOutboxEntityType;
    accId: string | null;
    buyerId: string | null;
    insertBy: string | null;
    commissions: Commission[] | null;
    vendor: PurchaseVendor | null;
    secVendor: PurchaseVendor | null;
    vendAcc: PurchaseVendorAccount | null;
    secVendAcc: PurchaseVendorAccount | null;
    tags: Tag[] | null;
    /** The order number of the purchase from the PurchaseVendor */
    vendOrdId: string | null;
    poState: PurchaseOrderState;
    poDate: string | null;
    /** This is basically the number of ticket groups in this PO. */
    tktGrpCnt: number;
    /** This is for currency-input, */
    currency: string;
    pmtStat: PurchasePaymentStatus | null;
    pmtMethod: PurchasePaymentMethodType | null;
    privNotes: string | null;
    qcState: QualityControlState | null;
    isAutoPo: boolean | null;
    rowVer: number;
    isCommissionsLocked: boolean | null;
    pmtMtdFullDisp: PurchasePaymentMethod[] | null;
    ticketCnt: number;
    totalPmt: UiMoney | null;
    totalConvertedPmt: UiMoney | null;
    /** Outstanding Balance = TotalCost - (TotalConvertedPaymentAmount / TotalPaymentAmount) */
    outsBal: UiMoney | null;
    pmtConvRate: number | null;
    delivType: DeliveryType | null;
    totalCst: UiMoney | null;
    unitCst: UiMoney | null;
    viagVirtId: string | null;
}

export interface PurchaseOrderTicketGroup extends PurchaseOrder {
    /** This is a thin version of ticket group to show in the purchase order table. */
    ticketGroupItems: IPurchaseOrderTicketGroupItem[] | null;
    isTktGrp: boolean | null;
    /** Has user document artifacts to download */
    canGetDocArts: boolean | null;
    tgId: number | null;
    tickets: Ticket[];
    isMultEv: boolean | null;
    seating: Seating | null;
    seatTraits: ListingNote[] | null;
    perfId: number | null;
    venId: number | null;
}

export interface IPurchaseOrderTicketGroupItem {
    /** True if this instance is a ticket group, can be under a purchase order or containing purchase order info */
    isTktGrp: boolean | null;
    /** Has user document artifacts to download */
    canGetDocArts: boolean | null;
    tgId: number | null;
    viagVirtId: string;
    perfId: number | null;
    venId: number | null;
    /** True if this is a multi-event PO */
    isMultEv: boolean | null;
    seating: Seating | null;
    /** If this is a PO (IsTktGrp == false), this is the number of tickets in the whole PO.
Otherwise, this is the number of tickets in this ticket group. */
    ticketCnt: number;
    tickets: Ticket[];
    seatTraits: ListingNote[] | null;
    /** The overall delivery for the PO (if there are several, the first one is listed)
If this is a ticket group, this is the delivery for this ticket group. */
    delivType: DeliveryType | null;
    totalCst: UiMoney | null;
    unitCst: UiMoney | null;
}

export interface Ticket {
    id: number;
    tgId: number;
    ord: number;
    /** This is the order that considers merged listings too, safe to use anywhere
        
NOTE - this is required to be kept Nullable as it should remains Null when setting to the server
making it non-null requires you to handle it or else it will get set to 0 for all seatings and that will have bad consequences */
    lstOrd: number | null;
    row: string | null;
    seat: string;
    barcode: string | null;
    ticketUrl: string | null;
    externalTicketId: string | null;
    eTicket: UserDocumentLinks | null;
    qrCode: UserDocumentLinks | null;
    holdId: number | null;
    saleId: number | null;
    listingId: number | null;
    poId: number | null;
    unitCost: UiMoney | null;
    isWasted: boolean | null;
}

export interface UserDocument {
    entityId: number | null;
    documentId: string;
    pageNumber: number | null;
    pageId: string | null;
    documentType: DocumentType | null;
}

export interface UserDocumentLinks extends UserDocument {
    documentUri: string;
    pageUri: string;
}

export interface Commission {
    /** Buyer BuyerUserId */
    buyerUserId: string;
    /** The percentage of the commission */
    commissionPercentage: number;
}

export interface PurchaseVendor {
    id: number;
    name: string;
    isGlobal: boolean | null;
    vendAccCounts: number | null;
    delivType: DeliveryType | null;
    isNoFulfill: boolean | null;
    tktTypeRules: TicketTypeOverride | null;
}

export interface PurchaseVendorAccount {
    id: string;
    vendorId: number;
    name: string;
    email: string;
    password: string | null;
    dftPayMethodId: number | null;
    dftBuyerId: string | null;
}

export enum PurchaseOrderState {
    Active = "Active",
    Cancelled = "Cancelled",
    Void = "Void",
    Drafted = "Drafted",
}

export enum PurchasePaymentStatus {
    Unpaid = "Unpaid",
    PartiallyPaid = "Partially Paid",
    Paid = "Paid",
    Failed = "Failed",
    RefundNeeded = "RefundNeeded",
    Refunded = "Refunded",
    PartiallyRefunded = "PartiallyRefunded",
}

export enum PurchasePaymentMethodType {
    PayPal = "PayPal",
    ECheck = "eCheck",
    Check = "Check",
    MoneyOrder = "Money Order",
    Card = "Credit Card",
    Cash = "Cash",
    Credit = "Credit",
    COD = "COD",
    BankTransfer = "Bank Transfer",
    DebitCard = "Debit Card",
    CreditMemo = "Credit Balance",
    DebitNote = "Debit Note",
    Other = "Other",
}

export interface PurchasePaymentMethod {
    id: number;
    display: string;
    name: string;
    type: PurchasePaymentMethodType;
}

export interface VenueMapInfo {
    eventId: number;
    venueId: number;
    venueCfgId: number;
    svgMapVer: number | null;
    geoJsonVer: number | null;
    sections: SectionInfo[];
    sectionScores: SectionScoreOverride[];
    focalPt: FocalPointInfo | null;
    hasRow: boolean;
}

export interface SectionInfo {
    id: number;
    name: string;
    rows: RowInfo[];
    sectionType: VenueMapSectionType;
    dist: number | null;
    angle: number | null;
    directionalAngle: number | null;
    height: number | null;
    specRow: VenueMapRow | null;
}

export interface RowInfo {
    id: number;
    name: string | null;
    ordinal: number | null;
    tktClass: TicketClassInfo | null;
    seatQualityScore: number | null;
    isSpeculative: boolean;
}

export interface TicketClassInfo {
    id: number;
    name: string;
    color: string;
    cssPostFix: string;
}

export interface VenueMapRow {
    id: number;
    name: string | null;
    ordinal: number | null;
    ticketClassId: number | null;
    tktClass: VenueMapTicketClass | null;
    seatQualityScore: number | null;
    isSpeculative: boolean;
}

export interface VenueMapTicketClass {
    ticketClassId: number;
    ticketClassName: string;
    color: string;
    cssPostFix: string;
}

export interface SectionScoreOverride {
    sectionId: number;
    rowId: number;
    rowName: string | null;
    rowOrdinal: number | null;
    tkClsId: number | null;
    /** Score normalized to 0-100 according to max score of venue heat map */
    score: number | null;
    scoreRaw: number | null;
    isManualOverride: boolean | null;
}

export interface FocalPointInfo {
    x: number | null;
    y: number | null;
    angleDeg: number | null;
    isDirectional: boolean;
}

export interface AdPlatformTransactionAgg {
    sellerId: string;
    adCampaignId: string | null;
    adGroupId: string | null;
    adSpend: UiMoney;
    salesProceeds: UiMoney;
    qtySold: number;
}

export enum TransactionAggType {
    None = "None",
    SellerId = "SellerId",
    CampaignId = "CampaignId",
    AdGroupId = "AdGroupId",
}

export interface AutoPoInboundEmail {
    inboundEmailId: number;
    subject: string | null;
    fromEmailAddress: string | null;
    toEmailAddress: string | null;
    receiveDate: string | null;
    createDate: string;
    purchaseOrderVendorId: number | null;
    partialPurchaseOrderId: number | null;
    purchaseOrderId: number | null;
    saleId: number | null;
    classificationType: AutoPoInboundEmailClassificationType | null;
}

export enum AutoPoInboundEmailClassificationType {
    NewPurchaseOrder = "NewPurchaseOrder",
    ExistingPurchaseOrder = "ExistingPurchaseOrder",
    Junk = "Junk",
    OneTimePass = "OneTimePass",
    Password = "Password",
    TicketsAvailable = "TicketsAvailable",
    PurchaseCancelled = "PurchaseCancelled",
    EventCancelled = "EventCancelled",
    EventPostponed = "EventPostponed",
    EnjoyTheEvent = "EnjoyTheEvent",
    TransferSent = "TransferSent",
    TransferAccepted = "TransferAccepted",
    TransferExpired = "TransferExpired",
    NewSale = "NewSale",
    ConfirmationDeadline = "ConfirmationDeadline",
    ShippingDeadline = "ShippingDeadline",
    SaleCancelled = "SaleCancelled",
    OtherMarketplaceContact = "OtherMarketplaceContact",
}

export interface AutoPoInboundEmailQuery {
    inboundEmailIds: number[] | null;
}

export interface AutoPoPartialPurchaseOrderInboundEmail {
    inboundEmailId: number;
    subject: string | null;
    fromEmailAddress: string | null;
    toEmailAddress: string | null;
    purchaseOrderVendorId: number | null;
    receiveDate: string | null;
    createDate: string;
    partialPurchaseOrderId: number | null;
    orderId: string | null;
    quantity: number | null;
    faceValue: number | null;
    purchaseOrderDate: string | null;
    totalCount: number;
}

export interface AutoPoInboundEmailPartialPurchaseOrderQuery {
    classificationTypes: AutoPoInboundEmailClassificationType[] | null;
    includeUnclassified: boolean | null;
    subjectSearchText: string | null;
    fromEmailAddress: string | null;
    toEmailAddress: string | null;
    textBodySearchText: string | null;
    classificationTypeUpdateDateFrom: string | null;
    classificationTypeUpdateDateTo: string | null;
}

export interface AutoPoPartialPurchaseOrder {
    partialPurchaseOrderId: number;
    orderId: string;
    eventName: string;
    eventDateTime: string | null;
    venueName: string;
    section: string;
    row: string;
    seatFrom: string;
    seatTo: string;
    quantity: number | null;
    faceValue: number | null;
    purchaseOrderDate: string | null;
}

export interface AutoPoInboundEmailThreadEmail {
    inboundEmailId: number;
    classificationType: AutoPoInboundEmailClassificationType | null;
    subject: string | null;
    fromEmailAddress: string | null;
    toEmailAddress: string | null;
    receiveDate: string | null;
    htmlBody: string | null;
    textBody: string | null;
    purchaseOrderId: number | null;
    saleId: number | null;
    partialPurchaseOrderId: number | null;
    orderId: string | null;
    quantity: number | null;
    faceValue: number | null;
    purchaseOrderDate: string | null;
    purchaseOrderVendorId: number | null;
    attachments: AutoPoInboundEmailAttachment[] | null;
}

export interface AutoPoInboundEmailAttachment {
    attachmentFileName: string;
    downloadUri: string;
}

export interface ValueTupleOfStringAndString {
    item1: string;
    item2: string;
}

export interface AutoPoSellerAccountCountryRestriction {
    country: string;
    isEnabled: boolean | null;
}

export interface AutoPoSellerAccountVendorRestriction {
    vendorId: number;
    isIncluded: boolean;
}

export interface BulkEditPreviewWithDetails {
    error: string | null;
    allItemsCount: number;
    preview: BulkEditPreview;
    sales: Sale[] | null;
    listings: Listing[] | null;
    purchases: PurchaseOrder[] | null;
    ticketGroups: PurchaseOrderTicketGroup[] | null;
}

export interface BulkEditPreview {
    bulkEditCountPreview: { [key in keyof typeof ActionOutboxEntityType]?: BulkEditCountPreview; };
    consigneeOwnership: { [key in keyof typeof ActionOutboxEntityType]?: { [key: string]: number[]; }; } | null;
}

export interface BulkEditCountPreview {
    entityType: ActionOutboxEntityType;
    totalCount: number;
    idsAffected: number[];
}

export interface EntityWithTicketsQuery {
    entityIds: number[] | null;
    marketplaceEntityIds: string[] | null;
    eventOrMappingIds: string[] | null;
    oldPosEventIds: string[] | null;
    performerIds: number[] | null;
    venueIds: number[] | null;
    countryCodes: string[] | null;
    stateProvinceIds: number[] | null;
    cityIds: number[] | null;
    purchaseOrderId: number | null;
    purchaseOrderIds: number[] | null;
    saleIds: number[] | null;
    listingIds: number[] | null;
    purchaseVendorId: number | null;
    vendorAccessControlProviderId: number | null;
    purchaseVendorAccountIds: string[] | null;
    purchaseVendorOrderId: string | null;
    purchaseBuyerId: string | null;
    purchaseOrderCreatedBy: string | null;
    purchaseCommissionUserId: string | null;
    purchaseDates: DateTimeRangeWithRelative | null;
    inHandDates: DateTimeRangeWithRelative | null;
    eventTimeFrameFilter: EventTimeFrameFilter | null;
    sections: string[] | null;
    rows: string[] | null;
    sectionContains: string | null;
    sectionEquals: string | null;
    sectionNotContains: string | null;
    rowContains: string | null;
    rowEquals: string | null;
    rowNotContains: string | null;
    isSeatSaver: boolean | null;
    /** This is currently only used to filter on the frontend application. */
    eventDates: DateTimeRangeWithRelative | null;
    /** This is currently only used to filter on the frontend application. */
    eventNotReviewedSinceDate: DateTimeRangeWithRelative | null;
    isMapped: boolean | null;
    isMappingRejected: boolean | null;
    searchText: string | null;
    sortBy: EventSort | null;
    isSortDescending: boolean | null;
    tagName: string | null;
    tagValue: string | null;
    eventTagName: string | null;
    eventTagValue: string | null;
    lastSaleDates: DateTimeRangeWithRelative | null;
    noSaleDates: DateTimeRangeWithRelative | null;
    numberOfTicketsHeld: NumericRange | null;
    topLevelCategories: TopLevelCategory[] | null;
    parentCategories: number[] | null;
    internalNotes: string | null;
    internalNotesContains: string | null;
    internalNotesEquals: string | null;
    internalNotesNotContains: string | null;
    /** Output from the frontend application: `new Date().getTimezoneOffset()`
E.g. UTC-8 => 480
Used for RelativeTimeRange typed properties
Currently only used for reporting */
    timezoneOffsetMins: number | null;
    currencyCode: string | null;
    currencyCodes: string[] | null;
    eventStatuses: ApiEventStatus[] | null;
    /** This is only used to filter on the frontend application. */
    searchConfigId: string | null;
    purchaseVendorIds: number[] | null;
    purchaseBuyerIds: string[] | null;
    purchaseOrderCreatedBys: string[] | null;
    purchaseCommissionUserIds: string[] | null;
}

export interface ListingQuery extends EntityWithTicketsQuery {
    pricerSellerUserId: string | null;
    isPredelivered: boolean | null;
    isListed: boolean | null;
    deliveryType: DeliveryType | null;
    eventHasUnsoldTickets: boolean | null;
    hasUnsoldTickets: boolean | null;
    hasBroadcastError: boolean | null;
    isAutoPricingEnabled: boolean | null;
    isPricedAboveZero: boolean | null;
    lastPriceUpdateDates: DateTimeRangeWithRelative | null;
    lastPriceNoUpdateDates: DateTimeRangeWithRelative | null;
    autoPricingResultTypes: AutoPricingResultType[] | null;
    isSeatingUnmapped: boolean | null;
    isAdminHold: boolean | null;
    isDuplicate: boolean | null;
    isPricedByMarketplace: boolean | null;
    isPendingProof: boolean | null;
    purchaseCancellationDates: DateTimeRangeWithRelative | null;
    purchaseCancelledOnly: boolean | null;
    isNoFulfill: boolean | null;
    ticketType: TicketType | null;
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    eventUnpricedStatus: EventUnpricedStatus | null;
}

export interface DateTimeRangeWithRelative extends DateTimeRange {
    relativeStartSecs: number | null;
    relativeEndSecs: number | null;
    roundingMode: RelativeTimeRoundingMode | null;
}

export enum RelativeTimeRoundingMode {
    Day = "Day",
    Week = "Week",
    Month = "Month",
    Year = "Year",
}

export enum InventoryViewMode {
    TileView = "Tile View",
    MetricView = "Metric View",
    FlattenedView = "Flattened View",
}

export enum EventUnpricedStatus {
    AllUnpriced = "All",
    NoneUnpriced = "None",
    AnyUnpriced = "Any",
}

export enum EventTimeFrameFilter {
    Future = "Future Events",
    Past = "Past Events",
}

export enum EventSort {
    Date = "Sort by Date",
    MainDisplay = "Sort by Title",
}

export interface NumericRange {
    start: number | null;
    end: number | null;
}

export interface BulkEditProgress {
    updateKey: string;
    method: string;
    step: BulkEditStep;
    successCount: number;
    failureCount: number;
    warningCount: number;
    totalCount: number;
    status: string | null;
    error: string | null;
    warning: string | null;
    successPercent: number | null;
    failurePercent: number | null;
    warningPercent: number | null;
    countsByEntity: { [key in keyof typeof ActionOutboxEntityType]?: BulkEditCount; };
    retryableEntities: BulkEditPreview | null;
}

export enum BulkEditStep {
    Disabled = "Disabled",
    Initializing = "Initializing",
    InProgress = "InProgress",
    Done = "Done",
    Cancelled = "Cancelled",
    DoneWithRetryableEntities = "DoneWithRetryableEntities",
}

export interface BulkEditCount {
    totalCount: number;
    successCount: number;
    failureCount: number;
    warningCount: number;
    entityType: ActionOutboxEntityType;
    ttlCnt: number;
    succCnt: number;
    failCnt: number;
    warnCnt: number;
}

export enum ListingPriceAdjustmentType {
    CurrentPrice = "CurrentPrice",
    UnitCost = "UnitCost",
}

export enum PricingFloorCeilingAdjustmentType {
    MarketPrice = "MarketPrice",
    UnitCost = "UnitCost",
    CurrentFloor = "CurrentFloor",
}

export interface ValueTupleOfBulkEditPreviewAndListingDetailsUpdateInput {
    item1: BulkEditPreview;
    item2: ListingDetailsUpdateInput;
}

export interface ListingDetailsPricingUpdates {
    netProceedsFloor: number | null;
    netProceedsCeiling: number | null;
    skipPriceProtection: boolean | null;
    skipAutoPricing: boolean | null;
    autoPricingEnabled: boolean | null;
    undercutMode: AutoPricingUndercutMode | null;
    skipUndercut: boolean | null;
    undercutAbsoluteAmount: number | null;
    undercutRelativeAmount: number | null;
    undercutReferenceListingPosition: number | null;
    compListingMode: AutoPricingCompListingMode | null;
    skipCompListing: boolean | null;
    compListingFloor: number | null;
    compListingCeiling: number | null;
    compListingQuantityScoreAdjustmentEnabled: boolean | null;
    compListingQuantityScoreAdjustmentOverrides: { [key: string]: number; } | null;
    compListingQuantityScoreAdjustmentOverrideJson: string | null;
    compListingOnlyForSameZoneEnabled: boolean | null;
    compListingOnlyForSelectedSectionsEnabled: boolean | null;
    compListingExcludeFanInventory: boolean | null;
    compListingExcludeDefects: boolean | null;
    compListingIncludeUnmappedInventory: boolean | null;
    compListingSelectedSectionSettings: SelectedSectionSettings | null;
    compListingQuantityFilters: CompListingQuantity | null;
    skipAdvancePricing: boolean | null;
    circuitBreakerRelativeCeiling: number | null;
    circuitBreakerRelativeFloor: number | null;
    circuitBreakerMaxDiscountVelocityPercent: number | null;
    circuitBreakerMaxDiscountVelocityTicksInHours: number | null;
    circuitBreakerMinCompListingCount: number | null;
    velocityCircuitBreakerStateRowVersion: number | null;
    outlierMode: AutoPricingOutlierMode | null;
    outlierStandardDeviations: number | null;
    outlierKthLowestLimit: number | null;
    outlierKthLowestLimitRelativeSpacing: number | null;
    outlierKthLowestLimitAbsoluteSpacing: number | null;
    currencyCode: string | null;
}

export interface ListingDetailsUpdateInput extends ListingDetailsPricingUpdates {
    id: number;
    rowVersion: number | null;
    adminHoldExpirationDate: string | null;
    adminHoldNotes: string | null;
    marketplaceSeatOverrides: ListingMarketplaceSeatingOverride[];
    splitType: SplitType | null;
    hideSeatsFromMarketplace: boolean | null;
    faceValue: number | null;
    inHandDate: string | null;
    daysBeforeEvent: number | null;
    section: string | null;
    sectionId: number | null;
    row: string | null;
    rowId: number | null;
    internalNotes: string | null;
    ticketTypeRules: TicketTypeOverride | null;
    manualMaxDisplayQuantity: number | null;
    isNoFulfill: boolean | null;
    enableNativeSync: boolean | null;
    seatTraits: ListingNote[] | null;
    delivType: DeliveryType | null;
    updateSalesOfListings: boolean | null;
    pricerSellerUserId: string | null;
    listPrice: number | null;
    allInPrice: number | null;
    buyerUserId: string | null;
    marketplacePriceUpdates: ListingMarketplacePriceUpdateInput[];
    tags: Tag[] | null;
}

export interface ListingMarketplaceSeatingOverride {
    marketplace: Marketplace;
    overrideSection: string | null;
    overrideRow: string | null;
    overrideSeats: string | null;
    overrideRowId: number | null;
    overrideSectionId: number | null;
}

export interface ListingMarketplacePriceUpdateInput {
    listPrice: number | null;
    allInPrice: number | null;
    priceByMarketplace: boolean;
    marketplace: Marketplace;
    markup: number | null;
}

export interface CompListingQuantity {
    exactQuantities: number[];
    greaterThanOrEqualToQuantity: number | null;
}

export interface ValueTupleOfBulkEditPreviewAndListingDetailsAutoPricingSectionUpdatesV2 {
    item1: BulkEditPreview;
    item2: ListingDetailsAutoPricingSectionUpdatesV2;
}

export interface ListingDetailsAutoPricingSectionUpdatesV2 {
    id: number;
    rowVersion: number | null;
    currencyCode: string | null;
    netProceedsFloor: PosFieldOfNullableDecimal | null;
    netProceedsCeiling: PosFieldOfNullableDecimal | null;
    netProceedsFloorAdjustmentType: PricingFloorCeilingAdjustmentType | null;
    netProceedsFloorAdjustmentAmount: number | null;
    netProceedsFloorAdjustmentRelative: boolean | null;
    autoPricingEnabled: PosFieldOfNullableBoolean | null;
    undercutMode: PosFieldOfNullableAutoPricingUndercutMode | null;
    undercutAbsoluteAmount: PosFieldOfNullableDecimal | null;
    undercutRelativeAmount: PosFieldOfNullableDecimal | null;
    undercutReferenceListingPosition: PosFieldOfNullableInteger | null;
    compListingMode: PosFieldOfNullableAutoPricingCompListingMode | null;
    compListingFloor: PosFieldOfNullableDecimal | null;
    compListingCeiling: PosFieldOfNullableDecimal | null;
    compListingQuantityScoreAdjustmentEnabled: PosFieldOfNullableBoolean | null;
    compListingQuantityScoreAdjustmentOverrideJson: PosFieldOfString | null;
    compListingOnlyForSameZoneEnabled: PosFieldOfNullableBoolean | null;
    compListingOnlyForSelectedSectionsEnabled: PosFieldOfNullableBoolean | null;
    compListingExcludeFanInventory: PosFieldOfNullableBoolean | null;
    compListingExcludeDefects: PosFieldOfNullableBoolean | null;
    compListingIncludeUnmappedInventory: PosFieldOfNullableBoolean | null;
    compListingSelectedSectionSettings: PosFieldOfSelectedSectionSettings | null;
    includeExistingSelectedSections: boolean | null;
    venueZoneMapName: string | null;
    deriveCompsFromVenueZoneConfig: boolean | null;
    includeBetterZones: boolean | null;
    rowCompOffset: number | null;
    useDefaultQuantityFilters: boolean | null;
    circuitBreakerRelativeCeiling: PosFieldOfNullableDecimal | null;
    circuitBreakerRelativeFloor: PosFieldOfNullableDecimal | null;
    circuitBreakerMaxDiscountVelocityPercent: PosFieldOfNullableDecimal | null;
    circuitBreakerMaxDiscountVelocityTicksInHours: PosFieldOfNullableLong | null;
    circuitBreakerMinCompListingCount: PosFieldOfNullableInteger | null;
    outlierMode: PosFieldOfNullableAutoPricingOutlierMode | null;
    outlierStandardDeviations: PosFieldOfNullableDecimal | null;
    outlierKthLowestLimit: PosFieldOfNullableInteger | null;
    outlierKthLowestLimitRelativeSpacing: PosFieldOfNullableDecimal | null;
    outlierKthLowestLimitAbsoluteSpacing: PosFieldOfNullableDecimal | null;
    previewMarketPrices: { [key: string]: number; } | null;
}

export interface PosFieldOfNullableDecimal {
    value: number | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableBoolean {
    value: boolean | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableAutoPricingUndercutMode {
    value: AutoPricingUndercutMode | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableInteger {
    value: number | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableAutoPricingCompListingMode {
    value: AutoPricingCompListingMode | null;
    hasChanged: boolean;
}

export interface PosFieldOfString {
    value: string | null;
    hasChanged: boolean;
}

export interface PosFieldOfSelectedSectionSettings {
    value: SelectedSectionSettings | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableLong {
    value: number | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableAutoPricingOutlierMode {
    value: AutoPricingOutlierMode | null;
    hasChanged: boolean;
}

export interface BulkListingPriceCalculationResult {
    listingPriceCalculations: BulkListingPriceCalculation[];
    compListings: CompListing[];
    sellerCompListings: CompListing[];
    sellerAccountPosListingIds: number[];
}

export interface BaseListingPriceCalculation {
    listingId: number;
    websitePrice: UiMoney | null;
    autoPricingResultType: AutoPricingResultType | null;
    autoPricingConstraintType: AutoPricingConstraintType | null;
    errorMessage: string | null;
    underCutChosenListingId: number | null;
    /** Computed Floor, includes premiums */
    cmpFlr: UiMoney | null;
    /** Computed Ceiling, includes premiums */
    cmpCeil: UiMoney | null;
    /** UndercutAbsolute amount */
    udrAbs: number | null;
    /** UndercutRelative amount */
    udrRel: number | null;
    /** UndercutAbsolute Rank Premium */
    udrAbsPrm: number | null;
    /** UndercutRelative Rank Premium */
    udrRelPrm: number | null;
    /** NewPriceIncludeFanInventory - Calculated undercut price including fan inventory listings */
    newPrcInclFanInv: number | null;
    /** UndercutReferenceListingIds - List of listing Ids that were considered for undercutting */
    udrRefLstIds: number[] | null;
    /** UndercutReferencePrice - Calculated price to undercut, based on the undercut reference listings */
    udrRefPrc: UiMoney | null;
    /** SellerAccountPosListingIds - POS Listing Ids that are filtered with the price calculation comp criteria */
    sellerAccountPosListingIds: number[];
}

export interface BulkListingPriceCalculation extends BaseListingPriceCalculation {
    compStubHubListingIds: number[];
    outlierStubHubListingIds: number[];
    sellerCompStubHubListingIds: number[];
}

export interface CompListing {
    listingId: number;
    availableTickets: number | null;
    rowId: number | null;
    section: string | null;
    row: string | null;
    seatFrom: string | null;
    seatTo: string | null;
    sellerNetProceeds: UiMoney | null;
    sellerNetProceedsInUSD: UiMoney | null;
    sellerAllInPrice: UiMoney | null;
    currencyCode: string | null;
    listingNotes: ListingNote[] | null;
    isWithoutOutlier: boolean | null;
    isAnchor: boolean | null;
    isSellerCompListing: boolean | null;
    isFanInventory: boolean | null;
    validPurchaseQuantities: number[];
}

export interface ValueTupleOfInt64OfAndListingPriceCalculationsInEventInput {
    item1: number[];
    item2: ListingPriceCalculationsInEventInput;
}

export interface ListingPriceCalculationsInEventInput {
    compListingSetting: CompListingSettingUpdate;
    underCutSetting: UnderCutSettingUpdate;
    outlierSetting: OutlierSettingUpdate;
    netProceedsFloor: PosFieldOfNetProceedsFloorAdjustment | null;
    netProceedsCeiling: PosFieldOfUiMoney | null;
    rankPremium: PosFieldOfRankPremiumAdjustment | null;
    velocityCircuitBreakerStateMaxRowVersion: number | null;
}

export interface CompListingSettingUpdate {
    mode: PosFieldOfNullableAutoPricingCompListingMode | null;
    selectedSectionSettings: PosFieldOfSelectedSectionSettings | null;
    includeExistingSelectedSectionSettings: PosFieldOfNullableBoolean | null;
    onlyForSelectedSectionsEnabled: PosFieldOfNullableBoolean | null;
    quantityFilters: PosFieldOfCompListingQuantity | null;
    excludeFanInventory: PosFieldOfNullableBoolean | null;
    excludeDefects: PosFieldOfNullableBoolean | null;
    includeUnmappedInventory: PosFieldOfNullableBoolean | null;
}

export interface PosFieldOfCompListingQuantity {
    value: CompListingQuantity | null;
    hasChanged: boolean;
}

export interface UnderCutSettingUpdate {
    mode: PosFieldOfNullableAutoPricingUndercutMode | null;
    underCutAbsoluteAmount: PosFieldOfUiMoney | null;
    underCutRelativeAmount: PosFieldOfNullableDecimal | null;
    referenceListingPosition: PosFieldOfNullableInteger | null;
}

export interface PosFieldOfUiMoney {
    value: UiMoney | null;
    hasChanged: boolean;
}

export interface OutlierSettingUpdate {
    mode: PosFieldOfNullableAutoPricingOutlierMode | null;
    standardDeviations: PosFieldOfNullableDecimal | null;
    outlierLimit: PosFieldOfNullableInteger | null;
    absoluteOutlierSpacing: PosFieldOfUiMoney | null;
    relativeOutlierSpacing: PosFieldOfNullableDecimal | null;
}

export interface PosFieldOfNetProceedsFloorAdjustment {
    value: NetProceedsFloorAdjustment | null;
    hasChanged: boolean;
}

export interface NetProceedsFloorAdjustment {
    relativeAdjustmentType: PricingFloorCeilingAdjustmentType | null;
    absoluteAmount: UiMoney | null;
    relativeAmount: UiMoney | null;
    relativePercentage: number | null;
}

export interface PosFieldOfRankPremiumAdjustment {
    value: RankPremiumAdjustment | null;
    hasChanged: boolean;
}

export interface RankPremiumAdjustment {
    absoluteAmount: UiMoney | null;
    relativePercentage: number | null;
}

export interface ValueTupleOfBulkEditPreviewAndListingPricesUpdateInput {
    item1: BulkEditPreview;
    item2: ListingPricesUpdateInput;
}

export interface ListingPricesUpdateInput {
    id: number;
    listPrice: number | null;
    allInPrice: number | null;
    netProceedsFloor: number | null;
    netProceedsCeiling: number | null;
    autoPricingEnabled: boolean | null;
    marketplacePriceUpdates: ListingMarketplacePriceUpdateInput[];
}

export interface ValueTupleOfBulkEditPreviewAndISetOfMarketplaceAndISetOfMarketplace {
    item1: BulkEditPreview;
    item2: Marketplace[];
    item3: Marketplace[];
}

export interface ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority {
    item1: BulkEditPreview;
    item2: DeliveryType;
    item3: TicketTypePriority[];
}

export interface MergeListingGroupInputList {
    mergeListingGroupInputs: MergeListingGroupInput[];
}

export interface MergeListingGroupInput {
    listingGroupId: string;
    name: string;
    viagogoEventId: number | null;
    viagogoMappingId: string | null;
    desiredActiveListings: number | null;
    minActiveListings: number | null;
    maxActiveListings: number | null;
    targetPercentage: number | null;
    deprioritizedQuantities: string[] | null;
    listingGroupItems: ListingGroupItemInput[];
    groupUndercutSetting: ListingGroupUndercutSetting | null;
    marketplaceSettings: ListingGroupListingMarketplaceSettings | null;
    groupingMethods: ListingGroupingMethods | null;
    /** If true, the listing should pull pricing settings down from the group */
    inheritListingGroupSettings: boolean | null;
    /** If true, the listing should maintain pricing stagger */
    maintainPriceStagger: boolean | null;
}

export interface ListingGroupItemInput {
    listingId: number;
    priority: number;
    groupId: string | null;
    undercutSetting: ListingGroupUndercutSetting | null;
}

export interface ListingGroupListingMarketplaceSettings {
    listingMarketplaceSettings: { [key: string]: ListingMarketplaceSetting; } | null;
}

export interface ListingMarketplaceSetting {
    listingBroadcastStateId: number;
}

export interface ListingGroupingMethods {
    groupingMethods: ListingGroupingMethod[];
}

export interface ListingGroupingMethod {
    groupingOrder: number;
    groupingType: GroupingType;
    groupingValue: string | null;
    numberOfBucket: number | null;
    bucketType: BucketType | null;
}

export enum GroupingType {
    None = "None",
    Zone = "Zone",
    Section = "Section",
    Row = "Row",
    SeatScore = "SeatScore",
    Quantity = "Quantity",
    UnitCost = "UnitCost",
    Custom = "Custom",
}

export enum BucketType {
    None = "None",
    Clusters = "Clusters",
    SameSize = "SameSize",
}

export interface AutoGroupListingV2Input {
    mode: AutoCompAndAutoGroupMode;
    viagogoEventId: number;
    eventListingIds: number[];
    zoneSectionAreaGroupLookupJson: string;
    /** Determines how the row ordinal comps will be determinedjd */
    rowCompOffset: number;
    /** Determines how the RowArea names will be determined */
    rowGroupSetting: RowGroupSetting;
    venueZoneConfigType: VenueZoneConfigType;
    combineCornersAndEnds: boolean;
    rowCompOverrides: RowCompOverride[];
    useCustomRank: boolean;
    mergeListingGroupInputs: MergeListingGroupInput[] | null;
}

export enum AutoCompAndAutoGroupMode {
    AutoComp = "AutoComp",
    AutoGroup = "AutoGroup",
    AutoCompAndAutoGroup = "AutoCompAndAutoGroup",
}

export enum RowGroupSetting {
    SingleTwoToFiveSixPlus = "SingleTwoToFiveSixPlus",
    OneToFiveSixPlus = "OneToFiveSixPlus",
    OneToTenElevenPlus = "OneToTenElevenPlus",
    AllRows = "AllRows",
    OneTwoToFiveSixToTwelveThirteenPlus = "OneTwoToFiveSixToTwelveThirteenPlus",
}

export enum VenueZoneConfigType {
    Amphitheater = "Amphitheater",
    ConcertsSectionsBehindStage = "ConcertsSectionsBehindStage",
    SportsOrConcertsWith360 = "SportsOrConcertsWith360",
}

export interface RowCompOverride {
    rowOrdinalFrom: number;
    rowOrdinalTo: number;
    offsetOverride: number;
}

export interface ValueTupleOfBulkEditPreviewAndIListOfCommission {
    item1: BulkEditPreview;
    item2: Commission[];
}

export interface ValueTupleOfBulkEditPreviewAndIListOfListingNote {
    item1: BulkEditPreview;
    item2: ListingNote[];
}

export interface TicketBarcodeResponse {
    ticketId: number;
    barcode: string | null;
    section: string | null;
    row: string | null;
    seat: string | null;
}

export interface TicketBarcode {
    ticketId: number;
    barcode: string;
    section: string | null;
    row: string | null;
    seat: string | null;
}

export interface ImportFileResult {
    startedInBackground: boolean;
    success: boolean;
    successCount: number;
    failureCount: number;
    warningCount: number;
    totalCount: number;
    errors: string[];
    warnings: string[];
    errorRows: number[];
}

export interface ValueTupleOfBulkEditPreviewAndIDictionaryOfLongAndListOfInteger {
    item1: BulkEditPreview;
    item2: { [key: string]: number[]; };
}

export interface BulkEditListingGroupSettingsInput {
    viagogoEventId: number | null;
    desiredActiveListings: number | null;
    deprioritizedQuantities: string[] | null;
    groupUndercutSetting: ListingGroupUndercutSetting | null;
    marketplaceSettings: ListingGroupListingMarketplaceSettings | null;
    autoPricingInputs: AutoPricingInputs | null;
    listingGroupListingIds: number[] | null;
}

export interface AutoPricingInputs {
    autoPriceFrequency: number | null;
    scoreModel: ScoreModel | null;
    venueZoneConfigType: VenueZoneConfigType | null;
    venueZoneOverrideId: number | null;
    autoPricingDefaultQuantityFiltersJson: string | null;
    undercutMode: AutoPricingUndercutMode | null;
    undercutAbsoluteAmount: number | null;
    undercutRelativeAmount: number | null;
    undercutReferenceListingPosition: number | null;
    compListingMode: AutoPricingCompListingMode | null;
    compListingFloor: number | null;
    compListingCeiling: number | null;
    compListingQuantityScoreAdjustmentEnabled: boolean | null;
    compListingQuantityScoreAdjustmentOverrides: { [key: string]: number; } | null;
    compListingQuantityScoreAdjustmentOverrideJson: string | null;
    compListingOnlyForSameZoneEnabled: boolean | null;
    compListingOnlyForSelectedSectionsEnabled: boolean | null;
    compListingExcludeFanInventory: boolean | null;
    compListingExcludeDefects: boolean | null;
    compListingIncludeUnmappedInventory: boolean | null;
    compListingSelectedSectionSettings: SelectedSectionSettings | null;
    compListingQuantityFilters: CompListingQuantity | null;
    circuitBreakerRelativeCeiling: number | null;
    circuitBreakerRelativeFloor: number | null;
    circuitBreakerMaxDiscountVelocityPercent: number | null;
    circuitBreakerMaxDiscountVelocityTicksInHours: number | null;
    circuitBreakerMinCompListingCount: number | null;
    outlierMode: AutoPricingOutlierMode | null;
    outlierStandardDeviations: number | null;
    outlierKthLowestLimit: number | null;
    outlierKthLowestLimitRelativeSpacing: number | null;
    outlierKthLowestLimitAbsoluteSpacing: number | null;
}

export enum ScoreModel {
    Model1 = "Model1",
    Model2 = "Model2",
    Model3 = "Model3",
    Model4 = "Model4",
    VenueGeometry = "VenueGeometry",
    MergedVenueGeometry = "MergedVenueGeometry",
    Bezier = "Bezier",
    AdvancedVenueGeometry = "AdvancedVenueGeometry",
    BespokeBaseball = "BespokeBaseball",
    SqsClassifier = "sqsClassifier",
}

export interface BulkEditLog {
    entityType: ActionOutboxEntityType;
    bulkActionType: BulkActionType;
    bulkProcessingId: string;
    payload: BulkEditLogPayload;
    sellerUserId: string | null;
    startDate: string;
    endDate: string | null;
}

/** Enum used when saving bulk action logs and then retrieving them by action type for display. */
export enum BulkActionType {
    GroupListings = "GroupListings",
    ChangeEvent = "ChangeEvent",
    AdminHold = "AdminHold",
    MarkAsFulfilled = "MarkAsFulfilled",
    CancelPurchase = "CancelPurchase",
    DeleteTicketGroup = "DeleteTicketGroup",
    UploadPurchaseFile = "UploadPurchaseFile",
    BackfillDeliverySettings = "BackfillDeliverySettings",
    ConvertPurchasePayment = "ConvertPurchasePayment",
    WasteTickets = "WasteTickets",
    MergeSelectedListings = "MergeSelectedListings",
    UploadSeatSaversFile = "UploadSeatSaversFile",
    UpdateBroadcastSettings = "UpdateBroadcastSettings",
    UpdatePrices = "UpdatePrices",
    UpdateTagValues = "UpdateTagValues",
    UpdatePriceFloorCeiling = "UpdatePriceFloorCeiling",
    UpdateAutoPricingSettings = "UpdateAutoPricingSettings",
    UpdateGeneralSettings = "UpdateGeneralSettings",
    UpdateMarketplaceSeating = "UpdateMarketplaceSeating",
    UpdateTicketTypeRules = "UpdateTicketTypeRules",
    UpdateBuyerCommissions = "UpdateBuyerCommissions",
    UpdateInternalNotes = "UpdateInternalNotes",
    UpdateIsNoFulfill = "UpdateIsNoFulfill",
    UpdateDeliveryType = "UpdateDeliveryType",
    UpdateSeatTraits = "UpdateSeatTraits",
    UpdateMarketplacePrices = "UpdateMarketplacePrices",
    UpdatePurchaseCurrency = "UpdatePurchaseCurrency",
    UpdateBarcodes = "UpdateBarcodes",
    UpdateSaleFulfiller = "UpdateSaleFulfiller",
    DeleteSeatSavers = "DeleteSeatSavers",
    RemovePredelivery = "RemovePredelivery",
    ResetMergedListings = "ResetMergedListings",
    UngroupListings = "UngroupListings",
    EditListingGroupSetting = "EditListingGroupSetting",
    MarkPurchaseAsPaid = "MarkPurchaseAsPaid",
    MarkSaleAsPaid = "MarkSaleAsPaid",
    CancelSale = "CancelSale",
    AdjustCost = "AdjustCost",
    ReturnTicket = "ReturnTicket",
    SplitListings = "SplitListings",
}

export interface BulkEditLogPayload {
    method: string;
    latestStep: BulkEditStep;
    errors: string[];
    warnings: string[];
    entitiesByType: { [key in keyof typeof ActionOutboxEntityType]?: BulkEditCountWithId; };
    filterQuery: EntityWithTicketsQuery | null;
    /** Free form dict to save all params that we can */
    params: any | null;
    startDate: string;
    endDate: string;
}

export interface BulkEditCountWithId extends BulkEditCount {
    skipCount: number;
    idsToBeProcessed: string[];
    idsSkipped: string[];
    idsSuccessful: string[];
    idsFailed: string[];
    idsWarning: string[];
    idsToRetry: string[];
}

export interface BulkEditLogQuery {
    startDates: DateTimeRangeWithRelative | null;
    entityType: ActionOutboxEntityType | null;
    bulkActionTypes: BulkActionType[];
    timezoneOffsetMins: number | null;
}

export interface PurchaseOrderQuery extends EntityWithTicketsQuery {
    ticketGroupIds: number[] | null;
    purchaseMonths: string[] | null;
    /** Payment method type */
    paymentMethod: PurchasePaymentMethodType | null;
    paymentStatus: PurchasePaymentStatus | null;
    paymentDates: DateTimeRangeWithRelative | null;
    totalCostHigh: number | null;
    totalCostLow: number | null;
    deliveryType: DeliveryType | null;
    purchaseOrderState: PurchaseOrderState | null;
    /** This is only used to filter on the frontend application. */
    viewMode: PurchaseViewMode | null;
    /** Exact payment method used */
    paymentMethodId: number | null;
    paymentCurrencyCodes: string[] | null;
    isConsignment: boolean | null;
}

export enum PurchaseViewMode {
    TileView = "Tile View",
    FlattenedView = "Flattened View",
    EventTileView = "Event Tile View",
}

export interface ValueTupleOfBulkEditPreviewAndPosFieldOfNullableGuid {
    item1: BulkEditPreview;
    item2: PosFieldOfNullableGuid;
}

export interface PosFieldOfNullableGuid {
    value: string | null;
    hasChanged: boolean;
}

export interface ValueTupleOfBulkEditPreviewAndString {
    item1: BulkEditPreview;
    item2: string;
}

export interface ValueTupleOfBulkEditPreviewAndNullableSaleCancellationReason {
    item1: BulkEditPreview;
    item2: SaleCancellationReason | null;
}

export enum BulkChangePriceMode {
    Increase = "Increase",
    Decrease = "Decrease",
    Override = "Override",
}

export enum BulkAdjustCostField {
    UnitCost = "UnitCost",
    TotalTicketCost = "TotalTicketCost",
}

export interface SaleQuery extends EntityWithTicketsQuery {
    soldOnMarketplace: Marketplace | null;
    saleStatus: PointOfSaleSaleStatus | null;
    saleStatuses: PointOfSaleSaleStatus[] | null;
    fulfillmentStates: PointOfSaleFulfillmentState[] | null;
    paymentState: PointOfSalePaymentState | null;
    marketplacePaymentState: MarketplacePaymentState | null;
    paymentReceived: boolean | null;
    paymentReferenceId: string | null;
    paymentDates: DateTimeRangeWithRelative | null;
    fulfillmentDates: DateTimeRangeWithRelative | null;
    cancellationDates: DateTimeRangeWithRelative | null;
    saleDates: DateTimeRangeWithRelative | null;
    ticketType: TicketType | null;
    fulfillerSellerUserId: string | null;
    listingInsertBy: string | null;
    isNoFulfill: boolean | null;
    /** This is only used to filter on the frontend application. */
    viewMode: SalesViewMode | null;
}

export enum SalesViewMode {
    TileView = "Tile View",
    FlattenedView = "Flattened View",
}

export interface ValueTupleOfBulkEditPreviewAndSaleInput {
    item1: BulkEditPreview;
    item2: SaleInput;
}

export interface SaleInput {
    saleId: number;
    ticketType: PosFieldOfNullableTicketType | null;
    fulfillerSellerUserId: PosFieldOfNullableGuid | null;
    internalNotes: PosFieldOfString | null;
    tags: PosFieldArrayOfTag | null;
    lineItems: PosFieldArrayOfSaleLineItem | null;
    marketplacePaymentLines: PosFieldArrayOfSiteMarketplacePaymentLineInput | null;
    paymentReceived: PosFieldOfNullableBoolean | null;
    paymentReferenceId: PosFieldOfString | null;
    lastPaymentDate: PosFieldOfNullableDateTime | null;
    paymentAmountReceived: PosFieldOfNullableDecimal | null;
    paymentCurrency: PosFieldOfString | null;
    disableAutoSourcing: PosFieldOfNullableBoolean | null;
    isNoFulfill: PosFieldOfNullableBoolean | null;
    commissions: PosFieldArrayOfCommission | null;
    cancellationReason: PosFieldOfNullableSaleCancellationReason | null;
}

export interface PosFieldOfNullableTicketType {
    value: TicketType | null;
    hasChanged: boolean;
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfTag {
    value: Tag[] | null;
    hasChanged: boolean;
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfSaleLineItem {
    value: SaleLineItem[] | null;
    hasChanged: boolean;
}

export interface SaleLineItem {
    id: number;
    saleId: number;
    status: SaleLineItemStatus;
    costType: SaleCostType;
    costDate: string | null;
    dueDate: string | null;
    cost: number;
    currencyCode: string;
    description: string | null;
    saleLineItemChargeReason: SaleLineItemChargeReason | null;
    saleLineItemCreditReason: SaleLineItemCreditReason | null;
    marketplacePaymentLineId: number | null;
    isMarketplacePaymentLocked: boolean | null;
    paymentReceived: boolean | null;
    paymentReferenceId: string | null;
}

export enum SaleLineItemStatus {
    Paid = "Paid",
    Unpaid = "Unpaid",
}

export enum SaleCostType {
    Charge = "Charge",
    Credit = "Credit",
    Proceeds = "Proceeds",
    Taxes = "Taxes",
}

export enum SaleLineItemChargeReason {
    CancelledProceeds = "CancelledProceeds",
    DroppedOrderPenalty = "DroppedOrderPenalty",
    Compensation = "Compensation",
    Other = "Other",
}

export enum SaleLineItemCreditReason {
    ReversedPenalty = "ReversedPenalty",
    ReversedCharge = "ReversedCharge",
    ProceedRepayment = "ProceedRepayment",
    Other = "Other",
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfSiteMarketplacePaymentLineInput {
    value: SiteMarketplacePaymentLineInput[] | null;
    hasChanged: boolean;
}

export interface SiteMarketplacePaymentLineInput {
    marketplacePaymentLineId: number | null;
    marketplacePaymentId: number | null;
    externalPaymentId: string;
    externalPaymentLineId: string;
    externalSaleId: string;
    saleId: number | null;
    currency: string;
    amount: number;
    isCredit: boolean;
    paymentLineType: MarketplacePaymentLineType;
    paymentState: MarketplacePaymentState;
    paymentDate: string | null;
    receivedDate: string | null;
    isLocked: boolean | null;
}

export enum MarketplacePaymentLineType {
    Credit = "Credit",
    Proceeds = "Proceeds",
    FullPrice = "FullPrice",
    SellerFee = "SellerFee",
    Penalty = "Penalty",
    AlternativeTickets = "AlternativeTickets",
    OrderNotFulfilled = "OrderNotFulfilled",
    CancelledEvent = "CancelledEvent",
    WitheldFunds = "WitheldFunds",
    LastMinuteSalesLateDelivery = "LastMinuteSalesLateDelivery",
    ExpiredShippingLabel = "ExpiredShippingLabel",
    DeliveryMethodChange = "DeliveryMethodChange",
    BuyerDeniedEntry = "BuyerDeniedEntry",
    WrongTicketsReturnShippingCost = "WrongTicketsReturnShippingCost",
    EarlyShippingLabelGeneration = "EarlyShippingLabelGeneration",
    WrongTrackingNumber = "WrongTrackingNumber",
    ExcessiveFailureRate = "ExcessiveFailureRate",
    SellerError = "SellerError",
    AlternativeTicketsBuyerCompensation = "AlternativeTicketsBuyerCompensation",
    RAGSellerFaultNoResponse = "RAGSellerFaultNoResponse",
    OverchargedSeller = "OverchargedSeller",
    ShippingRefund = "ShippingRefund",
    SellerRelationship = "SellerRelationship",
    RAGDeliveryDispute = "RAGDeliveryDispute",
    CSError = "CSError",
    LMSError = "LMSError",
    TaxRefund = "TaxRefund",
    Other = "Other",
    Charge = "Charge",
}

export interface PosFieldOfNullableDateTime {
    value: string | null;
    hasChanged: boolean;
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfCommission {
    value: Commission[] | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableSaleCancellationReason {
    value: SaleCancellationReason | null;
    hasChanged: boolean;
}

export interface SalesFulfillerBackfillQuery {
    venueIds: number[] | null;
    eventId: number | null;
    fulfillerSellerUserId: string;
}

export interface ValueTupleOfBulkEditPreviewAndGuid {
    item1: BulkEditPreview;
    item2: string;
}

export interface ValueTupleOfIListOfIntegerAndIListOfInteger {
    item1: number[];
    item2: number[];
}

export interface BaseClientResponse {
    success: boolean;
    errorMessage: string | null;
    validationErrors: ValidationError[] | null;
}

export interface ValidationError {
    field: string;
    message: string;
    code: string;
}

export interface SponsoredListingsCampaignInput {
    /** The Viagogo Event ID associated with this campaign.
NOTE: unmapped event are not allowed to be boosted. */
    eventId: number;
    campaignId: number;
    dateRange: DateTimeRange;
    campaignName: PosFieldOfString;
    recurringFlightBudget: PosFieldOfNullableDecimal;
    flightDuration: PosFieldOfNullableFlightDuration;
    biddingMode: PosFieldOfNullableBiddingMode;
    targetTicketClassIds: PosFieldOfIListOfInteger;
    editBudgetForActiveFlightOnly: PosFieldOfNullableBoolean;
}

export interface PosFieldOfNullableFlightDuration {
    value: FlightDuration | null;
    hasChanged: boolean;
}

export enum FlightDuration {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
}

export interface PosFieldOfNullableBiddingMode {
    value: BiddingMode | null;
    hasChanged: boolean;
}

export enum BiddingMode {
    Manual = "Manual",
    Automatic = "Automatic",
}

export interface PosFieldOfIListOfInteger {
    value: number[] | null;
    hasChanged: boolean;
}

export interface UpdateCampaignStateClientResponse extends BaseClientResponse {
}

export enum AdCampaignState {
    Active = "Active",
    Paused = "Paused",
    Deleted = "Deleted",
}

export interface SponsoredListingsCampaign {
    /** The Viagogo Event ID associated with this campaign.
NOTE: unmapped event are not allowed to be boosted. */
    eventId: number;
    performerId: number | null;
    campaignName: string;
    campaignId: number;
    totalBudget: number | null;
    totalSpend: number | null;
    baseBid: number | null;
    maxBid: number | null;
    recurringFlightBudget: number | null;
    flightDuration: FlightDuration | null;
    dateRange: DateTimeRange;
    biddingMode: BiddingMode;
    targetTicketClassIds: number[] | null;
    campaignState: AdCampaignState;
    currencyCode: string;
    activeFlight: SponsoredListingsFlight | null;
    campaignFlightIds: number[] | null;
    adGroups: SponsoredListingsAdGroup[] | null;
    flights: SponsoredListingsFlight[] | null;
}

export interface SponsoredListingsFlight {
    flightId: number;
    dateRange: DateTimeRange;
    flightBudget: number;
    flightSpend: number | null;
    baseBid: number | null;
    maxBid: number | null;
    pacingOption: FlightPacingOption | null;
    isCurrent: boolean;
}

export enum FlightPacingOption {
    PaceToEndOfFlight = "PaceToEndOfFlight",
    ASAP = "ASAP",
}

export interface SponsoredListingsAdGroup {
    adGroupId: number;
    name: string;
    state: AdGroupState;
}

export enum AdGroupState {
    Active = "Active",
    Paused = "Paused",
    Deleted = "Deleted",
}

export interface BoostedSale {
    saleId: number;
    posEventId: string;
    adCampaignFlightId: number;
    currencyCode: string;
    listingId: number | null;
    originatedFromListingId: number | null;
    totalCost: number | null;
    totalNetProceeds: number;
}

export interface CatalogResults {
    events: { [key: string]: EventWithData; };
    performers: { [key: string]: Performer; };
    venues: { [key: string]: Venue; };
    viagIdToLatestIdLookup: { [key: string]: string; };
    posIdToViagIdLookup: { [key: string]: string; };
    countries: { [key: string]: Country; };
    purchaseCount: number;
}

export interface Country {
    code: string | null;
    name: string | null;
}

export interface CatalogEntityMetricsResultsOfSaleMetrics {
    maxRowVersion: number | null;
    events: { [key: string]: SaleMetrics; };
    performers: { [key: string]: SaleMetrics; };
    venues: { [key: string]: SaleMetrics; };
    usedCache: boolean | null;
    cacheStale: boolean | null;
    cacheStaleTimeMs: number | null;
    missingPosEventIdsCount: number | null;
    top100MissingPosEventIds: string[] | null;
    metricsDif: { [key: string]: any; } | null;
    timeDif: { [key: string]: number; } | null;
}

export interface CatalogSaleMetricsResults extends CatalogEntityMetricsResultsOfSaleMetrics {
}

export interface SaleMetrics {
    /** Sold Ticket Quantity */
    qtySold: number;
    /** Unfulfilled Sales */
    saleUnfilled: number;
    /** Total net proceeds of sold tickets */
    netProcs: number | null;
    /** Total cost */
    ttlCst: number | null;
    currency: string | null;
    /** Margin */
    marg: number | null;
    tags: Tag[] | null;
}

export interface CatalogEntityMetricsResultsOfTicketGroupMetrics {
    maxRowVersion: number | null;
    events: { [key: string]: TicketGroupMetrics; };
    performers: { [key: string]: TicketGroupMetrics; };
    venues: { [key: string]: TicketGroupMetrics; };
    usedCache: boolean | null;
    cacheStale: boolean | null;
    cacheStaleTimeMs: number | null;
    missingPosEventIdsCount: number | null;
    top100MissingPosEventIds: string[] | null;
    metricsDif: { [key: string]: any; } | null;
    timeDif: { [key: string]: number; } | null;
}

export interface CatalogTicketGroupMetricsResults extends CatalogEntityMetricsResultsOfTicketGroupMetrics {
}

export interface TicketGroupMetrics {
    /** Total Ticket Quantity */
    tktQty: number;
    /** Total cost */
    ttlCst: number | null;
    currency: string | null;
    tags: Tag[] | null;
}

export interface EventGroupingQuery {
    groupingType: EventGroupingType;
    searchText: string | null;
    sortBy: EventGroupingSortBy | null;
    isSortDescending: boolean | null;
}

export enum EventGroupingType {
    Performer = "Performers",
    Venue = "Venues",
}

export enum EventGroupingSortBy {
    Name = "Name",
}

export interface EventSearchQuery {
    searchText: string | null;
    performerId: number | null;
    venueId: number | null;
    timeFrame: EventTimeFrameFilter | null;
}

export interface CatalogEntityMetricsResultsOfListingMetrics {
    maxRowVersion: number | null;
    events: { [key: string]: ListingMetrics; };
    performers: { [key: string]: ListingMetrics; };
    venues: { [key: string]: ListingMetrics; };
    usedCache: boolean | null;
    cacheStale: boolean | null;
    cacheStaleTimeMs: number | null;
    missingPosEventIdsCount: number | null;
    top100MissingPosEventIds: string[] | null;
    metricsDif: { [key: string]: any; } | null;
    timeDif: { [key: string]: number; } | null;
}

export interface CatalogListingMetricsResults extends CatalogEntityMetricsResultsOfListingMetrics {
    eventsDetailed: { [key: string]: ListingDetailedMetrics; };
}

export interface ListingMetrics {
    /** Total Ticket Quantity */
    tktQty: number;
    /** Sold Ticket Quantity */
    soldQty: number;
    unsoldQty: number;
    listQty: number;
    /** Unlisted ticket quantity */
    unlistQty: number;
    currency: string;
    /** Total cost of all tickets */
    ttlCst: number;
    /** Total cost of sold tickets */
    soldCst: number;
    /** Total cost of unsold tickets */
    unsoldCst: number;
    /** Total list price of all tickets */
    ttlListPrc: number;
    /** Total list price of unsold tickets */
    ttlUnsoldListPrc: number;
    /** Total net proceeds of sold tickets */
    netProcs: number;
    /** Total gross profit of sold tickets, i.e. SumNetProcs - SumSoldCst */
    pandL: number;
    tags: Tag[] | null;
}

export interface ListingDetailedMetrics extends ListingMetrics {
    /** Sell through rate */
    str: number;
    /** Revenue */
    rvn: number;
    /** Lift percentage */
    liftPerc: number;
    /** Average ticket price */
    atp: number;
    listedATP: number;
    /** Last price updated date */
    priceUpdatedOn: string | null;
}

export interface ListingMetricsInput {
    totalTicketQuantity: number | null;
    totalSoldQuantity: number | null;
    totalUnsoldQuantity: number | null;
    totalListedQuantity: number | null;
    totalUnlistedQuantity: number | null;
    currencyCode: string | null;
    /** Total cost of all tickets */
    totalCost: number | null;
    /** Total cost of sold tickets */
    totalSoldCost: number | null;
    /** Total cost of unsold tickets */
    totalUnsoldCost: number | null;
    /** Total list price of all tickets */
    totalListPrice: number | null;
    /** Total value of all listed tickets */
    totalListedValue: number | null;
    /** Total list price of unsold tickets */
    totalUnsoldListPrice: number | null;
    /** Total net proceeds of sold tickets */
    totalNetProceeds: number | null;
    /** Total gross profit of sold tickets */
    totalGrossProfit: number | null;
}

export interface ValueTupleOfEventAndVenueAndPerformer {
    item1: Event;
    item2: Venue;
    item3: Performer;
}

export interface EventMappingRequest {
    eventName: string;
    eventDate: string;
    isEventDateConfirmed: boolean | null;
    eventNote: string | null;
    venueName: string;
    city: string;
    stateProvince: string;
    countryCode: string;
}

export interface UpcomingOnSalesResult {
    catalog: CatalogResults;
    marketplaceEventInfos: { [key: string]: SellerEventMarketplaceEventInfo[]; };
}

export interface SellerEventMarketplaceEventInfo {
    viagogoEventId: number | null;
    marketplace: Marketplace;
    mappedEventId: string | null;
    websiteEventId: string | null;
    eventIdOverride: string | null;
    eventMappingId: string | null;
}

export interface OnSaleEventQuery {
    onSaleDates: DateTimeRangeWithRelative | null;
    performerIds: number[] | null;
    venueIds: number[] | null;
    countryCodes: string[] | null;
    stateProvinceIds: number[] | null;
    cityIds: number[] | null;
    topLevelCategories: TopLevelCategory[] | null;
    parentCategories: number[] | null;
    timezoneOffsetMins: number | null;
    viewMode: OnSaleEventViewMode | null;
    searchText: string | null;
    eventIds: number[] | null;
    listingQtyRange: NumericRange | null;
    ticketQtyRange: NumericRange | null;
    visitsL1HRange: NumericRange | null;
    visitsL24HRange: NumericRange | null;
    visitsL3DRange: NumericRange | null;
    visitsL7DRange: NumericRange | null;
    transL1HRange: NumericRange | null;
    transL24HRange: NumericRange | null;
    transL3DRange: NumericRange | null;
    transL7DRange: NumericRange | null;
    priceMinRange: NumericRange | null;
    priceP25Range: NumericRange | null;
    priceP50Range: NumericRange | null;
}

export enum OnSaleEventViewMode {
    MetricView = "Metric View",
}

export interface OnSaleEventMetrics {
    /** Event ID.
             */
    eId: number;
    eventVisits: OnSaleEventCountMetrics | null;
    eventTransactions: OnSaleEventCountMetrics | null;
    /** Min UnitNetProceeds
             */
    minUNP: number;
    /** P25 UnitNetProceeds
             */
    p25UNP: number;
    /** P50 UnitNetProceeds
             */
    p50UNP: number;
    /** Listing Count
             */
    ltgCnt: number;
    /** Ticket Count
             */
    tktCnt: number;
    /** Recent visits bucket.
             */
    vstBkt: number[];
    /** Recent visits ordinal index.
             */
    vstIdx: number;
}

export interface OnSaleEventCountMetrics {
    lastHour: number;
    lastDay: number;
    lastThreeDays: number;
    lastSevenDays: number;
}

export interface EventAttributes {
    eventId: number;
    inferredPrimary: string | null;
}

export interface CategoryResult {
    categoryId: number;
    imageUrl: string | null;
    description: string | null;
}

export interface CatalogResultsSlim {
    events: Event[];
    venues: Venue[];
    performers: Performer[];
    countries: Country[];
}

export interface CatalogCounts {
    entityCnts: EventEntityCounts[];
    /** Reason for this is a Purchase can include in multiple events, while
multiple events can include multiple purchases, so the count is for the
whole catalog, not per event like listings or sales */
    purchaseCount: number;
    usedCache: boolean | null;
    cacheStale: boolean | null;
    cacheStaleTimeMs: number | null;
    countDif: { [key: string]: any; } | null;
    timeDif: { [key: string]: number; } | null;
    missingPosEventIdsCount: number | null;
    top100MissingPosEventIds: string[] | null;
}

export interface InsertCatchUpModeEventIdsMapRequest {
    catchUpModeSource: CatchUpModeSource;
    eventIds: string[];
}

export enum CatchUpModeSource {
    InventoryEvents = "InventoryEvents",
    OnSaleEvents = "OnSaleEvents",
}

export interface CatchUpModeEventIdsMapResponse {
    mapId: string;
    catchUpModeSource: CatchUpModeSource;
    eventIdsJson: string;
    insertDate: string;
}

export interface ClientLogRequest {
    logLevel: LogLevel;
    applicationSource: string;
    errorId: string | null;
    error: string;
    pageUrl: string;
    componentStack: string | null;
    timestamp: string;
    additionalInfo: { [key: string]: any; } | null;
}

export enum LogLevel {
    Trace = "Trace",
    Verbose = "Verbose",
    Information = "Information",
    Warning = "Warning",
    Error = "Error",
    Critical = "Critical",
    None = "None",
}

export interface StopwatchLogEntry {
    applicationSource: string;
    logId: string | null;
    message: string;
    pageUrl: string;
    startTime: string;
    endTime: string;
    totalDurationMs: number;
    stopGaps: { [key: string]: StopwatchStopGap; };
    hasGrpcCacheFeature: boolean | null;
    usedJSHeapSize: number | null;
    totalJSHeapSize: number | null;
    jsHeapSizeLimit: number | null;
    browserCap: BrowserCap | null;
}

export interface StopwatchStopGap {
    name: string;
    time: string;
    logKey: string | null;
    browserCap: BrowserCap | null;
    usedJSHeapSize: number | null;
    totalJSHeapSize: number | null;
    jsHeapSizeLimit: number | null;
}

export interface BrowserCap {
    estimatedCpuLoad: EstimatedCpuLoad | null;
    estimatedNetworkSpeed: NetworkSpeed | null;
    domContentLoadedMs: number | null;
    loadCompleteMs: number | null;
    renderTimeMs: number | null;
    hardwareConcurrency: number | null;
    browserAgent: string | null;
}

export enum EstimatedCpuLoad {
    Unknown = "Unknown",
    Low = "Low",
    Medium = "Medium",
    High = "High",
}

export enum NetworkSpeed {
    Unknown = "Unknown",
    Slow = "Slow",
    Moderate = "Moderate",
    Fast = "Fast",
}

export enum CommandOptionType {
    NavigateHome = "NavigateHome",
    NavigateInventory = "NavigateInventory",
    NavigateSales = "NavigateSales",
    NavigatePurchases = "NavigatePurchases",
    NavigatePayments = "NavigatePayments",
    NavigateReports = "NavigateReports",
    NavigateSettings = "NavigateSettings",
    ToggleTheme = "ToggleTheme",
    ToggleSelectionMode = "ToggleSelectionMode",
    SelectAll = "SelectAll",
    ListingBulkEditListingGroupSettings = "ListingBulkEditListingGroupSettings",
    ListingsGroupListings = "ListingsGroupListings",
    ListingBulkEditMoveToGroup = "ListingBulkEditMoveToGroup",
    ListingBulkEditUngroupListings = "ListingBulkEditUngroupListings",
    ListingBulkEditAddTags = "ListingBulkEditAddTags",
    ListingBulkEditRemoveTags = "ListingBulkEditRemoveTags",
    ListingBroadcastListing = "ListingBroadcastListing",
    ListingUnbroadcastListing = "ListingUnbroadcastListing",
    ListingBulkEditAddHold = "ListingBulkEditAddHold",
    ListingBulkEditRemoveHold = "ListingBulkEditRemoveHold",
    ListingBulkEditIncreasePrice = "ListingBulkEditIncreasePrice",
    ListingBulkEditDecreasePrice = "ListingBulkEditDecreasePrice",
    ListingBulkEditAdjustFloor = "ListingBulkEditAdjustFloor",
    ListingBulkEditAdjustCeiling = "ListingBulkEditAdjustCeiling",
    ListingBulkEditAutoPricingSettings = "ListingBulkEditAutoPricingSettings",
    ListingBulkEditUpdateMarketplacePrices = "ListingBulkEditUpdateMarketplacePrices",
    ExpandAll = "ExpandAll",
    CollapseAll = "CollapseAll",
    ListingCatchupMode = "ListingCatchupMode",
    ListingBulkEditChangeEvent = "ListingBulkEditChangeEvent",
    ListingBulkEditTicketTypeRule = "ListingBulkEditTicketTypeRule",
    ListingBulkEditCommissionAction = "ListingBulkEditCommissionAction",
    ListingBulkEditMarketplaceSeating = "ListingBulkEditMarketplaceSeating",
    ListingBulkEditRemovePredelivery = "ListingBulkEditRemovePredelivery",
    ListingBulkEditAutoFulfill = "ListingBulkEditAutoFulfill",
    ListingBulkUpdateBarcodes = "ListingBulkUpdateBarcodes",
    ListingBulkEditDeliveryType = "ListingBulkEditDeliveryType",
    ListingBulkEditInternalNotes = "ListingBulkEditInternalNotes",
    ListingBulkEditUpdateListingSettings = "ListingBulkEditUpdateListingSettings",
    ListingBulkEditSeatTraits = "ListingBulkEditSeatTraits",
    ListingBulkEditWasteTickets = "ListingBulkEditWasteTickets",
    ListingBulkEditDeleteSeatSavers = "ListingBulkEditDeleteSeatSavers",
    ListingExportListing = "ListingExportListing",
    ListingBulkReturnTicket = "ListingBulkReturnTicket",
    SalesBulkEditDeallocate = "SalesBulkEditDeallocate",
    SalesBulkEditReject = "SalesBulkEditReject",
    SalesBulkUpdateBarcodes = "SalesBulkUpdateBarcodes",
    SalesBulkEditCommission = "SalesBulkEditCommission",
    SalesBulkEditAddTags = "SalesBulkEditAddTags",
    SalesBulkEditRemoveTags = "SalesBulkEditRemoveTags",
    SalesBulkEditMarkAsFulfilled = "SalesBulkEditMarkAsFulfilled",
    SalesBulkMarkSaleAsPaid = "SalesBulkMarkSaleAsPaid",
    SalesBulkEditAutoFulfill = "SalesBulkEditAutoFulfill",
    SalesBulkEditInternalNotes = "SalesBulkEditInternalNotes",
    SalesBulkEditGeneralSettings = "SalesBulkEditGeneralSettings",
    SalesExportSales = "SalesExportSales",
    PurchasesBulkAdjustCost = "PurchasesBulkAdjustCost",
    PurchaseBulkCancelPurchase = "PurchaseBulkCancelPurchase",
    PurchasesBulkConvertPurchasePayment = "PurchasesBulkConvertPurchasePayment",
    PurchaseBulkDeleteTicketGroup = "PurchaseBulkDeleteTicketGroup",
    PurchasesBulkEditCommissionAction = "PurchasesBulkEditCommissionAction",
    PurchasesBulkEditAddTag = "PurchasesBulkEditAddTag",
    PurchasesBulkEditRemoveTag = "PurchasesBulkEditRemoveTag",
    PurchasesBulkMarkPurchaseAsPaid = "PurchasesBulkMarkPurchaseAsPaid",
    PurchasesBulkUpdateDeliveryType = "PurchasesBulkUpdateDeliveryType",
    PurchasesBulkUpdateInternalNotes = "PurchasesBulkUpdateInternalNotes",
    PurchasesBulkChangeEvent = "PurchasesBulkChangeEvent",
    PurchasesBulkUpdatePurhcaseCurrencyCode = "PurchasesBulkUpdatePurhcaseCurrencyCode",
    PurchasesBulkUpdatePurchaseSettings = "PurchasesBulkUpdatePurchaseSettings",
    PurchasesBulkUpdateSeatTraits = "PurchasesBulkUpdateSeatTraits",
    PurchasesExportPurchases = "PurchasesExportPurchases",
}

export interface ContentData {
    body: string;
}

export interface DocumentUploadInfo {
    entityId: number;
    entityType: ActionOutboxEntityType;
    documentType: DocumentType;
    blobName: string;
    documentId: string;
    contentType: string;
}

export interface PosUiActionResult {
    entityId: number | null;
    entityType: ActionOutboxEntityType | null;
    status: number | null;
    message: string | null;
}

export interface PosUiActionResultWithDataOfUserDocumentLinks extends PosUiActionResult {
    data: UserDocumentLinks | null;
}

export interface DocumentPage {
    id: string;
    documentId: string;
    pageNumber: number;
    thumbUrl: string;
    documentUrl: string;
}

export interface EventListingConstraints {
    eventId: number;
    validListingNoteIds: number[] | null;
    validTicketTypes: number[] | null;
    isSeatRequired: boolean | null;
    validSplitTypes: number[] | null;
}

export interface MarketTransaction {
    listingId: number;
    transactionDateTime: string;
    section: string;
    row: string;
    seatFrom: string;
    seatTo: string;
    quantityPurchased: number;
    sellerUserId: string;
    sellerNetProceeds: number;
    sellerCurrencyCode: string;
}

export interface SellerEventNote {
    eventId: number | null;
    sellerEventNoteId: number;
    sellerUserId: string;
    content: string;
    createDate: string;
}

export interface SellerEventNoteResult extends SellerEventNote {
    sellerDisplayName: string;
}

export interface SellerAccountEventSetting {
    delivType: DeliveryType | null;
    isNoFulfill: boolean | null;
    tktTypeRules: TicketTypeOverride | null;
    inHandAt: string | null;
    vendorId: number | null;
}

export interface EventDiscoveryQuotaConfig {
    enabled: boolean | null;
    autoRenew: boolean | null;
    eventViewQuota: number;
    stubHubProceedsAdvantageAmount: number;
}

export interface OnSaleEventAccess {
    onSaleEventAccessLevel: OnSaleEventAccessLevel;
    eventDiscoveryConfig: EventDiscoveryConfig;
    eventDiscoveryQuota: SellerAccountEventDiscoveryQuota | null;
    recentViewed: boolean;
    hasAccessToView: boolean;
    hasQuota: boolean;
    noProceedsAdvantage: boolean;
}

export enum OnSaleEventAccessLevel {
    Granted = "Granted",
    RecentViewedWithAccess = "RecentViewedWithAccess",
    RecentViewedWithNoQuota = "RecentViewedWithNoQuota",
    RecentViewedWithNoProceedsAdvantage = "RecentViewedWithNoProceedsAdvantage",
    DeniedWithNoProceedsAdvantage = "DeniedWithNoProceedsAdvantage",
    DeniedWithNoQuota = "DeniedWithNoQuota",
}

export interface EventDiscoveryConfig {
    proceedsAdvantageDurationInHours: number;
    eventDiscoveryQuotaResetFrequencyInHours: number;
    quotaConfigs: EventDiscoveryQuotaConfig[];
}

export interface SellerAccountEventDiscoveryQuota {
    eventViewQuota: number;
    eventViewQuotaUsed: number;
    eventViewQuotaUsedResetFrequencyInHours: number;
    eventViewQuotaUsedNextResetDate: string;
}

export interface EventDiscoveryConfigSettings {
    eventDiscoveryConfig: EventDiscoveryConfig;
    sellerProceedsAdvantageConfig: SellerProceedsAdvantageConfig;
    sellerAccountEventDiscoveryQuota: SellerAccountEventDiscoveryQuota | null;
}

export interface SellerProceedsAdvantageConfig {
    hasActiveProceedsAdvantage: boolean;
    hasRenewableActiveProceedsAdvantage: boolean;
    activeProceedsAdvantageAmount: number;
}

export interface EventSectionMetrics {
    sectionId: number;
    pageVisits: EventIncrementalMetricsOfNullableInteger;
    mapSectionClicks: EventIncrementalMetricsOfNullableInteger;
    transactions: EventIncrementalMetricsOfNullableInteger;
    availableTickets: EventIncrementalMetricsOfNullableInteger;
    minPrice: EventIncrementalMetricsOfUiMoney;
    p25Price: EventIncrementalMetricsOfUiMoney;
    medianPrice: EventIncrementalMetricsOfUiMoney;
}

export interface EventIncrementalMetricsOfNullableInteger {
    currentMetricsValue: number | null;
    previousMetricsValue: number | null;
}

export interface EventIncrementalMetricsOfUiMoney {
    currentMetricsValue: UiMoney;
    previousMetricsValue: UiMoney;
}

export enum EventMetricsTimestamp {
    LastHour = "LastHour",
    LastDay = "LastDay",
    Last3Days = "Last3Days",
    LastWeek = "LastWeek",
}

export interface EventNotification {
    id: string;
    name: string;
    notificationType: EventNotificationType;
    status: EventNotificationStatus;
    filters: OnSaleEventQuery;
    userIdTargets: string[];
    webhookTargets: Webhook[];
}

export enum EventNotificationType {
    Email = "Email",
    Webhook = "Webhook",
}

export enum EventNotificationStatus {
    Active = "Active",
    Deactivated = "Deactivated",
}

export interface Webhook {
    id: number;
    name: string;
    url: string;
    authorizationHeader: string;
}

export interface FulfillmentProvider {
    fulfillmentProviderSellerUserId: string;
    fulfillmentProviderName: string;
    descriptionMessage: string;
    isEnabled: boolean;
    costPercentagePerTransfer: number | null;
    flatCostPerTransfer: number | null;
}

export interface EventMarketplaceWebsiteMetrics {
    ticketsOnPlatform: EventMarketplaceWebsiteMetricOfInteger;
    eventVisitors: EventMarketplaceWebsiteMetricOfInteger;
    visitorsInCheckout: EventMarketplaceWebsiteMetricOfInteger;
    totalTicketPriceInCheckout: EventMarketplaceWebsiteMetricOfUiMoney;
}

export interface EventMarketplaceWebsiteMetricOfInteger {
    currentValue: number;
    previousValue: number;
}

export interface EventMarketplaceWebsiteMetricOfUiMoney {
    currentValue: UiMoney;
    previousValue: UiMoney;
}

export interface InventoryMetricsQueryId {
    posEventId: string | null;
    viagogoEventId: number | null;
}

export enum EventWebsiteMetricsTimePeriod {
    OneHour = "OneHour",
    OneDay = "OneDay",
}

export interface EventDemandFactor {
    type: EventDemandFactorType;
    value: string;
}

export enum EventDemandFactorType {
    Opponent = "Opponent",
    Weather = "Weather",
    Standing = "Standing",
    Stakes = "Stakes",
    SpotifyPopularity = "SpotifyPopularity",
    HomeTeamOdds = "HomeTeamOdds",
}

/** Represents the results for the inventory event dashboard. */
export interface InventoryEventDashboardResults {
    /** Gets or sets the marketplace shares as a dictionary with the marketplace as the key and the share percentage as the
value
             */
    mktShares: MarketplaceMarketShare[];
    /** Gets or sets the average ticket price (ATP) value, which represents the average cost of tickets listed by the
seller for the event
             */
    atp: TicketPricePercentiles;
    totalListings: number;
}

export interface MarketplaceMarketShare {
    mktPlc: Marketplace;
    share: number;
}

export interface TicketPricePercentiles {
    currency: string;
    listingCount: number;
    ticketCount: number;
    min: number;
    p25: number;
    p50: number;
    p75: number;
    max: number;
}

export enum SellerEventDashboardMetricsTimePeriod {
    Last7Days = "Last7Days",
    AllTime = "AllTime",
}

export interface EventSectionClearingPrices {
    sectionId: number | null;
    sectionName: string;
    p01: UiMoney;
    p25: UiMoney;
    p50: UiMoney;
    p75: UiMoney;
    p99: UiMoney;
    transactionCount: number;
    normalizedScore: number;
}

export enum EventSectionMetricsTimePeriod {
    LastSixHours = "LastSixHours",
    LastTwentyFourHours = "LastTwentyFourHours",
    LastThreeDays = "LastThreeDays",
    LastSevenDays = "LastSevenDays",
}

export interface EventSupplyMetrics {
    dateTime: string;
    listingCount: number;
    ticketCount: number;
    min: number;
    p25: number;
    p50: number;
    p75: number;
    max: number;
}

export enum EventSupplyMetricsTimePeriod {
    LastDay = "LastDay",
    LastSevenDays = "LastSevenDays",
    LastNinetyDays = "LastNinetyDays",
}

export interface ListingDetails extends Listing {
    purchaseInfos: UiPurchaseInfo[] | null;
    tickets: Ticket[] | null;
    /** Available Artifact Types */
    availArtTypes: ArtifactType[] | null;
    saleInfos: SaleDisplayInfo[] | null;
    proofOfPurchaseDocs: UserDocumentLinks[] | null;
    no_Op: MarketplaceListing | null;
}

export interface UiPurchaseInfo {
    purchaseOrderId: number;
    vendorOrderId: string | null;
    purchaseOrderDate: string | null;
    buyerUserId: string | null;
    vendor: UiPurchaseVendorInfo | null;
    vendorAccount: UiVendorAccountInfo | null;
    createdBy: string | null;
    internalNotes: string | null;
}

export interface UiPurchaseVendorInfo {
    vendorId: number;
    vendorName: string;
}

export interface UiVendorAccountInfo {
    vendorAccountId: string;
    vendorId: number;
    vendorAccountName: string | null;
    encryptedEmailAddress: string;
}

export enum ArtifactType {
    TicketUrl = "TicketUrl",
    ExternalId = "ExternalId",
    ETicket = "ETicket",
    ETicketUrl = "ETicketUrl",
    TransferProof = "TransferProof",
    Barcode = "Barcode",
    QRCode = "QRCode",
}

export interface SaleDisplayInfo {
    /** SaleId */
    id: number;
    /** MarketplaceSaleId */
    idOnMkp: string | null;
    /** Marketplace */
    mkp: Marketplace;
    /** SaleStatus */
    stat: PointOfSaleSaleStatus;
    /** ExternalId */
    externalId: string | null;
}

export interface EntitiesWithSummaryOfListing {
    items: Listing[];
    summary: Listing | null;
    /** PIT ID for next page requests, null if not using PIT (Point-In-Time) pagination */
    pitId: string | null;
    /** Total number of matching documents that may have not been returned yet due to pagination */
    totalItemsCount: number | null;
}

export interface EntitiesWithSummaryOfListingWithCatalogData {
    items: ListingWithCatalogData[];
    summary: ListingWithCatalogData | null;
    /** PIT ID for next page requests, null if not using PIT (Point-In-Time) pagination */
    pitId: string | null;
    /** Total number of matching documents that may have not been returned yet due to pagination */
    totalItemsCount: number | null;
}

/** Extends the Listing model to include catalog data about the event, venue, and performer to power Opensearch-based search experience which doesn't depend on a separate catalog service call. */
export interface ListingWithCatalogData extends Listing {
    eventDateTime: string | null;
    eventName: string | null;
    eventShortName: string | null;
    eventStatus: ApiEventStatus | null;
    eventGenre: TopLevelCategory | null;
    eventSubGenre: number | null;
    venueId: number | null;
    venueName: string | null;
    venueCity: string | null;
    venueCityId: number | null;
    venueStateProvince: string | null;
    venueStateProvinceId: number | null;
    venueCountry: string | null;
    venueCountryCode: string | null;
    performerId: number | null;
    performerName: string | null;
}

/** Extended version of ListingQuery with support for operations for each filter that is supported in search v2 with OpenSearch */
export interface ListingQueryV2 extends ListingQuery {
    pricerSellerUserIds: string[] | null;
    deliveryTypes: DeliveryType[] | null;
    ticketTypes: TicketType[] | null;
    eventUnpricedStatuses: EventUnpricedStatus[] | null;
    operations: ListingQueryOperations | null;
    searchOptions: UISearchOptions | null;
}

export interface EntityWithTicketsQueryOperations {
    entityIdsOp: FilterOperationType | null;
    marketplaceEntityIdsOp: FilterOperationType | null;
    eventOrMappingIdsOp: FilterOperationType | null;
    oldPosEventIdsOp: FilterOperationType | null;
    performerIdsOp: FilterOperationType | null;
    venueIdsOp: FilterOperationType | null;
    countryCodesOp: FilterOperationType | null;
    stateProvinceIdsOp: FilterOperationType | null;
    cityIdsOp: FilterOperationType | null;
    purchaseOrderIdsOp: FilterOperationType | null;
    saleIdsOp: FilterOperationType | null;
    listingIdsOp: FilterOperationType | null;
    purchaseVendorIdOp: FilterOperationType | null;
    vendorAccessControlProviderIdOp: FilterOperationType | null;
    purchaseVendorAccountIdsOp: FilterOperationType | null;
    purchaseVendorOrderIdOp: FilterOperationType | null;
    purchaseBuyerIdOp: FilterOperationType | null;
    purchaseOrderCreatedByOp: FilterOperationType | null;
    purchaseCommissionUserIdOp: FilterOperationType | null;
    purchaseDatesOp: FilterOperationType | null;
    inHandDatesOp: FilterOperationType | null;
    eventTimeFrameFilterOp: FilterOperationType | null;
    sectionOp: FilterOperationType | null;
    rowOp: FilterOperationType | null;
    isSeatSaverOp: FilterOperationType | null;
    eventDatesOp: FilterOperationType | null;
    eventNotReviewedSinceDateOp: FilterOperationType | null;
    isMappedOp: FilterOperationType | null;
    isMappingRejectedOp: FilterOperationType | null;
    searchTextOp: FilterOperationType | null;
    sortByOp: FilterOperationType | null;
    isSortDescendingOp: FilterOperationType | null;
    tagNameOp: FilterOperationType | null;
    tagValueOp: FilterOperationType | null;
    eventTagNameOp: FilterOperationType | null;
    eventTagValueOp: FilterOperationType | null;
    lastSaleDatesOp: FilterOperationType | null;
    noSaleDatesOp: FilterOperationType | null;
    numberOfTicketsHeldOp: FilterOperationType | null;
    topLevelCategoriesOp: FilterOperationType | null;
    parentCategoriesOp: FilterOperationType | null;
    internalNotesOp: FilterOperationType | null;
    currencyCodesOp: FilterOperationType | null;
    eventStatusesOp: FilterOperationType | null;
    searchConfigIdOp: FilterOperationType | null;
}

export interface ListingQueryOperations extends EntityWithTicketsQueryOperations {
    pricerSellerUserIdOp: FilterOperationType | null;
    isPredeliveredOp: FilterOperationType | null;
    isListedOp: FilterOperationType | null;
    deliveryTypeOp: FilterOperationType | null;
    eventHasUnsoldTicketsOp: FilterOperationType | null;
    hasUnsoldTicketsOp: FilterOperationType | null;
    hasBroadcastErrorOp: FilterOperationType | null;
    isAutoPricingEnabledOp: FilterOperationType | null;
    isPricedAboveZeroOp: FilterOperationType | null;
    lastPriceUpdateDatesOp: FilterOperationType | null;
    autoPricingResultTypesOp: FilterOperationType | null;
    isSeatingUnmappedOp: FilterOperationType | null;
    isAdminHoldOp: FilterOperationType | null;
    isDuplicateOp: FilterOperationType | null;
    isPricedByMarketplaceOp: FilterOperationType | null;
    isPendingProofOp: FilterOperationType | null;
    purchaseCancellationDatesOp: FilterOperationType | null;
    purchaseCancelledOnlyOp: FilterOperationType | null;
    isNoFulfillOp: FilterOperationType | null;
    ticketTypeOp: FilterOperationType | null;
    eventUnpricedStatusOp: FilterOperationType | null;
}

export enum FilterOperationType {
    Equals = "Equals",
    NotEquals = "NotEquals",
    GreaterThan = "GreaterThan",
    LessThan = "LessThan",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    LessThanOrEqual = "LessThanOrEqual",
    Between = "Between",
    In = "In",
    NotIn = "NotIn",
    Contains = "Contains",
    NotContains = "NotContains",
}

export interface UISearchOptions {
    take: number | null;
    skip: number | null;
    sort: UISortCriteria[] | null;
    includeAggregations: boolean | null;
    pitId: string | null;
}

export interface UISortCriteria {
    /** The field name to sort by */
    field: string | null;
    /** The sort order (asc/desc) */
    desc: boolean | null;
}

export interface SectionalListingsForEventsInput {
    listingQuery: ListingQuery;
    curListings: Listing[] | null;
}

export interface ValueTupleOfBooleanAndIListOfTicket {
    item1: boolean;
    item2: Ticket[];
}

export interface DuplicateListingDetails {
    listingId: number;
    lastUpdateDate: string;
    duplicateListingId: number;
    duplicateListingLastUpdateDate: string;
}

export interface ValueTupleOfLongAndListingDetailsUpdateInput {
    item1: number;
    item2: ListingDetailsUpdateInput;
}

export interface MergeListingsInput {
    listingIds: number[];
}

export interface BulkMergeListingsInput {
    listingIdLists: number[][];
    /** If provided, for each ListingIdList, the first listing Id in the list will be mapped
to the corresponding ConsigneeSellerAccountId in this dictionary.

Key: ListingId (for each ListingIdList, first listing Id in the list)
Value: ConsigneeSellerAccountId */
    consigneeOwnership: { [key: string]: string; } | null;
}

export interface ListingMergeSuggestion {
    listingIds: number[];
    eventId: number | null;
    eventMappingId: string | null;
    seatFrom: string | null;
    seatTo: string | null;
    accId: string | null;
}

export interface SplitListingInput {
    sourceListingId: number;
    numOfListings: number;
    /** Each of the sub-list will be considered 1 listing */
    ticketsByListingNumber: TicketByListingNumber[];
    alwaysUnbroadcastListing: boolean;
    useOriginalTicketGroupInfoForNewListings: boolean;
}

export interface TicketByListingNumber {
    ticket: Ticket;
    listingNumber: number;
}

export interface TicketExternalId {
    ticketId: number;
    externalId: string;
    section: string | null;
    row: string | null;
    seat: string | null;
}

export interface TicketUrl {
    ticketId: number;
    url: string;
    section: string | null;
    row: string | null;
    seat: string | null;
}

export interface ListingPriceHistory {
    unitNetProceeds: UiMoney;
    priceDate: string;
    marketplace: Marketplace | null;
    pricerUserId: string | null;
    applicationName: string | null;
}

export interface ValueTupleOfLongAndNullableInteger {
    item1: number;
    item2: number | null;
}

export interface ListingPriceCalculation extends BaseListingPriceCalculation {
    compListings: CompListing[];
}

export interface ValueTupleOfListingQueryAndListingCsvColumnSelectionConfig {
    item1: ListingQuery;
    item2: ListingCsvColumnSelectionConfig;
}

export interface ListingCsvColumnSelectionConfig {
    hasAutoPricingFeature: boolean | null;
}

export interface SeatSaverListingDetailsInput {
    event: Event;
    autoBroadcastCreatedListing: boolean;
    sellerOwnTickets: boolean | null;
    seatings: SeatSaverSeating[];
    deliveryType: DeliveryType;
    ticketTypeRules: TicketTypeOverride | null;
    inHandDate: string | null;
    daysBeforeEvent: number | null;
}

export interface SeatSaverSeating {
    section: string;
    sectionId: number | null;
    row: string | null;
    rowId: number | null;
    quantity: number | null;
    maxDisplayQuantity: number | null;
    listingNotes: ListingNote[] | null;
    unitNetProceeds: number | null;
    websitePrice: number | null;
    faceValue: number | null;
}

export interface BatchSwapListingGroupInput {
    listings: SwapListingGroupInput[];
    toListingGroupId: string;
}

export interface SwapListingGroupInput {
    listingId: number;
    listingGroupId: string | null;
    quantity: number;
    adminHoldExpirationDate: string | null;
}

export interface ReorderListingInGroupInput {
    listingGroupId: string;
    listingId: number;
    fromPosition: number;
    toPosition: number;
}

export interface ListingDetailsBroadcastSectionUpdates {
    id: number;
    rowVersion: number | null;
    adminHoldNotes: string | null;
    marketplaceSeatOverrides: ListingMarketplaceSeatingOverride[];
    enableNativeSync: boolean | null;
}

export interface ListingDetailsTicketSectionUpdates {
    id: number;
    rowVersion: number | null;
    splitType: SplitType | null;
    hideSeatsFromMarketplace: boolean | null;
    faceValue: number | null;
    inHandDate: string | null;
    daysBeforeEvent: number | null;
    section: string | null;
    sectionId: number | null;
    row: string | null;
    rowId: number | null;
    internalNotes: string | null;
    ticketTypeRules: TicketTypeOverride | null;
    manualMaxDisplayQuantity: number | null;
    isNoFulfill: boolean | null;
    seatTraits: ListingNote[] | null;
    delivType: DeliveryType | null;
    updateSalesOfListings: boolean | null;
    updatePredeliveryETicketArtifacts: boolean | null;
}

export interface ListingPricingSectionPosFieldUpdates {
    unitNetProceeds: PosFieldOfNullableDecimal | null;
    autoPricingEnabled: PosFieldOfNullableBoolean | null;
    netProceedsFloor: PosFieldOfNullableDecimal | null;
    netProceedsCeiling: PosFieldOfNullableDecimal | null;
    pricerSellerUserId: PosFieldOfNullableGuid | null;
}

export interface ListingDetailsPricingSectionUpdates {
    id: number;
    rowVersion: number | null;
    pricerSellerUserId: string | null;
    listPrice: number | null;
    allInPrice: number | null;
    netProceedsFloor: number | null;
    netProceedsCeiling: number | null;
    autoPricingEnabled: boolean | null;
    buyerUserId: string | null;
    marketplacePriceUpdates: ListingMarketplacePriceUpdateInput[];
    currencyCode: string | null;
}

export interface ListingDetailsAutoPricingSectionUpdates extends AutoPricingInputs {
    id: number;
    rowVersion: number | null;
    netProceedsFloor: number | null;
    netProceedsCeiling: number | null;
    skipAutoPricing: boolean | null;
    autoPricingEnabled: boolean | null;
    skipUndercut: boolean | null;
    skipCompListing: boolean | null;
    skipAdvancePricing: boolean | null;
    velocityCircuitBreakerStateRowVersion: number | null;
    currencyCode: string | null;
    sectionRowScoreRecommendations: SectionRowScoreRecommendations | null;
}

export interface SectionRowScoreRecommendations {
    eventId: number;
    venueConfigId: number;
    modelVersionId: number;
    recommendedSelectedSectionSettings: SelectedSectionSettings;
}

export interface ListingDetailsTagsSectionUpdates {
    id: number;
    rowVersion: number | null;
    tags: Tag[] | null;
}

export interface ListingStatusInfo {
    entityType: ActionOutboxEntityType;
    id: number;
    accId: string | null;
    status: ListingStatus;
    /** Marketplace listing broadcast status */
    brdcstStatus: ListingBroadcastStatus | null;
    /** Marketplace where these tickets were listed and sold */
    mkp: Marketplace | null;
    /** Represent either the MarketplaceListingId or MarketplaceSaleId */
    idOnMkp: string | null;
    pendProofState: PendingProofState | null;
    mkpListings: MarketplaceListingStatusInfo[];
}

export interface MarketplaceListingStatusInfo {
    mkpListingId: string | null;
    mkp: Marketplace;
    status: ListingStatus;
}

export interface ListingExperiment {
    viagogoEventId: number;
    listingGroupId: string | null;
    listingGroupName: string | null;
    targetPercentage: number | null;
    discountPercentage: number | null;
    startDate: string;
    endDate: string;
    insertBy: string;
}

export interface ListingGroup extends Listing {
    groupType: GroupType;
    groupName: string;
    deliveryTypes: ValueTupleOfDeliveryTypeAndNullableTicketType[];
    groupItems: IListingGroupItem[];
    desiredActiveListings: number | null;
    minActiveListings: number | null;
    maxActiveListings: number | null;
    targetPercentage: number | null;
    desiredAvailableQuantity: number | null;
    deprioritizedQuantities: string[] | null;
    marketplaceSettings: ListingGroupListingMarketplaceSettings | null;
    absoluteRankPremium: number | null;
    relativeRankPremium: number | null;
    /** This is for UI only - but it indicates that the entire group is locked from editing so that
when you're making edits to the groups you don't accidentally modify the groups again in parallel and create conflicts */
    isLockedFromEdits: boolean | null;
    /** Indicates whether the listing group's price stagger feature is enabled */
    isPrcStaggerOn: boolean | null;
}

export enum GroupType {
    Invisible = "Invisible",
    FullySold = "FullySold",
    Inactive = "Inactive",
    Active = "Active",
    Leader = "Leader",
}

export interface ValueTupleOfDeliveryTypeAndNullableTicketType {
    item1: DeliveryType;
    item2: TicketType | null;
}

export interface IListingGroupItem {
    ltGrpId: string | null;
    isLtGrp: boolean;
    isFull: boolean;
    id: number;
    insertBy: string | null;
    rowVer: number;
    ltGrpParentId: number | null;
    ltGrpPrior: number | null;
    seating: Seating;
    delivType: DeliveryType;
    topPriTktType: TicketType | null;
    /** This the number of tickets that have not yet sold and is always less than TicketCount. */
    availQty: number;
    wastedQty: number | null;
    ticketCnt: number;
    /** MaxDisplayQuantity */
    maxDispQty: number;
    /** ManualMaxDisplayQuantity */
    manMaxDispQty: number | null;
    ltGrpActive: boolean | null;
    unitCst: UiMoney | null;
    faceValue: UiMoney | null;
    currency: string;
    isDeleted: boolean;
    ltGrpUndercut: ListingGroupUndercutSetting | null;
    /** Marketplace listing broadcast status */
    brdcstStatus: ListingBroadcastStatus | null;
}

export interface PosUiActionResultWithDataOfAutoCompListingsPreview extends PosUiActionResult {
    data: AutoCompListingsPreview | null;
}

export interface AutoCompListingsPreview {
    zoneSectionAreaGroupLookup: ZoneSectionAreaGroupLookup;
}

export interface ZoneSectionAreaGroupLookup {
    zoneSectionAreaRankOverrides: ZoneSectionAreaRankOverride[];
    groupIdToSectionIdMap: { [key: string]: ZoneSectionArea[]; };
    groupIdToMedianSeatScoreMap: { [key: string]: number; };
    sectionIdToGroupIdMap: { [key: string]: string; };
    zoneNameToRankMap: { [key: string]: { [key: string]: number; }; };
    customSectionGroups: string[];
}

export interface ZoneSectionAreaRankOverride {
    zoneAreaName: string;
    rank: number;
    color: string;
}

export interface ZoneSectionArea {
    sectId: number;
    rank: number;
    zoneAreaName: string;
    ticketClassId: number;
    ticketClassName: string;
}

/** Input settings for the auto comparison preview. */
export interface AutoCompSettingsPreviewInput {
    viagogoEventId: number;
    venueZoneConfigType: VenueZoneConfigType;
    combineCornersAndEnds: boolean;
}

export interface PosUiActionResultWithDataOfAutoGroupListingsPreview extends PosUiActionResult {
    data: AutoGroupListingsPreview | null;
}

export interface AutoGroupListingsPreview {
    listingGroups: { [key: string]: AutoGroupListingsPreviewListingUpdate[]; };
}

export interface AutoGroupListingsPreviewListingUpdate {
    listingId: number;
    selectedSectionSettings: SelectedSectionSettings | null;
    onlyForSelectedSectionsEnabled: boolean | null;
    compListingMode: AutoPricingCompListingMode | null;
    compListingFloor: number | null;
    compListingCeiling: number | null;
    autoPricingEnabled: boolean | null;
    circuitBreakerMinCompListingCount: number | null;
    excludeFanInventory: boolean | null;
    area: RowArea;
    filteredAreas: RowArea[];
}

export interface RowArea extends RowInfo {
    sectId: number;
    normOrd: number;
    area: ConfigArea;
    sectName: string;
}

export interface ConfigArea {
    areaName: string;
    rank: number;
}

export interface AutoGroupListingsPreviewInput {
    viagogoEventId: number;
    eventListingIds: number[];
    zoneSectionAreaGroupLookupJson: string;
    /** Determines how the offset ordinal for row comps */
    rowCompOffset: number;
    /** Determines how the RowArea names will be determined */
    rowGroupSetting: RowGroupSetting;
    venueZoneConfigType: VenueZoneConfigType;
    combineCornersAndEnds: boolean;
    rowCompOverrides: RowCompOverride[];
    useCustomRank: boolean;
}

export interface PosUiActionResultWithDataOfIEnumerableOfMergeListingGroupInput extends PosUiActionResult {
    data: (MergeListingGroupInput | null)[] | null;
}

export interface ListingGroupCompData {
    totalCompListingCount: number;
    compListings: CompListing[];
}

/** Result of a secure listing search with mapped Listing DTOs */
export interface SecureListingSearchMappedResult {
    /** The mapped Listing DTOs ready for UI consumption */
    listings: ListingWithCatalogData[];
    /** Total number of matching documents */
    total: number;
    /** Time taken for the search in milliseconds */
    took: number;
    /** Maximum score of the results (for relevance ranking) */
    maxScore: number | null;
    /** Whether the search timed out */
    timedOut: boolean;
    /** Applied security filters for debugging */
    appliedSecurityFilters: string[] | null;
    /** Number of fields that were allowed for the user */
    allowedFieldCount: number;
    /** Parsed aggregation results */
    aggregations: { [key: string]: AggregationResult; } | null;
    /** PIT ID for next page requests, null if not using PIT (Point-In-Time) pagination */
    pitId: string | null;
    /** Search after values for next page cursor (null if no more pages) */
    searchAfter: any[] | null;
    /** Whether there are more pages available */
    hasNextPage: boolean;
}

export interface AggregationResult {
    value: any;
    displayName: string;
    type: AggregationType;
    metadata: { [key: string]: any; } | null;
}

export enum AggregationType {
    Sum = "Sum",
    Count = "Count",
    Average = "Average",
    Min = "Min",
    Max = "Max",
    DistinctCount = "DistinctCount",
}

export interface ProblemDetails {
    type: string | null;
    title: string | null;
    status: number | null;
    detail: string | null;
    instance: string | null;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export interface OpenSearchRequestOfListingFilterQueryV2 {
    filter: ListingFilterQueryV2;
    options: SearchOptions | null;
}

export interface ListingSearchRequestV2 extends OpenSearchRequestOfListingFilterQueryV2 {
    allowedFields: string[] | null;
    appliedSecurityFilters: string[] | null;
    dataIsolationContext: { [key: string]: any; } | null;
}

export interface ListingFilterQueryV2 {
    eventIds: FieldFilter | null;
    eventDates: FieldFilter | null;
    eventTimeFrameFilters: FieldFilter | null;
    clientTimezoneOffsetMins: number | null;
    eventStatuses: FieldFilter | null;
    topLevelCategories: FieldFilter | null;
    parentCategories: FieldFilter | null;
    eventOrMappingIds: FieldFilter | null;
    oldPosEventIds: FieldFilter | null;
    performerIds: FieldFilter | null;
    venueIds: FieldFilter | null;
    countryCodes: FieldFilter | null;
    stateProvinceIds: FieldFilter | null;
    cityIds: FieldFilter | null;
    eventNotReviewedSince: FieldFilter | null;
    lastSaleDates: FieldFilter | null;
    numberOfAvailableTickets: FieldFilter | null;
    eventHasUnsoldTickets: FieldFilter | null;
    eventMappingStatus: FieldFilter | null;
    hasUnpricedListings: FieldFilter | null;
    isListed: FieldFilter | null;
    hasBroadcastError: FieldFilter | null;
    isDuplicate: FieldFilter | null;
    isAdminHold: FieldFilter | null;
    isPendingProof: FieldFilter | null;
    listingIds: FieldFilter | null;
    lastPriceUpdateDates: FieldFilter | null;
    lastUpdateDates: FieldFilter | null;
    listingInsertByIds: FieldFilter | null;
    sellerAccountIds: FieldFilter | null;
    pricedByIds: FieldFilter | null;
    isAutoPricingEnabled: FieldFilter | null;
    autoPricingResultState: FieldFilter | null;
    isPriced: FieldFilter | null;
    isPricedByMarketplace: FieldFilter | null;
    currencyCodes: FieldFilter | null;
    isPredelivered: FieldFilter | null;
    deliveryTypes: FieldFilter | null;
    inHandDates: FieldFilter | null;
    ticketTypes: FieldFilter | null;
    isNoFulfill: FieldFilter | null;
    hasUnsoldTickets: FieldFilter | null;
    section: FieldFilter | null;
    row: FieldFilter | null;
    splitTypes: FieldFilter | null;
    isEventMapped: FieldFilter | null;
    isSeatingUnmapped: FieldFilter | null;
    internalNotes: FieldFilter | null;
    tagPairs: TagPairFilter | null;
    eventTagPairs: TagPairFilter | null;
    purchaseOrderTagPairs: TagPairFilter | null;
    purchaseOrderIds: FieldFilter | null;
    purchaseVendorIds: FieldFilter | null;
    purchaseVendorAccountIds: FieldFilter | null;
    purchaseVendorOrderIds: FieldFilter | null;
    purchaseBuyerIds: FieldFilter | null;
    purchaseInsertByIds: FieldFilter | null;
    purchaseDates: FieldFilter | null;
    unitCosts: FieldFilter | null;
    prices: FieldFilter | null;
    quantity: FieldFilter | null;
    quantitySold: FieldFilter | null;
    quantityWasted: FieldFilter | null;
    isUndeliverable: FieldFilter | null;
    isSeatSaver: FieldFilter | null;
    and: ListingFilterQueryV2[] | null;
    or: ListingFilterQueryV2[] | null;
    orConditions: ListingFilterQueryV2[] | null;
    not: boolean | null;
    orListingInsertByUserId: string | null;
    orPricerSellerUserId: string | null;
    orPurchaseBuyerId: string | null;
    dataIsolationContext: { [key: string]: any; } | null;
    allowedFields: string[] | null;
    appliedSecurityFilters: string[] | null;
}

export interface FieldFilter {
    operation: FilterOperationType;
    value: any | null;
    values: any[] | null;
    start: any | null;
    end: any | null;
    min: any | null;
    max: any | null;
}

export interface TagPairFilter {
    operation: TagPairOperation;
    pairs: TagPair[];
}

export enum TagPairOperation {
    AnyOf = "AnyOf",
    AllOf = "AllOf",
    Contains = "Contains",
    Equals = "Equals",
    NotExists = "NotExists",
    NotEquals = "NotEquals",
    NotContains = "NotContains",
}

export interface TagPair {
    name: string;
    value: string | null;
    operation: TagPairOperation | null;
}

export interface SearchOptions {
    size: number | null;
    from: number | null;
    sort: SortCriteria[] | null;
    aggregations: AggregationDictionary | null;
    timeoutMs: number | null;
    includeAggregations: boolean;
    allowedFields: string[] | null;
    pitId: string | null;
    searchAfter: any[] | null;
    keepAlive: string | null;
    usesPitPagination: boolean;
}

export interface SortCriteria {
    field: string | null;
    order: string | null;
}

export interface IsADictionaryBaseOfStringAndIAggregationContainer {
    Item: IAggregationContainer | null;
    BackingDictionary: { [key: string]: IAggregationContainer; } | null;
}

/** Describes aggregations that we would like to execute on OpenSearch. In OSC Aggregation always refers to an aggregation sent to OpenSearch and an Aggregate describes an aggregation returned from OpenSearch. */
export interface AggregationDictionary extends IsADictionaryBaseOfStringAndIAggregationContainer {
}

export interface IAggregationContainer {
    adjacencyMatrix: IAdjacencyMatrixAggregation | null;
    aggregations: AggregationDictionary | null;
    average: IAverageAggregation | null;
    averageBucket: IAverageBucketAggregation | null;
    bucketScript: IBucketScriptAggregation | null;
    bucketSelector: IBucketSelectorAggregation | null;
    bucketSort: IBucketSortAggregation | null;
    cardinality: ICardinalityAggregation | null;
    children: IChildrenAggregation | null;
    composite: ICompositeAggregation | null;
    cumulativeSum: ICumulativeSumAggregation | null;
    dateHistogram: IDateHistogramAggregation | null;
    autoDateHistogram: IAutoDateHistogramAggregation | null;
    dateRange: IDateRangeAggregation | null;
    derivative: IDerivativeAggregation | null;
    diversifiedSampler: IDiversifiedSamplerAggregation | null;
    extendedStats: IExtendedStatsAggregation | null;
    extendedStatsBucket: IExtendedStatsBucketAggregation | null;
    filter: IFilterAggregation | null;
    filters: IFiltersAggregation | null;
    geoBounds: IGeoBoundsAggregation | null;
    geoCentroid: IGeoCentroidAggregation | null;
    geoDistance: IGeoDistanceAggregation | null;
    geoHash: IGeoHashGridAggregation | null;
    geoLine: IGeoLineAggregation | null;
    geoTile: IGeoTileGridAggregation | null;
    global: IGlobalAggregation | null;
    histogram: IHistogramAggregation | null;
    ipRange: IIpRangeAggregation | null;
    matrixStats: IMatrixStatsAggregation | null;
    max: IMaxAggregation | null;
    maxBucket: IMaxBucketAggregation | null;
    meta: { [key: string]: any; } | null;
    min: IMinAggregation | null;
    minBucket: IMinBucketAggregation | null;
    missing: IMissingAggregation | null;
    movingAverage: IMovingAverageAggregation | null;
    movingFunction: IMovingFunctionAggregation | null;
    nested: INestedAggregation | null;
    /** A special single bucket aggregation that selects parent documents that
have the specified type, as defined in a join field. */
    parent: IParentAggregation | null;
    percentileRanks: IPercentileRanksAggregation | null;
    percentiles: IPercentilesAggregation | null;
    percentilesBucket: IPercentilesBucketAggregation | null;
    range: IRangeAggregation | null;
    rareTerms: IRareTermsAggregation | null;
    reverseNested: IReverseNestedAggregation | null;
    sampler: ISamplerAggregation | null;
    scriptedMetric: IScriptedMetricAggregation | null;
    serialDifferencing: ISerialDifferencingAggregation | null;
    significantTerms: ISignificantTermsAggregation | null;
    significantText: ISignificantTextAggregation | null;
    stats: IStatsAggregation | null;
    statsBucket: IStatsBucketAggregation | null;
    sum: ISumAggregation | null;
    sumBucket: ISumBucketAggregation | null;
    terms: ITermsAggregation | null;
    topHits: ITopHitsAggregation | null;
    valueCount: IValueCountAggregation | null;
    weightedAverage: IWeightedAverageAggregation | null;
    medianAbsoluteDeviation: IMedianAbsoluteDeviationAggregation | null;
    multiTerms: IMultiTermsAggregation | null;
    variableWidthHistogram: IVariableWidthHistogramAggregation | null;
}

export interface IAdjacencyMatrixAggregation {
    filters: INamedFiltersContainer | null;
}

export interface INamedFiltersContainer {
}

export interface IAverageAggregation {
}

export interface IAverageBucketAggregation {
}

export interface IBucketScriptAggregation {
    script: IScript | null;
}

/** A script to execute to provide custom computation */
export interface IScript {
    /** Language of script. */
    lang: string | null;
    /** Scripts are compiled and cached for faster execution.
If the same script can be used, just with different parameters provided,
it is preferable to use the ability to pass parameters to the script itself.
             */
    params: { [key: string]: any; } | null;
}

export interface IBucketSelectorAggregation {
    script: IScript | null;
}

/** A parent pipeline aggregation which sorts the buckets of its parent multi-bucket aggregation. Zero or more sort fields may be specified together with the corresponding sort order. Each bucket may be sorted based on its _key, _count or its sub-aggregations. In addition, parameters from and size may be set in order to truncate the result buckets. */
export interface IBucketSortAggregation {
    /** Buckets in positions prior to the set value will be truncated */
    from: number | null;
    /** The policy to apply when gaps are found in the data */
    gapPolicy: GapPolicy | null;
    /** The number of buckets to return. Defaults to all buckets of the parent aggregation
             */
    size: number | null;
    /** The list of fields to sort on */
    sort: ISort[] | null;
}

export enum GapPolicy {
    Skip = "skip",
    InsertZeros = "insert_zeros",
}

export interface ISort {
    /** Specifies how documents which are missing the sort field should
be treated. */
    missing: any | null;
    /** Controls what collection value is picked for sorting a document
when the field is a collection */
    mode: SortMode | null;
    /** Set a single resolution for the sort */
    numericType: NumericType | null;
    /** Specifies the path and filter to apply when sorting on a nested field */
    nested: INestedSort | null;
    /** Controls the order of sorting */
    order: SortOrder | null;
}

/** OpenSearch supports sorting by array or multi-valued fields. The mode option controls what array value is picked for sorting the document it belongs to. */
export enum SortMode {
    Min = "min",
    Max = "max",
    Sum = "sum",
    Average = "avg",
    Median = "median",
}

/** For numeric fields it is also possible to cast the values from one type to another using this option. This can be useful for cross-index search if the sort field is mapped differently on some indices. */
export enum NumericType {
    Long = "long",
    Double = "double",
    Date = "date",
    DateNanos = "date_nanos",
}

/** Sort on a field inside one or more nested objects. */
export interface INestedSort {
    /** A filter that the inner objects inside the nested path should match with in order for its field values to be taken into account
by sorting. A common pattern is to repeat the query/filter inside the nested filter or query.
By default no nested filter is active. */
    filter: QueryContainer | null;
    /** Same as top-level nested, but applies to another nested path within the current nested object. */
    nested: INestedSort | null;
    /** Defines on which nested object to sort. The actual sort field must be a direct field inside this nested object.
When sorting by nested field, this field is mandatory. */
    path: Field | null;
    /** The maximum number of children to consider per root document when picking the sort value. Defaults to unlimited. */
    maxChildren: number | null;
}

export interface QueryContainer {
}

export interface Field {
    /** A boost to apply to the field */
    boost: number | null;
    /** A format to apply to the field. */
    format: string | null;
    cachableExpression: boolean;
    /** An expression from which the name of the field can be inferred */
    expression: Expression | null;
    /** The name of the field */
    name: string | null;
    /** A property from which the name of the field can be inferred */
    property: PropertyInfo | null;
}

export interface Expression {
    nodeType: ExpressionType;
    type: string;
    canReduce: boolean;
}

export enum ExpressionType {
    Add = "Add",
    AddChecked = "AddChecked",
    And = "And",
    AndAlso = "AndAlso",
    ArrayLength = "ArrayLength",
    ArrayIndex = "ArrayIndex",
    Call = "Call",
    Coalesce = "Coalesce",
    Conditional = "Conditional",
    Constant = "Constant",
    Convert = "Convert",
    ConvertChecked = "ConvertChecked",
    Divide = "Divide",
    Equal = "Equal",
    ExclusiveOr = "ExclusiveOr",
    GreaterThan = "GreaterThan",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    Invoke = "Invoke",
    Lambda = "Lambda",
    LeftShift = "LeftShift",
    LessThan = "LessThan",
    LessThanOrEqual = "LessThanOrEqual",
    ListInit = "ListInit",
    MemberAccess = "MemberAccess",
    MemberInit = "MemberInit",
    Modulo = "Modulo",
    Multiply = "Multiply",
    MultiplyChecked = "MultiplyChecked",
    Negate = "Negate",
    UnaryPlus = "UnaryPlus",
    NegateChecked = "NegateChecked",
    New = "New",
    NewArrayInit = "NewArrayInit",
    NewArrayBounds = "NewArrayBounds",
    Not = "Not",
    NotEqual = "NotEqual",
    Or = "Or",
    OrElse = "OrElse",
    Parameter = "Parameter",
    Power = "Power",
    Quote = "Quote",
    RightShift = "RightShift",
    Subtract = "Subtract",
    SubtractChecked = "SubtractChecked",
    TypeAs = "TypeAs",
    TypeIs = "TypeIs",
    Assign = "Assign",
    Block = "Block",
    DebugInfo = "DebugInfo",
    Decrement = "Decrement",
    Dynamic = "Dynamic",
    Default = "Default",
    Extension = "Extension",
    Goto = "Goto",
    Increment = "Increment",
    Index = "Index",
    Label = "Label",
    RuntimeVariables = "RuntimeVariables",
    Loop = "Loop",
    Switch = "Switch",
    Throw = "Throw",
    Try = "Try",
    Unbox = "Unbox",
    AddAssign = "AddAssign",
    AndAssign = "AndAssign",
    DivideAssign = "DivideAssign",
    ExclusiveOrAssign = "ExclusiveOrAssign",
    LeftShiftAssign = "LeftShiftAssign",
    ModuloAssign = "ModuloAssign",
    MultiplyAssign = "MultiplyAssign",
    OrAssign = "OrAssign",
    PowerAssign = "PowerAssign",
    RightShiftAssign = "RightShiftAssign",
    SubtractAssign = "SubtractAssign",
    AddAssignChecked = "AddAssignChecked",
    MultiplyAssignChecked = "MultiplyAssignChecked",
    SubtractAssignChecked = "SubtractAssignChecked",
    PreIncrementAssign = "PreIncrementAssign",
    PreDecrementAssign = "PreDecrementAssign",
    PostIncrementAssign = "PostIncrementAssign",
    PostDecrementAssign = "PostDecrementAssign",
    TypeEqual = "TypeEqual",
    OnesComplement = "OnesComplement",
    IsTrue = "IsTrue",
    IsFalse = "IsFalse",
}

export interface MemberInfo {
    module: Module;
    customAttributes: CustomAttributeData[];
    isCollectible: boolean;
    metadataToken: number;
}

export interface PropertyInfo extends MemberInfo {
    memberType: MemberTypes;
    isSpecialName: boolean;
    getMethod: MethodInfo | null;
    setMethod: MethodInfo | null;
}

export enum MemberTypes {
    Constructor = "Constructor",
    Event = "Event",
    Field = "Field",
    Method = "Method",
    Property = "Property",
    TypeInfo = "TypeInfo",
    Custom = "Custom",
    NestedType = "NestedType",
    All = "All",
}

export interface MethodBase extends MemberInfo {
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
}

export interface MethodInfo extends MethodBase {
    memberType: MemberTypes;
    returnParameter: ParameterInfo;
    returnType: string;
}

export interface ParameterInfo {
    attributes: ParameterAttributes;
    member: MemberInfo;
    name: string | null;
    parameterType: string;
    position: number;
    isIn: boolean;
    isLcid: boolean;
    isOptional: boolean;
    isOut: boolean;
    isRetval: boolean;
    defaultValue: any | null;
    rawDefaultValue: any | null;
    hasDefaultValue: boolean;
    customAttributes: CustomAttributeData[];
    metadataToken: number;
}

export enum ParameterAttributes {
    None = "None",
    In = "In",
    Out = "Out",
    Lcid = "Lcid",
    Retval = "Retval",
    Optional = "Optional",
    HasDefault = "HasDefault",
    HasFieldMarshal = "HasFieldMarshal",
    Reserved3 = "Reserved3",
    Reserved4 = "Reserved4",
    ReservedMask = "ReservedMask",
}

export interface Module {
    assembly: Assembly;
    fullyQualifiedName: string;
    name: string;
    mdStreamVersion: number;
    moduleVersionId: string;
    scopeName: string;
    moduleHandle: ModuleHandle;
    customAttributes: CustomAttributeData[];
    metadataToken: number;
}

export interface Assembly {
    definedTypes: string[];
    exportedTypes: string[];
    codeBase: string | null;
    entryPoint: MethodInfo | null;
    fullName: string | null;
    imageRuntimeVersion: string;
    isDynamic: boolean;
    location: string;
    reflectionOnly: boolean;
    isCollectible: boolean;
    isFullyTrusted: boolean;
    customAttributes: CustomAttributeData[];
    escapedCodeBase: string;
    manifestModule: Module;
    modules: Module[];
    globalAssemblyCache: boolean;
    hostContext: number;
    securityRuleSet: SecurityRuleSet;
}

export interface CustomAttributeData {
    attributeType: string;
    constructor: ConstructorInfo;
    constructorArguments: CustomAttributeTypedArgument[];
    namedArguments: CustomAttributeNamedArgument[];
}

export interface ConstructorInfo extends MethodBase {
    memberType: MemberTypes;
}

export enum MethodImplAttributes {
    IL = "Managed",
    Managed = "Managed",
    Native = "Native",
    OPTIL = "OPTIL",
    CodeTypeMask = "Runtime",
    Runtime = "Runtime",
    ManagedMask = "ManagedMask",
    Unmanaged = "ManagedMask",
    NoInlining = "NoInlining",
    ForwardRef = "ForwardRef",
    Synchronized = "Synchronized",
    NoOptimization = "NoOptimization",
    PreserveSig = "PreserveSig",
    AggressiveInlining = "AggressiveInlining",
    AggressiveOptimization = "AggressiveOptimization",
    InternalCall = "InternalCall",
    MaxMethodImplVal = "MaxMethodImplVal",
}

export enum CallingConventions {
    Standard = "Standard",
    VarArgs = "VarArgs",
    Any = "Any",
    HasThis = "HasThis",
    ExplicitThis = "ExplicitThis",
}

export interface CustomAttributeTypedArgument {
    argumentType: string;
    value: any | null;
}

export interface CustomAttributeNamedArgument {
    memberInfo: MemberInfo;
    typedValue: CustomAttributeTypedArgument;
    memberName: string;
    isField: boolean;
}

export enum SecurityRuleSet {
    None = "None",
    Level1 = "Level1",
    Level2 = "Level2",
}

export interface ModuleHandle {
    mdStreamVersion: number;
}

export enum SortOrder {
    Ascending = "asc",
    Descending = "desc",
}

export interface ICardinalityAggregation {
    precisionThreshold: number | null;
    rehash: boolean | null;
}

export interface IChildrenAggregation {
    type: RelationName | null;
}

export interface RelationName {
    name: string | null;
    type: string | null;
}

/** A multi-bucket aggregation that creates composite buckets from different sources. */
export interface ICompositeAggregation {
    /** Used to retrieve the composite buckets that are after the
last composite buckets returned in a previous round */
    after: CompositeKey | null;
    /** Defines how many composite buckets should be returned.
Each composite bucket is considered as a single bucket so
setting a size of 10 will return the first 10 composite buckets
created from the values source. */
    size: number | null;
    /** Controls the sources that should be used to build the composite buckets */
    sources: ICompositeAggregationSource[] | null;
}

export interface IsAReadOnlyDictionaryBaseOfStringAndObject {
    Count: number;
    Item: any | null;
    Keys: string[] | null;
    Values: any[] | null;
    BackingDictionary: { [key: string]: any; } | null;
}

/** A key for a CompositeBucket */
export interface CompositeKey extends IsAReadOnlyDictionaryBaseOfStringAndObject {
}

/** A values source for ICompositeAggregation */
export interface ICompositeAggregationSource {
    /** The field from which to extract value */
    field: Field | null;
    /** By default documents without a value for a given source are ignored. It is possible to include
them in the response as null by setting this to true */
    missingBucket: boolean | null;
    /** Defines the direction of sorting for each
value source. Defaults to Ascending */
    order: SortOrder | null;
}

export interface ICumulativeSumAggregation {
}

export interface IDateHistogramAggregation {
    /** Extend the bounds of the date histogram beyond the data itself,
forcing the aggregation to start building buckets on
a specific min and/or max value.
Using extended bounds only makes sense when MinimumDocumentCount is 0
as empty buckets will never be returned if it is greater than 0. */
    extendedBounds: ExtendedBoundsOfDateMath | null;
    /** The hard_bounds is a counterpart of extended_bounds and can limit the range of buckets in the histogram.
It is particularly useful in the case of open data ranges that can result in a very large number of buckets. */
    hardBounds: HardBoundsOfDateMath | null;
    /** The field to target */
    field: Field | null;
    /** Return a formatted date string as the key instead an epoch long */
    format: string | null;
    /** The calendar interval to use when bucketing documents */
    calendarInterval: UnionOfNullableDateIntervalAndDateMathTime | null;
    /** The fixed interval to use when bucketing documents */
    fixedInterval: Time | null;
    /** The minimum number of documents that a bucket must contain to be returned in the response.
The default is 0 meaning that buckets with no documents will be returned. */
    minimumDocumentCount: number | null;
    /** Defines how to treat documents that are missing a value. By default, they are ignored,
but it is also possible to treat them as if they have a value. */
    missing: string | null;
    /** Change the start value of each bucket by the specified positive (+) or negative offset (-) duration,
such as 1h for an hour, or 1d for a day. */
    offset: string | null;
    /** Defines an order in which returned buckets are sorted.
By default the returned buckets are sorted by their key ascending. */
    order: HistogramOrder | null;
    /** A script to execute to provide custom computation */
    script: IScript | null;
    /** Used to indicate that bucketing should use a different time zone.
Time zones may either be specified as an ISO 8601 UTC offset (e.g. +01:00 or -08:00)
or as a timezone id, an identifier used in the TZ database like America/Los_Angeles. */
    timeZone: string | null;
}

export interface ExtendedBoundsOfDateMath {
    maximum: DateMath | null;
    minimum: DateMath | null;
}

export interface DateMath {
}

export interface HardBoundsOfDateMath {
    maximum: DateMath | null;
    minimum: DateMath | null;
}

/** Represents the union of two types,  and . Used in scenarios where an OpenSearch API may accept more than one different input data structure. */
export interface UnionOfNullableDateIntervalAndDateMathTime {
}

/** Represents a time value */
export interface Time {
    factor: number | null;
    interval: TimeUnit | null;
    milliseconds: number | null;
}

export enum TimeUnit {
    Nanoseconds = "nanos",
    Microseconds = "micros",
    Millisecond = "ms",
    Second = "s",
    Minute = "m",
    Hour = "h",
    Day = "d",
}

export interface HistogramOrder {
    key: string | null;
    order: SortOrder;
}

export interface IAutoDateHistogramAggregation {
    field: Field | null;
    buckets: number | null;
    format: string | null;
    missing: string | null;
    offset: string | null;
    params: { [key: string]: any; } | null;
    script: IScript | null;
    timeZone: string | null;
    /** Specify the minimum rounding interval that should be used. This can make the collection process
more efficient, as the aggregation will not attempt to round at any interval lower than this. */
    minimumInterval: MinimumInterval | null;
}

export enum MinimumInterval {
    Second = "second",
    Minute = "minute",
    Hour = "hour",
    Day = "day",
    Month = "month",
    Year = "year",
}

export interface IDateRangeAggregation {
    field: Field | null;
    format: string | null;
    missing: any | null;
    ranges: IDateRangeExpression[] | null;
    timeZone: string | null;
}

export interface IDateRangeExpression {
    from: DateMath | null;
    key: string | null;
    to: DateMath | null;
}

export interface IDerivativeAggregation {
}

export interface IDiversifiedSamplerAggregation {
    executionHint: DiversifiedSamplerAggregationExecutionHint | null;
    field: Field | null;
    maxDocsPerValue: number | null;
    script: IScript | null;
    shardSize: number | null;
}

export enum DiversifiedSamplerAggregationExecutionHint {
    Map = "map",
    GlobalOrdinals = "global_ordinals",
    BytesHash = "bytes_hash",
}

export interface IExtendedStatsAggregation {
    sigma: number | null;
}

export interface IExtendedStatsBucketAggregation {
    sigma: number | null;
}

export interface IFilterAggregation {
    filter: QueryContainer | null;
}

export interface IFiltersAggregation {
    filters: UnionOfINamedFiltersContainerAndIEnumerableOfQueryContainer | null;
    otherBucket: boolean | null;
    otherBucketKey: string | null;
}

/** Represents the union of two types,  and . Used in scenarios where an OpenSearch API may accept more than one different input data structure. */
export interface UnionOfINamedFiltersContainerAndIEnumerableOfQueryContainer {
}

export interface IGeoBoundsAggregation {
    wrapLongitude: boolean | null;
}

export interface IGeoCentroidAggregation {
}

export interface IGeoDistanceAggregation {
    distanceType: GeoDistanceType | null;
    field: Field | null;
    origin: GeoLocation | null;
    ranges: IAggregationRange[] | null;
    unit: DistanceUnit | null;
}

export enum GeoDistanceType {
    Arc = "arc",
    Plane = "plane",
}

/** Represents a Latitude/Longitude as a 2 dimensional point that gets serialized as { lat, lon } */
export interface GeoLocation {
    /** Latitude */
    latitude: number;
    /** Longitude */
    longitude: number;
}

/** Range that defines a bucket for either the RangeAggregation or GeoDistanceAggregation. If you are looking to store ranges as part of your document please use explicit range class e.g DateRange, FloatRange etc */
export interface IAggregationRange {
    from: number | null;
    key: string | null;
    to: number | null;
}

export enum DistanceUnit {
    Inch = "in",
    Feet = "ft",
    Yards = "yd",
    Miles = "mi",
    NauticalMiles = "nmi",
    Kilometers = "km",
    Meters = "m",
    Centimeters = "cm",
    Millimeters = "mm",
}

/** A multi-bucket aggregation that works on geo_point fields and groups points into buckets that represent cells in a grid. The resulting grid can be sparse and only contains cells that have matching data. Each cell is labeled using a geohash which is of user-definable precision. */
export interface IGeoHashGridAggregation {
    /** The name of the field indexed with geopoints. */
    field: Field | null;
    /** The string length of the geohashes used to define cells/buckets in the results.
Defaults to Precision5. */
    precision: GeoHashPrecision | null;
    /** To allow for more accurate counting of the top cells returned in the final result the aggregation defaults to returning
max(10,(size x number-of-shards)) buckets from each shard. If this heuristic is undesirable,
the number considered from each shard can be over-ridden using this parameter. */
    shardSize: number | null;
    /** The maximum number of geohash buckets to return. Defaults to 10,000. When results are trimmed,
buckets are prioritised based on the volumes of documents they contain. */
    size: number | null;
    /** Restricts the points considered to those that fall within the bounds provided. */
    bounds: IBoundingBox | null;
}

export enum GeoHashPrecision {
    Precision1 = "Precision1",
    Precision2 = "Precision2",
    Precision3 = "Precision3",
    Precision4 = "Precision4",
    Precision5 = "Precision5",
    Precision6 = "Precision6",
    Precision7 = "Precision7",
    Precision8 = "Precision8",
    Precision9 = "Precision9",
    Precision10 = "Precision10",
    Precision11 = "Precision11",
    Precision12 = "Precision12",
}

export interface IBoundingBox {
    bottomRight: GeoLocation | null;
    topLeft: GeoLocation | null;
    wellKnownText: string | null;
}

export interface IGeoLineAggregation {
    point: GeoLinePoint | null;
    sort: GeoLineSort | null;
    includeSort: boolean | null;
    sortOrder: string | null;
    size: number | null;
}

export interface GeoLinePoint {
    field: Field | null;
}

export interface GeoLineSort {
    field: Field | null;
}

export interface IGeoTileGridAggregation {
    /** The name of the field indexed with GeoPoints. */
    field: Field | null;
    /** The zoom of the key used to define cells/buckets in the results. */
    precision: GeoTilePrecision | null;
    /** To allow for more accurate counting of the top cells returned in the final result the aggregation. */
    shardSize: number | null;
    /** The maximum number of geohash buckets to return. */
    size: number | null;
}

export enum GeoTilePrecision {
    Precision0 = "Precision0",
    Precision1 = "Precision1",
    Precision2 = "Precision2",
    Precision3 = "Precision3",
    Precision4 = "Precision4",
    Precision5 = "Precision5",
    Precision6 = "Precision6",
    Precision7 = "Precision7",
    Precision8 = "Precision8",
    Precision9 = "Precision9",
    Precision10 = "Precision10",
    Precision11 = "Precision11",
    Precision12 = "Precision12",
    Precision13 = "Precision13",
    Precision14 = "Precision14",
    Precision15 = "Precision15",
    Precision16 = "Precision16",
    Precision17 = "Precision17",
    Precision18 = "Precision18",
    Precision19 = "Precision19",
    Precision20 = "Precision20",
    Precision21 = "Precision21",
    Precision22 = "Precision22",
    Precision23 = "Precision23",
    Precision24 = "Precision24",
    Precision25 = "Precision25",
    Precision26 = "Precision26",
    Precision27 = "Precision27",
    Precision28 = "Precision28",
    Precision29 = "Precision29",
}

export interface IGlobalAggregation {
}

export interface IHistogramAggregation {
    extendedBounds: ExtendedBoundsOfDouble | null;
    hardBounds: HardBoundsOfDouble | null;
    field: Field | null;
    interval: number | null;
    minimumDocumentCount: number | null;
    missing: number | null;
    offset: number | null;
    order: HistogramOrder | null;
    script: IScript | null;
}

export interface ExtendedBoundsOfDouble {
    maximum: number;
    minimum: number;
}

export interface HardBoundsOfDouble {
    maximum: number;
    minimum: number;
}

export interface IIpRangeAggregation {
    field: Field | null;
    ranges: IIpRangeAggregationRange[] | null;
}

export interface IIpRangeAggregationRange {
    from: string | null;
    mask: string | null;
    to: string | null;
}

export interface IMatrixStatsAggregation {
    mode: MatrixStatsMode | null;
}

/** The matrix_stats aggregation treats each document field as an independent sample. The mode parameter controls what array value the aggregation will use for array or multi-valued fields. */
export enum MatrixStatsMode {
    Avg = "avg",
    Min = "min",
    Max = "max",
    Sum = "sum",
    Median = "median",
}

export interface IMaxAggregation {
}

export interface IMaxBucketAggregation {
}

export interface IMinAggregation {
}

export interface IMinBucketAggregation {
}

export interface IMissingAggregation {
    field: Field | null;
}

export interface IMovingAverageAggregation {
    minimize: boolean | null;
    model: IMovingAverageModel | null;
    predict: number | null;
    window: number | null;
}

export interface IMovingAverageModel {
}

export interface IMovingFunctionAggregation {
    script: string | null;
    window: number | null;
    shift: number | null;
}

export interface INestedAggregation {
    path: Field | null;
}

/** A special single bucket aggregation that selects parent documents that have the specified type, as defined in a join field. */
export interface IParentAggregation {
    /** The type for the child in the parent/child relationship */
    type: RelationName | null;
}

export interface IPercentileRanksAggregation {
    method: IPercentilesMethod | null;
    values: number[] | null;
    keyed: boolean | null;
}

export interface IPercentilesMethod {
}

export interface IPercentilesAggregation {
    method: IPercentilesMethod | null;
    percents: number[] | null;
    keyed: boolean | null;
}

export interface IPercentilesBucketAggregation {
    percents: number[] | null;
}

export interface IRangeAggregation {
    field: Field | null;
    ranges: IAggregationRange[] | null;
    script: IScript | null;
}

/** A multi-bucket value source based aggregation which finds "rare" terms — terms that are at the long-tail of the distribution and are not frequent. Conceptually, this is like a terms aggregation that is sorted by _count ascending. */
export interface IRareTermsAggregation {
    /** Terms that should be excluded from the aggregation */
    exclude: TermsExclude | null;
    /** The field to find rare terms in */
    field: Field | null;
    /** Terms that should be included in the aggregation */
    include: TermsInclude | null;
    /** The maximum number of documents a term should appear in.
Defaults to 1 */
    maximumDocumentCount: number | null;
    /** The value that should be used if a document does not have the field being aggregated */
    missing: any | null;
    /** The precision of the internal CuckooFilters. Smaller precision leads to better approximation,
but higher memory usage. Cannot be smaller than 0.00001. Defaults to 0.01 */
    precision: number | null;
}

/** Filters which terms to exclude from the response */
export interface TermsExclude {
    /** The regular expression pattern to determine terms to exclude from the response */
    pattern: string | null;
    /** Collection of terms to exclude from the response */
    values: string[] | null;
}

/** Filters which terms to include in the response */
export interface TermsInclude {
    /** The total number of partitions we are interested in */
    numberOfPartitions: number | null;
    /** The current partition of terms we are interested in */
    partition: number | null;
}

export interface IReverseNestedAggregation {
    path: Field | null;
}

export interface ISamplerAggregation {
    shardSize: number | null;
}

export interface IScriptedMetricAggregation {
    combineScript: IScript | null;
    initScript: IScript | null;
    mapScript: IScript | null;
    params: { [key: string]: any; } | null;
    reduceScript: IScript | null;
}

export interface ISerialDifferencingAggregation {
    lag: number | null;
}

export interface ISignificantTermsAggregation {
    /** The default source of statistical information for background term
frequencies is the entire index. This scope can be narrowed
through the use of a background filter to focus in on significant
terms within a narrower context */
    backgroundFilter: QueryContainer | null;
    /** Use chi square to calculate significance score */
    chiSquare: IChiSquareHeuristic | null;
    /** Exclude term values for which buckets will be created. */
    exclude: IncludeExclude | null;
    /** Determines the mechanism by which aggregations are executed */
    executionHint: TermsAggregationExecutionHint | null;
    /** The field on which to run the aggregation */
    field: Field | null;
    /** Use Google normalized distance to calculate significance score */
    googleNormalizedDistance: IGoogleNormalizedDistanceHeuristic | null;
    /** Include term values for which buckets will be created. */
    include: IncludeExclude | null;
    /** Return only terms that match equal to or more than a configurable
number of hits */
    minimumDocumentCount: number | null;
    /** Use mutual information to calculate significance score */
    mutualInformation: IMutualInformationHeuristic | null;
    /** Use percentage to calculate significance score.

A simple calculation of the number of documents in the foreground
sample with a term divided by the number of documents in the background
with the term. By default this produces a score greater than zero
 and less than one. */
    percentageScore: IPercentageScoreHeuristic | null;
    /** Use a script to calculate a custom significance score. */
    script: IScriptedHeuristic | null;
    /** Regulates the certainty a shard has if the term should actually be added to the candidate
list or not with respect to the MinimumDocumentCount.
Terms will only be considered if their local shard frequency within
the set is higher than the ShardMinimumDocumentCount. */
    shardMinimumDocumentCount: number | null;
    /** Controls the number of candidate terms produced by each shard from which
the Size of terms is selected. */
    shardSize: number | null;
    /** Defines how many term buckets should be returned out of the overall
terms list */
    size: number | null;
}

export interface IChiSquareHeuristic {
    backgroundIsSuperSet: boolean | null;
    includeNegatives: boolean | null;
}

export interface IncludeExclude {
}

/** Determines how the terms aggregation is executed */
export enum TermsAggregationExecutionHint {
    Map = "map",
    GlobalOrdinals = "global_ordinals",
    GlobalOrdinalsHash = "global_ordinals_hash",
    GlobalOrdinalsLowCardinality = "global_ordinals_low_cardinality",
}

export interface IGoogleNormalizedDistanceHeuristic {
    backgroundIsSuperSet: boolean | null;
}

export interface IMutualInformationHeuristic {
    backgroundIsSuperSet: boolean | null;
    includeNegatives: boolean | null;
}

export interface IPercentageScoreHeuristic {
}

export interface IScriptedHeuristic {
    script: IScript | null;
}

/** An aggregation that returns interesting or unusual occurrences of free-text terms in a set. */
export interface ISignificantTextAggregation {
    /** The default source of statistical information for background term
frequencies is the entire index. This scope can be narrowed
through the use of a background filter to focus in on significant
terms within a narrower context */
    backgroundFilter: QueryContainer | null;
    /** Use chi square to calculate significance score */
    chiSquare: IChiSquareHeuristic | null;
    /** Exclude term values for which buckets will be created. */
    exclude: IncludeExclude | null;
    /** Determines the mechanism by which aggregations are executed */
    executionHint: TermsAggregationExecutionHint | null;
    /** The field on which to run the aggregation */
    field: Field | null;
    /** Whether to filter out near-duplicate text */
    filterDuplicateText: boolean | null;
    /** Use Google normalized distance to calculate significance score */
    googleNormalizedDistance: IGoogleNormalizedDistanceHeuristic | null;
    /** Include term values for which buckets will be created. */
    include: IncludeExclude | null;
    /** Return only terms that match equal to or more than a configurable
number of hits */
    minimumDocumentCount: number | null;
    /** Use mutual information to calculate significance score */
    mutualInformation: IMutualInformationHeuristic | null;
    /** Use percentage to calculate significance score.

A simple calculation of the number of documents in the foreground
sample with a term divided by the number of documents in the background
with the term. By default this produces a score greater than zero
 and less than one. */
    percentageScore: IPercentageScoreHeuristic | null;
    /** Use a script to calculate a custom significance score. */
    script: IScriptedHeuristic | null;
    /** Regulates the certainty a shard has if the term should actually be added to the candidate
list or not with respect to the MinimumDocumentCount.
Terms will only be considered if their local shard frequency within
the set is higher than the ShardMinimumDocumentCount. */
    shardMinimumDocumentCount: number | null;
    /** Controls the number of candidate terms produced by each shard from which
the Size of terms is selected. */
    shardSize: number | null;
    /** Defines how many term buckets should be returned out of the overall
terms list */
    size: number | null;
    /** Ordinarily the indexed field name and the original JSON field being
retrieved share the same name. However with more complex field
mappings using features like copy_to the source JSON field(s)
and the indexed field being aggregated can differ.
In these cases it is possible to list the JSON _source fields
from which text will be analyzed using SourceFields */
    sourceFields: Field[] | null;
}

export interface IStatsAggregation {
}

export interface IStatsBucketAggregation {
}

export interface ISumAggregation {
}

export interface ISumBucketAggregation {
}

export interface ITermsAggregation {
    collectMode: TermsAggregationCollectMode | null;
    exclude: TermsExclude | null;
    executionHint: TermsAggregationExecutionHint | null;
    field: Field | null;
    include: TermsInclude | null;
    minimumDocumentCount: number | null;
    missing: any | null;
    order: TermsOrder[] | null;
    script: IScript | null;
    shardSize: number | null;
    showTermDocCountError: boolean | null;
    size: number | null;
}

/** Determines how the terms aggregation is executed */
export enum TermsAggregationCollectMode {
    DepthFirst = "depth_first",
    BreadthFirst = "breadth_first",
}

export interface TermsOrder {
    key: string | null;
    order: SortOrder;
}

export interface ITopHitsAggregation {
    docValueFields: Field[] | null;
    explain: boolean | null;
    from: number | null;
    highlight: IHighlight | null;
    scriptFields: IScriptFields | null;
    size: number | null;
    sort: ISort[] | null;
    source: UnionOfBooleanAndISourceFilter | null;
    storedFields: Field[] | null;
    trackScores: boolean | null;
    version: boolean | null;
}

export interface IHighlight {
    /** Defines what constitutes a boundary for highlighting when using the fast vector highlighter.
It's a single string with each boundary character defined in it. It defaults to .,!? \t\n. */
    boundaryChars: string | null;
    /** Controls how far to look for boundary characters. Defaults to 20. */
    boundaryMaxScan: number | null;
    /** When highlighting a field using the unified highlighter or the fast vector highlighter, you can specify how to break the highlighted
fragments using boundary_scanner */
    boundaryScanner: BoundaryScanner | null;
    /** You can further specify boundary_scanner_locale to control which Locale is used to search the text for these boundaries. */
    boundaryScannerLocale: string | null;
    /** Define how highlighted text will be encoded.
It can be either default (no encoding) or html (will escape html, if you use html highlighting tags). */
    encoder: HighlighterEncoder | null;
    fields: { [key: string]: IHighlightField; } | null;
    /** Fragmenter can control how text should be broken up in highlight snippets. However, this option is
applicable only for the Plain Highlighter */
    fragmenter: HighlighterFragmenter | null;
    /** Controls the margin to start highlighting from when using the fast vector highlighter */
    fragmentOffset: number | null;
    /** The size of the highlighted fragment, in characters. Defaults to 100 */
    fragmentSize: number | null;
    /** The query to use for highlighting */
    highlightQuery: QueryContainer | null;
    /** If this setting is set to a non-negative value, the highlighting stops at this defined maximum limit, and the
rest of the text is not processed, thus not highlighted and no error is returned. */
    maxAnalyzerOffset: number | null;
    maxFragmentLength: number | null;
    /** In the case where there is no matching fragment to highlight, the default is to not return anything. Instead, we can return a snippet of
text from
the beginning of the field by setting no_match_size (default 0) to the length of the text that you want returned. The actual length may be
shorter or longer than specified as it tries to break on a word boundary. */
    noMatchSize: number | null;
    /** The maximum number of fragments to return. Defaults to 5. */
    numberOfFragments: number | null;
    /** The order in which highlighted fragments are sorted */
    order: HighlighterOrder | null;
    /** Controls the post tag in which to wrap highights.
By default, the highlighting will wrap highlighted text in <em> and </em>.
Using the fast vector highlighter, there can be more tags, and the importance is ordered. */
    postTags: string[] | null;
    /** Controls the pre tag in which to wrap highights.
By default, the highlighting will wrap highlighted text in <em> and </em>.
Using the fast vector highlighter, there can be more tags, and the importance is ordered. */
    preTags: string[] | null;
    /** Use a specific "tag" schemas. */
    requireFieldMatch: boolean | null;
    /** Use a specific "tag" schemas. */
    tagsSchema: HighlighterTagsSchema | null;
}

export enum BoundaryScanner {
    Characters = "chars",
    Sentence = "sentence",
    Word = "word",
}

/** Indicates if the highlighted text should be HTML encoded */
export enum HighlighterEncoder {
    Default = "default",
    Html = "html",
}

export interface IHighlightField {
    /** Defines what constitutes a boundary for highlighting when using the fast vector highlighter.
It's a single string with each boundary character defined in it. It defaults to .,!? \t\n. */
    boundaryChars: string | null;
    /** Controls how far to look for boundary characters. Defaults to 20. */
    boundaryMaxScan: number | null;
    /** When highlighting a field using the unified highlighter or the fast vector highlighter, you can specify how to break
the highlighted
fragments using boundary_scanner */
    boundaryScanner: BoundaryScanner | null;
    /** You can further specify boundary_scanner_locale to control which Locale is used to search the text for these
boundaries. */
    boundaryScannerLocale: string | null;
    /** The field on which to perform highlighting. */
    field: Field | null;
    /** Forces the highlighting to highlight fields based on the source even if fields are stored separately. */
    forceSource: boolean | null;
    /** Fragmenter can control how text should be broken up in highlight snippets. However, this option is
applicable only for the Plain Highlighter */
    fragmenter: HighlighterFragmenter | null;
    /** Controls the margin to start highlighting from when using the fast vector highlighter */
    fragmentOffset: number | null;
    /** The size of the highlighted fragment, in characters. Defaults to 100 */
    fragmentSize: number | null;
    /** The query to use for highlighting */
    highlightQuery: QueryContainer | null;
    /** Combine matches on multiple fields to highlight a single field when using the fast vector highighter.
This is most intuitive for multifields that analyze the same string in different ways.
All matched fields must have term_vector set to with_positions_offsets, but only the field to
which the matches are combined is loaded so only that field would benefit from having store set to yes. */
    matchedFields: Field[] | null;
    /** If this setting is set to a non-negative value, the highlighting stops at this defined maximum limit, and the
rest of the text is not processed, thus not highlighted and no error is returned. */
    maxAnalyzerOffset: number | null;
    maxFragmentLength: number | null;
    /** The length of a snippet of text from the beginning of the field to return
when no match for highlighting is found. Default behaviour is to not return anything when a match is not found.
The actual length may be shorter than specified as it tries to break on a word boundary. */
    noMatchSize: number | null;
    /** The maximum number of fragments to return. Defaults to 5. */
    numberOfFragments: number | null;
    /** The order in which highlighted fragments are sorted. Only valid for the unified highlighter. */
    order: HighlighterOrder | null;
    /** Controls the number of matching phrases in a document that are considered. Prevents the
Fvh highlighter from analyzing too many phrases and consuming too much memory.
When using matched_fields, PhraseLimit phrases per matched field are considered. Raising the limit
increases query time
and consumes more memory. Only supported by the Fvh highlighter. Defaults to 256. */
    phraseLimit: number | null;
    /** Controls the post tag in which to wrap highights.
By default, the highlighting will wrap highlighted text in <em> and </em>.
Using the fast vector highlighter, there can be more tags, and the importance is ordered. */
    postTags: string[] | null;
    /** Controls the pre tag in which to wrap highights.
By default, the highlighting will wrap highlighted text in <em> and </em>.
Using the fast vector highlighter, there can be more tags, and the importance is ordered. */
    preTags: string[] | null;
    /** Determines if only fields that hold a query match will be highlighted. Set to false
will cause any field to be highlighted regardless of whether the query matched specifically on them. Default behaviour
is true. */
    requireFieldMatch: boolean | null;
    /** Use a specific "tag" schemas. */
    tagsSchema: HighlighterTagsSchema | null;
    /** The type of highlighter to use. Can be a defined or custom highlighter */
    type: UnionOfHighlighterTypeAndString | null;
}

/** Fragmenter can control how text should be broken up in highlight snippets. However, this option is applicable only for the Plain Highlighter */
export enum HighlighterFragmenter {
    Simple = "simple",
    Span = "span",
}

/** Sorts highlighted fragments */
export enum HighlighterOrder {
    Score = "score",
}

/** Use a built-in tag schema */
export enum HighlighterTagsSchema {
    Styled = "styled",
}

/** Represents the union of two types,  and . Used in scenarios where an OpenSearch API may accept more than one different input data structure. */
export interface UnionOfHighlighterTypeAndString {
}

export interface IScriptFields {
}

/** Represents the union of two types,  and . Used in scenarios where an OpenSearch API may accept more than one different input data structure. */
export interface UnionOfBooleanAndISourceFilter {
}

export interface IValueCountAggregation {
}

export interface IWeightedAverageAggregation {
    /** The optional numeric response formatter */
    format: string | null;
    /** The configuration for the field or script that provides the values */
    value: IWeightedAverageValue | null;
    /** A hint about the values for pure scripts or unmapped fields  */
    valueType: ValueType | null;
    /** The configuration for the field or script that provides the weights */
    weight: IWeightedAverageValue | null;
}

/** The configuration for a field or script that provides a value or weight for WeightedAverageAggregation */
export interface IWeightedAverageValue {
    /** The field that values should be extracted from */
    field: Field | null;
    /** defines how documents that are missing a value should be treated.
            The default behavior is different for value and weight:
            By default, if the value field is missing the document is ignored and the aggregation
            moves on to the next document.
            If the weight field is missing, it is assumed to have a weight of 1 (like a normal average).
             */
    missing: number | null;
    /** A script to derive the value and the weight from */
    script: IScript | null;
}

/** The type of value */
export enum ValueType {
    String = "string",
    Long = "long",
    Double = "double",
    Number = "number",
    Date = "date",
    DateNanos = "date_nanos",
    Ip = "ip",
    Numeric = "numeric",
    GeoPoint = "geo_point",
    Boolean = "boolean",
}

/** This single-value aggregation approximates the median absolute deviation of its search results.                       	Median absolute deviation is a measure of variability. It is a robust statistic, meaning that it is useful for describing data that may have outliers, or may not be normally distributed. For such data it can be more descriptive than standard deviation.                       	It is calculated as the median of each data point’s deviation from the median of the entire sample. That is, for a random variable X, the median absolute deviation is median(|median(X) - Xi|). */
export interface IMedianAbsoluteDeviationAggregation {
    /** TDigest algorithm component that controls memory usage and approximation error.
By increasing the compression value, you can increase the accuracy
at the cost of more memory. Larger compression values also make
the algorithm slower since the underlying tree data structure grows in
size, resulting in more expensive operations. The default compression value is 100. */
    compression: number | null;
}

export interface IMultiTermsAggregation {
    collectMode: TermsAggregationCollectMode | null;
    minimumDocumentCount: number | null;
    order: TermsOrder[] | null;
    script: IScript | null;
    shardMinimumDocumentCount: number | null;
    shardSize: number | null;
    showTermDocCountError: boolean | null;
    size: number | null;
    terms: ITerm[] | null;
}

export interface ITerm {
    field: Field | null;
    missing: any | null;
}

export interface IVariableWidthHistogramAggregation {
    /** The field to target. */
    field: Field | null;
    buckets: number | null;
    initialBuffer: number | null;
    shardSize: number | null;
}

export interface LoginContext {
    isSuccess: boolean;
    user: UserDetail | null;
    returnUrl: string | null;
    authorizationUrl: string | null;
    version: string | null;
}

export interface UserDetail {
    userId: string;
    displayName: string;
    userName: string;
    localeLanguage: string;
    activeAccount: SellerAccount;
    features: Feature[];
    hasManyAccounts: boolean;
    impersonatorDisplayName: string | null;
    permissions: Permission[];
}

export interface SellerAccount {
    id: string;
    accountName: string;
    impersonatedUserId: string | null;
    impersonatedUsername: string | null;
    currencyCode: string | null;
    sellerAccountSettings: SellerAccountSettings;
    marketplaceSettings: MarketplaceAccountSetting[];
    isConsignor: boolean | null;
    isConsignee: boolean | null;
    sellerAccountState: SellerAccountState | null;
    sellerAccountType: SellerAccountType | null;
    isCached: boolean;
}

export interface SellerAccountSettings {
    defaultSplitType: number | null;
    ticketTypeRules: string | null;
    inHandDatePaddingInDays: number | null;
    defaultHideSeatNumbers: boolean | null;
    priceFloor: number | null;
    defaultMaxQuantityDisplay: number | null;
    saleListingPriceBoundary: number | null;
    inHandDaysBeforeEvent: number | null;
    defaultManualMaxDisplayQuantity: number | null;
    adminHoldIndefinitelyForCancelledSales: boolean | null;
}

export interface MarketplaceAccountSetting {
    isEnabled: boolean;
    mkp: Marketplace;
    markup: number | null;
    sellerFee: number | null;
    hasApiToken: boolean;
    hasApiRefreshToken: boolean;
    tokenExpired: boolean;
    seatSaverFee: number | null;
    isSyncHandledByProcessor: boolean;
}

export enum SellerAccountState {
    Migrating = "Migrating",
    Active = "Active",
    Churned = "Churned",
    Blocked = "Blocked",
}

export enum SellerAccountType {
    Sandbox = "Sandbox",
    Live = "Live",
    Employee = "Employee",
    Processor = "Processor",
    BrokerReadonly = "BrokerReadonly",
    Trial = "Trial",
    International = "International",
    DI = "DI",
}

export enum Permission {
    Sales_ViewAll = "Sales_ViewAll",
    Sales_ViewRecent = "Sales_ViewRecent",
    Sales_ViewRecentFromExternalMarketplace = "Sales_ViewRecentFromExternalMarketplace",
    Sales_ConfirmReject = "Sales_ConfirmReject",
    Sales_Fulfill = "Sales_Fulfill",
    Sales_CreateForExternalMarketplaces = "Sales_CreateForExternalMarketplaces",
    Sales_ViewProceeds = "Sales_ViewProceeds",
    Sales_ViewRecentProceeds = "Sales_ViewRecentProceeds",
    Sales_ViewCostAndMargin = "Sales_ViewCostAndMargin",
    Sales_ViewPaymentState = "Sales_ViewPaymentState",
    Sales_ViewFulfillmentArtifacts = "Sales_ViewFulfillmentArtifacts",
    Sales_ManageHold = "Sales_ManageHold",
    Sales_AddTagType = "Sales_AddTagType",
    Sales_UpdateTags = "Sales_UpdateTags",
    Sales_ViewSalesOnIsPricerOf = "Sales_ViewSalesOnIsPricerOf",
    Sales_UpdateSalesInfo = "Sales_UpdateSalesInfo",
    Sales_UpdateSalesInfoOnIsPricerOf = "Sales_UpdateSalesInfoOnIsPricerOf",
    Sales_UpdateSalesInfoOnIsFulfillerOf = "Sales_UpdateSalesInfoOnIsFulfillerOf",
    Sales_FulfillOnIsFulfillerOf = "Sales_FulfillOnIsFulfillerOf",
    Sales_ViewSalesOnPurchasedBy = "Sales_ViewSalesOnPurchasedBy",
    Sales_UpdateSaleOnPurchasedBy = "Sales_UpdateSaleOnPurchasedBy",
    Sales_FulfillOnPurchasedBy = "Sales_FulfillOnPurchasedBy",
    Sales_FulfillOnPricerOf = "Sales_FulfillOnPricerOf",
    Sales_UpdateTagsOnPurchasedBy = "Sales_UpdateTagsOnPurchasedBy",
    Sales_UpdateTagsOnIsPricerOf = "Sales_UpdateTagsOnIsPricerOf",
    Sales_UpdateTagsOnIsFulfillerOf = "Sales_UpdateTagsOnIsFulfillerOf",
    Sales_ConfirmRejectOnIsPricerOf = "Sales_ConfirmRejectOnIsPricerOf",
    Sales_ConfirmRejectOnPurchasedBy = "Sales_ConfirmRejectOnPurchasedBy",
    Sales_ViewFulfillmentArtifactsOnPurchasedBy = "Sales_ViewFulfillmentArtifactsOnPurchasedBy",
    Sales_ViewFulfillmentArtifactsOnIsPricerOf = "Sales_ViewFulfillmentArtifactsOnIsPricerOf",
    Sales_ConfirmRejectOnIsFulfillerOf = "Sales_ConfirmRejectOnIsFulfillerOf",
    Sales_ViewSalesOnIsFulfillerOf = "Sales_ViewSalesOnIsFulfillerOf",
    Sales_ViewFulfillmentArtifactsOnIsFulfillerOf = "Sales_ViewFulfillmentArtifactsOnIsFulfillerOf",
    Sales_CreateOfflineSale = "Sales_CreateOfflineSale",
    Sales_ManageOfflineSale = "Sales_ManageOfflineSale",
    Sales_ManageOfflineSaleCreatedBy = "Sales_ManageOfflineSaleCreatedBy",
    Sales_ConfirmTransferWithoutProof = "Sales_ConfirmTransferWithoutProof",
    Sales_ResetFulfillment = "Sales_ResetFulfillment",
    Sales_ViewHomePageMetrics = "Sales_ViewHomePageMetrics",
    Sales_Export = "Sales_Export",
    Sales_ViewColumnTotals = "Sales_ViewColumnTotals",
    Inventory_ViewAll = "Inventory_ViewAll",
    Inventory_ViewRecent = "Inventory_ViewRecent",
    Inventory_ViewRecentFromExternalMarketplace = "Inventory_ViewRecentFromExternalMarketplace",
    Inventory_ViewAllMarketplaceAttributes = "Inventory_ViewAllMarketplaceAttributes",
    Inventory_ViewExternalMarketplaceAttributes = "Inventory_ViewExternalMarketplaceAttributes",
    Inventory_ViewFulfillmentArtifacts = "Inventory_ViewFulfillmentArtifacts",
    Inventory_SetPrice = "Inventory_SetPrice",
    Inventory_SetPriceOnPurchasedBy = "Inventory_SetPriceOnPurchasedBy",
    Inventory_SetPriceOnIsPricerOf = "Inventory_SetPriceOnIsPricerOf",
    Inventory_Predelivery = "Inventory_Predelivery",
    Inventory_BroadcastUnbroadcast = "Inventory_BroadcastUnbroadcast",
    Inventory_BroadcastUnbroadcastOnPurchasedBy = "Inventory_BroadcastUnbroadcastOnPurchasedBy",
    Inventory_EditPricing = "Inventory_EditPricing",
    Inventory_UpdateListingInfo = "Inventory_UpdateListingInfo",
    Inventory_UpdateListingInfoOnPurchasedBy = "Inventory_UpdateListingInfoOnPurchasedBy",
    Inventory_AddTagType = "Inventory_AddTagType",
    Inventory_UpdateTags = "Inventory_UpdateTags",
    Inventory_UpdateTagsOnPurchasedBy = "Inventory_UpdateTagsOnPurchasedBy",
    Inventory_ViewListingOnIsPricerOf = "Inventory_ViewListingOnIsPricerOf",
    Inventory_UpdateListingInfoOnIsPricerOf = "Inventory_UpdateListingInfoOnIsPricerOf",
    Inventory_UpdateTagsOnIsPricerOf = "Inventory_UpdateTagsOnIsPricerOf",
    Inventory_PredeliveryOnPurchasedBy = "Inventory_PredeliveryOnPurchasedBy",
    Inventory_PredeliveryOnIsPricerOf = "Inventory_PredeliveryOnIsPricerOf",
    Inventory_ViewListingsOnPurchasedBy = "Inventory_ViewListingsOnPurchasedBy",
    Inventory_ViewFulfillmentArtifactsOnPurchasedBy = "Inventory_ViewFulfillmentArtifactsOnPurchasedBy",
    Inventory_ViewFulfillmentArtifactsOnIsPricerOf = "Inventory_ViewFulfillmentArtifactsOnIsPricerOf",
    Inventory_BroadcastUnbroadcastOnIsPricerOf = "Inventory_BroadcastUnbroadcastOnIsPricerOf",
    Inventory_AddSeatSaver = "Inventory_AddSeatSaver",
    Inventory_ManageSeatSaver = "Inventory_ManageSeatSaver",
    Inventory_ManageSeatSaverCreatedBy = "Inventory_ManageSeatSaverCreatedBy",
    Inventory_UpdateDeliveryStrategy = "Inventory_UpdateDeliveryStrategy",
    Inventory_UpdateDeliveryStrategyOnIsPricerOf = "Inventory_UpdateDeliveryStrategyOnIsPricerOf",
    Inventory_UpdateDeliveryStrategyOnPurchasedBy = "Inventory_UpdateDeliveryStrategyOnPurchasedBy",
    Inventory_ManageAdminHolds = "Inventory_ManageAdminHolds",
    Inventory_Export = "Inventory_Export",
    Inventory_ViewColumnTotals = "Inventory_ViewColumnTotals",
    SellerAccount_Admin = "SellerAccount_Admin",
    SellerSupportCase_Create = "SellerSupportCase_Create",
    SellerSupportCase_View = "SellerSupportCase_View",
    Purchases_ViewAll = "Purchases_ViewAll",
    Purchases_ViewRecent = "Purchases_ViewRecent",
    Purchases_Edit = "Purchases_Edit",
    Purchases_EditOwned = "Purchases_EditOwned",
    Purchases_Create = "Purchases_Create",
    Purchases_AddTagType = "Purchases_AddTagType",
    Purchases_UpdateTags = "Purchases_UpdateTags",
    Purchases_UpdateTagsOwned = "Purchases_UpdateTagsOwned",
    Purchases_ViewOwned = "Purchases_ViewOwned",
    Purchases_UpdateBuyerCommission = "Purchases_UpdateBuyerCommission",
    Purchases_UpdateBuyerCommissionOwned = "Purchases_UpdateBuyerCommissionOwned",
    Purchases_UpdateDeliveryType = "Purchases_UpdateDeliveryType",
    Purchases_UpdateDeliveryTypeOwned = "Purchases_UpdateDeliveryTypeOwned",
    Purchases_UpdateCustomDeliveryType = "Purchases_UpdateCustomDeliveryType",
    Purchases_UpdateCustomDeliveryTypeOwned = "Purchases_UpdateCustomDeliveryTypeOwned",
    Purchases_UpdateSeatTraits = "Purchases_UpdateSeatTraits",
    Purchases_UpdateSeatTraitsOwned = "Purchases_UpdateSeatTraitsOwned",
    Purchases_LockUnlockCommission = "Purchases_LockUnlockCommission",
    Purchases_LockUnlockCommissionOwned = "Purchases_LockUnlockCommissionOwned",
    Purchases_EditVendor = "Purchases_EditVendor",
    Purchases_Export = "Purchases_Export",
    Purchases_ViewColumnTotals = "Purchases_ViewColumnTotals",
    Events_ViewAll = "Events_ViewAll",
    Events_AddTagType = "Events_AddTagType",
    Events_UpdateTags = "Events_UpdateTags",
    Events_SetPrice = "Events_SetPrice",
    Events_Edit = "Events_Edit",
    Events_ManageEventDiscovery = "Events_ManageEventDiscovery",
    Events_TeamPricing = "Events_TeamPricing",
    Accounts_ViewAll = "Accounts_ViewAll",
    Account_SetPrice = "Account_SetPrice",
    TicketGroups_ViewAll = "TicketGroups_ViewAll",
    Webhook_View = "Webhook_View",
    Webhook_Create = "Webhook_Create",
    Webhook_Edit = "Webhook_Edit",
    EventConfig_Edit = "EventConfig_Edit",
    EventConfig_Create = "EventConfig_Create",
    EventConfig_View = "EventConfig_View",
    Reports_CreateReports = "Reports_CreateReports",
    Reports_UpdateReports = "Reports_UpdateReports",
    Reports_UpdateReportsOwned = "Reports_UpdateReportsOwned",
    Reports_ViewInventoryReports = "Reports_ViewInventoryReports",
    Reports_ViewSalesReports = "Reports_ViewSalesReports",
    Reports_ViewAll = "Reports_ViewAll",
    Reports_ViewGlobalReports = "Reports_ViewGlobalReports",
    Accounting_ViewAll = "Accounting_ViewAll",
    Accounting_ViewPaymentsOnSale = "Accounting_ViewPaymentsOnSale",
    Accounting_ViewStubhubPayments = "Accounting_ViewStubhubPayments",
    Accounting_ViewAutoPricingSettings = "Accounting_ViewAutoPricingSettings",
    AdPlatform_Edit = "AdPlatform_Edit",
    General_ViewReleaseNotes = "General_ViewReleaseNotes",
    General_ViewNotifications = "General_ViewNotifications",
    General_ViewHelpCenter = "General_ViewHelpCenter",
}

export interface LoginRequest {
    code: string | null;
    state: string | null;
}

export interface EntitiesWithSummaryOfMarketplaceSalePayment {
    items: MarketplaceSalePayment[];
    summary: MarketplaceSalePayment | null;
    /** PIT ID for next page requests, null if not using PIT (Point-In-Time) pagination */
    pitId: string | null;
    /** Total number of matching documents that may have not been returned yet due to pagination */
    totalItemsCount: number | null;
}

export interface MarketplaceSalePayment {
    /** MarketplacePaymentLineId */
    id: number;
    /** Marketplace */
    mkp: Marketplace | null;
    /** ExternalPaymentId */
    extPmtId: string;
    /** PaymentReferenceId */
    pmtRefId: string | null;
    pmtDate: string | null;
    recvDate: string | null;
    state: MarketplacePaymentState;
    /** PaymentAmount */
    pmtAmt: UiMoney;
    /** ProceedsAmount */
    proceedsAmt: UiMoney | null;
    credit: UiMoney | null;
    charge: UiMoney | null;
    convertedPmtAmt: UiMoney | null;
    mkpPmtTerm: MarketplacePaymentTerm | null;
    manualPmtAmt: UiMoney | null;
    manualProceedsAmt: UiMoney | null;
    manualCreditAmt: UiMoney | null;
    manualChargeAmt: UiMoney | null;
    isLocked: boolean | null;
}

export enum MarketplacePaymentTerm {
    PaymentUponSaleConfirmation = "PaymentUponSaleConfirmation",
    PaymentUponDelivery = "PaymentUponDelivery",
    PaymentPostEvent = "PaymentPostEvent",
}

export interface MarketplacePaymentQuery {
    marketplace: Marketplace | null;
    marketplacePaymentState: MarketplacePaymentState | null;
    paymentDates: DateTimeRangeWithRelative | null;
    sortBy: EventSort | null;
    isSortDescending: boolean | null;
    hasPaymentLineUnmappedToSale: boolean | null;
    hasPaymentLineUnmappedToSaleLineItem: boolean | null;
    hasPaymentTotalDiscrepancy: boolean | null;
    hasProceedsTotalDiscrepancy: boolean | null;
    hasCreditTotalDiscrepancy: boolean | null;
    hasChargeTotalDiscrepancy: boolean | null;
    currencyCodes: string[] | null;
    /** Dummy property for the UI to match the interface */
    viewMode: string | null;
    /** Output from the frontend application: `new Date().getTimezoneOffset()`
E.g. UTC-8 => 480
Used for RelativeTimeRange typed properties
Currently only used for reporting */
    timezoneOffsetMins: number | null;
}

export interface MonthContainingMarketplacePaymentsResult {
    firstOfMonth: string;
    totalPaymentAmount: UiMoney | null;
}

export interface MarketplacePaymentLineWithSaleInfo {
    /** MarketplacePaymentLineId */
    id: number;
    /** Marketplace */
    marketplace: Marketplace | null;
    /** MarketplacePaymentId */
    posPmtId: number;
    /** ExternalPaymentId */
    extPmtId: string;
    /** ExternalPaymentLineId */
    extLineId: string;
    state: MarketplacePaymentState;
    date: string | null;
    recvDate: string | null;
    /** IsCredit */
    isCred: boolean;
    /** Amount */
    amt: UiMoney;
    type: MarketplacePaymentLineType;
    isAddedToSale: boolean | null;
    isLocked: boolean | null;
    saleId: number | null;
    extSaleId: string;
    saleStatus: PointOfSaleSaleStatus | null;
    /** The event of which this entity is for. */
    posEvId: string | null;
    viagEvId: number | null;
    viagEvMapId: string | null;
    viagVirtId: string | null;
    seating: Seating | null;
    convertedPmtAmt: UiMoney | null;
}

export interface MarketplacePaymentLineQuery {
    hasUnlinkedChargesCredits: boolean | null;
    externalSaleIdContains: string | null;
    /** Dummy property for the UI to match the interface */
    viewMode: string | null;
    /** Output from the frontend application: `new Date().getTimezoneOffset()`
E.g. UTC-8 => 480
Used for RelativeTimeRange typed properties
Currently only used for reporting */
    timezoneOffsetMins: number | null;
}

export interface MarketplacePaymentSaleLineInput {
    marketplacePaymentLineId: number;
    marketplacePaymentId: number;
    externalPaymentLineId: PosFieldOfString | null;
    paymentLineType: PosFieldOfNullableMarketplacePaymentLineType | null;
    saleId: PosFieldOfNullableLong | null;
    externalSaleId: PosFieldOfString | null;
    amount: PosFieldOfNullableDecimal | null;
    currency: PosFieldOfString | null;
}

export interface PosFieldOfNullableMarketplacePaymentLineType {
    value: MarketplacePaymentLineType | null;
    hasChanged: boolean;
}

export interface MarketplacePaymentInput {
    marketplacePaymentId: number;
    externalPaymentId: PosFieldOfString | null;
    marketplace: PosFieldOfNullableMarketplace | null;
    paymentDate: PosFieldOfNullableDateTime | null;
    paymentReferenceId: PosFieldOfString | null;
    paymentCurrency: PosFieldOfString | null;
    manualPaymentAmount: PosFieldOfNullableDecimal | null;
    manualProceedsAmount: PosFieldOfNullableDecimal | null;
    manualCreditAmount: PosFieldOfNullableDecimal | null;
    manualChargeAmount: PosFieldOfNullableDecimal | null;
}

export interface PosFieldOfNullableMarketplace {
    value: Marketplace | null;
    hasChanged: boolean;
}

export interface UiCurrency {
    code: string;
    dec: number;
    sym: string;
}

export interface Notification {
    notificationId: number;
    notificationType: NotificationType;
    entityType: ActionOutboxEntityType;
    entityId: number;
    notificationState: NotificationState;
    createDateTime: string;
    expirationDateTime: string;
    posEventId: string | null;
    section: string | null;
    row: string | null;
    piggybackRow: string | null;
    seatFrom: string | null;
    seatTo: string | null;
    marketplace: Marketplace | null;
    marketplaceEntityId: string | null;
    event: Event | null;
    performer: Performer | null;
    venue: Venue | null;
}

export enum NotificationType {
    SaleNew = "SaleNew",
    SaleFulfilmentFailed = "SaleFulfilmentFailed",
    SaleMarketplaceCancelled = "SaleMarketplaceCancelled",
    ListingHideSeatsFailed = "ListingHideSeatsFailed",
    ListingUpdateAllInPriceFailed = "ListingUpdateAllInPriceFailed",
    ListingUpdateInHandDateFailed = "ListingUpdateInHandDateFailed",
    ListingUpdateSplitTypeFailed = "ListingUpdateSplitTypeFailed",
    ListingUpdateDeliveryTypeFailed = "ListingUpdateDeliveryTypeFailed",
    ListingUpdateUnitNetProceedsFailed = "ListingUpdateUnitNetProceedsFailed",
    ListingBroadcastFailed = "ListingBroadcastFailed",
    ListingUnbroadcastFailed = "ListingUnbroadcastFailed",
    ListingMergeFailed = "ListingMergeFailed",
    ListingSplitFailed = "ListingSplitFailed",
    ListingPriceUpdate = "ListingPriceUpdate",
    AutopriceBelowFloor = "AutopriceBelowFloor",
    AutopriceInsufficientCompListings = "AutopriceInsufficientCompListings",
    AutopriceFirebrake = "AutopriceFirebrake",
    SellerSupportCaseNewReply = "SellerSupportCaseNewReply",
}

export enum NotificationState {
    Active = "Active",
    Inactive = "Inactive",
}

export interface UpdateListingGroupAutoPriceSettingsFromOnePagerRequest {
    autoPricingSettings: ListingGroupAutoPriceSettings;
    hasChangesInCompSettings: boolean;
    hasChangesInUndercutSettings: boolean;
    hasChangesInOutlierSettings: boolean;
}

export interface ListingGroupAutoPriceSettings extends AutoPricingInputs {
    desiredActiveListings: number | null;
    deprioritizedQuantities: string[] | null;
    /** Rank Premium UndercutAbsoluteAmount */
    undAbsAmt: number | null;
    /** Rank Premium UndercutRelativeAmount */
    undRelAmt: number | null;
    netProceedsFloor: number | null;
    netProceedsCeiling: number | null;
    autoPricingEnabled: boolean | null;
    /** Starting amount for manual price rank premiums in a group. Listings
of rank n will have a rank premium of StartingUnitNetProceeds + (n-1) * RankPremium
set as their unit net proceeds. */
    startingUnitNetProceeds: number | null;
}

export interface EventAutoPricingSettingsInputs extends AutoPricingInputs {
    compRowOffsetMode: CompRowOffsetMode | null;
}

export enum CompRowOffsetMode {
    Ordinal = "Ordinal",
    Text = "Text",
}

export interface EventConfigScoreOverride {
    id: number;
    name: string;
    eventIds: number[] | null;
    cfgId: number;
    cfgPayload: string | null;
    scoreOverrides: SectionScoreOverride[];
    isActive: boolean | null;
    isTemplate: boolean | null;
    viagogoEventId: number | null;
    venueId: number | null;
    categoryId: number | null;
}

export interface SellerAccountEventConfigScoreOverrides {
    eventConfigScoreOverrideId: number;
    configPayload: string;
    name: string;
    eventId: number | null;
    createDate: string;
    updateDate: string;
}

export interface SellThroughRateHistory {
    sellThroughRatePercentage: number;
    timelineDate: string;
}

export interface AutoPricingSettingsCollection extends AutoPricingInputs {
    autoPricingSettingsCollectionId: number | null;
    strategyName: string;
}

export interface UpsertAutoCompSettingsInput {
    viagogoEventId: number;
    venueZoneConfigType: string;
    rowCompOffset: number;
    rowGroupSetting: string;
    sectionGroupCustomRankEnabled: boolean;
    rowCompOverrides: RowCompOverrideInput[];
    zoneSectionAreaGroupLookupJson: string;
}

export interface RowCompOverrideInput {
    rowOrdinalFrom: number;
    rowOrdinalTo: number;
    offsetOverride: number;
}

export interface AutoCompSettingsResult {
    venueZoneConfigType: VenueZoneConfigType | null;
    rowCompOffset: number;
    rowGroupSetting: RowGroupSetting | null;
    sectionGroupCustomRankEnabled: boolean;
    rowCompOverrides: RowCompOverride[] | null;
}

export interface VenueMapZoneConfigInfo {
    defaultVenueZoneConfigType: VenueZoneConfigType;
    venueMapZoneConfigs: { [key in keyof typeof VenueZoneConfigType]?: { [key: string]: SectionSectionGroup; }; };
}

export interface SectionSectionGroup {
    sectId: number;
    areaRank: number;
    sectionGroupRank: number;
    sectionGroupAreaType: SectionGroupAreaType | null;
    sectionGroupAreaName: string | null;
    ticketClassId: number | null;
    ticketClassName: string | null;
    sectionGroupColor: string;
}

export enum SectionGroupAreaType {
    Unknown = "Unknown",
    Center = "Center",
    LeftRight = "LeftRight",
    FarLeftFarRight = "FarLeftFarRight",
    Front = "Front",
    Sides = "Sides",
    SideT1 = "SideT1",
    SideT2 = "SideT2",
    Ends = "Ends",
    Rear = "Rear",
    Corners = "Corners",
}

export interface EventsPricingConfig {
    sharedConfigId: number | null;
    canUseZoneMap: boolean;
}

export interface VenueZoneConfigOverride {
    name: string;
    eventId: number | null;
    configId: number | null;
    venueId: number | null;
    sectionSectionGroupLookup: { [key: string]: SectionSectionGroup; };
}

export interface UpsertVenueZoneSectionGroupOverridesInput {
    viagogoEventId: number;
    venueZoneOverrideId: number | null;
    name: string;
    sectionSectionGroupsJson: string;
    saveAsNewMap: boolean;
}

export interface EventMapConfigMetadata {
    /** The selected or default VenueZoneConfigType */
    defaultVenueZoneConfigType: VenueZoneConfigType;
    /** The selected or default VenueZoneConfigType */
    selectedVenueMapConfigType: VenueZoneConfigType | null;
    /** The selected custom VenueZone override id. If this value is null then we will always use the DefaultVenueZoneConfigType
as a fallback, but the override will always take precedence */
    selectedOverrideId: number | null;
    /** The selected custom VenueZone override name */
    selectedOverrideName: string | null;
    /** Data needed to render the preview of the selected config when hovering over the "View Event Map" button */
    selectedVenueMapConfig: { [key: string]: SectionSectionGroup; };
}

export interface SqsSectionRowRecommendations {
    modelVersionId: number;
    rowRecommendations: { [key: string]: SelectedSectionSettings; };
}

export enum VelocityCircuitBreakerSuppressionType {
    Reset = "Reset",
    Permanent = "Permanent",
}

export interface SellerEventWithVenue {
    sellerEventId: string;
    viagogoEventId: number;
    venueId: number;
    venueConfigId: number;
}

export interface PurchaseOrderDetails extends PurchaseOrder {
    additionalCosts: CostDetail[] | null;
    ticketGroups: TicketGroup[];
    miniCatalog: CatalogResults | null;
    payments: PurchasePayment[] | null;
    transferId: string | null;
    hasMergedListings: boolean | null;
    hasSplitListings: boolean | null;
    deal: PurchaseOrderDeal | null;
}

export interface CostDetail {
    id: number;
    cost: UiMoney | null;
    costType: PurchaseOrderCostType;
    date: string;
    description: string | null;
}

export enum PurchaseOrderCostType {
    Tax = "Tax",
    Shipping = "Shipping",
    CreditCardFee = "Credit Card Fee",
    BulkDiscount = "Bulk Discount",
    Cancelled = "Cancelled",
}

export interface TicketGroup extends EntityWithTickets {
    entityType: ActionOutboxEntityType;
    tickets: Ticket[];
    unitCst: UiMoney;
    totalCst: UiMoney | null;
    expectedVal: UiMoney | null;
    webPrice: UiMoney | null;
    taxPaid: UiMoney | null;
    isFaceVal: boolean;
    faceVal: UiMoney | null;
    delivType: DeliveryType;
    delivCst: UiMoney | null;
    poId: number | null;
    vendOrdId: string | null;
    /** Available Artifact Types */
    availArtTypes: ArtifactType[];
    /** Has user document artifacts to download */
    canGetDocArts: boolean | null;
    venId: number | null;
    perfId: number | null;
}

export interface PurchasePayment {
    paymentId: number;
    paymentStatus: PurchasePaymentStatus;
    paymentDueDate: string;
    paymentDate: string | null;
    paymentAmount: UiMoney;
    currencyCode: string;
    convertedPaymentAmount: UiMoney | null;
    convertedCurrencyCode: string | null;
    conversionRate: number | null;
    conversionDate: string | null;
    conversionUserId: string | null;
    paymentMethod: PurchasePaymentMethod;
}

export interface PurchaseOrderDeal {
    dealId: string | null;
    dealType: DealType;
    dealDetails: PurchaseOrderDealDetails;
}

export enum DealType {
    Sor = "Sor",
    Guaranteed = "Guaranteed",
}

export interface PurchaseOrderDealDetails {
    guaranteedAmountPaid: number | null;
    dealStartDate: string | null;
    dealEndDate: string | null;
    configSplitType: DealSplitType;
    dealConfigId: string | null;
    dealFallbackConfig: PurchaseOrderDealConfig | null;
    dealConfigs: PurchaseOrderDealConfig[] | null;
}

export enum DealSplitType {
    Quantity = "Quantity",
    Sales = "Sales",
    None = "None",
}

export interface PurchaseOrderDealConfig {
    dealConfigHurdleId: string | null;
    thresholdSplitDirection: DealThresholdSplitDirection | null;
    thresholdValue: number | null;
    vendorCommission: PurchaseOrderDealCommission;
    purchaserCommissions: PurchaseOrderDealCommission[];
    priority: number | null;
}

export enum DealThresholdSplitDirection {
    Above = "Above",
    Below = "Below",
}

export interface PurchaseOrderDealCommission {
    userId: string;
    splitValue: number;
}

export interface EntitiesWithSummaryOfPurchaseOrder {
    items: PurchaseOrder[];
    summary: PurchaseOrder | null;
    /** PIT ID for next page requests, null if not using PIT (Point-In-Time) pagination */
    pitId: string | null;
    /** Total number of matching documents that may have not been returned yet due to pagination */
    totalItemsCount: number | null;
}

export interface EntitiesWithSummaryOfPurchaseOrderTicketGroup {
    items: PurchaseOrderTicketGroup[];
    summary: PurchaseOrderTicketGroup | null;
    /** PIT ID for next page requests, null if not using PIT (Point-In-Time) pagination */
    pitId: string | null;
    /** Total number of matching documents that may have not been returned yet due to pagination */
    totalItemsCount: number | null;
}

/** Extended version of PurchaseOrderQuery with support for operations for each filter that is supported in search v2 with OpenSearch */
export interface PurchaseOrderQueryV2 extends PurchaseOrderQuery {
    operations: PurchaseQueryOperations | null;
    searchOptions: UISearchOptions | null;
}

export interface PurchaseQueryOperations extends EntityWithTicketsQueryOperations {
    ticketGroupIdsOp: FilterOperationType | null;
    purchaseMonthsOp: FilterOperationType | null;
    /** Payment method type */
    paymentMethodOp: FilterOperationType | null;
    paymentStatusOp: FilterOperationType | null;
    paymentDatesOp: FilterOperationType | null;
    totalCostHighOp: FilterOperationType | null;
    totalCostLowOp: FilterOperationType | null;
    deliveryTypeOp: FilterOperationType | null;
    purchaseOrderStateOp: FilterOperationType | null;
    /** Exact payment method used */
    paymentMethodIdOp: FilterOperationType | null;
    paymentCurrencyCodesOp: FilterOperationType | null;
    isConsignmentOp: FilterOperationType | null;
}

export interface AccessControlProvider {
    id: number;
    name: string;
}

export interface ValueTupleOfISetOfIntegerAndISetOfGuid {
    item1: number[];
    item2: string[];
}

export interface PurchaseVendorAccountDetails extends PurchaseVendorAccount {
    delivType: DeliveryType | null;
    isNoFulfill: boolean | null;
    tktTypeRules: TicketTypeOverride | null;
    favPmtMethodIds: number[] | null;
}

export enum PurchasingIdInUseResultType {
    NoneMatching = "NoneMatching",
    SameOrderId = "SameOrderId",
    SameOrderIdAndVendorId = "SameOrderIdAndVendorId",
}

export interface MonthContainingPurchaseOrdersResult {
    firstOfMonth: string;
    purchaseCount: number;
    numOfTickets: number;
    totalCost: UiMoney | null;
}

export interface TimePeriodContainingPurchaseOrderResult {
    firstOfTimePeriod: string;
    purchaseCount: number;
    numOfTickets: number;
    totalCost: UiMoney | null;
}

export enum TimePeriodType {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
}

export interface PurchaseOrderDetailsInput {
    id: number;
    vendorOrderId: PosFieldOfString | null;
    purchaseDate: PosFieldOfNullableDateTime | null;
    buyerUserId: PosFieldOfNullableGuid | null;
    currencyCode: PosFieldOfString | null;
    commissions: PosFieldArrayOfCommission | null;
    vendor: PosFieldOfPurchaseVendor | null;
    vendorAccount: PosFieldOfPurchaseVendorAccount | null;
    partialVendorAccount: PartialPurchaseVendorAccount | null;
    secondaryVendorAccount: PosFieldOfPurchaseVendorAccount | null;
    partialSecondaryVendorAccount: PartialPurchaseVendorAccount | null;
    secondaryVendor: PosFieldOfPurchaseVendor | null;
    additionalCosts: PosFieldArrayOfCostDetail | null;
    payments: PosFieldArrayOfPurchasePayment | null;
    transferId: PosFieldOfString | null;
    tags: PosFieldArrayOfTag | null;
    privateNotes: PosFieldOfString | null;
    qcState: PosFieldOfNullableQualityControlState | null;
    isAutoPo: boolean;
    ticketGroups: TicketGroupInput[];
    deal: PosFieldOfPurchaseOrderDealInput | null;
    isCommissionsLocked: PosFieldOfNullableBoolean | null;
}

export interface PosFieldOfPurchaseVendor {
    value: PurchaseVendor | null;
    hasChanged: boolean;
}

export interface PosFieldOfPurchaseVendorAccount {
    value: PurchaseVendorAccount | null;
    hasChanged: boolean;
}

export interface PartialPurchaseVendorAccount {
    vendorId: number;
    name: string | null;
    email: string;
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfCostDetail {
    value: CostDetail[] | null;
    hasChanged: boolean;
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfPurchasePayment {
    value: PurchasePayment[] | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableQualityControlState {
    value: QualityControlState | null;
    hasChanged: boolean;
}

export interface TicketGroupInput {
    ticketGroupId: number;
    purchaseOrderId: number | null;
    /** Because the TicketGroup is used for input, this property will be used to pass back
when selecting an Event and related info to create the TicketGroup for a PurchaseOrder */
    event: Event | null;
    performer: Performer | null;
    venue: Venue | null;
    /** Has user document artifacts to download */
    canGetDocArts: boolean | null;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    viagogoVirtualId: string;
    posEventId: string | null;
    unitCost: PosFieldOfNullableDecimal | null;
    inHandDate: PosFieldOfNullableDateTime | null;
    expectedValue: PosFieldOfNullableDecimal | null;
    isFaceValueCost: PosFieldOfNullableBoolean | null;
    faceValueCost: PosFieldOfNullableDecimal | null;
    deliveryType: PosFieldOfNullableDeliveryType | null;
    totalCost: PosFieldOfNullableDecimal | null;
    taxPaid: PosFieldOfNullableDecimal | null;
    deliveryCost: PosFieldOfNullableDecimal | null;
    currencyCode: PosFieldOfString | null;
    section: PosFieldOfString | null;
    sectionId: PosFieldOfNullableInteger | null;
    rowId: PosFieldOfNullableInteger | null;
    row: PosFieldOfString | null;
    tickets: PosFieldArrayOfTicket | null;
    numberOfTickets: PosFieldOfNullableInteger | null;
    ticketTypeRules: TicketTypeOverride | null;
    /** Note - TicketGroup doesn't have InternalNotes as a field, but they are passed in from API to be set onto Listing */
    internalNotes: PosFieldOfString | null;
    listingNotes: PosFieldArrayOfListingNote | null;
    seatIncementType: number | null;
    allocateSeats: boolean | null;
    webPrice: number | null;
    autoBroadcastCreatedListing: boolean | null;
}

export interface PosFieldOfNullableDeliveryType {
    value: DeliveryType | null;
    hasChanged: boolean;
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfTicket {
    value: Ticket[] | null;
    hasChanged: boolean;
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfListingNote {
    value: ListingNote[] | null;
    hasChanged: boolean;
}

export interface PosFieldOfPurchaseOrderDealInput {
    value: PurchaseOrderDealInput | null;
    hasChanged: boolean;
}

export interface PurchaseOrderDealInput {
    dealId: string | null;
    dealType: DealType;
    dealDetails: PurchaseOrderDealDetailsInput;
}

export interface PurchaseOrderDealDetailsInput {
    guaranteedAmountPaid: number | null;
    dealStartDate: string | null;
    dealEndDate: string | null;
    configSplitType: PosFieldOfNullableDealSplitType;
    dealConfigId: string | null;
    dealFallbackConfig: PurchaseOrderDealConfig | null;
    dealConfigs: PosFieldArrayOfPurchaseOrderDealConfig | null;
}

export interface PosFieldOfNullableDealSplitType {
    value: DealSplitType | null;
    hasChanged: boolean;
}

/** Note - doing PosFieldArray so it can be property generated to React TypeScript */
export interface PosFieldArrayOfPurchaseOrderDealConfig {
    value: PurchaseOrderDealConfig[] | null;
    hasChanged: boolean;
}

export interface PosUiActionResultWithDataOfIEnumerableOfNullableLong extends PosUiActionResult {
    data: (number | null)[] | null;
}

export interface ValueTupleOfISetOfLongAndPosFieldOfNullableQualityControlState {
    item1: number[];
    item2: PosFieldOfNullableQualityControlState;
}

export interface CurrencyConversionOverride {
    currencyConversionOverrideId: number;
    fromCurrencyCode: string;
    toCurrencyCode: string;
    purchasePaymentMethodId: number | null;
    /** Ignored if `PaymentMethodNameKnownRegexId` is not null. */
    purchasePaymentMethodName: string | null;
    paymentMethodNameKnownRegexId: PaymentMethodNameKnownRegex | null;
    conversionRate: number;
    conversionRateDate: string;
}

export enum PaymentMethodNameKnownRegex {
    All = "All",
    AllAmex = "AllAmex",
    AllVisa = "AllVisa",
    AllMastercard = "AllMastercard",
}

export interface CurrencyConversionOverrideRequest {
    currencyConversionOverrideId: number | null;
    conversionRateDate: string;
    fromCurrencyCode: string;
    toCurrencyCode: string;
    purchasePaymentMethodId: number | null;
    paymentMethodNameKnownRegexId: PaymentMethodNameKnownRegex | null;
    conversionRate: number;
}

export interface DeliveryOverride {
    delivType: DeliveryType | null;
    tktTypeRules: TicketTypeOverride | null;
    inHandAt: string | null;
}

export interface ValueTupleOfNullableIntegerAndNullableIntegerAndNullableGuidAndBoolean {
    item1: number | null;
    item2: number | null;
    item3: string | null;
    item4: boolean;
}

export interface PurchaseEventOverride {
    delivType: DeliveryType;
    vendorId: number | null;
}

export interface PurchaseOrderExportRequest {
    query: PurchaseOrderQuery;
    exportColumns: string[] | null;
}

/** Result of a secure purchase orders search with mapped PurchaseOrder DTOs Mirrors SecureSalesSearchMappedResult but for purchase orders */
export interface SecurePurchaseOrdersSearchMappedResult {
    /** The mapped PurchaseOrder DTOs ready for UI consumption */
    purchaseOrders: PurchaseOrderTicketGroup[];
    /** Total number of matching documents */
    total: number;
    /** Time taken for the search in milliseconds */
    took: number;
    /** Maximum score of the results (for relevance ranking) */
    maxScore: number | null;
    /** Whether the search timed out */
    timedOut: boolean;
    /** Applied security filters for debugging */
    appliedSecurityFilters: string[] | null;
    /** Number of fields that were allowed for the user */
    allowedFieldCount: number;
    /** Parsed aggregation results */
    aggregations: { [key: string]: AggregationResult; } | null;
    /** PIT ID for next page requests, null if not using PIT (Point-In-Time) pagination */
    pitId: string | null;
    /** Search after values for next page cursor (null if no more pages) */
    searchAfter: any[] | null;
    /** Whether there are more pages available */
    hasNextPage: boolean;
}

export interface OpenSearchRequestOfPurchaseOrderFilterQueryV2 {
    filter: PurchaseOrderFilterQueryV2;
    options: SearchOptions | null;
}

export interface PurchaseOrderSearchRequestV2 extends OpenSearchRequestOfPurchaseOrderFilterQueryV2 {
    allowedFields: string[] | null;
    appliedSecurityFilters: string[] | null;
    dataIsolationContext: { [key: string]: any; } | null;
}

export interface PurchaseOrderFilterQueryV2 {
    eventIds: FieldFilter | null;
    eventDates: FieldFilter | null;
    eventTimeFrameFilters: FieldFilter | null;
    clientTimezoneOffsetMins: number | null;
    eventStatuses: FieldFilter | null;
    topLevelCategories: FieldFilter | null;
    parentCategories: FieldFilter | null;
    eventOrMappingIds: FieldFilter | null;
    oldPosEventIds: FieldFilter | null;
    performerIds: FieldFilter | null;
    venueIds: FieldFilter | null;
    countryCodes: FieldFilter | null;
    stateProvinceIds: FieldFilter | null;
    cityIds: FieldFilter | null;
    purchaseOrderIds: FieldFilter | null;
    purchaseVendorIds: FieldFilter | null;
    purchaseVendorAccountIds: FieldFilter | null;
    purchaseVendorOrderIds: FieldFilter | null;
    purchaseBuyerIds: FieldFilter | null;
    purchaseInsertByIds: FieldFilter | null;
    purchaseDates: FieldFilter | null;
    purchaseCommissionUserIds: FieldFilter | null;
    orBuyerUserId: FieldFilter | null;
    paymentDates: FieldFilter | null;
    paymentStatuses: FieldFilter | null;
    paymentMethodTypes: FieldFilter | null;
    paymentMethodUsedIds: FieldFilter | null;
    deliveryTypes: FieldFilter | null;
    purchaseOrderStates: FieldFilter | null;
    isConsignment: FieldFilter | null;
    totalCost: FieldFilter | null;
    currencyCodes: FieldFilter | null;
    internalNotes: FieldFilter | null;
    tagPairs: TagPairFilter | null;
    eventTagPairs: TagPairFilter | null;
    and: PurchaseOrderFilterQueryV2[] | null;
    or: PurchaseOrderFilterQueryV2[] | null;
    not: boolean;
}

export interface ReportConfigOfListingQueryAndReportWidgetTypesInventory {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    groupBy: ReportGroupBy;
    widgets: ReportWidgetTypesInventory[] | null;
    metrics: string[];
    filter: ListingQuery | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    numberOfItemsPerPage: number | null;
    sortBy: string | null;
    isSortDescending: boolean | null;
    arAgingTimeBuckets: DateTimeRangeWithRelative[] | null;
    reportId: number | null;
    /** If specified, open this report instead when the user clicks on a report link. */
    reportIdRedirect: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    allowReaderEditMetrics: boolean;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    hasFilterOverride: boolean | null;
}

export enum ReportGroupBy {
    Performer = "Performer",
    Event = "Event",
    Venue = "Venue",
    EventGenre = "EventGenre",
    EventCountry = "EventCountry",
    EventCity = "EventCity",
    SeatingSection = "SeatingSection",
    SeatingRow = "SeatingRow",
    SaleMarketplace = "SaleMarketplace",
    SaleMonth = "SaleMonth",
    SaleWeek = "SaleWeek",
    SaleDay = "SaleDay",
    SaleId = "SaleId",
    ListingId = "ListingId",
    PurchaseId = "PurchaseId",
    PurchasedBy = "PurchasedBy",
    PricedBy = "PricedBy",
    FulfilledBy = "FulfilledBy",
    Vendor = "Vendor",
    SaleIdTicketIdCommissionUser = "SaleIdTicketIdCommissionUser",
    ArAgingMarketplace = "ArAgingMarketplace",
}

/** Available widgets to show in inventory reports */
export enum ReportWidgetTypesInventory {
    TicketsListedAndSold = "TicketsListedAndSold",
    SalesAndMargin = "SalesAndMargin",
    AverageTicketPrice = "AverageTicketPrice",
}

export interface ReportConfigOverrideOfListingQuery {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    metrics: string[] | null;
    filter: ListingQuery | null;
}

export interface ReportConfigOfSaleQueryAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    groupBy: ReportGroupBy;
    widgets: ReportWidgetTypesNone[] | null;
    metrics: string[];
    filter: SaleQuery | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    numberOfItemsPerPage: number | null;
    sortBy: string | null;
    isSortDescending: boolean | null;
    arAgingTimeBuckets: DateTimeRangeWithRelative[] | null;
    reportId: number | null;
    /** If specified, open this report instead when the user clicks on a report link. */
    reportIdRedirect: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    allowReaderEditMetrics: boolean;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    hasFilterOverride: boolean | null;
}

/** Widgets to show in reports. There are currently no available widgets, so this `None` serves as a placeholder and new widgets can be added in the future */
export enum ReportWidgetTypesNone {
    None = "None",
}

export interface ReportConfigOverrideOfSaleQuery {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    metrics: string[] | null;
    filter: SaleQuery | null;
}

export interface ListingReportMetricsResponse {
    metrics: ListingReportMetrics[];
    summary: ListingReportMetrics;
    totalCount: number;
    hasTimeout: boolean;
    hasUnknownError: boolean;
}

export interface ReportMetricsBase {
    /** Peformer id */
    perfId: number | null;
    venueId: number | null;
    /** This is viagogoEventId.toString() ?? viagogoEventMappingId.toString() */
    eventId: string | null;
    genre: TopLevelCategory | null;
    country: Country | null;
    city: string | null;
    section: string | null;
    row: string | null;
    /** Seating seat from */
    seatFr: string | null;
    /** Seating seat to */
    seatTo: string | null;
    /** Aggregated value of tags
Currently only support numerical value types (TagsValueType.Int, TagsValueType.Decimal) */
    tags: ReportTag[];
    /** Value of event tags
Currently only support numerical value types (TagsValueType.Int, TagsValueType.Decimal) */
    eventTags: ReportTag[];
    posEventIds: string[];
}

export interface ListingReportMetrics extends ReportMetricsBase {
    listId: number | null;
    tktQty: number;
    availQty: number;
    soldQty: number;
    currency: string;
    /** Total cost of all tickets */
    ttlCst: UiMoney;
    /** Total list price of all tickets */
    ttlListPrc: UiMoney;
    /** Total all-in price of all tickets */
    ttlWebPrc: UiMoney;
    soldCst: UiMoney;
    soldProcs: UiMoney;
    unsoldCst: UiMoney;
    pandL: UiMoney;
    /** Margin (SoldProceeds - SoldCost) / SoldProceeds */
    marg: number | null;
    delivType: DeliveryType | null;
    inHandDate: string | null;
    poInfos: PurchaseInfosReport;
    zone: string | null;
    pricerId: string | null;
    sales: SaleInfoReport[];
    holds: SaleInfoReport[];
    privNotes: string | null;
}

export interface PurchaseInfosReportBase {
    createdBys: string[];
    /** Purchase order ids */
    poIds: number[];
    /** Ticket group ids */
    tktGrIds: number[];
    buyers: PurchaseBuyerInfo[];
    vendors: PurchaseVendorInfo[];
    vendorAccs: PurchaseVendorAccountInfo[];
}

export interface PurchaseInfosReport extends PurchaseInfosReportBase {
    poDates: string[];
    pmtStatuses: PurchasePaymentStatus[];
    pmtMethods: PurchasePaymentMethodType[];
    privNotes: string[];
    vendOrdIds: string[];
    cancDates: string[];
}

export interface PurchaseBuyerInfo {
    buyerUserId: string;
    averageBuyerCommissionPercent: number | null;
}

export interface PurchaseVendorInfo {
    vendorId: number;
    vendorName: string;
}

export interface PurchaseVendorAccountInfo {
    vendorAccountId: string;
    vendorId: number;
    vendorAccountName: string;
    encryptedEmailAddress: string;
}

export interface SaleInfoReport {
    saleId: number;
    pmtState: PointOfSalePaymentState | null;
    mkpPmtState: MarketplacePaymentState | null;
    chargs: UiMoney | null;
    creds: UiMoney | null;
    fulfillerId: string | null;
    ttlNetProcs: UiMoney;
    qtySold: number;
    soldCst: UiMoney | null;
    status: PointOfSaleSaleStatus;
}

export interface ReportTag {
    key: string;
    value: string;
    valueType: TagsValueType | null;
}

export interface ListingReportMetricsRequest {
    query: ListingQuery;
    groupBy: ReportGroupBy;
    globalReportTypeId: number | null;
    isUsingFilterOverride: boolean | null;
    listingReportMetricsRequested: ListingReportMetricColumn[];
}

/** Enum to determine the metric to calculate/get report for */
export enum ListingReportMetricColumn {
    Zone = "Zone",
}

export interface SaleReportMetricsResponse {
    metrics: SaleReportMetrics[];
    summary: SaleReportMetrics;
    totalCount: number;
    hasTimeout: boolean;
    hasUnknownError: boolean;
}

export interface SaleReportMetrics extends ReportMetricsBase {
    saleDate: string | null;
    mkp: Marketplace | null;
    saleId: number | null;
    ticketId: number | null;
    tktGrId: number | null;
    mkpSaleId: string | null;
    /** Ar Aging Time Bucket
            
If group by is set to ArAging*, then this will be set
Only TtlOutsBal (TotalOutstandingBalance) among the metrics will be set */
    timeBkt: DateTimeRangeWithRelative | null;
    mkpPmtTerm: MarketplacePaymentTerm | null;
    qtySold: number;
    currency: string;
    netProcs: UiMoney;
    /** Total outstanding balance */
    ttlOutsBal: UiMoney;
    soldCst: UiMoney;
    /** Commision share */
    commssionShr: UiMoney | null;
    commission: BuyerCommission | null;
    pandL: UiMoney;
    /** Margin (TotalNetProceeds - SoldCost) / TotalNetProceeds */
    marg: number | null;
    chargs: UiMoney;
    creds: UiMoney;
    saleStatus: PointOfSaleSaleStatus | null;
    ticketType: TicketType | null;
    inHandDate: string | null;
    pmtState: PointOfSalePaymentState | null;
    mkpPmtState: MarketplacePaymentState | null;
    /** Payment received */
    pmtRcv: boolean | null;
    pmtRefId: string | null;
    lastPmtOn: string | null;
    cancelDate: string | null;
    allocState: PointOfSaleAllocationState | null;
    fulfillerId: string | null;
    fulfillDate: string | null;
    pricerId: string | null;
    poInfos: PurchaseInfosReport;
    privNotes: string | null;
}

export interface BuyerCommission {
    buyerUserId: string;
    commissionPercentage: number | null;
}

export enum PointOfSaleAllocationState {
    Pending = "Pending",
    Allocated = "Allocated",
    TicketsUnavailable = "TicketsUnavailable",
    AlternativeTicketsOffered = "AlternativeTicketsOffered",
    BlockingAllocation = "BlockingAllocation",
    AutoSourced = "AutoSourced",
}

export interface SaleReportMetricsRequest {
    query: SaleQuery;
    groupBy: ReportGroupBy;
    globalReportTypeId: number | null;
    isUsingFilterOverride: boolean | null;
    arAgingTimeBuckets: DateTimeRangeWithRelative[] | null;
}

export interface ReportSnapshotInfo {
    name: string;
    createdDate: string;
    documentId: string;
    downloadUri: string;
}

export interface SaleReportMetricsDownloadRequest extends SaleReportMetricsRequest {
    metrics: string[] | null;
    fileType: ReportFileType;
}

export enum ReportFileType {
    CSV = "CSV",
    XLSX = "XLSX",
    PDF = "PDF",
}

export interface ListingReportMetricsDownloadRequest extends ListingReportMetricsRequest {
    metrics: string[] | null;
    fileType: ReportFileType;
}

export interface ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesInventory[] | null;
    request: InventoryReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2ListingQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2ListingQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
}

export interface InventoryReportV2Request extends ReportBaseRequestOfUIReportV2ListingQuery {
}

export interface ReportColumn {
    /** Identifier of column, used for displaying in the UI and rendering the table, defined in the ListingReportTableGroupingColumnId / ListingReportTableValueColumnId enum */
    columnName: string;
    /** Expressions of columnId, format is ready for ReportingService to parse and transform into raw sql expressions */
    columnValue: string;
}

export interface ReportEntityWithTicketsQuery {
    performerIds: number[] | null;
    venueIds: number[] | null;
    countryCodes: string[] | null;
    stateProvinceIds: number[] | null;
    cityIds: number[] | null;
    purchaseOrderId: number | null;
    purchaseVendorId: number | null;
    vendorAccessControlProviderId: number | null;
    purchaseVendorAccountIds: string[] | null;
    purchaseVendorOrderId: string | null;
    purchaseBuyerId: string | null;
    purchaseOrderCreatedBy: string | null;
    purchaseCommissionUserId: string | null;
    purchaseDates: DateTimeRangeWithRelative | null;
    inHandDates: DateTimeRangeWithRelative | null;
    eventTimeFrameFilter: EventTimeFrameFilter | null;
    sections: string[] | null;
    rows: string[] | null;
    sectionContains: string | null;
    sectionEquals: string | null;
    sectionNotContains: string | null;
    rowContains: string | null;
    rowEquals: string | null;
    rowNotContains: string | null;
    isSeatSaver: boolean | null;
    eventDates: DateTimeRangeWithRelative | null;
    noSaleDates: DateTimeRangeWithRelative | null;
    tagName: string | null;
    tagValue: string | null;
    eventTagName: string | null;
    eventTagValue: string | null;
    lastSaleDates: DateTimeRangeWithRelative | null;
    eventNotReviewedSinceDate: DateTimeRangeWithRelative | null;
    eventUnpricedStatus: number | null;
    numberOfTicketsHeld: NumericRange | null;
    topLevelCategories: TopLevelCategory[] | null;
    parentCategories: number[] | null;
    internalNotes: string | null;
    internalNotesContains: string | null;
    internalNotesEquals: string | null;
    internalNotesNotContains: string | null;
    timezoneOffsetMins: number | null;
    currencyCode: string | null;
    currencyCodes: string[] | null;
    eventStatuses: ApiEventStatus[] | null;
    eventHasUnsoldTickets: boolean | null;
    purchaseCancellationDates: DateTimeRangeWithRelative | null;
    isParking: boolean | null;
    listingIdContains: string | null;
    saleIdContains: string | null;
    marketplaceSaleIdContains: string | null;
    purchaseOrderIdContains: string | null;
    vendorOrderIdContains: string | null;
}

export interface ReportV2ListingQuery extends ReportEntityWithTicketsQuery {
    isPredelivered: boolean | null;
    isNoFulfill: boolean | null;
    lastPriceUpdateDates: DateTimeRangeWithRelative | null;
    isPricedByMarketplace: boolean | null;
    isAutoPricingEnabled: boolean | null;
    isListed: boolean | null;
    isMapped: boolean | null;
    isDuplicate: boolean | null;
    isSeatingUnmapped: boolean | null;
    isAdminHold: boolean | null;
    pricerSellerUserId: string | null;
    purchaseCancelledOnly: boolean | null;
    hasUnsoldTickets: boolean | null;
    autoPricingResultTypes: AutoPricingResultType[] | null;
    isPricedAboveZero: boolean | null;
    hasBroadcastError: boolean | null;
    isPendingProof: boolean | null;
    deliveryType: DeliveryType | null;
    ticketType: TicketType | null;
    purchaseInsertBy: string | null;
}

export interface UIReportV2ListingQuery extends ReportV2ListingQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: SalesReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2SaleQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2SaleQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
}

export interface SalesReportV2Request extends ReportBaseRequestOfUIReportV2SaleQuery {
}

export interface ReportV2SaleQuery extends ReportEntityWithTicketsQuery {
    isNoFulfill: boolean | null;
    saleDates: DateTimeRangeWithRelative | null;
    saleStatuses: PointOfSaleSaleStatus[] | null;
    soldOnMarketplace: Marketplace | null;
    cancellationDates: DateTimeRangeWithRelative | null;
    fulfillerSellerUserId: string | null;
    fulfillmentDates: DateTimeRangeWithRelative | null;
    paymentDates: DateTimeRangeWithRelative | null;
    marketplacePaymentState: MarketplacePaymentState | null;
    paymentReferenceId: string | null;
    listingInsertBy: string | null;
    dayOfWeek: number | null;
    quantityWasted: NumericRange | null;
    insertBy: string | null;
    listingNoteIds: number[] | null;
    originatedFromListingIdContains: string | null;
    seatContains: string | null;
    listingTagName: string | null;
    listingTagValue: string | null;
    purchaseOrderTagName: string | null;
    purchaseOrderTagValue: string | null;
    originatedFromListingTagName: string | null;
    originatedFromListingTagValue: string | null;
    ticketType: TicketType | null;
    pricerSellerUserId: string | null;
}

export interface UIReportV2SaleQuery extends ReportV2SaleQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: PurchaseReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2PurchaseQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2PurchaseQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
}

export interface PurchaseReportV2Request extends ReportBaseRequestOfUIReportV2PurchaseQuery {
}

export interface ReportV2PurchaseQuery extends ReportEntityWithTicketsQuery {
    paymentMethod: PurchasePaymentMethodType | null;
    paymentStatus: PurchasePaymentStatus | null;
    purchaseOrderState: PurchaseOrderState | null;
}

export interface UIReportV2PurchaseQuery extends ReportV2PurchaseQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: SaleLineItemReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2SaleLineItemQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2SaleLineItemQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
}

export interface SaleLineItemReportV2Request extends ReportBaseRequestOfUIReportV2SaleLineItemQuery {
}

export interface ReportV2SaleLineItemQuery extends ReportEntityWithTicketsQuery {
    isNoFulfill: boolean | null;
    saleDates: DateTimeRangeWithRelative | null;
    saleStatuses: PointOfSaleSaleStatus[] | null;
    soldOnMarketplace: Marketplace | null;
    cancellationDates: DateTimeRangeWithRelative | null;
    fulfillerSellerUserId: string | null;
    fulfillmentDates: DateTimeRangeWithRelative | null;
    paymentDates: DateTimeRangeWithRelative | null;
    marketplacePaymentState: MarketplacePaymentState | null;
}

export interface UIReportV2SaleLineItemQuery extends ReportV2SaleLineItemQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: PurchaseOrderLineItemReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2PurchaseOrderLineItemQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2PurchaseOrderLineItemQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
}

export interface PurchaseOrderLineItemReportV2Request extends ReportBaseRequestOfUIReportV2PurchaseOrderLineItemQuery {
}

export interface ReportV2PurchaseOrderLineItemQuery extends ReportEntityWithTicketsQuery {
    purchaseOrderCostTypeId: number | null;
    purchaseOrderState: PurchaseOrderState | null;
    purchasePaymentStatus: PurchasePaymentStatus | null;
}

export interface UIReportV2PurchaseOrderLineItemQuery extends ReportV2PurchaseOrderLineItemQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: SoldTicketReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2SoldTicketQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2SoldTicketQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
}

export interface SoldTicketReportV2Request extends ReportBaseRequestOfUIReportV2SoldTicketQuery {
}

export interface ReportV2SoldTicketQuery extends ReportEntityWithTicketsQuery {
    isNoFulfill: boolean | null;
    saleDates: DateTimeRangeWithRelative | null;
    saleStatuses: PointOfSaleSaleStatus[] | null;
    soldOnMarketplace: Marketplace | null;
    cancellationDates: DateTimeRangeWithRelative | null;
    fulfillerSellerUserId: string | null;
    fulfillmentDates: DateTimeRangeWithRelative | null;
    paymentDates: DateTimeRangeWithRelative | null;
    marketplacePaymentState: MarketplacePaymentState | null;
}

export interface UIReportV2SoldTicketQuery extends ReportV2SoldTicketQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfCommissionReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: CommissionReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportCommissionQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportCommissionQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
}

export interface CommissionReportV2Request extends ReportBaseRequestOfUIReportCommissionQuery {
}

export interface ReportCommissionQuery {
    eventDates: DateTimeRangeWithRelative | null;
    eventTimeFrameFilter: EventTimeFrameFilter | null;
    saleDates: DateTimeRangeWithRelative | null;
    saleStatuses: PointOfSaleSaleStatus[] | null;
    soldOnMarketplace: Marketplace | null;
    paymentDates: DateTimeRangeWithRelative | null;
    fulfillmentDates: DateTimeRangeWithRelative | null;
    purchaseCommissionUserId: string | null;
    isCommissionEligible: boolean | null;
    commissionEligibilityDates: DateTimeRangeWithRelative | null;
    timezoneOffsetMins: number | null;
}

export interface UIReportCommissionQuery extends ReportCommissionQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: CostOfGoodsSoldReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2CostOfGoodsSoldQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2CostOfGoodsSoldQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
}

export interface CostOfGoodsSoldReportV2Request extends ReportBaseRequestOfUIReportV2CostOfGoodsSoldQuery {
}

export interface ReportV2CostOfGoodsSoldQuery extends ReportEntityWithTicketsQuery {
    adjustmentsSinceDate: DateTimeRangeWithRelative | null;
    adjustmentType: string | null;
    isActive: boolean | null;
}

export interface UIReportV2CostOfGoodsSoldQuery extends ReportV2CostOfGoodsSoldQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: SaleTotalCostAdjustmentReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2SaleTotalCostAdjustmentsQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2SaleTotalCostAdjustmentsQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
}

export interface SaleTotalCostAdjustmentReportV2Request extends ReportBaseRequestOfUIReportV2SaleTotalCostAdjustmentsQuery {
}

export interface ReportV2SaleTotalCostAdjustmentsQuery extends ReportEntityWithTicketsQuery {
    adjustmentsSinceDate: DateTimeRangeWithRelative | null;
    adjustmentType: string | null;
}

export interface UIReportV2SaleTotalCostAdjustmentsQuery extends ReportV2SaleTotalCostAdjustmentsQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: TicketGroupReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    /** Controls whether consumer of the report can edit the filters when viewing the report. */
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    /** Used to keep track of the original report from which this report was converted (v1) */
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2TicketGroupQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2TicketGroupQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
}

export interface TicketGroupReportV2Request extends ReportBaseRequestOfUIReportV2TicketGroupQuery {
}

export interface ReportV2TicketGroupQuery extends ReportEntityWithTicketsQuery {
    paymentMethod: PurchasePaymentMethodType | null;
    paymentStatus: PurchasePaymentStatus | null;
    purchaseOrderState: PurchaseOrderState | null;
    isMapped: boolean | null;
    isConsignment: boolean | null;
    deliveryType: DeliveryType | null;
    ticketStatuses: string[] | null;
}

export interface UIReportV2TicketGroupQuery extends ReportV2TicketGroupQuery {
    /** This is only used to filter on the frontend application. */
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOverride {
    schemaVersion: string;
    request: ReportOverrideRequest;
}

export interface ReportOverrideRequest {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
}

export interface ReportMetricsV2 {
    rows: { [key: string]: any; }[];
    valueTypes: { [key: string]: ReportValueType; };
}

export enum ReportValueType {
    None = "None",
    Guid = "Guid",
    Integer = "Integer",
    Money = "Money",
    DateTime = "DateTime",
    String = "String",
    User = "User",
    Decimal = "Decimal",
    Boolean = "Boolean",
    DateTimeList = "DateTimeList",
    IntegerList = "IntegerList",
    GuidList = "GuidList",
    UserList = "UserList",
    StringList = "StringList",
    BooleanList = "BooleanList",
}

export interface ReportMetricsSummaryV2 {
    row: { [key: string]: any; };
    valueTypes: { [key: string]: ReportValueType; };
}

export interface FileExportResult {
    fileName: string | null;
    fileUri: string | null;
    errorMessage: string | null;
    isSuccess: boolean;
}

export interface FileExportProgress {
    /** Percentage completed (0-100) */
    percentage: number;
}

export interface EntitiesWithSummaryOfSale {
    items: Sale[];
    summary: Sale | null;
    /** PIT ID for next page requests, null if not using PIT (Point-In-Time) pagination */
    pitId: string | null;
    /** Total number of matching documents that may have not been returned yet due to pagination */
    totalItemsCount: number | null;
}

export interface EntitiesWithSummaryOfSaleWithCatalogData {
    items: SaleWithCatalogData[];
    summary: SaleWithCatalogData | null;
    /** PIT ID for next page requests, null if not using PIT (Point-In-Time) pagination */
    pitId: string | null;
    /** Total number of matching documents that may have not been returned yet due to pagination */
    totalItemsCount: number | null;
}

/** Extends the Sale model to include catalog data about the event, venue, and performer to power Opensearch-based search experience which doesn't depend on a separate catalog service call. */
export interface SaleWithCatalogData extends Sale {
    eventDateTime: string | null;
    eventName: string | null;
    eventShortName: string | null;
    eventStatus: ApiEventStatus | null;
    eventGenre: TopLevelCategory | null;
    eventSubGenre: number | null;
    venueId: number | null;
    venueName: string | null;
    venueCity: string | null;
    venueCityId: number | null;
    venueStateProvince: string | null;
    venueStateProvinceId: number | null;
    venueCountry: string | null;
    venueCountryCode: string | null;
    performerId: number | null;
    performerName: string | null;
}

/** Extended version of SaleQuery with support for operations for each filter that is supported in search v2 with OpenSearch */
export interface SaleQueryV2 extends SaleQuery {
    soldOnMarketplaces: Marketplace[] | null;
    marketplacePaymentStates: MarketplacePaymentState[] | null;
    ticketTypes: TicketType[] | null;
    fulfillerSellerUserIds: string[] | null;
    listingInsertBys: string[] | null;
    operations: SaleQueryOperations | null;
    searchOptions: UISearchOptions | null;
}

export interface SaleQueryOperations extends EntityWithTicketsQueryOperations {
    soldOnMarketplaceOp: FilterOperationType | null;
    saleStatusesOp: FilterOperationType | null;
    fulfillmentStatesOp: FilterOperationType | null;
    paymentStateOp: FilterOperationType | null;
    marketplacePaymentStateOp: FilterOperationType | null;
    paymentReceivedOp: FilterOperationType | null;
    paymentReferenceIdOp: FilterOperationType | null;
    paymentDatesOp: FilterOperationType | null;
    fulfillmentDatesOp: FilterOperationType | null;
    cancellationDatesOp: FilterOperationType | null;
    saleDatesOp: FilterOperationType | null;
    ticketTypeOp: FilterOperationType | null;
    fulfillerSellerUserIdOp: FilterOperationType | null;
    listingInsertByOp: FilterOperationType | null;
    isNoFulfillOp: FilterOperationType | null;
}

export interface ValueTupleOfIEnumerableOfSaleAndUInt64 {
    item1: Sale[];
    item2: number;
}

export interface SaleDetails extends Sale {
    tickets: Ticket[];
    ticketGroupInfos: SaleTicketGroupInfo[];
    poInfos: UiPurchaseInfo[];
    isMarketplacePaymentLocked: boolean | null;
    /** Transfer Source */
    transSrc: TicketTransferInfo[] | null;
    /** Transfer Destination */
    transDest: TicketTransferInfo | null;
    transferUrls: string[] | null;
    transferProofDocs: UserDocumentLinks[] | null;
    transferProofId: string | null;
    /** AvailabileArtifactTypes */
    availArtTypes: ArtifactType[];
    lineItems: SaleLineItem[];
    mkpLines: MarketplaceSaleLineItem[];
    mkpLinesTotal: UiMoney;
    mkpSeating: Seating | null;
    mkpSaleTtlNetProcs: UiMoney | null;
    /** commissions got override at sale level */
    commissionOverride: Commission[] | null;
    /** the original commissions percentage set on the purchase order, which the allocated tickets are linked to */
    purchaseOrderCommissions: PurchaseOrderCommissions[] | null;
    mkpPmtTerm: MarketplacePaymentTerm | null;
}

export interface PurchaseOrderInfo {
    purchaseOrderId: number;
    purchaseOrderDate: string | null;
    ticketGroupId: number;
    buyerCommissionPercent: number | null;
    ticketCount: number;
    buyerUserId: string | null;
    vendor: PurchaseVendorInfo | null;
    vendorAccount: PurchaseVendorAccountInfo | null;
    createdBy: string | null;
    internalNotes: string | null;
}

export interface SaleTicketGroupInfo extends PurchaseOrderInfo {
    seating: Seating;
    vendorOrderId: string | null;
}

export interface TicketTransferInfo {
    name: string;
    email: string;
    app: string | null;
    appId: number;
    phoneNumber: string | null;
}

export interface MarketplaceSaleLineItem {
    /** MarketplacePaymentId */
    posPmtId: number;
    /** MarketplacePaymentLineId */
    id: number;
    /** ExternalPaymentId */
    extPmtId: string;
    /** ExternalPaymentLineId */
    extLineId: string;
    extSaleId: string;
    saleId: number | null;
    state: MarketplacePaymentState;
    date: string | null;
    recvDate: string | null;
    /** IsCredit */
    isCred: boolean;
    /** Amount */
    amt: UiMoney;
    type: MarketplacePaymentLineType;
    isLocked: boolean | null;
}

export interface PurchaseOrderCommissions {
    purchaseOrderId: number;
    orderId: string;
    commissions: Commission[];
}

export interface TicketTransferRequest {
    saleId: number;
    transferType: TransferTicketType;
    acceptanceUrls: string[] | null;
    uploadProofDocuments: UserDocument[] | null;
    transferProofId: string | null;
    barcodes: TicketBarcode[] | null;
}

export enum TransferTicketType {
    None = "None",
    ImageProof = "ImageProof",
    URL = "URL",
    IdProof = "IdProof",
    ApiTransferTicketmaster = "ApiTransferTicketmaster",
    ApiTransfer1Ticket = "ApiTransfer1Ticket",
}

export interface SaleAvailableSeatings {
    hasMoreAllocations: boolean;
    possibleSeatings: SeatingForAlloc[];
}

export interface SeatingForAlloc extends Seating {
    tktsForAlloc: TicketInfoForAllocation[];
    recAlloc: boolean | null;
    nonConsecSeats: boolean | null;
}

export interface TicketInfoForAllocation {
    id: number;
    row: string | null;
    seat: string;
    listingId: number | null;
    listingOrd: number | null;
    ticketOrd: number;
    purchasedBy: string | null;
    vendorId: number | null;
    vendorName: string | null;
    vendorAccId: string | null;
    vendorAccEmail: string | null;
    vendorAccName: string | null;
    isListingOnAdminHold: boolean | null;
}

export interface ValueTupleOfLongAndNullableBoolean {
    item1: number;
    item2: boolean | null;
}

/** A marketplace sale that originated from (and is managed by) the POS (Marketplace = Offline/Direct) Unlike other marketplace sales which are synced from that Marketplace (e.g. StubHub, Ticketmaster, VividSeat, etc.) */
export interface PosManagedMarketplaceSaleInput {
    listingId: number;
    saleId: number | null;
    marketplaceSaleId: PosFieldOfString | null;
    posEventId: string;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    venueId: number | null;
    saleDate: PosFieldOfNullableDateTime | null;
    currencyCode: PosFieldOfString | null;
    totalNetProceeds: PosFieldOfNullableDecimal | null;
    inHandDate: PosFieldOfNullableDateTime | null;
    quantitySold: PosFieldOfNullableInteger | null;
    section: PosFieldOfString | null;
    row: PosFieldOfString | null;
    seatFrom: PosFieldOfString | null;
    seatTo: PosFieldOfString | null;
    ticketType: PosFieldOfNullableTicketType | null;
    buyerName: PosFieldOfString | null;
    buyerEmail: PosFieldOfString | null;
    buyerPhone: PosFieldOfString | null;
    listingNotes: PosFieldArrayOfListingNote | null;
    saleStatus: PosFieldOfNullablePointOfSaleSaleStatus | null;
    paymentState: PosFieldOfNullablePointOfSalePaymentState | null;
    fulfillerSellerUserId: PosFieldOfNullableGuid | null;
    internalNotes: PosFieldOfString | null;
}

export interface PosFieldOfNullablePointOfSaleSaleStatus {
    value: PointOfSaleSaleStatus | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullablePointOfSalePaymentState {
    value: PointOfSalePaymentState | null;
    hasChanged: boolean;
}

export interface MarketplaceSaleInput {
    listingId: number;
    saleId: number | null;
    marketplace: Marketplace;
    marketplaceSaleId: PosFieldOfString | null;
    posEventId: string;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    venueId: number | null;
    saleDate: PosFieldOfNullableDateTime | null;
    currencyCode: PosFieldOfString | null;
    totalNetProceeds: PosFieldOfNullableDecimal | null;
    inHandDate: PosFieldOfNullableDateTime | null;
    quantitySold: PosFieldOfNullableInteger | null;
    section: PosFieldOfString | null;
    row: PosFieldOfString | null;
    seatFrom: PosFieldOfString | null;
    seatTo: PosFieldOfString | null;
    ticketType: PosFieldOfNullableTicketType | null;
    buyerName: PosFieldOfString | null;
    buyerEmail: PosFieldOfString | null;
    buyerPhone: PosFieldOfString | null;
    listingNotes: PosFieldArrayOfListingNote | null;
    saleStatus: PosFieldOfNullablePointOfSaleSaleStatus | null;
    paymentState: PosFieldOfNullablePointOfSalePaymentState | null;
    fulfillerSellerUserId: PosFieldOfNullableGuid | null;
    internalNotes: PosFieldOfString | null;
}

export interface BuyerInfo {
    email: string;
    name: string;
    phone: string;
}

export interface WasteListingTicketsInput {
    listingId: number;
}

export interface UnwasteSaleInput {
    saleId: number;
}

export interface AggregatedSaleMetric {
    dateTime: string;
    marketplaceId: number;
    totalQuantity: number;
    totalRevenue: number;
    totalPnL: number;
    totalNetProceeds: number;
    totalFees: number;
    maxSaleTimestamp: string;
}

export enum AggregateMetricsTimePeriod {
    UnspecifiedAggregatedSaleMetricsTimePeriod = "UnspecifiedAggregatedSaleMetricsTimePeriod",
    Today = "Today",
    LastWeek = "LastWeek",
    LastMonth = "LastMonth",
    LastThreeMonths = "LastThreeMonths",
    LastSixMonths = "LastSixMonths",
    Ytd = "Ytd",
    LastYear = "LastYear",
    LastFiveYears = "LastFiveYears",
    All = "All",
}

/** Result of a secure sales search with mapped Sale DTOs */
export interface SecureSalesSearchMappedResult {
    /** The mapped Sale DTOs ready for UI consumption */
    sales: SaleWithCatalogData[];
    /** Total number of matching documents */
    total: number;
    /** Time taken for the search in milliseconds */
    took: number;
    /** Maximum score of the results (for relevance ranking) */
    maxScore: number | null;
    /** Whether the search timed out */
    timedOut: boolean;
    /** Applied security filters for debugging */
    appliedSecurityFilters: string[] | null;
    /** Number of fields that were allowed for the user */
    allowedFieldCount: number;
    /** Parsed aggregation results */
    aggregations: { [key: string]: AggregationResult; } | null;
    /** PIT ID for next page requests, null if not using PIT (Point-In-Time) pagination */
    pitId: string | null;
    /** Search after values for next page cursor (null if no more pages) */
    searchAfter: any[] | null;
    /** Whether there are more pages available */
    hasNextPage: boolean;
}

export interface OpenSearchRequestOfSaleFilterQueryV2 {
    filter: SaleFilterQueryV2;
    options: SearchOptions | null;
}

export interface SaleSearchRequestV2 extends OpenSearchRequestOfSaleFilterQueryV2 {
    allowedFields: string[] | null;
    appliedSecurityFilters: string[] | null;
    dataIsolationContext: { [key: string]: any; } | null;
}

export interface SaleFilterQueryV2 {
    eventIds: FieldFilter | null;
    eventDates: FieldFilter | null;
    eventTimeFrameFilters: FieldFilter | null;
    clientTimezoneOffsetMins: number | null;
    eventStatuses: FieldFilter | null;
    topLevelCategories: FieldFilter | null;
    parentCategories: FieldFilter | null;
    lastSaleDates: FieldFilter | null;
    numberOfAvailableTickets: FieldFilter | null;
    eventHasUnsoldTickets: FieldFilter | null;
    eventOrMappingIds: FieldFilter | null;
    oldPosEventIds: FieldFilter | null;
    performerIds: FieldFilter | null;
    venueIds: FieldFilter | null;
    countryCodes: FieldFilter | null;
    stateProvinceIds: FieldFilter | null;
    cityIds: FieldFilter | null;
    fulfillmentStates: FieldFilter | null;
    inHandDates: FieldFilter | null;
    ticketTypes: FieldFilter | null;
    fulfilledBySellerIds: FieldFilter | null;
    isPlaceholder: FieldFilter | null;
    fulfillmentDates: FieldFilter | null;
    isNoFulfill: FieldFilter | null;
    cancellationDates: FieldFilter | null;
    soldOnMarketplace: FieldFilter | null;
    saleDates: FieldFilter | null;
    listingInsertBy: FieldFilter | null;
    paymentStates: FieldFilter | null;
    marketplacePaymentStates: FieldFilter | null;
    paymentReferenceIds: FieldFilter | null;
    paymentDates: FieldFilter | null;
    isPaymentReceived: FieldFilter | null;
    currencyCodes: FieldFilter | null;
    sections: FieldFilter | null;
    rows: FieldFilter | null;
    purchaseOrderIds: FieldFilter | null;
    purchaseVendorIds: FieldFilter | null;
    purchaseVendorAccountIds: FieldFilter | null;
    purchaseVendorOrderIds: FieldFilter | null;
    purchaseBuyerIds: FieldFilter | null;
    purchaseInsertByIds: FieldFilter | null;
    purchaseDates: FieldFilter | null;
    internalNotes: FieldFilter | null;
    tagPairs: TagPairFilter | null;
    eventTagPairs: TagPairFilter | null;
    listingTagPairs: TagPairFilter | null;
    purchaseOrderTagPairs: TagPairFilter | null;
    purchaseOrdersFilter: PurchaseOrderNestedFilter | null;
    isSeatSaver: FieldFilter | null;
    saleStatuses: FieldFilter | null;
    marketplaceFulfillmentState: FieldFilter | null;
    marketplaceContractState: FieldFilter | null;
    prices: FieldFilter | null;
    quantitySold: FieldFilter | null;
    quantityWasted: FieldFilter | null;
    and: SaleFilterQueryV2[] | null;
    or: SaleFilterQueryV2[] | null;
    orConditions: SaleFilterQueryV2[] | null;
    not: boolean | null;
    orFulfillerSellerUserId: string | null;
    orPricerSellerUserId: string | null;
    orPurchaseBuyerId: string | null;
}

export interface PurchaseOrderNestedFilter {
    purchaseOrderIds: FieldFilter | null;
    purchaseOrderDates: FieldFilter | null;
    purchaseOrderVendorOrderIds: FieldFilter | null;
    purchaseOrderVendorAccountIds: FieldFilter | null;
    purchaseOrderVendorIds: FieldFilter | null;
    buyerUserIds: FieldFilter | null;
    purchaseOrderInsertByUserIds: FieldFilter | null;
    encryptedEmailAddresses: FieldFilter | null;
    purchaseOrderVendorAccountNames: FieldFilter | null;
    purchaseOrderVendorNames: FieldFilter | null;
}

export interface SearchResult {
    name: string | null;
    id: string | null;
    ownerUserId: string | null;
    count: number | null;
    entityIds: number[] | null;
    /** Note we call this fetch (instead of refresh) because this refers to the EntityIds that is obtained by running the query
Not the data for each of the entity which is obtained via another method */
    lastFetchDate: string | null;
}

export interface PurchaseSearchResult extends SearchResult {
    query: PurchaseOrderQuery | null;
    queryV2: PurchaseOrderQueryV2 | null;
}

export interface SaleSearchResult extends SearchResult {
    query: SaleQuery | null;
    queryV2: SaleQueryV2 | null;
}

export interface InventorySearchResult extends SearchResult {
    query: ListingQuery | null;
    queryV2: ListingQueryV2 | null;
}

export interface SellerUserAccountInfo {
    userId: string;
    consigneeSellerAccountId: string | null;
    displayName: string;
    email: string;
    isDeactivated: boolean;
    roles: number[];
    userGroupIds: number[];
}

export interface SellerRoleInfo {
    id: number;
    consigneeSellerAccountId: string | null;
    prefinedRole: Role | null;
    name: string;
    details: string | null;
    isDeleted: boolean;
    permissions: Permission[];
}

export enum Role {
    Owner = "Owner",
    Buyer = "Buyer",
    FinanceAPI = "FinanceAPI",
    Fulfillment = "Fulfillment",
    Pricer = "Pricer",
    Processor = "Processor",
    AutoPO = "AutoPO",
    AutoFulfill = "AutoFulfill",
    AutoPricer = "AutoPricer",
    Reporter = "Reporter",
    Finance = "Finance",
}

export interface SellerPermissionInfo {
    name: string;
    permission: Permission;
    area: PermissionAccessArea;
    details: string;
}

export enum PermissionAccessArea {
    General = "General",
    Inventory = "Inventory",
    Sales = "Sales",
    Purchases = "Purchases",
    Events = "Events",
    Account = "Account",
    Reporting = "Reporting",
    Messages = "Messages",
    Accounting = "Accounting",
    AdPlatform = "AdPlatform",
}

export interface SellerUserInput {
    sellerUserId: string;
    consigneeSellerAccountId: string | null;
    displayName: string;
    roles: number[];
    userGroupIds: number[];
}

export interface SellerUser {
    sellerUserId: string;
    stubHubLoginId: string;
    sellerDisplayName: string;
    sellerUserName: string;
    email: string;
    deleteDate: string | null;
}

export interface SellerUserRolesInput {
    sellerUserId: string;
    consigneeSellerAccountId: string | null;
    roles: number[];
}

export interface SellerUserAccountInput {
    sellerUserId: string;
    consigneeSellerAccountId: string | null;
}

export interface SyncCenterSettings {
    defaultSplitType: SplitType | null;
    defaultSplitTypeForSeatSaver: SplitType | null;
    ticketTypeRules: TicketTypeRule[] | null;
    inHandDatePaddingInDays: number | null;
    defaultHideSeatNumbers: boolean | null;
    priceFloor: number | null;
    defaultMaxQuantityDisplay: number | null;
    marketplaceSettings: MarketplaceAccountSettingInput[] | null;
    adminHoldIndefinitelyForCancelledSales: boolean | null;
    inHandDaysBeforeEvent: number | null;
    isAutoPoQualityControlled: boolean | null;
    isAutoAddCancelledProceedsEnabled: boolean | null;
    isAutoLinkSaleLineItemEnabled: boolean | null;
    enableListingSplitOnDiscontinuousOrdinal: boolean | null;
    defaultManualMaxDisplayQuantity: number | null;
    showUnbroadcastListingsInComps: boolean | null;
}

export interface TicketTypeRule {
    deliveryType: DeliveryType;
    ticketTypePriorityOrders: TicketTypePriorityOrder[];
}

export interface TicketTypePriorityOrder {
    ticketType: TicketType;
    priorityOrder: number | null;
    /** Whether this ticket type shouldn't be used */
    blocked: boolean | null;
}

export interface MarketplaceAccountSettingInput {
    marketplace: Marketplace;
    isEnabled: boolean;
    markup: number | null;
    sellerFee: number | null;
    /** This field is currently only used for read and does not need to be sent in the update request. */
    userName: string | null;
    /** This field is currently only used for read and does not need to be sent in the update request. */
    tokenVersion: number | null;
    paymentTerm: MarketplacePaymentTerm;
    broadcastHoldDurationInDays: number | null;
    maxHoldDurationInHours: number | null;
}

export interface AccountAutoPricingSettingsInputs extends AutoPricingInputs {
    defaultCompListingQuantityFilters: CompListingQuantityFiltersCollection | null;
    compRowOffsetMode: CompRowOffsetMode | null;
    autoPricingPauseType: AutoPricingPauseType | null;
    compFailureActionType: AutoPricingCompFailureActionType | null;
}

export interface CompListingQuantityFiltersCollection {
    exactMatchQuantityFilters: CompListingQuantityFilters[] | null;
    greaterThanOrEqualToQuantityFilter: CompListingQuantityFilters | null;
}

export interface CompListingQuantityFilters {
    posListingQuantity: number;
    compQuantityFilters: CompListingQuantity;
}

export enum AutoPricingPauseType {
    PriceDecreases = "PriceDecreases",
    AllPriceUpdates = "AllPriceUpdates",
}

export enum AutoPricingCompFailureActionType {
    DontChangePrice = "DontChangePrice",
    SetPriceToCeiling = "SetPriceToCeiling",
}

export interface AutoCurrencyConversionSettings {
    enabled: boolean;
    defaultCurrencyCode: string | null;
    ignoredCurrencyCodes: string[] | null;
}

export interface TimezoneInfo {
    value: string;
    timezoneOffsetMins: number;
}

export interface SellerRoleInput {
    id: number;
    consigneeSellerAccountId: string | null;
    name: string | null;
    details: string | null;
    permissions: Permission[] | null;
    userIds: string[] | null;
}

export interface TradeDeskPasswordResetInput {
    username: string;
    oldPassword: string | null;
    newPassword: string;
    code: string;
}

export interface RevealMarketExternalPosSyncConfig {
    overrideRevealSyncDateRelativeStartSecs: number | null;
    overrideRevealSyncDateRelativeEndSecs: number | null;
    overrideRevealSyncDateStart: string | null;
    overrideRevealSyncDateEnd: string | null;
    overrideRevealSyncDateRoundingMode: RelativeTimeRoundingMode | null;

    [key: string]: any;
}

export interface RevealSyncConfigOverrideInput {
    syncDateOverride: DateTimeRangeWithRelative;
}

export interface ConfirmationDialogSettingsResponse {
    settings: { [key in keyof typeof ConfirmationDialogType]?: ConfirmationDialogSettingItem; };
    metadata: ConfirmationDialogMetadata[];
}

export enum ConfirmationDialogType {
    FloorCeilingViolation = "FloorCeilingViolation",
    SuspiciousPriceChange = "SuspiciousPriceChange",
    AutoPricingDisable = "AutoPricingDisable",
    AbsolutePriceDrop = "AbsolutePriceDrop",
    RelativePriceDrop = "RelativePriceDrop",
    RelativeFloorPriceDrop = "RelativeFloorPriceDrop",
    PriceStaggerFloorPriceDrop = "PriceStaggerFloorPriceDrop",
}

export interface ConfirmationDialogSettingItem {
    isActive: boolean;
    absoluteThreshold: number | null;
    relativeThreshold: number | null;
}

export interface ConfirmationDialogMetadata {
    dialogType: ConfirmationDialogType;
    thresholdType: ConfirmationDialogThresholdType;
}

export enum ConfirmationDialogThresholdType {
    None = "None",
    Absolute = "Absolute",
    Relative = "Relative",
    Both = "Both",
}

export interface ConfirmationDialogSettingRequest {
    settings: ConfirmationDialogSettingRequestItem[];
}

export interface ConfirmationDialogSettingRequestItem {
    confirmationDialogType: ConfirmationDialogType;
    isActive: boolean;
    absoluteThreshold: number | null;
    relativeThreshold: number | null;
}

export interface PurchaseOrderSettings {
    isAutoGeneratedVendorOrderIdEnabled: boolean | null;
    vendorOrderIdPrefix: string | null;
}

export interface ListingGroupSettings {
    defaultExcludeFullySoldInGroup: boolean | null;
    defaultCollapseListingGroups: boolean | null;
}

export interface SellerAccountFulfillmentRuleDto {
    sellerAccountFulfillmentRuleId: number;
    fulfillerSellerUserId: string;
    fulfillmentRuleTargetType: FulfillmentRuleTargetType;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    purchaseOrderVendorId: number | null;
    purchaseOrderId: number | null;
    viagogoVenueId: number | null;
}

export enum FulfillmentRuleTargetType {
    Event = "Event",
    Vendor = "Vendor",
    Venue = "Venue",
    PurchaseOrder = "PurchaseOrder",
}

export interface SellerAccountFulfillmentRulesInput {
    sellerAccountFulfillmentRulesId: number | null;
    fulfillerSellerUserId: string;
    fulfillmentRuleTargetTypeId: number;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    purchaseOrderVendorId: number | null;
    purchaseOrderId: number | null;
    viagogoVenueId: number | null;
}

export interface SellerAccountFulfillmentRule {
    sellerAccountFulfillmentRuleId: number;
    fulfillerSellerUserId: string;
    fulfillmentRuleTargetType: FulfillmentRuleTargetType;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    eventName: string | null;
    purchaseOrderVendorId: number | null;
    purchaseOrderId: number | null;
    viagogoVenueId: number | null;
    venueName: string | null;
}

export interface SellerSupportCaseNote {
    sellerSupportCaseNoteId: number;
    createByUserId: string | null;
    impersonatedUserId: string | null;
    createDate: string;
    workItemNoteId: number | null;
    noteContent: string | null;
    readDate: string | null;
    attachments: AttachmentResource[] | null;
}

export interface AttachmentResource {
    id: string;
    name: string;
    content_type: string;
    content: string | null;
}

export interface SellerSupportCase {
    createByUserId: string;
    impersonatedUserId: string | null;
    marketplace: Marketplace;
    sellerSupportCaseId: number;
    entityId: number | null;
    entityType: ActionOutboxEntityType | null;
    marketplaceEntityId: string | null;
    workItemId: number | null;
    readDate: string | null;
    createDate: string;
    lastNoteDate: string;
    unreadNoteCount: number;
}

export interface SellerSupportCaseQuery {
    isMostRecent: boolean | null;
    sellerSupportCaseIds: number[] | null;
}

export interface SellerSupportCaseRequest {
    marketplace: Marketplace;
    entityId: number | null;
    entityType: ActionOutboxEntityType | null;
    marketplaceEntityId: string | null;
    noteContent: string | null;
    attachments: string[] | null;
}

export interface FileDownloadInfo {
    contentType: string;
    contentDisposition: string;
    length: number;
    name: string;
    fileName: string;
    content: string | null;
}

export interface SellerSupportCaseAttachmentRequest {
    id: string;
    name: string;
    contentType: string;
}

export interface SellerUserSetting {
    userSetting: UserSetting;
    /** JSON string of setting */
    userSettingValue: string;
}

export enum UserSetting {
    QuickFiltersStateInventory = "QuickFiltersStateInventory",
    QuickFiltersCustomInventory = "QuickFiltersCustomInventory",
    QuickFiltersStateSales = "QuickFiltersStateSales",
    QuickFiltersCustomSales = "QuickFiltersCustomSales",
    QuickFiltersStatePurchases = "QuickFiltersStatePurchases",
    QuickFiltersCustomPurchases = "QuickFiltersCustomPurchases",
    SalesViewSelected = "SalesViewSelected",
    SuspiciousPriceChange = "SuspiciousPriceChange",
    InternationalCompliance = "InternationalCompliance",
    InventoryPageViewMode = "InventoryPageViewMode",
    InventoryColumnOrder = "InventoryColumnOrder",
    InventoryColumnNumberPrecision = "InventoryColumnNumberPrecision",
    InventoryColumnWidths = "InventoryColumnWidths",
    InventoryCustomColumns = "InventoryCustomColumns",
    InventoryColumnEditability = "InventoryColumnEditability",
    SaleColumnOrder = "SaleColumnOrder",
    SaleCustomColumns = "SaleCustomColumns",
    SaleColumnEditability = "SaleColumnEditability",
    SaleColumnNumberPrecision = "SaleColumnNumberPrecision",
    ReportConfigInventory = "ReportConfigInventory",
    ReportConfigSale = "ReportConfigSale",
    EventsColumnOrder = "EventsColumnOrder",
    EventsCustomColumns = "EventsCustomColumns",
    EventsColumnEditability = "EventsColumnEditability",
    EventsColumnNumberPrecision = "EventsColumnNumberPrecision",
    SiteTheme = "SiteTheme",
    ReportingColumnLimit = "ReportingColumnLimit",
    PriceFloorCeilingMode = "PriceFloorCeilingMode",
    ReleaseNoteIdsRead = "ReleaseNoteIdsRead",
    EventsColumnsEnabled = "EventsColumnsEnabled",
    InventoryColumnsEnabled = "InventoryColumnsEnabled",
    SaleColumnsEnabled = "SaleColumnsEnabled",
    SiteZoom = "SiteZoom",
    InventoryDefaultTab = "InventoryDefaultTab",
    PurchaseColumnOrder = "PurchaseColumnOrder",
    PurchaseCustomColumns = "PurchaseCustomColumns",
    PurchaseColumnEditability = "PurchaseColumnEditability",
    PurchaseColumnNumberPrecision = "PurchaseColumnNumberPrecision",
    PurchaseColumnsEnabled = "PurchaseColumnsEnabled",
    InventoryFlattenedColumnOrder = "InventoryFlattenedColumnOrder",
    InventoryFlattenedColumnsEnabled = "InventoryFlattenedColumnsEnabled",
    InventoryFlattenedColumnEditability = "InventoryFlattenedColumnEditability",
    InventoryFlattenedColumnNumberPrecision = "InventoryFlattenedColumnNumberPrecision",
    SaleFlattenedColumnOrder = "SaleFlattenedColumnOrder",
    SaleFlattenedColumnsEnabled = "SaleFlattenedColumnsEnabled",
    SaleFlattenedColumnEditability = "SaleFlattenedColumnEditability",
    SaleFlattenedColumnNumberPrecision = "SaleFlattenedColumnNumberPrecision",
    SaleColumnWidths = "SaleColumnWidths",
    PurchaseColumnWidths = "PurchaseColumnWidths",
    InventoryV2DefaultTab = "InventoryV2DefaultTab",
    SalePageViewMode = "SalePageViewMode",
    PurchasePageViewMode = "PurchasePageViewMode",
    InventoryReportColumnWidths = "InventoryReportColumnWidths",
    SaleReportColumnWidths = "SaleReportColumnWidths",
    EventsColumnWidths = "EventsColumnWidths",
    PurchaseEventColumnOrder = "PurchaseEventColumnOrder",
    PurchaseEventColumnsEnabled = "PurchaseEventColumnsEnabled",
    PurchaseEventColumnEditability = "PurchaseEventColumnEditability",
    PurchaseEventColumnNumberPrecision = "PurchaseEventColumnNumberPrecision",
    PurchaseEventColumnWidths = "PurchaseEventColumnWidths",
    SidePanelWidths = "SidePanelWidths",
    SalesDefaultTab = "SalesDefaultTab",
    PurchasesDefaultTab = "PurchasesDefaultTab",
    SalesSideTableColumnOrder = "SalesSideTableColumnOrder",
    SalesSideTableColumnsEnabled = "SalesSideTableColumnsEnabled",
    SalesSideTableColumnEditability = "SalesSideTableColumnEditability",
    SalesSideTableColumnNumberPrecision = "SalesSideTableColumnNumberPrecision",
    PurchaseSideTableColumnOrder = "PurchaseSideTableColumnOrder",
    PurchaseSideTableColumnsEnabled = "PurchaseSideTableColumnsEnabled",
    PurchaseSideTableColumnEditability = "PurchaseSideTableColumnEditability",
    PurchaseSideTableColumnNumberPrecision = "PurchaseSideTableColumnNumberPrecision",
    InventorySideTableColumnOrder = "InventorySideTableColumnOrder",
    InventorySideTableColumnsEnabled = "InventorySideTableColumnsEnabled",
    InventorySideTableColumnEditability = "InventorySideTableColumnEditability",
    InventorySideTableColumnNumberPrecision = "InventorySideTableColumnNumberPrecision",
    MarketplacePaymentsTableColumnOrder = "MarketplacePaymentsTableColumnOrder",
    MarketplacePaymentsCustomColumns = "MarketplacePaymentsCustomColumns",
    MarketplacePaymentsTableColumnsEnabled = "MarketplacePaymentsTableColumnsEnabled",
    MarketplacePaymentsColumnNumberPrecision = "MarketplacePaymentsColumnNumberPrecision",
    MarketplacePaymentsColumnEditability = "MarketplacePaymentsColumnEditability",
    MarketplacePaymentsColumnsWidth = "MarketplacePaymentsColumnsWidth",
    QuickFloorPromptDismissal = "QuickFloorPromptDismissal",
    QuickFiltersCustomMarketplacePayments = "QuickFiltersCustomMarketplacePayments",
    QuickFiltersStateMarketplacePayments = "QuickFiltersStateMarketplacePayments",
    QuickFiltersStateOnSaleEvent = "QuickFiltersStateOnSaleEvent",
    QuickFiltersCustomOnSaleEvent = "QuickFiltersCustomOnSaleEvent",
    OnSaleEventColumnsOrder = "OnSaleEventColumnsOrder",
    OnSaleEventColumnsWidths = "OnSaleEventColumnsWidths",
    OnSaleEventColumnNumberPrecision = "OnSaleEventColumnNumberPrecision",
    OnSaleEventCustomColumns = "OnSaleEventCustomColumns",
    OnSaleEventColumnEditability = "OnSaleEventColumnEditability",
    OnSaleEventColumnsEnabled = "OnSaleEventColumnsEnabled",
    FirstTimeFeaturesViewed = "FirstTimeFeaturesViewed",
    InventoryMenuTabFavorite = "InventoryMenuTabFavorite",
    SaleMenuTabFavorite = "SaleMenuTabFavorite",
    PurchaseMenuTabFavorite = "PurchaseMenuTabFavorite",
    RecentSalesTableColumnsWidths = "RecentSalesTableColumnsWidths",
    RecentSalesTableColumnsOrder = "RecentSalesTableColumnsOrder",
    RecentSalesTableColumnsEnabled = "RecentSalesTableColumnsEnabled",
    RecentSalesTableColumnNumberPrecision = "RecentSalesTableColumnNumberPrecision",
    RecentSalesTableColumnEditability = "RecentSalesTableColumnEditability",
    ReportCustomColumnInventory = "ReportCustomColumnInventory",
    ReportCustomColumnSales = "ReportCustomColumnSales",
    ReportCustomColumnSaleLineItem = "ReportCustomColumnSaleLineItem",
    ReportCustomColumnSoldTicket = "ReportCustomColumnSoldTicket",
    ReportCustomColumnPurchase = "ReportCustomColumnPurchase",
    ReportCustomColumnCommission = "ReportCustomColumnCommission",
    ReportV2InventoryColumnWidths = "ReportV2InventoryColumnWidths",
    ReportV2SaleColumnWidths = "ReportV2SaleColumnWidths",
    ReportV2CommissionColumnWidths = "ReportV2CommissionColumnWidths",
    ReportV2PurchaseColumnWidths = "ReportV2PurchaseColumnWidths",
    ReportV2SaleLineItemColumnWidths = "ReportV2SaleLineItemColumnWidths",
    ReportV2SoldTicketColumnWidths = "ReportV2SoldTicketColumnWidths",
    ReportV2PurchaseOrderLineItemColumnWidths = "ReportV2PurchaseOrderLineItemColumnWidths",
    ReportV2ColumnNumberPrecision = "ReportV2ColumnNumberPrecision",
    ReportCustomColumnCostOfGoodsSold = "ReportCustomColumnCostOfGoodsSold",
    ReportCostOfGoodsSoldColumnWidths = "ReportCostOfGoodsSoldColumnWidths",
    ReportCustomColumnSaleCostAdjustments = "ReportCustomColumnSaleCostAdjustments",
    ReportSaleCostAdjustmentsColumnWidths = "ReportSaleCostAdjustmentsColumnWidths",
    EnableSelectionByDefault = "EnableSelectionByDefault",
    GroupInventoryEventView = "GroupInventoryEventView",
    FavoriteVendorIds = "FavoriteVendorIds",
    EnableNotifications = "EnableNotifications",
    ReportCustomColumnTicketGroup = "ReportCustomColumnTicketGroup",
    ReportTicketGroupColumnWidths = "ReportTicketGroupColumnWidths",
    InventoryPortfolioColumnSort = "InventoryPortfolioColumnSort",
    InventoryEventColumnSort = "InventoryEventColumnSort",
    PurchasePortfolioColumnSort = "PurchasePortfolioColumnSort",
    PurchaseEventColumnSort = "PurchaseEventColumnSort",
    SalePortfolioColumnSort = "SalePortfolioColumnSort",
    SaleEventColumnSort = "SaleEventColumnSort",
    InventorySearchColumnSort = "InventorySearchColumnSort",
    PurchaseSearchColumnSort = "PurchaseSearchColumnSort",
    SaleSearchColumnSort = "SaleSearchColumnSort",
    HasCreatedAdCampaign = "HasCreatedAdCampaign",
}

export interface CustomQuickFilterOfListingQuery {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    id: string;
    name: string;
    data: ListingQuery;
}

export interface CustomQuickFilterOfOnSaleEventQuery {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    id: string;
    name: string;
    data: OnSaleEventQuery;
}

export interface CustomQuickFilterOfSaleQuery {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    id: string;
    name: string;
    data: SaleQuery;
}

export interface CustomQuickFilterOfPurchaseOrderQuery {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    id: string;
    name: string;
    data: PurchaseOrderQuery;
}

export interface CustomQuickFilterOfMarketplacePaymentQuery {
    /** Used for disambugating serialized versions of this class. */
    schemaVersion: string;
    id: string;
    name: string;
    data: MarketplacePaymentQuery;
}

export interface ReleaseNote {
    id: number;
    title: string;
    releaseNoteType: ReleaseNoteType;
    descriptionHtml: string | null;
    /** Date when user gets access to this release note. For "NewFeature" type,
this is `FeatureInsertDate` from ReleaseNoteDto, date when user is granted access.
Otherwise (e.g. BugFix), it is the date the release note itself is created */
    releaseNoteGetAccessDate: string;
}

export enum ReleaseNoteType {
    NewFeature = "NewFeature",
    BugFix = "BugFix",
}

export interface TutorialItem {
    tutorialItemId: number;
    title: string;
    titleContentId: number | null;
    parentTutorialItemId: number | null;
    tutorialItemType: TutorialItemType;
}

export enum TutorialItemType {
    Folder = "Folder",
    Document = "Document",
}

export interface TutorialItemContent {
    tutorialItemId: number;
    tutorialItemContentId: number | null;
    contentHtml: string;
}

export interface SellerEventConfirmationDialogSuppression {
    confirmationDialogType: ConfirmationDialogType;
    startDate: string;
    endDate: string;
}

export interface PosActionResult {
    succeeded: boolean;
    errorStatusCode: number | null;
    errorMessage: string | null;
}

export interface InsertSellerEventConfirmationDialogSuppressionRequest {
    viagogoVirtualId: string;
    confirmationDialogType: ConfirmationDialogType;
    durationHours: number;
}

export interface DeliveryTypeTicketTypeMapping {
    deliveryType: DeliveryType;
    ticketTypes: { [key in keyof typeof TicketType]?: number[]; };
}

export interface TicketGroupMergeInput {
    intentions: TicketGroupIntention[];
    purchaseOrderId: number;
    ticketGroups: TicketGroupInput[];
    updateSalesOfListings: boolean | null;
    deallocateSales: boolean | null;
    updatePredeliveryETicketArtifacts: boolean | null;
}

export interface TicketGroupIntention {
    ticketGroupId: number;
    reason: TicketGroupEditReason;
    additionalInfo: string;
}

export enum TicketGroupEditReason {
    AmendTickets = "Amend Tickets",
    CancelTickets = "Cancel Tickets",
    AddTickets = "Add Tickets",
    ExchangeTickets = "Exchange Tickets",
    EditEvent = "Edit Event",
}

export interface UserGroup {
    userGroupId: number;
    userGroupName: string;
    userGroupDescription: string | null;
    sellerUserIds: string[];
    consigneeSellerAccountId: string | null;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export type PosClientConfig = {
  activeAccountId?: string;
};